import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  OpaOptions: any;
};

export type AbuseReport = {
  __typename?: 'AbuseReport';
  id: Scalars['ID'];
  comment: Maybe<FeedActivityPostComment>;
  createdAt: Scalars['DateTime'];
  reason: AbuseReportReason;
  reporter: User;
  seen: Scalars['Boolean'];
};

export type AbuseReportConnection = Connection & {
  __typename?: 'AbuseReportConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<AbuseReportEdge>>;
};

export type AbuseReportEdge = Edge & {
  __typename?: 'AbuseReportEdge';
  node: Maybe<AbuseReport>;
  cursor: Maybe<Scalars['String']>;
};

export type AbuseReportFilterInput = {
  reporterId?: Maybe<Array<Scalars['ID']>>;
  reason?: Maybe<Array<AbuseReportReason>>;
  commentId?: Maybe<Array<Scalars['ID']>>;
};

export type AbuseReportMutation = {
  __typename?: 'AbuseReportMutation';
  markSeen: Maybe<AbuseReportResponse>;
};


export type AbuseReportMutationMarkSeenArgs = {
  id: Scalars['ID'];
};

export type AbuseReportNotFoundProblem = Problem & {
  __typename?: 'AbuseReportNotFoundProblem';
  message: Scalars['String'];
};

export enum AbuseReportReason {
  Spam = 'SPAM',
  Violence = 'VIOLENCE',
  Nudity = 'NUDITY',
  HateSpeech = 'HATE_SPEECH',
  Unlawful = 'UNLAWFUL',
  Harassment = 'HARASSMENT',
  FalseInformation = 'FALSE_INFORMATION'
}

export type AbuseReportResponse = Resource | AbuseReportNotFoundProblem | AbuseReportUnknownErrorProblem;

export type AbuseReportUnknownErrorProblem = Problem & {
  __typename?: 'AbuseReportUnknownErrorProblem';
  message: Scalars['String'];
};

/** Input to add a billing plan entry. */
export type AddBillingPlanEntryInput = {
  billingCycle: Scalars['Int'];
  delay: Scalars['Int'];
};

/** Response from adding billing plan entry mutation. */
export type AddBillingPlanEntryResponse = BillingPlanEntry | BillingPlanEntryUnknownProblem | BillingPlanEntryNotFoundProblem | BillingPlanEntryBillingPlanNotFoundProblem | BillingPlanEntryMinimumCycleProblem | BillingPlanEntryCyclesNotProgressiveProblem | BillingPlanEntryDelayNotPositiveProblem | BillingPlanEntryDelayNotProgressiveProblem | BillingPlanEntryDelayTooLongProblem | BillingPlanEntryNotValidProblem;

/** Input used when adding a discount code to the cart. */
export type AddDiscountInput = {
  discountCode: Scalars['String'];
  cartId?: Maybe<Scalars['ID']>;
};

export type AddDiscountResponse = Resource | CartAddDiscountCartNotFoundProblem | CartAddDiscountIncorrectDiscountCodeProblem | CartAddDiscountUserMismatchProblem;

export type AddItemInput = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  cartId?: Maybe<Scalars['ID']>;
  forestId?: Maybe<Scalars['ID']>;
  variantId?: Maybe<Scalars['ID']>;
  /** Product'll be sent within a gift */
  isGift?: Maybe<Scalars['Boolean']>;
  currency: ShopCurrency;
  cartType?: Maybe<CartType>;
};

export type AddItemResponse = CartAddItemSuccessResponse | CartAddItemProductNotSellableProblem | CartAddItemProductNotFoundProblem | CartAddItemProductVariantNotFoundProblem | CartAddItemProductNotAvailableProblem | CartAddItemProductOutOfStockProblem | CartAddItemCurrencyMismatchProblem | CartAddItemCartTypeMismatchProblem | CartAddItemUnauthorizedProductProblem;

/** Input to add a product plan. */
export type AddPlanProductInput = {
  assignmentCycle: Scalars['Int'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  delay: Scalars['Int'];
};

/** Problem that occurs when trying to add product plan. */
export type AddPlanProductProblem = Problem & {
  __typename?: 'AddPlanProductProblem';
  message: Scalars['String'];
  code: PlanProductProblemCode;
};

/** Response from add product plan. */
export type AddPlanProductResponse = PlanProduct | AddPlanProductProblem;

export type AddRuleSetMissingRuleTypeProblem = Problem & {
  __typename?: 'AddRuleSetMissingRuleTypeProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type AddRuleSetMoreThanOneRuleTypeProblem = Problem & {
  __typename?: 'AddRuleSetMoreThanOneRuleTypeProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type AddRuleSetMutationResponse = PerkRuleSet | AddRuleSetProductProblem | AddRuleSetPlanProblem | AddRuleSetMoreThanOneRuleTypeProblem | AddRuleSetMissingRuleTypeProblem | AddRuleSetTreeQuantityProblem;

export type AddRuleSetPlanProblem = Problem & {
  __typename?: 'AddRuleSetPlanProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type AddRuleSetProductProblem = Problem & {
  __typename?: 'AddRuleSetProductProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type AddRuleSetTreeQuantityProblem = Problem & {
  __typename?: 'AddRuleSetTreeQuantityProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type AddShippingInfoInput = {
  orderId: Scalars['ID'];
  /**
   * Some systems send the whole history of statuses. Generally speaking, we would filter all the
   * statuses greater than the last one we have.
   */
  shippingStatuses?: Maybe<Array<ShippingStatus>>;
  shippingTrackingInfo?: Maybe<ShippingTrackingInfo>;
  partner: ClothingPartnerEnum;
};

export type AddShippingInfoResponse = OrderAddShippingInfoSuccessResponse | OrderAddShippingInfoOrderNotFoundProblem | OrderAddShippingInfoOrderUpdateProblem;

/** Reason for canceling the subscription. */
export type AddSubscriptionCancelationSurveyInput = {
  /** The reason for canceling the subscription. */
  reason: SubscriptionCancelationSurveyReason;
  /** Additional information about the cancelation. */
  message?: Maybe<Scalars['String']>;
  /** Whether the subscription is cancelled or going to be cancelled soon. */
  isSubscriptionCanceled: Scalars['Boolean'];
};

/** Problem that occurs when the input is invalid. */
export type AddSubscriptionCancelationSurveyInvalidInputProblem = Problem & {
  __typename?: 'AddSubscriptionCancelationSurveyInvalidInputProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the subscription is not found. */
export type AddSubscriptionCancelationSurveyNotFoundProblem = Problem & {
  __typename?: 'AddSubscriptionCancelationSurveyNotFoundProblem';
  message: Scalars['String'];
};

/** Response from adding a subscription cancelation survey. */
export type AddSubscriptionCancelationSurveyResponse = AddSubscriptionCancelationSurveySuccessResponse | AddSubscriptionCancelationSurveyInvalidInputProblem | AddSubscriptionCancelationSurveyNotFoundProblem | AddSubscriptionCancelationSurveyUnknownProblem;

/** Response from successfully adding a subscription cancelation survey. */
export type AddSubscriptionCancelationSurveySuccessResponse = {
  __typename?: 'AddSubscriptionCancelationSurveySuccessResponse';
  /** The identifier of the survey. */
  id: Scalars['ID'];
};

/** Indicates that an unknown problem occurred when adding the subscription cancelation survey. */
export type AddSubscriptionCancelationSurveyUnknownProblem = Problem & {
  __typename?: 'AddSubscriptionCancelationSurveyUnknownProblem';
  message: Scalars['String'];
};

export type AdminMutation = {
  __typename?: 'AdminMutation';
  /** Compute the ranking of the users by the number of planted trees. */
  computeRankingByPlantedTrees: Maybe<Scalars['Boolean']>;
};

export type AdminQuery = {
  __typename?: 'AdminQuery';
  giftableTrees: GiftableTreesConnection;
};


export type AdminQueryGiftableTreesArgs = {
  userId: Scalars['ID'];
  forestId?: Maybe<Scalars['ID']>;
  productIds: Array<Scalars['ID']>;
  assignedOnFrom?: Maybe<Scalars['Date']>;
  assignedOnTo?: Maybe<Scalars['Date']>;
  pagination?: Maybe<PaginationInput>;
};

export type AdyenPaymentDetailsInput = {
  MD?: Maybe<Scalars['String']>;
  PaReq?: Maybe<Scalars['String']>;
  PaRes?: Maybe<Scalars['String']>;
  billingToken?: Maybe<Scalars['String']>;
  facilitatorAccessToken?: Maybe<Scalars['String']>;
  oneTimePasscode?: Maybe<Scalars['String']>;
  orderID?: Maybe<Scalars['String']>;
  payerID?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['String']>;
  paymentID?: Maybe<Scalars['String']>;
  redirectResult?: Maybe<Scalars['String']>;
  threeDSResult?: Maybe<Scalars['String']>;
};

export enum AdyenPaymentState {
  AuthenticationFinished = 'AuthenticationFinished',
  AuthenticationNotRequred = 'AuthenticationNotRequred',
  Authorised = 'Authorised',
  Cancelled = 'Cancelled',
  ChallengeShopper = 'ChallengeShopper',
  Error = 'Error',
  IdentifyShopper = 'IdentifyShopper',
  Pending = 'Pending',
  PresentToShopper = 'PresentToShopper',
  Received = 'Received',
  RedirectShopper = 'RedirectShopper',
  Refused = 'Refused',
  Success = 'Success',
  PartiallyAuthorized = 'PartiallyAuthorized'
}

export type AnswerFeedActivityQuizInput = {
  userId: Scalars['ID'];
  activityId: Scalars['ID'];
  answerKey: Scalars['ID'];
};

export type AnswerFeedActivityQuizResponse = Resource | FeedActivityUnknownErrorProblem | FeedActivityNotFoundProblem | FeedActivityNotValidTypeProblem | FeedActivityQuizAnswerNotValidProblem;

/** Response from approving a quotation. */
export type ApproveQuotationResponse = Quotation | QuotationNotFoundProblem | QuotationApproveUnknownProblem;

export type Asset = Image;

export type AssignedTrees = {
  __typename?: 'AssignedTrees';
  forestryTree: ForestryTree;
  treedomTree: Tree;
};

export type AssignForestryForestProblem = Problem & {
  __typename?: 'AssignForestryForestProblem';
  message: Scalars['String'];
};

export type AssignForestryInput = {
  /** The flow type */
  flow: AssignForestryTreesFlowType;
  /**
   * An identifier which will represent the request from the client side.
   * - ctOrderId for B2C_COMMERCE_TOOLS_ORDER
   * - salesOrderId for B2B_SALES_ORDER
   * - subscriptionId for ALLOTMENT
   */
  flowId: Scalars['ID'];
  /** The treedom user ID which will be the owner of the trees */
  ownerId: Scalars['ID'];
  /** The treedom user ID which will be the planter of the trees */
  planterId: Scalars['ID'];
  /** An array of trees which will be assigned */
  trees: Array<AssignForestryTreeInput>;
  /** Id propagated into the body of the sent events */
  processId?: Maybe<Scalars['String']>;
};

export type AssignForestryTreeInput = {
  /** The treedom product id */
  productId: Scalars['ID'];
  /** The id of the forest where tree will be planted on */
  forestId?: Maybe<Scalars['ID']>;
  /**
   * The preassigned forestry tree id which will be linked to the treedom tree.
   * Required in B2C_COMMERCE_TOOLS and B2B_SALES_ORDER flow, ignored in ALLOTMENT
   */
  forestryTreeId?: Maybe<Scalars['ID']>;
  /** A date used to override the default seed until calculation. Used only in B2B_SALES_ORDER flow */
  seedUntil?: Maybe<Scalars['DateTime']>;
};

export enum AssignForestryTreesFlowType {
  B2CCommerceTools = 'B2C_COMMERCE_TOOLS',
  B2BSalesOrder = 'B2B_SALES_ORDER',
  Allotment = 'ALLOTMENT',
  VirginCodes = 'VIRGIN_CODES'
}

export type AssignForestryTreesForestryTreeProblem = Problem & {
  __typename?: 'AssignForestryTreesForestryTreeProblem';
  message: Scalars['String'];
};

export type AssignForestryTreesPositiveResponse = {
  __typename?: 'AssignForestryTreesPositiveResponse';
  assignedTrees: Array<AssignedTrees>;
};

export type AssignForestryTreesProductProblem = Problem & {
  __typename?: 'AssignForestryTreesProductProblem';
  message: Scalars['String'];
};

export type AssignForestryTreesResponse = AssignForestryTreesPositiveResponse | AssignForestryTreesProductProblem | AssignForestryTreesUserProblem | AssignForestryForestProblem | AssignForestryUnknownProblem | AssignForestryTreesRetrievesTreesProblem | AssignForestryTreesForestryTreeProblem | AssignForestryTreesSeedUntilNotAllowedProblem;

export type AssignForestryTreesRetrievesTreesProblem = Problem & {
  __typename?: 'AssignForestryTreesRetrievesTreesProblem';
  message: Scalars['String'];
};

export type AssignForestryTreesSeedUntilNotAllowedProblem = Problem & {
  __typename?: 'AssignForestryTreesSeedUntilNotAllowedProblem';
  message: Scalars['String'];
};

export type AssignForestryTreesUserProblem = Problem & {
  __typename?: 'AssignForestryTreesUserProblem';
  message: Scalars['String'];
};

export type AssignForestryUnknownProblem = Problem & {
  __typename?: 'AssignForestryUnknownProblem';
  message: Scalars['String'];
};

export enum AssignmentChannel {
  Generic = 'GENERIC',
  B2B = 'B2B',
  Allotment = 'ALLOTMENT',
  Virgin = 'VIRGIN'
}

export type AssistantMutation = {
  __typename?: 'AssistantMutation';
  customerFeedback: CustomerFeedbackMutation;
};

export type AssistantQuery = {
  __typename?: 'AssistantQuery';
  thread: Maybe<AssistantThread>;
};


export type AssistantQueryThreadArgs = {
  id: Scalars['ID'];
};

export type AssistantThread = {
  __typename?: 'AssistantThread';
  id: Scalars['ID'];
  messages: AssistantThreadMessagesConnection;
  status: AssistantThreadStatus;
};


export type AssistantThreadMessagesArgs = {
  pagination?: Maybe<PaginationInput>;
};

export type AssistantThreadMessage = {
  __typename?: 'AssistantThreadMessage';
  id: Scalars['ID'];
  role: AssistantThreadMessageRole;
  content: AssistantThreadMessageContent;
};

export type AssistantThreadMessageContent = {
  __typename?: 'AssistantThreadMessageContent';
  text: Scalars['String'];
};

export type AssistantThreadMessageEdge = Edge & {
  __typename?: 'AssistantThreadMessageEdge';
  node: Maybe<AssistantThreadMessage>;
  cursor: Maybe<Scalars['String']>;
};

export enum AssistantThreadMessageRole {
  User = 'USER',
  Assistant = 'ASSISTANT'
}

export type AssistantThreadMessagesConnection = Connection & {
  __typename?: 'AssistantThreadMessagesConnection';
  totalCount: Scalars['Int'];
  pageInfo: Maybe<PageInfo>;
  edges: Maybe<Array<Maybe<AssistantThreadMessageEdge>>>;
};

export enum AssistantThreadStatus {
  Queued = 'QUEUED',
  InProgress = 'IN_PROGRESS',
  RequiresAction = 'REQUIRES_ACTION',
  Cancelling = 'CANCELLING',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Completed = 'COMPLETED',
  Incomplete = 'INCOMPLETE',
  Expired = 'EXPIRED',
  Unknown = 'UNKNOWN'
}

export type AuthDirectivePolicy = {
  rolesSome?: Maybe<Array<Scalars['String']>>;
  rolesEvery?: Maybe<Array<Scalars['String']>>;
  rolesNone?: Maybe<Array<Scalars['String']>>;
  scopesSome?: Maybe<Array<Scalars['String']>>;
  scopesEvery?: Maybe<Array<Scalars['String']>>;
  scopesNone?: Maybe<Array<Scalars['String']>>;
  tokenType?: Maybe<AuthTokenType>;
  argsEqAuth?: Maybe<Array<Array<Scalars['String']>>>;
  argsEmpty?: Maybe<Array<Scalars['String']>>;
  argsNotEmpty?: Maybe<Array<Scalars['String']>>;
  argsSome?: Maybe<Array<Scalars['String']>>;
  parentEqAuth?: Maybe<Array<Array<Scalars['String']>>>;
  claimsSome?: Maybe<Array<Scalars['String']>>;
  claimsEvery?: Maybe<Array<Scalars['String']>>;
  claimsNone?: Maybe<Array<Scalars['String']>>;
  claimsEqValue?: Maybe<Array<Array<Scalars['String']>>>;
};

export enum AuthTokenType {
  IdToken = 'ID_TOKEN',
  AccessToken = 'ACCESS_TOKEN'
}

export type BaseConnection = {
  totalCount: Scalars['Int'];
  pageInfo: Maybe<PageInfo>;
};

export enum BeverageBrewingPartnerEnum {
  Amka = 'AMKA'
}

export type BillingPlan = {
  __typename?: 'BillingPlan';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  duration: Scalars['Int'];
  entries: Array<BillingPlanEntry>;
  name: Scalars['String'];
  /** @deprecated This field is deprecated. The information is not anymore part of type. */
  renewLimit: Scalars['Int'];
  totalBillings: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BillingPlanConnection = Connection & {
  __typename?: 'BillingPlanConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<BillingPlanEdge>>;
};

/** Problem that occurs when billing plan hasn't positive duration. */
export type BillingPlanDurationNotPositiveProblem = Problem & {
  __typename?: 'BillingPlanDurationNotPositiveProblem';
  message: Scalars['String'];
};

export type BillingPlanEdge = Edge & {
  __typename?: 'BillingPlanEdge';
  node: Maybe<BillingPlan>;
  cursor: Scalars['String'];
};

/** Problem that occurs when billing plan has empty name. */
export type BillingPlanEmptyNameProblem = Problem & {
  __typename?: 'BillingPlanEmptyNameProblem';
  message: Scalars['String'];
};

export type BillingPlanEntry = {
  __typename?: 'BillingPlanEntry';
  id: Scalars['ID'];
  billingCycle: Scalars['Int'];
  delay: Scalars['Int'];
};

/** Problem that occurs when billing plan not found. */
export type BillingPlanEntryBillingPlanNotFoundProblem = Problem & {
  __typename?: 'BillingPlanEntryBillingPlanNotFoundProblem';
  message: Scalars['String'];
};

/** Problem that occurs when billing plan entry cycles are not progressive. */
export type BillingPlanEntryCyclesNotProgressiveProblem = Problem & {
  __typename?: 'BillingPlanEntryCyclesNotProgressiveProblem';
  message: Scalars['String'];
};

/** Problem that occurs when billing plan entry delay isn't positive. */
export type BillingPlanEntryDelayNotPositiveProblem = Problem & {
  __typename?: 'BillingPlanEntryDelayNotPositiveProblem';
  message: Scalars['String'];
};

/** Problem that occurs when billing plan entry delay isn't progressive. */
export type BillingPlanEntryDelayNotProgressiveProblem = Problem & {
  __typename?: 'BillingPlanEntryDelayNotProgressiveProblem';
  message: Scalars['String'];
};

/** Problem that occurs when billing plan entry delay is longer than entire duration. */
export type BillingPlanEntryDelayTooLongProblem = Problem & {
  __typename?: 'BillingPlanEntryDelayTooLongProblem';
  message: Scalars['String'];
};

/** Problem that occurs when billing plan entry hasn't minimum cycles required. */
export type BillingPlanEntryMinimumCycleProblem = Problem & {
  __typename?: 'BillingPlanEntryMinimumCycleProblem';
  message: Scalars['String'];
};

export type BillingPlanEntryMutation = {
  __typename?: 'BillingPlanEntryMutation';
  add: AddBillingPlanEntryResponse;
  delete: DeleteBillingPlanEntryResponse;
  update: UpdateBillingPlanEntryResponse;
};


export type BillingPlanEntryMutationAddArgs = {
  billingPlanId: Scalars['ID'];
  input: AddBillingPlanEntryInput;
};


export type BillingPlanEntryMutationDeleteArgs = {
  id: Scalars['ID'];
};


export type BillingPlanEntryMutationUpdateArgs = {
  id: Scalars['ID'];
  input: UpdateBillingPlanEntryInput;
};

/** Problem that occurs when billing plan entry not found. */
export type BillingPlanEntryNotFoundProblem = Problem & {
  __typename?: 'BillingPlanEntryNotFoundProblem';
  message: Scalars['String'];
};

/** Problem that occurs when billing plan entry isn't valid. */
export type BillingPlanEntryNotValidProblem = Problem & {
  __typename?: 'BillingPlanEntryNotValidProblem';
  message: Scalars['String'];
};

/** Problem that occurs when there's an unknown problem. */
export type BillingPlanEntryUnknownProblem = Problem & {
  __typename?: 'BillingPlanEntryUnknownProblem';
  message: Scalars['String'];
};

export type BillingPlanFilterInput = {
  /** Search by billing plan name. */
  name?: Maybe<Scalars['String']>;
};

/** Problem that occurs when a billing plan is referenced by some active subscription. */
export type BillingPlanInUseProblem = Problem & {
  __typename?: 'BillingPlanInUseProblem';
  message: Scalars['String'];
};

/** Problem that occurs when billing plan has invalid renew limit. */
export type BillingPlanInvalidRenewLimitProblem = Problem & {
  __typename?: 'BillingPlanInvalidRenewLimitProblem';
  message: Scalars['String'];
};

/** Problem that occurs when billing plan is missing entries. */
export type BillingPlanMissingEntriesProblem = Problem & {
  __typename?: 'BillingPlanMissingEntriesProblem';
  message: Scalars['String'];
};

export type BillingPlanMutation = {
  __typename?: 'BillingPlanMutation';
  entry: BillingPlanEntryMutation;
  /** Create a new billing plan. */
  create: CreateBillingPlanResponse;
  /** Delete a subscription billing plan. */
  delete: DeleteBillingPlanResponse;
  /**
   * Refresh an existing billing plan in the cache.
   * Optionally it can refresh billing and assignment plans.
   */
  refresh: RefreshBillingResponse;
  /** Update an existing billing plan. */
  update: UpdateBillingPlanResponse;
};


export type BillingPlanMutationCreateArgs = {
  input: CreateBillingPlanInput;
};


export type BillingPlanMutationDeleteArgs = {
  billingPlanId: Scalars['ID'];
};


export type BillingPlanMutationRefreshArgs = {
  billingPlanId: Scalars['ID'];
  input?: Maybe<RefreshBillingInput>;
};


export type BillingPlanMutationUpdateArgs = {
  billingPlanId: Scalars['ID'];
  input: UpdateBillingPlanInput;
};

/** Problem that occurs when billing plan not found. */
export type BillingPlanNotFoundProblem = Problem & {
  __typename?: 'BillingPlanNotFoundProblem';
  message: Scalars['String'];
};

export enum BillingPlanSortInput {
  /** Sort by created at, ascending. */
  CreatedAtAsc = 'CREATED_AT_ASC',
  /** Sort by created at, descending. */
  CreatedAtDesc = 'CREATED_AT_DESC'
}

/** Problem that occurs when there's an unknown problem. */
export type BillingPlanUnknownProblem = Problem & {
  __typename?: 'BillingPlanUnknownProblem';
  message: Scalars['String'];
};

export type BlogPost = {
  __typename?: 'BlogPost';
  id: Scalars['ID'];
  authorName: Scalars['String'];
  language: Scalars['String'];
  url: Scalars['String'];
  useFeaturedImage: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  postBody: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  postSummary: Maybe<Scalars['String']>;
  metaDescription: Maybe<Scalars['String']>;
  featuredImage: Maybe<Scalars['String']>;
  publishDate: Maybe<Scalars['DateTime']>;
};

export type BlogPostConnection = Connection & {
  __typename?: 'BlogPostConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<BlogPostEdge>>;
};

export type BlogPostEdge = Edge & {
  __typename?: 'BlogPostEdge';
  node: Maybe<BlogPost>;
  cursor: Maybe<Scalars['String']>;
};

export type BlogPostFilterInput = {
  /** Filter the posts only for a specific locale. Accept any valid ISO 639-1 language (es. "it")  */
  locale: Scalars['String'];
};

export enum BooleanFilter {
  True = 'TRUE',
  False = 'FALSE',
  All = 'ALL'
}

export type BulkChangeOwnershipInput = {
  /** Current user owner of gifts */
  sourceUserId: Scalars['ID'];
  /** Target user who will become the owner of gifts */
  targetUserId: Scalars['ID'];
};

export type BulkChangeOwnershipInvalidTargetUserProblem = Problem & {
  __typename?: 'BulkChangeOwnershipInvalidTargetUserProblem';
  message: Scalars['String'];
};

export type BulkChangeOwnershipResponse = BulkChangeOwnershipResponseData | BulkChangeOwnershipUnknownProblem | BulkChangeOwnershipInvalidTargetUserProblem;

export type BulkChangeOwnershipResponseData = {
  __typename?: 'BulkChangeOwnershipResponseData';
  /** Total number of gifted treecodes transferred from source to target user */
  totalGiftedTreecodesTransferred: Scalars['Int'];
  /** Total number of redeemed treecodes transferred from source to target user */
  totalRedeemedTreecodesTransferred: Scalars['Int'];
};

export type BulkChangeOwnershipUnknownProblem = Problem & {
  __typename?: 'BulkChangeOwnershipUnknownProblem';
  message: Scalars['String'];
};

/** The argument "input.creationDateFrom" must be a valid date */
export type BulkDeleteTreecodeCreationDateFromNotValidProblem = Problem & {
  __typename?: 'BulkDeleteTreecodeCreationDateFromNotValidProblem';
  message: Scalars['String'];
};

/** The argument "input.creationDateTo" must be a valid date */
export type BulkDeleteTreecodeCreationDateToNotValidProblem = Problem & {
  __typename?: 'BulkDeleteTreecodeCreationDateToNotValidProblem';
  message: Scalars['String'];
};

export type BulkDeleteTreecodeFindInput = {
  /** Filter by generation process ids */
  generationProcessName: Scalars['String'];
  /**
   * Filter by forest where gifted trees are planted.
   * Working for following treecode types only:
   *    - Picker
   */
  forestId?: Maybe<Scalars['ID']>;
  /** Filter by treecode types (OPEN is no more supported and will not work) */
  types?: Maybe<Array<Maybe<TreecodeType>>>;
  /** Filter by create date range From */
  creationDateFrom?: Maybe<Scalars['Date']>;
  /** Filter by create date range To */
  creationDateTo?: Maybe<Scalars['Date']>;
};

/** The argument "input.generationProcessName" must be a string with length > 0 */
export type BulkDeleteTreecodeGenerationProcessNameNotValidProblem = Problem & {
  __typename?: 'BulkDeleteTreecodeGenerationProcessNameNotValidProblem';
  message: Scalars['String'];
};

export type BulkDeleteTreecodeResponse = BulkDeleteTreecodeResponseData | BulkDeleteTreecodeCreationDateFromNotValidProblem | BulkDeleteTreecodeCreationDateToNotValidProblem | BulkDeleteTreecodeUnknownProblem | BulkDeleteTreecodeGenerationProcessNameNotValidProblem;

export type BulkDeleteTreecodeResponseData = {
  __typename?: 'BulkDeleteTreecodeResponseData';
  /** Total number of treecodes deleted */
  treecodesDeleted: Scalars['Int'];
};

/** Unknown problem */
export type BulkDeleteTreecodeUnknownProblem = Problem & {
  __typename?: 'BulkDeleteTreecodeUnknownProblem';
  message: Scalars['String'];
};

/** The argument "input.creationDateFrom" must be a valid date */
export type BulkUpdateTreecodeCreationDateFromNotValidProblem = Problem & {
  __typename?: 'BulkUpdateTreecodeCreationDateFromNotValidProblem';
  message: Scalars['String'];
};

/** The argument "input.creationDateTo" must be a valid date */
export type BulkUpdateTreecodeCreationDateToNotValidProblem = Problem & {
  __typename?: 'BulkUpdateTreecodeCreationDateToNotValidProblem';
  message: Scalars['String'];
};

export type BulkUpdateTreecodeFindInput = {
  /** Filter by generation process ids */
  generationProcessName: Scalars['String'];
  /**
   * Filter by forest where gifted trees are planted.
   * Working for following treecode types only:
   *    - Picker
   */
  forestId?: Maybe<Scalars['ID']>;
  /** Filter by treecode types (OPEN is no more supported and will not work) */
  types?: Maybe<Array<Maybe<TreecodeType>>>;
  /** Filter by create date range From */
  creationDateFrom?: Maybe<Scalars['Date']>;
  /** Filter by create date range To */
  creationDateTo?: Maybe<Scalars['Date']>;
};

/** The argument "input.generationProcessName" must be a string with length > 0 */
export type BulkUpdateTreecodeGenerationProcessNameNotValidProblem = Problem & {
  __typename?: 'BulkUpdateTreecodeGenerationProcessNameNotValidProblem';
  message: Scalars['String'];
};

export type BulkUpdateTreecodeInput = {
  /** Set an expire date */
  expiresAt?: Maybe<Scalars['Date']>;
  /** Change the enabled status */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Change the redeem type */
  redeemType?: Maybe<TreecodeRedeemType>;
  /** Update redeemable tree. You can update this value if treecode type PICKER is selected on input filter. */
  redeemableTree?: Maybe<TreecodePickerRedeemableTreeInput>;
};

/** At least one field to update is required */
export type BulkUpdateTreecodeMissingInputFieldProblem = Problem & {
  __typename?: 'BulkUpdateTreecodeMissingInputFieldProblem';
  message: Scalars['String'];
};

/** The argument "input.redeemableTree.assignedOnFrom" must be a valid date */
export type BulkUpdateTreecodeRedeemableTreeAssignedOnFromNotValid = Problem & {
  __typename?: 'BulkUpdateTreecodeRedeemableTreeAssignedOnFromNotValid';
  message: Scalars['String'];
};

/** The argument "input.redeemableTree.assignedOnTo" must be a valid date */
export type BulkUpdateTreecodeRedeemableTreeAssignedOnToNotValid = Problem & {
  __typename?: 'BulkUpdateTreecodeRedeemableTreeAssignedOnToNotValid';
  message: Scalars['String'];
};

export type BulkUpdateTreecodeResponse = BulkUpdateTreecodeResponseData | BulkUpdateTreecodeCreationDateFromNotValidProblem | BulkUpdateTreecodeCreationDateToNotValidProblem | BulkUpdateTreecodeUnknownProblem | BulkUpdateTreecodeGenerationProcessNameNotValidProblem | BulkUpdateTreecodeMissingInputFieldProblem | BulkUpdateTreecodeUpdateRedeemableTreeNotAvailable | BulkUpdateTreecodeRedeemableTreeAssignedOnFromNotValid | BulkUpdateTreecodeRedeemableTreeAssignedOnToNotValid;

export type BulkUpdateTreecodeResponseData = {
  __typename?: 'BulkUpdateTreecodeResponseData';
  /** Total number of treecodes Updated */
  treecodesUpdated: Scalars['Int'];
};

/** Unknown problem */
export type BulkUpdateTreecodeUnknownProblem = Problem & {
  __typename?: 'BulkUpdateTreecodeUnknownProblem';
  message: Scalars['String'];
};

/** Cannot update redeemableTree because you didn't select treecode type PICKER input filter  */
export type BulkUpdateTreecodeUpdateRedeemableTreeNotAvailable = Problem & {
  __typename?: 'BulkUpdateTreecodeUpdateRedeemableTreeNotAvailable';
  message: Scalars['String'];
};

export enum BusinessDepartment {
  Accounting = 'ACCOUNTING',
  AdministrationLegal = 'ADMINISTRATION_LEGAL',
  Communication = 'COMMUNICATION',
  CsrSustainability = 'CSR_SUSTAINABILITY',
  Events = 'EVENTS',
  Hr = 'HR',
  It = 'IT',
  ManagementBoard = 'MANAGEMENT_BOARD',
  Marketing = 'MARKETING',
  PrMedia = 'PR_MEDIA',
  PurchasingFinance = 'PURCHASING_FINANCE',
  Sales = 'SALES',
  Other = 'OTHER'
}

export type BusinessLanding = {
  __typename?: 'BusinessLanding';
  /** The BusinessLanding URL friendly name */
  id: Scalars['ID'];
  /** The Active Locales of the BusinessLanding. */
  activeLocales: Maybe<Array<BusinessLandingLocale>>;
  /** The Background Image of the BusinessLanding. */
  backgroundImage: Image;
  /** The Button (CTA) URL of the BusinessLanding. */
  ctaUrl: Scalars['String'];
  /** The forest of the BusinessLanding. */
  forest: Maybe<Forest>;
  /** The logo of the BusinessLanding. */
  logo: Image;
  /** The Main Message of the BusinessLanding. */
  mainMessage: Scalars['String'];
  /** The URL friendly SLUG of the BusinessLanding. */
  slug: Scalars['String'];
  /** The name of the BusinessLanding. */
  title: Scalars['String'];
  /** The type of the BusinessLanding. */
  type: BusinessLandingType;
  /** The name of the BusinessLanding. */
  user: User;
  /** The Video URL of the BusinessLanding. */
  video: Scalars['String'];
};


export type BusinessLandingCtaUrlArgs = {
  locale: Scalars['String'];
};


export type BusinessLandingMainMessageArgs = {
  locale: Scalars['String'];
};


export type BusinessLandingSlugArgs = {
  locale: Scalars['String'];
};


export type BusinessLandingTitleArgs = {
  locale: Scalars['String'];
};


export type BusinessLandingVideoArgs = {
  locale: Scalars['String'];
};

export type BusinessLandingBySlugInput = {
  value: Scalars['String'];
  locale: Scalars['String'];
};

export enum BusinessLandingLocale {
  En = 'en',
  It = 'it',
  De = 'de',
  Fr = 'fr',
  Es = 'es'
}

export enum BusinessLandingType {
  Forest = 'FOREST',
  Treecode = 'TREECODE'
}

export enum BusinessSector {
  Agriculture = 'AGRICULTURE',
  Automotive = 'AUTOMOTIVE',
  BanksFinanceInsuranceRealEstate = 'BANKS_FINANCE_INSURANCE_REAL_ESTATE',
  CharityNotForProfit = 'CHARITY_NOT_FOR_PROFIT',
  ChemicalIndustry = 'CHEMICAL_INDUSTRY',
  ClothingTextilesFootwearRetail = 'CLOTHING_TEXTILES_FOOTWEAR_RETAIL',
  CommunicationAgencyAdvMediaPr = 'COMMUNICATION_AGENCY_ADV_MEDIA_PR',
  ConstructionsBuildingMaterialsEquipment = 'CONSTRUCTIONS_BUILDING_MATERIALS_EQUIPMENT',
  Consultancy = 'CONSULTANCY',
  Cosmetics = 'COSMETICS',
  DefenceIndustry = 'DEFENCE_INDUSTRY',
  EcommerceSharingEconomy = 'ECOMMERCE_SHARING_ECONOMY',
  Education = 'EDUCATION',
  EnergyOilGasUtilities = 'ENERGY_OIL_GAS_UTILITIES',
  Entertainment = 'ENTERTAINMENT',
  EventOrganization = 'EVENT_ORGANIZATION',
  FoodBeverage = 'FOOD_BEVERAGE',
  FreelanceFirms = 'FREELANCE_FIRMS',
  Furniture = 'FURNITURE',
  GiftGadgetMerchandising = 'GIFT_GADGET_MERCHANDISING',
  HealthPharmaceutics = 'HEALTH_PHARMACEUTICS',
  HomeAppliancesElectronics = 'HOME_APPLIANCES_ELECTRONICS',
  HotelTravelServices = 'HOTEL_TRAVEL_SERVICES',
  IndustrialMachineryMetalIndustry = 'INDUSTRIAL_MACHINERY_METAL_INDUSTRY',
  ItSoftwareComputer = 'IT_SOFTWARE_COMPUTER',
  JewelryLuxury = 'JEWELRY_LUXURY',
  LargeScaleRetailers = 'LARGE_SCALE_RETAILERS',
  Manufacturing = 'MANUFACTURING',
  MultinationalConglomerate = 'MULTINATIONAL_CONGLOMERATE',
  NewspaperMagazineBookPublishing = 'NEWSPAPER_MAGAZINE_BOOK_PUBLISHING',
  NftBlockchainCrypto = 'NFT_BLOCKCHAIN_CRYPTO',
  PackagingPaperIndustry = 'PACKAGING_PAPER_INDUSTRY',
  PublicAdministration = 'PUBLIC_ADMINISTRATION',
  RestaurantCafeClub = 'RESTAURANT_CAFE_CLUB',
  ShippingServices = 'SHIPPING_SERVICES',
  Sport = 'SPORT',
  Telecommunication = 'TELECOMMUNICATION',
  ToysGaming = 'TOYS_GAMING',
  TransportationLogistic = 'TRANSPORTATION_LOGISTIC',
  Other = 'OTHER'
}

export type CancelPaymentMethodInput = {
  /** Payment method id. For Adyen this is the payment token. */
  id: Scalars['ID'];
  /** Explicit if and only if it's a s2s or admin request */
  userId?: Maybe<Scalars['ID']>;
};

/** Input to cancel a quotation. */
export type CancelQuotationInput = {
  /** The quote to cancel */
  quotationId: Scalars['ID'];
  /** Is the cancel operation requested by the customer? Default: false */
  requestedByUser?: Maybe<Scalars['Boolean']>;
};

/** Response from canceling a quotation. */
export type CancelQuotationResponse = Quotation | QuotationNotFoundProblem | QuotationCancelUnknownProblem | QuotationWrongStateProblem;

export type CapabilityGroup = {
  __typename?: 'CapabilityGroup';
  key: Scalars['ID'];
  capabilities: Array<Scalars['String']>;
};

export type CapabilityGroupMutation = {
  __typename?: 'CapabilityGroupMutation';
  create: CreateCapabilityGroupResponse;
  setCapabilities: SetCapabilityGroupCapabilitiesResponse;
};


export type CapabilityGroupMutationCreateArgs = {
  input: CreateCapabilityGroupInput;
};


export type CapabilityGroupMutationSetCapabilitiesArgs = {
  key: Scalars['ID'];
  capabilities: Array<Scalars['String']>;
};

export type Cart = {
  __typename?: 'Cart';
  id: Scalars['ID'];
  /** Total price of entire cart items */
  totalPrice: Price;
  /** Total price of entire cart items without discounts */
  fullTotalPrice: Price;
  /** Currency used on cart */
  currency: ShopCurrency;
  /**
   * Line items which contain sold out products
   * Used during recalculate cart process only
   */
  soldOutLineItems: Maybe<Array<Maybe<CartLineItem>>>;
  customLineItems: Array<CustomLineItem>;
  /** Discount applied to the cart. */
  discount: Maybe<CartDiscount>;
  /** Indicates if cart is anonymous (user owner is not logged-in) */
  isAnonymous: Maybe<Scalars['Boolean']>;
  /** Indicates if cart requires a shipping address. */
  isShippingAddressRequired: Maybe<Scalars['Boolean']>;
  lineItems: Array<CartLineItem>;
  order: Maybe<Order>;
  /** Indicates the cart shipping address */
  shippingAddress: Maybe<ShippingAddress>;
};

/** Problem that occurs when the cart is not found while attempting to add a discount code. */
export type CartAddDiscountCartNotFoundProblem = Problem & {
  __typename?: 'CartAddDiscountCartNotFoundProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the discount code is incorrect and cannot be applied to the cart. */
export type CartAddDiscountIncorrectDiscountCodeProblem = Problem & {
  __typename?: 'CartAddDiscountIncorrectDiscountCodeProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the request is trying to add a discount for a cart that does not belong to the authenticated user. */
export type CartAddDiscountUserMismatchProblem = Problem & {
  __typename?: 'CartAddDiscountUserMismatchProblem';
  message: Scalars['String'];
};

/** The cartId provided refers to a cart type that mismatch the item type */
export type CartAddItemCartTypeMismatchProblem = Problem & {
  __typename?: 'CartAddItemCartTypeMismatchProblem';
  message: Scalars['String'];
};

/** The cartId provided refers to a cart that mismatch the currency. Use changeCurrency mutation to resolve. */
export type CartAddItemCurrencyMismatchProblem = Problem & {
  __typename?: 'CartAddItemCurrencyMismatchProblem';
  message: Scalars['String'];
};

/** The selected product is not available */
export type CartAddItemProductNotAvailableProblem = Problem & {
  __typename?: 'CartAddItemProductNotAvailableProblem';
  message: Scalars['String'];
};

/** The selected product does not exist */
export type CartAddItemProductNotFoundProblem = Problem & {
  __typename?: 'CartAddItemProductNotFoundProblem';
  message: Scalars['String'];
};

/** The selected product is not sellable */
export type CartAddItemProductNotSellableProblem = Problem & {
  __typename?: 'CartAddItemProductNotSellableProblem';
  message: Scalars['String'];
};

/** The selected product is out of stock */
export type CartAddItemProductOutOfStockProblem = Problem & {
  __typename?: 'CartAddItemProductOutOfStockProblem';
  message: Scalars['String'];
};

/** The selected product variant does not exist */
export type CartAddItemProductVariantNotFoundProblem = Problem & {
  __typename?: 'CartAddItemProductVariantNotFoundProblem';
  message: Scalars['String'];
};

export type CartAddItemSuccessResponse = {
  __typename?: 'CartAddItemSuccessResponse';
  cartId: Scalars['ID'];
  cartItemId: Scalars['ID'];
};

/**
 * The product may not be added to the cart if its price does not match any existing item in the cart or if there are discrepancies
 * in currency or price associated with specific customer groups.
 */
export type CartAddItemUnauthorizedProductProblem = Problem & {
  __typename?: 'CartAddItemUnauthorizedProductProblem';
  message: Scalars['String'];
};

/** problem: Cart item not found */
export type CartChangeGiftItemCartItemNotFoundProblem = Problem & {
  __typename?: 'CartChangeGiftItemCartItemNotFoundProblem';
  message: Scalars['String'];
};

/** problem: Cart not found */
export type CartChangeGiftItemCartNotFoundProblem = Problem & {
  __typename?: 'CartChangeGiftItemCartNotFoundProblem';
  message: Scalars['String'];
};

/** problem: Cart not provided */
export type CartChangeGiftItemMissingCartProblem = Problem & {
  __typename?: 'CartChangeGiftItemMissingCartProblem';
  message: Scalars['String'];
};

/** problem: Status of cart item gift is the same as the one you're trying to set */
export type CartChangeGiftItemSameStatusProblem = Problem & {
  __typename?: 'CartChangeGiftItemSameStatusProblem';
  message: Scalars['String'];
};

export enum CartChannel {
  Web = 'WEB',
  App = 'APP'
}

/**
 * mutation: cart
 * action: checkout
 * problem: Request failed trying to interact with Adyen
 */
export type CartCheckoutAdyenCreateSessionProblem = Problem & {
  __typename?: 'CartCheckoutAdyenCreateSessionProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: checkout
 * problem: Missing cart for this user
 */
export type CartCheckoutNoCartForCustomerProblem = Problem & {
  __typename?: 'CartCheckoutNoCartForCustomerProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: checkout
 * problem: The customer already has an active subscription for the given planId
 */
export type CartCheckoutSubscriptionAlreadyActiveProblem = Problem & {
  __typename?: 'CartCheckoutSubscriptionAlreadyActiveProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: checkout
 * problem: Request failed trying to update the cart info
 */
export type CartCheckoutUpdateCartProblem = Problem & {
  __typename?: 'CartCheckoutUpdateCartProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: checkout
 * problem: Request failed trying to update the customer info
 */
export type CartCheckoutUpdateUserProblem = Problem & {
  __typename?: 'CartCheckoutUpdateUserProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: checkout
 * problem: Cart does not belong to this user
 */
export type CartCheckoutWrongCartOwnerProblem = Problem & {
  __typename?: 'CartCheckoutWrongCartOwnerProblem';
  message: Scalars['String'];
};

export type CartDeleteNotFoundProblem = Problem & {
  __typename?: 'CartDeleteNotFoundProblem';
  message: Scalars['String'];
};

export type CartDeleteResponse = Resource | CartDeleteNotFoundProblem;

/** Discount applied to a cart. */
export type CartDiscount = {
  __typename?: 'CartDiscount';
  id: Scalars['ID'];
  /** The code used to apply the discount. */
  code: Maybe<Scalars['String']>;
  /** The state of the applied discount. */
  state: CartDiscountState;
  /** The type of the applied discount. */
  type: CartDiscountType;
  /**
   * The amount of the applied discount.
   * 
   * If discount type is relative, amount is a percentage expressed with decimals (es. 12% will be 1200).
   * If discount type is absolute or fixed, amount is a price expressed with decimals (es. 10$ will be 1000).
   */
  amount: Scalars['Int'];
  /** Required conditions in order to apply the discount. */
  requirements: Maybe<Array<CartDiscountRequirement>>;
};

export type CartDiscountRequirement = CartDiscountRequirementMissingProduct | CartDiscountRequirementExpectedMinPrice;

export type CartDiscountRequirementExpectedMinPrice = {
  __typename?: 'CartDiscountRequirementExpectedMinPrice';
  type: CartDiscountRequirementType;
  /** Required cart's minimum price in order to apply the discount. */
  price: Scalars['Int'];
};

export type CartDiscountRequirementMissingProduct = {
  __typename?: 'CartDiscountRequirementMissingProduct';
  type: CartDiscountRequirementType;
  /** Required product inside cart in order to apply the discount. */
  product: Product;
};

export enum CartDiscountRequirementType {
  MissingProduct = 'MissingProduct',
  ExpectedMinPrice = 'ExpectedMinPrice'
}

export enum CartDiscountState {
  NotActive = 'NotActive',
  NotValid = 'NotValid',
  DoesNotMatchCart = 'DoesNotMatchCart',
  MatchesCart = 'MatchesCart',
  MaxApplicationReached = 'MaxApplicationReached',
  ApplicationStoppedByPreviousDiscount = 'ApplicationStoppedByPreviousDiscount'
}

export enum CartDiscountType {
  Relative = 'Relative',
  Absolute = 'Absolute',
  Fixed = 'Fixed',
  GiftLineItem = 'GiftLineItem'
}

export type CartLineItem = {
  __typename?: 'CartLineItem';
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  /** Price of lineitem possibly discounted. */
  price: Maybe<Price>;
  /** Price of lineitem without discount. */
  fullPrice: Maybe<Price>;
  /** Price of lineitem with possibly optional add-ons (insurance, shipping ecc...) and possibly discounted. */
  totalPrice: Maybe<Price>;
  /** Price of lineitem with possibly optional add-ons (insurance, shipping ecc...) without discounts. */
  fullTotalPrice: Maybe<Price>;
  /** Product of this lineitem will be inserted in the indicated forest. */
  forest: Maybe<Forest>;
  product: Product;
  productVariant: Maybe<ProductVariant>;
  /** Product of this item will be included in a gift process. */
  isGift: Scalars['Boolean'];
  /** Product got for free from applied discount. */
  isFreeLineItem: Maybe<Scalars['Boolean']>;
};

export type CartMutation = {
  __typename?: 'CartMutation';
  /** Adds a discount code to the cart. */
  addDiscount: AddDiscountResponse;
  /**
   * Add an item to a cart. 
   * If the cart id is not provided a new cart will be created.
   */
  addItem: AddItemResponse;
  changeCurrency: Maybe<ChangeCurrencyResponse>;
  /**
   * Update cart item gift status.
   * Indicates if the product contained on cart line item will be used for a gift.
   */
  changeGiftItem: ChangeGiftItemResponse;
  checkout: CheckoutResponse;
  /** Delete entire cart by id. When no cartId is provided, the authenticated user default cart is used */
  delete: CartDeleteResponse;
  /**
   * Recalculate the sub total of the cart.
   * If the cartId is not provided, will be referred the cart of the logged user
   */
  recalculate: RecalculateCartResponse;
  /** Release the items in the cart. */
  releaseItems: ReleaseItemsResponse;
  /** Removes a discount from the cart. */
  removeDiscount: RemoveDiscountResponse;
  /** Remove item from cart */
  removeItem: RemoveItemResponse;
  /** Reserve items before payment. */
  reserveItems: ReserveItemsResponse;
  /** Set the marketing campaign data of a cart */
  setMarketingCampaign: CartSetMarketingCampaignResponse;
  /** Set details of previously created payment. */
  setPaymentDetails: SetPaymentDetailsResponse;
  /** Set the shipping address of a cart */
  setShippingAddress: CartSetShippingAddressResponse;
  /** Set the giftable status of all the line items in this cart */
  toggleLineItemsGiftable: ToggleLineItemsGiftableResponse;
  /** Update cart item */
  updateItem: UpdateItemResponse;
};


export type CartMutationAddDiscountArgs = {
  input: AddDiscountInput;
};


export type CartMutationAddItemArgs = {
  input: AddItemInput;
};


export type CartMutationChangeCurrencyArgs = {
  cartId?: Maybe<Scalars['ID']>;
  currency: ShopCurrency;
};


export type CartMutationChangeGiftItemArgs = {
  id: Scalars['ID'];
  input: ChangeGiftItemInput;
};


export type CartMutationCheckoutArgs = {
  input: CheckoutInput;
};


export type CartMutationDeleteArgs = {
  cartId?: Maybe<Scalars['ID']>;
};


export type CartMutationRecalculateArgs = {
  input?: Maybe<RecalculateCartInput>;
};


export type CartMutationReleaseItemsArgs = {
  input?: Maybe<ReleaseItemsInput>;
};


export type CartMutationRemoveDiscountArgs = {
  input: RemoveDiscountInput;
};


export type CartMutationRemoveItemArgs = {
  id: Scalars['ID'];
  input: RemoveItemInput;
};


export type CartMutationReserveItemsArgs = {
  input?: Maybe<ReserveItemsInput>;
};


export type CartMutationSetMarketingCampaignArgs = {
  input: MarketingCampaignInput;
};


export type CartMutationSetPaymentDetailsArgs = {
  input: SetPaymentDetailsInput;
};


export type CartMutationSetShippingAddressArgs = {
  input: ShippingAddressInput;
};


export type CartMutationToggleLineItemsGiftableArgs = {
  input: ToggleLineItemsGiftableInput;
};


export type CartMutationUpdateItemArgs = {
  id: Scalars['ID'];
  input: UpdateItemInput;
};

/** Problem that occurs when the cart is not found while releasing items. */
export type CartReleaseItemsCartNotFoundProblem = Problem & {
  __typename?: 'CartReleaseItemsCartNotFoundProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the cart is not found while attempting to remove a discount. */
export type CartRemoveDiscountCartNotFoundProblem = Problem & {
  __typename?: 'CartRemoveDiscountCartNotFoundProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the discount code is not found on the current cart. */
export type CartRemoveDiscountIncorrectDiscountCodeProblem = Problem & {
  __typename?: 'CartRemoveDiscountIncorrectDiscountCodeProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the request is trying to remove a discount from a cart that does not belong to the authenticated user. */
export type CartRemoveDiscountUserMismatchProblem = Problem & {
  __typename?: 'CartRemoveDiscountUserMismatchProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: removeItem
 * problem: Cart not found
 */
export type CartRemoveItemCartNotFoundProblem = Problem & {
  __typename?: 'CartRemoveItemCartNotFoundProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: removeItem
 * problem: Cart not provided
 */
export type CartRemoveItemMissingCartProblem = Problem & {
  __typename?: 'CartRemoveItemMissingCartProblem';
  message: Scalars['String'];
};

export type CartReserveItemsCartNotFoundProblem = Problem & {
  __typename?: 'CartReserveItemsCartNotFoundProblem';
  message: Scalars['String'];
};

/** It occurs when cart items require shipping, yet no valid shipping address is present into the cart */
export type CartReserveItemsMissingRequiredShippingAddressProblem = Problem & {
  __typename?: 'CartReserveItemsMissingRequiredShippingAddressProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the a Cart with the specified cart ID does not exist. */
export type CartSetMarketingCampaignCartNotFound = Problem & {
  __typename?: 'CartSetMarketingCampaignCartNotFound';
  message: Scalars['String'];
};

export type CartSetMarketingCampaignResponse = Resource | CartSetMarketingCampaignCartNotFound | CartSetMarketingCampaignUpdateProblem | CartSetMarketingCampaignUserMismatchProblem;

/** Problem that occurs when Cart update operation fails trying to set the shipping address ID. */
export type CartSetMarketingCampaignUpdateProblem = Problem & {
  __typename?: 'CartSetMarketingCampaignUpdateProblem';
  message: Scalars['String'];
};

/** Problem that occurs when Cart does not belong to the authenticated user. */
export type CartSetMarketingCampaignUserMismatchProblem = Problem & {
  __typename?: 'CartSetMarketingCampaignUserMismatchProblem';
  message: Scalars['String'];
};

export type CartSetShippingAddressResponse = Resource | CartShippingAddressCartNotFound | CartShippingAddressUserMismatchProblem | CartShippingAddressMissingRequiredFieldsProblem | CartShippingAddressInvalidFieldsProblem | CartShippingAddressSetUpdateProblem | CartShippingAddressSetCustomerDefaultAddressProblem;

/** Problem that occurs when the a Cart with the specified cart ID does not exist. */
export type CartShippingAddressCartNotFound = Problem & {
  __typename?: 'CartShippingAddressCartNotFound';
  message: Scalars['String'];
};

export type CartShippingAddressInput = {
  /** Two-digit country code as per ISO 3166-1 alpha-2. */
  country: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  postalCode: Scalars['String'];
  city: Scalars['String'];
  streetName: Scalars['String'];
  streetNumber?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** Should include the prefix in the form +39 */
  phone?: Maybe<Scalars['String']>;
  /** Further information on the street address */
  notes?: Maybe<Scalars['String']>;
  /** Save shipping address for the Customer. We support just one address, so it's an upsert operation. */
  saveAddress?: Maybe<Scalars['Boolean']>;
  /** Company name */
  company?: Maybe<Scalars['String']>;
};

/** Problem that occurs when the shipping address has some invalid fields. */
export type CartShippingAddressInvalidFieldsProblem = Problem & {
  __typename?: 'CartShippingAddressInvalidFieldsProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the shipping address misses required fields. */
export type CartShippingAddressMissingRequiredFieldsProblem = Problem & {
  __typename?: 'CartShippingAddressMissingRequiredFieldsProblem';
  message: Scalars['String'];
};

/** Problem that occurs when Cart update operation succeeds, but there was an error updating the default shipping address for the user. */
export type CartShippingAddressSetCustomerDefaultAddressProblem = Problem & {
  __typename?: 'CartShippingAddressSetCustomerDefaultAddressProblem';
  message: Scalars['String'];
};

/** Problem that occurs when Cart update operation fails trying to set the shipping address ID. */
export type CartShippingAddressSetUpdateProblem = Problem & {
  __typename?: 'CartShippingAddressSetUpdateProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the request is trying to set a shipping address for a cart that does not belong to the authenticated user. */
export type CartShippingAddressUserMismatchProblem = Problem & {
  __typename?: 'CartShippingAddressUserMismatchProblem';
  message: Scalars['String'];
};

/** Problem that occurs when the cart is not found while attempting to set the giftable state of its line items. */
export type CartToggleLineItemsGiftableCartNotFoundProblem = Problem & {
  __typename?: 'CartToggleLineItemsGiftableCartNotFoundProblem';
  message: Scalars['String'];
};

/**
 * Problem that occurs when the request to set the giftable state for the line items of a cart fails
 * on the update operations.
 */
export type CartToggleLineItemsGiftableUpdateProblem = Problem & {
  __typename?: 'CartToggleLineItemsGiftableUpdateProblem';
  message: Scalars['String'];
};

/**
 * Problem that occurs when the request is trying to set the giftable state for the line items of a cart that
 * does not belong to the authenticated user.
 */
export type CartToggleLineItemsGiftableUserMismatchProblem = Problem & {
  __typename?: 'CartToggleLineItemsGiftableUserMismatchProblem';
  message: Scalars['String'];
};

export enum CartType {
  Default = 'DEFAULT',
  Forest = 'FOREST',
  Subscription = 'SUBSCRIPTION'
}

/**
 * mutation: cart
 * action: updateItem
 * problem: Cart item not found
 */
export type CartUpdateItemCartItemNotFoundProblem = Problem & {
  __typename?: 'CartUpdateItemCartItemNotFoundProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: updateItem
 * problem: Cart not found
 */
export type CartUpdateItemCartNotFoundProblem = Problem & {
  __typename?: 'CartUpdateItemCartNotFoundProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: updateItem
 * problem: Cart not provided
 */
export type CartUpdateItemMissingCartProblem = Problem & {
  __typename?: 'CartUpdateItemMissingCartProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: updateItem
 * problem: Product not available in inventory
 */
export type CartUpdateItemProductNotAvailableProblem = Problem & {
  __typename?: 'CartUpdateItemProductNotAvailableProblem';
  message: Scalars['String'];
};

/**
 * mutation: cart
 * action: updateItem
 * problem: Product quantity not available
 */
export type CartUpdateItemProductQuantityNotAvailableProblem = Problem & {
  __typename?: 'CartUpdateItemProductQuantityNotAvailableProblem';
  message: Scalars['String'];
};

export type ChangeAvailableRedeemsInput = {
  id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
  availableRedeems: Scalars['Int'];
};

/** The provided treecode does not exists */
export type ChangeAvailableRedeemsNotExistsProblem = Problem & {
  __typename?: 'ChangeAvailableRedeemsNotExistsProblem';
  message: Scalars['String'];
};

/** The provided treecode is not multiple and then number of available redeems cannot be updated */
export type ChangeAvailableRedeemsNotUpdatable = Problem & {
  __typename?: 'ChangeAvailableRedeemsNotUpdatable';
  message: Scalars['String'];
};

/** The provided available redeems quantity is not valid */
export type ChangeAvailableRedeemsQuantityNotValid = Problem & {
  __typename?: 'ChangeAvailableRedeemsQuantityNotValid';
  message: Scalars['String'];
};

export type ChangeAvailableRedeemsResponse = Resource | ChangeAvailableRedeemsNotExistsProblem | ChangeAvailableRedeemsNotUpdatable | ChangeAvailableRedeemsQuantityNotValid;

export type ChangeBusinessInfoInput = {
  displayName?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  billingAddress?: Maybe<Scalars['String']>;
  localizedDescription?: Maybe<OptionalTranslationInput>;
  taxId?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  certifiedEmail?: Maybe<Scalars['String']>;
  recipientCode?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  sector?: Maybe<BusinessSector>;
  department?: Maybe<BusinessDepartment>;
  companySize?: Maybe<CompanySize>;
  phone?: Maybe<Scalars['String']>;
  organizationType?: Maybe<OrganizationType>;
  city?: Maybe<Scalars['String']>;
  socialLinks?: Maybe<ChangeBusinessInfoSocialLinkInput>;
};

export type ChangeBusinessInfoInvalidInputProblem = Problem & {
  __typename?: 'ChangeBusinessInfoInvalidInputProblem';
  message: Scalars['String'];
};

export type ChangeBusinessInfoResponse = Resource | ChangeBusinessInfoInvalidInputProblem;

export type ChangeBusinessInfoSocialLinkInput = {
  facebookUrl?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  pinterestUrl?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  tiktokUrl?: Maybe<Scalars['String']>;
};

export type ChangeCommunicationKitCtaFileInput = {
  /** ISO 639-1 or BCP 47 */
  locale: Scalars['String'];
  filename: Scalars['String'];
};

export type ChangeCommunicationKitCtaFileUploadResponse = FileUpload | CommunicationKitCtaTypeMismatchProblem | CommunicationKitInvalidLocaleProblem;

export type ChangeConsentFlagsInput = {
  allowTreeNews?: Maybe<Scalars['Boolean']>;
  allowNewsletter?: Maybe<Scalars['Boolean']>;
  allowMarketing?: Maybe<Scalars['Boolean']>;
};

export type ChangeConsentFlagsResponse = Resource;

export type ChangeCurrencyCartNotFoundProblem = Problem & {
  __typename?: 'ChangeCurrencyCartNotFoundProblem';
  message: Scalars['String'];
};

export type ChangeCurrencyResponse = Resource | ChangeCurrencyUserStandardCartNotFoundProblem | ChangeCurrencyCartNotFoundProblem;

export type ChangeCurrencyUserStandardCartNotFoundProblem = Problem & {
  __typename?: 'ChangeCurrencyUserStandardCartNotFoundProblem';
  message: Scalars['String'];
};

export type ChangeGiftItemInput = {
  /**
   * Cart where item'll be update
   * Can be leaved empty if request is authenticated (will default to logged-in user's active cart)
   */
  cartId?: Maybe<Scalars['ID']>;
  /** Indicates if the product contained on cart line item will be used for a gift */
  isGift: Scalars['Boolean'];
};

export type ChangeGiftItemResponse = Resource | CartChangeGiftItemCartNotFoundProblem | CartChangeGiftItemCartItemNotFoundProblem | CartChangeGiftItemMissingCartProblem | CartChangeGiftItemSameStatusProblem;

export type ChangeIdentityProfilerIdResponse = Resource | ChangeIdentityProviderIdUserNotFoundProblem;

export type ChangeIdentityProviderIdInput = {
  identityProviderId: Scalars['String'];
};

export type ChangeIdentityProviderIdUserNotFoundProblem = Problem & {
  __typename?: 'ChangeIdentityProviderIdUserNotFoundProblem';
  message: Scalars['String'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
};

/** Provided password does not respect security constraints */
export type ChangePasswordInvalidProblem = Problem & {
  __typename?: 'ChangePasswordInvalidProblem';
  message: Scalars['String'];
};

/** Generic/Unknown error has occurred while performing the operation */
export type ChangePasswordProblem = Problem & {
  __typename?: 'ChangePasswordProblem';
  message: Scalars['String'];
};

export type ChangePasswordResponse = Resource | ChangePasswordInvalidProblem | ChangePasswordProblem;

export type ChangePaymentMethodInput = {
  /** Subscription which you want to update payment method */
  subscriptionId: Scalars['ID'];
  /** Redirect URL needed for the payment gateway UI flow, to be included in the payment session generation */
  redirectUrl?: Maybe<Scalars['String']>;
  /** User two-letter country (ex.: IT). Based on this value we have different payment methods available. */
  country?: Maybe<Scalars['String']>;
};

export type ChangePrivacyFlagsInput = {
  showInSearch?: Maybe<Scalars['Boolean']>;
  showFromHome?: Maybe<Scalars['Boolean']>;
  showLocation?: Maybe<Scalars['Boolean']>;
  showBirthday?: Maybe<Scalars['Boolean']>;
  showWall?: Maybe<Scalars['Boolean']>;
  showPeople?: Maybe<Scalars['Boolean']>;
};

export type ChangePrivacyFlagsResponse = Resource;

export type ChangeProfileDuplicatedFieldProblem = Problem & {
  __typename?: 'ChangeProfileDuplicatedFieldProblem';
  message: Scalars['String'];
  /** unique input field that cannot be updated due to a duplicate found */
  field: Scalars['String'];
};

export type ChangeProfileInput = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  /** User slug, used to define public page URL */
  slug?: Maybe<Scalars['String']>;
  /**
   * User preferred language
   * Allows ISO639-1 two-letter codes
   */
  language?: Maybe<Scalars['String']>;
  /** Allows ISO3166-1 alpha-2 codes */
  country?: Maybe<Scalars['String']>;
  /**
   * Date expressed in ISO8601 without time
   * YYYY-MM-DD
   */
  birthdate?: Maybe<Scalars['String']>;
  /** Show birthdate on public profile */
  showBirthdate?: Maybe<Scalars['Boolean']>;
  /** Location */
  location?: Maybe<Scalars['String']>;
  /** Show location on public profile */
  showLocation?: Maybe<Scalars['Boolean']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type ChangeProfileInvalidFieldProblem = Problem & {
  __typename?: 'ChangeProfileInvalidFieldProblem';
  message: Scalars['String'];
  field: Scalars['String'];
};

export type ChangeProfilePictureResponse = {
  __typename?: 'ChangeProfilePictureResponse';
  uploadUrl: Scalars['String'];
};

export type ChangeProfileResponse = Resource | ChangeProfileDuplicatedFieldProblem | ChangeProfileInvalidFieldProblem | ChangeProfileUserNotFoundProblem;

export type ChangeProfileUserNotFoundProblem = Problem & {
  __typename?: 'ChangeProfileUserNotFoundProblem';
  message: Scalars['String'];
};

/** The provided assignedOnFrom value isn't a valid date */
export type ChangeRedeemableTreeAssignedOnFromNotValid = Problem & {
  __typename?: 'ChangeRedeemableTreeAssignedOnFromNotValid';
  message: Scalars['String'];
};

/** The provided assignedOnTo value isn't a valid date */
export type ChangeRedeemableTreeAssignedOnToNotValid = Problem & {
  __typename?: 'ChangeRedeemableTreeAssignedOnToNotValid';
  message: Scalars['String'];
};

export type ChangeRedeemableTreeFindInput = {
  id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type ChangeRedeemableTreeInput = {
  assignedOnFrom?: Maybe<Scalars['Date']>;
  assignedOnTo?: Maybe<Scalars['Date']>;
};

/** The provided input value is empty */
export type ChangeRedeemableTreeNoInputProvided = Problem & {
  __typename?: 'ChangeRedeemableTreeNoInputProvided';
  message: Scalars['String'];
};

/** The provided treecode does not exists */
export type ChangeRedeemableTreeNotExistsProblem = Problem & {
  __typename?: 'ChangeRedeemableTreeNotExistsProblem';
  message: Scalars['String'];
};

/** The provided treecode isn't updatable */
export type ChangeRedeemableTreeNotUpdatable = Problem & {
  __typename?: 'ChangeRedeemableTreeNotUpdatable';
  message: Scalars['String'];
};

export type ChangeRedeemableTreeResponse = Resource | ChangeRedeemableTreeNotExistsProblem | ChangeRedeemableTreeAssignedOnFromNotValid | ChangeRedeemableTreeAssignedOnToNotValid | ChangeRedeemableTreeNotUpdatable | ChangeRedeemableTreeNoInputProvided | ChangeRedeemableTreeUnknownProblem;

/** Unknown error */
export type ChangeRedeemableTreeUnknownProblem = Problem & {
  __typename?: 'ChangeRedeemableTreeUnknownProblem';
  message: Scalars['String'];
};

export type CheckoutInput = {
  country?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  cartId?: Maybe<Scalars['ID']>;
  /**
   * the locale for payment methods and PSP cta labels.
   * locale format: "xx_YY" ex. "en_US"
   */
  locale?: Maybe<Scalars['String']>;
};

export type CheckoutResponse = CheckoutSessionResponse | CartCheckoutAdyenCreateSessionProblem | CartCheckoutNoCartForCustomerProblem | CartCheckoutUpdateUserProblem | CartCheckoutWrongCartOwnerProblem | CartCheckoutSubscriptionAlreadyActiveProblem | CartCheckoutUpdateCartProblem;

export type CheckoutSessionResponse = {
  __typename?: 'CheckoutSessionResponse';
  id: Scalars['String'];
  sessionData: Scalars['String'];
  returnUrl: Scalars['String'];
  reference: Scalars['String'];
  expiresAt: Maybe<Scalars['DateTime']>;
};

export enum ClothingColorEnum {
  Red = 'Red',
  Green = 'Green',
  Blue = 'Blue',
  Yellow = 'Yellow',
  Orange = 'Orange',
  Purple = 'Purple',
  Pink = 'Pink',
  Brown = 'Brown',
  Black = 'Black',
  White = 'White',
  Gray = 'Gray'
}

export enum ClothingFit {
  Slim = 'Slim',
  Athletic = 'Athletic',
  Regular = 'Regular',
  Loose = 'Loose',
  Oversize = 'Oversize'
}

export enum ClothingPartnerEnum {
  Rifo = 'Rifo'
}

export enum ClothingSizeEnum {
  ExtraExtraSmall = 'ExtraExtraSmall',
  ExtraSmall = 'ExtraSmall',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  ExtraLarge = 'ExtraLarge',
  ExtraExtraLarge = 'ExtraExtraLarge'
}

/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKit = CommunicationKitInterface & {
  __typename?: 'CommunicationKit';
  /** The identifier of the communication kit. */
  id: Scalars['ID'];
  /** The category of the communication kit. */
  category: Scalars['String'];
  /** The title of the communication kit. */
  title: Maybe<Scalars['String']>;
  /** The description of the communication kit. */
  description: Maybe<Scalars['String']>;
  /** The icon image of the communication kit. */
  icon: Maybe<Image>;
  /** The CTA to use when the perk is active. */
  activeCta: Maybe<CommunicationKitCta>;
  /** Requests a signed URL where to upload the communication kit active file cta */
  activeCtaFileUpload: Maybe<ChangeCommunicationKitCtaFileUploadResponse>;
  /** The type of the communication kit. Defines the behavior of the active CTA. */
  activeCtaType: CommunicationKitCtaType;
  /**
   * Requests a signed URL where to upload the communication kit icon
   * The image must be provided in the 'file' parameter
   */
  iconFileUpload: Maybe<CommunicationKitIconFileUploadResponse>;
  /** The CTA to use when the perk is inactive. */
  inactiveCta: Maybe<CommunicationKitCta>;
  /** Requests a signed URL where to upload the communication kit inactive file cta */
  inactiveCtaFileUpload: Maybe<ChangeCommunicationKitCtaFileUploadResponse>;
  /** The type of the communication kit. Defines the behavior of the inactive CTA. */
  inactiveCtaType: CommunicationKitCtaType;
  /** The internal name of the communication kit. */
  internalName: Scalars['String'];
};


/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKitTitleArgs = {
  locale: Scalars['String'];
};


/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKitDescriptionArgs = {
  locale: Scalars['String'];
};


/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKitActiveCtaArgs = {
  locale: Scalars['String'];
};


/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKitActiveCtaFileUploadArgs = {
  input: ChangeCommunicationKitCtaFileInput;
};


/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKitInactiveCtaArgs = {
  locale: Scalars['String'];
};


/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKitInactiveCtaFileUploadArgs = {
  input: ChangeCommunicationKitCtaFileInput;
};

export type CommunicationKitConnection = Connection & {
  __typename?: 'CommunicationKitConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<CommunicationKitConnectionEdge>>;
};

export type CommunicationKitConnectionEdge = Edge & {
  __typename?: 'CommunicationKitConnectionEdge';
  node: Maybe<CommunicationKit>;
  cursor: Maybe<Scalars['String']>;
};

/** A CTA (call to action) for a communication kit. */
export type CommunicationKitCta = {
  __typename?: 'CommunicationKitCta';
  /** The label of the CTA. */
  label: Scalars['String'];
  /** The URL of the CTA. */
  url: Scalars['String'];
};

/** Specifies the type of CTA used in the communication kit. */
export enum CommunicationKitCtaType {
  /** The CTA is a link to a URL. */
  File = 'FILE',
  /** The CTA is a template URL that must be rendered by the client. */
  ExternalReference = 'EXTERNAL_REFERENCE'
}

export type CommunicationKitCtaTypeMismatchProblem = Problem & {
  __typename?: 'CommunicationKitCtaTypeMismatchProblem';
  message: Scalars['String'];
};

export type CommunicationKitIconFileUploadResponse = FileUpload | CommunicationKitNotFoundProblem;

/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKitInterface = {
  /** The ID of the communication kit. */
  id: Scalars['ID'];
  /** The category of the communication kit. */
  category: Scalars['String'];
  /** The description of the communication kit. */
  description: Maybe<Scalars['String']>;
  /** The icon image of the communication kit. */
  icon: Maybe<Image>;
  /** The title of the communication kit. */
  title: Maybe<Scalars['String']>;
};


/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKitInterfaceDescriptionArgs = {
  locale: Scalars['String'];
};


/** A communication kit is a collection of content that can be accessed by a user. CTAs provide a way to access the content. */
export type CommunicationKitInterfaceTitleArgs = {
  locale: Scalars['String'];
};

export type CommunicationKitInvalidCategoryProblem = Problem & {
  __typename?: 'CommunicationKitInvalidCategoryProblem';
  message: Scalars['String'];
};

export type CommunicationKitInvalidLocaleProblem = Problem & {
  __typename?: 'CommunicationKitInvalidLocaleProblem';
  message: Scalars['String'];
};

export type CommunicationKitMutation = {
  __typename?: 'CommunicationKitMutation';
  create: Maybe<CreateCommunicationKitResponse>;
  update: Maybe<UpdateCommunicationKitResponse>;
};


export type CommunicationKitMutationCreateArgs = {
  input?: Maybe<CreateCommunicationKitInput>;
};


export type CommunicationKitMutationUpdateArgs = {
  id: Scalars['ID'];
  input: UpdateCommunicationKitInput;
};

export type CommunicationKitNotFoundProblem = Problem & {
  __typename?: 'CommunicationKitNotFoundProblem';
  message: Scalars['String'];
};

export type CommunicationKitQueryInput = {
  /** The ID of the communication kit. */
  id: Scalars['ID'];
};

/** Filters for communication kits. */
export type CommunicationKitsFilterInput = {
  /** Filter by category. */
  categories?: Maybe<Array<Scalars['String']>>;
  /** Search by title. */
  title?: Maybe<Scalars['String']>;
  /** Locale to use when searching by title. */
  locale?: Maybe<Scalars['String']>;
  /** Search by internal name. */
  internalName?: Maybe<Scalars['String']>;
};

export enum CompanySize {
  From_1To_30 = 'FROM_1_TO_30',
  From_31To_100 = 'FROM_31_TO_100',
  From_101To_500 = 'FROM_101_TO_500',
  From_501Plus = 'FROM_501_PLUS'
}

export type Connection = {
  totalCount: Scalars['Int'];
  pageInfo: Maybe<PageInfo>;
};

export type ConsentFlags = {
  __typename?: 'ConsentFlags';
  /**
   * Allow communications relative to trees
   * @deprecated Old flag, use 'treeNews' instead
   */
  allowTreeNews: Maybe<Scalars['Boolean']>;
  /**
   * Allow communications relative to Treedom newsletter
   * @deprecated Old flag, use 'newsletter' instead
   */
  allowNewsletter: Maybe<Scalars['Boolean']>;
  /**
   * Allow marketing related communications
   * @deprecated Old flag, use 'marketing' instead
   */
  allowMarketing: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the user has accepted the privacy policy.
   * True if accepted, False otherwise.
   */
  privacyPolicy: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the user has accepted the terms and conditions of the service.
   * True if accepted, False otherwise.
   */
  termsAndConditions: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the user has accepted any unfair or disadvantageous terms.
   * True if accepted, False otherwise.
   */
  unfairTerms: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the user has consented to receive newsletters via email.
   * True if consented, False otherwise.
   */
  newsletter: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the user has consented to receive general marketing communications.
   * True if consented, False otherwise.
   */
  marketing: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the user has consented to receive updates or news specifically related to tree-related activities or content.
   * True if consented, False otherwise.
   */
  treeNews: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the user has consented to receive targeted marketing communications, such as personalized ads.
   * True if consented, False otherwise.
   */
  targetedMarketing: Maybe<Scalars['Boolean']>;
};

export type ConsentLegalNoticeInput = {
  identifier: LegalNoticeIdentifier;
  version: Scalars['Int'];
};

export type ConsentPreferencesInput = {
  privacyPolicy?: Maybe<Scalars['Boolean']>;
  termsAndConditions?: Maybe<Scalars['Boolean']>;
  unfairTerms?: Maybe<Scalars['Boolean']>;
  newsletter?: Maybe<Scalars['Boolean']>;
  marketing?: Maybe<Scalars['Boolean']>;
  treeNews?: Maybe<Scalars['Boolean']>;
  targetedMarketing?: Maybe<Scalars['Boolean']>;
};

export type ConsentProofInput = {
  content: Scalars['String'];
  form: Scalars['String'];
};

export type Country = {
  __typename?: 'Country';
  /** The country code (ISO 3166-1 alpha-2). */
  code: Scalars['ID'];
  /** The slug of the country. */
  slug: Scalars['String'];
  /** The country name in the given locale. */
  name: Scalars['String'];
  flagImage: Maybe<Image>;
  countryPage: Maybe<CountryPage>;
  /** Indicates if the country has no more active projects */
  legacy: Scalars['Boolean'];
  /**
   * Legacy country identifier
   * @deprecated Use code instead
   */
  legacyId: Maybe<Scalars['Int']>;
  gdpPerCapita: Maybe<Scalars['Float']>;
  location: Maybe<Place>;
};


export type CountryNameArgs = {
  locale: Scalars['String'];
};

export type CountryInput = {
  code?: Maybe<Scalars['String']>;
};

export type CountryPage = {
  __typename?: 'CountryPage';
  /** Code of the country */
  code: Scalars['ID'];
  /** Background photo for the country */
  background: Maybe<Image>;
  /** Introduction paragraph of the country page */
  intro: CountrySection;
  /** List of paragraphs for the country page */
  content: Array<CountrySection>;
  /** Number of beneficiaries in the country */
  totalBeneficiaries: Scalars['Int'];
  /** Number of trees planted in the country */
  totalTrees: Scalars['Int'];
  /** Quote related to the country */
  quote: Maybe<CountryQuote>;
  /** Description of the project made by Treedom in the country */
  projectDescription: Scalars['String'];
  /** Impact analysis of country */
  impactAnalysis: CountryPageImpactAnalysis;
};


export type CountryPageQuoteArgs = {
  locale: Scalars['String'];
};


export type CountryPageProjectDescriptionArgs = {
  locale: Scalars['String'];
};

export type CountryPageImpactAnalysis = {
  __typename?: 'CountryPageImpactAnalysis';
  /** Introduction - Impact Analysis */
  introduction: Maybe<Scalars['String']>;
  farmersEducation: Maybe<Scalars['Float']>;
  farmersIncome: Maybe<Scalars['Float']>;
  /** Introduction - Farmers */
  farmersIntroduction: Maybe<Scalars['String']>;
  farmersWellness: Maybe<Scalars['Float']>;
  /** Score - Access to financial resources */
  partnersFinancialResources: Maybe<Scalars['Float']>;
  /** Introduction - Partners */
  partnersIntroduction: Maybe<Scalars['String']>;
  /** Score - Management and development of the organization */
  partnersOrganizationDevManagement: Maybe<Scalars['Float']>;
  /** Score - Recognition of the organization in the territory */
  partnersOrganizationRecognition: Maybe<Scalars['Float']>;
  /** Score - Good practices of sustainable agriculture */
  partnersSustainableAgriculture: Maybe<Scalars['Float']>;
  partnersStaffEducation: Maybe<Scalars['Float']>;
  partnersStaffIncome: Maybe<Scalars['Float']>;
  /** Introduction - Partners Staff */
  partnersStaffIntroduction: Maybe<Scalars['String']>;
  partnersStaffWellness: Maybe<Scalars['Float']>;
};


export type CountryPageImpactAnalysisIntroductionArgs = {
  locale: Scalars['String'];
};


export type CountryPageImpactAnalysisFarmersIntroductionArgs = {
  locale: Scalars['String'];
};


export type CountryPageImpactAnalysisPartnersIntroductionArgs = {
  locale: Scalars['String'];
};


export type CountryPageImpactAnalysisPartnersStaffIntroductionArgs = {
  locale: Scalars['String'];
};

export type CountryQuote = {
  __typename?: 'CountryQuote';
  quote: Maybe<Scalars['String']>;
  author: Maybe<Scalars['String']>;
};

export type CountrySection = {
  __typename?: 'CountrySection';
  id: Scalars['ID'];
  title: Maybe<Scalars['String']>;
  body: Maybe<Scalars['String']>;
  image: Maybe<Image>;
};


export type CountrySectionTitleArgs = {
  locale: Scalars['String'];
};


export type CountrySectionBodyArgs = {
  locale: Scalars['String'];
};

/** Input to create a billing plan. */
export type CreateBillingPlanInput = {
  name: Scalars['String'];
  duration: Scalars['Int'];
};

/** Response from creating a billing plan. */
export type CreateBillingPlanResponse = BillingPlan | BillingPlanUnknownProblem | BillingPlanNotFoundProblem | BillingPlanMissingEntriesProblem | BillingPlanEmptyNameProblem | BillingPlanDurationNotPositiveProblem | BillingPlanInvalidRenewLimitProblem;

export type CreateCapabilityGroupAlreadyExistsProblem = Problem & {
  __typename?: 'CreateCapabilityGroupAlreadyExistsProblem';
  message: Scalars['String'];
};

export type CreateCapabilityGroupInput = {
  key: Scalars['String'];
  capabilities: Array<Scalars['String']>;
};

export type CreateCapabilityGroupMalformedCapabilityProblem = Problem & {
  __typename?: 'CreateCapabilityGroupMalformedCapabilityProblem';
  message: Scalars['String'];
};

export type CreateCapabilityGroupResponse = Resource | CreateCapabilityGroupAlreadyExistsProblem | CreateCapabilityGroupMalformedCapabilityProblem;

export type CreateCommunicationKitInput = {
  internalName: Scalars['String'];
  category: Scalars['String'];
  activeCtaType: CommunicationKitCtaType;
  inactiveCtaType: CommunicationKitCtaType;
};

export type CreateCommunicationKitResponse = Resource | CommunicationKitInvalidCategoryProblem;

export type CreateFeedActivityCommentInput = {
  activityId: Scalars['ID'];
  userId: Scalars['ID'];
  content: Scalars['String'];
};

export type CreateFeedActivityCommentLikeInput = {
  commentId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type CreateFeedActivityCommentLikeResponse = Resource | FeedActivityNotFoundProblem | FeedActivityUnknownErrorProblem | FeedActivityCommentNotFoundProblem | FeedActivityLikeAlreadyExistentProblem;

export type CreateFeedActivityCommentResponse = Resource | FeedActivityUnknownErrorProblem | FeedActivityNotFoundProblem;

export type CreateFeedActivityCommentUnknownProblem = Problem & {
  __typename?: 'CreateFeedActivityCommentUnknownProblem';
  message: Scalars['String'];
};

export type CreateFeedActivityLikeInput = {
  activityId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type CreateFeedActivityLikeResponse = Resource | FeedActivityUnknownErrorProblem | FeedActivityNotFoundProblem | FeedActivityLikeAlreadyExistentProblem;

export type CreateFeedAuthorInput = {
  name: Scalars['String'];
  avatarId: Scalars['String'];
  role: Array<LocalizedValueInput>;
  archived?: Maybe<Scalars['Boolean']>;
};

export type CreateFeedAuthorResponse = Resource | FeedAuthorUnknownErrorProblem;

export type CreateFeedBanAlreadyExistsErrorProblem = Problem & {
  __typename?: 'CreateFeedBanAlreadyExistsErrorProblem';
  message: Scalars['String'];
};

export type CreateFeedBanInput = {
  userId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type CreateFeedBanResponse = Resource | CreateFeedBanAlreadyExistsErrorProblem | CreateFeedBanUnknownErrorProblem;

export type CreateFeedBanUnknownErrorProblem = Problem & {
  __typename?: 'CreateFeedBanUnknownErrorProblem';
  message: Scalars['String'];
};

export type CreateFeedPostInput = {
  internalName: Scalars['String'];
  authorId: Scalars['ID'];
  contentType: FeedPostContentType;
  isPlusContent?: Maybe<Scalars['Boolean']>;
};

export type CreateFeedPostResponse = Resource | CreateFeedPostUnknownProblem;

export type CreateFeedPostUnknownProblem = Problem & {
  __typename?: 'CreateFeedPostUnknownProblem';
  message: Scalars['String'];
};

/** No forest can be created cause the requested event type does not exits */
export type CreateForestEventTypeDoesNotExistsProblem = Problem & {
  __typename?: 'CreateForestEventTypeDoesNotExistsProblem';
  message: Scalars['String'];
};

/** Unknown error in forest create forest mutation */
export type CreateForestUnknownProblem = Problem & {
  __typename?: 'CreateForestUnknownProblem';
  message: Scalars['String'];
};

/** No forest can be created when there is already one unpublished */
export type CreateForestUnpublishedForestAlreadyExistsProblem = Problem & {
  __typename?: 'CreateForestUnpublishedForestAlreadyExistsProblem';
  message: Scalars['String'];
};

export type CreateOriginatorInput = {
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  countryCode: Scalars['String'];
  nurseryPlace: PlaceInput;
  enabled?: Maybe<Scalars['Boolean']>;
  concluded?: Maybe<Scalars['Boolean']>;
};

export type CreateOriginatorResponse = Resource;

export type CreatePartnerClientInput = {
  partnerId: Scalars['ID'];
  scopes: Array<Scalars['String']>;
};

export type CreatePartnerInput = {
  name: Scalars['String'];
};

/** Input for creating a plan. */
export type CreatePlanInput = {
  name: Scalars['String'];
  duration: Scalars['Int'];
  renewLimit: Scalars['Int'];
};

/** Problem that occurs when trying to create a plan. */
export type CreatePlanProblem = Problem & {
  __typename?: 'CreatePlanProblem';
  message: Scalars['String'];
  code: PlanProblemCode;
};

/** Response from creating a plan. */
export type CreatePlanResponse = Plan | CreatePlanProblem;

export type CreatePoolInput = {
  partnerId: Scalars['ID'];
  name: Scalars['String'];
  forestId: Scalars['String'];
  minAmount?: Maybe<Scalars['Int']>;
  maxAmount?: Maybe<Scalars['Int']>;
  targetAmount?: Maybe<Scalars['Int']>;
  currency: Scalars['String'];
  fractionDigits: Scalars['Int'];
};

/** Input to create a quotation. */
export type CreateQuotationInput = {
  /** The quote is strictly related to a cart. */
  cart: Scalars['ID'];
  /** The quote is valid for X days. Default: 7g */
  expiresAfter?: Maybe<Scalars['Int']>;
  /** Is this quote used to give away trees (for free)? Default: false */
  giveAway?: Maybe<Scalars['Boolean']>;
  /** The seller could associate a message when creating this quote */
  sellerComment?: Maybe<Scalars['String']>;
};

/** Response from creating a quotation. */
export type CreateQuotationResponse = Quotation | QuotationUnknownProblem | QuotationCartNotFoundProblem | QuotationCartUpdateProblem | QuotationInvalidExpirationProblem;

export type CreateTreecodeGiftInput = {
  /** User who's the creator of the Gift (default same as gifter) */
  creatorId?: Maybe<Scalars['ID']>;
  /** User who's the gifter of trees (default same as creator) */
  gifterId?: Maybe<Scalars['ID']>;
  /**
   * Message which'll be shown to the user during redeem process
   * If you haven't localized message, put the same for each language
   */
  redeemMessage: TranslationInput;
  /** Delivery type of the gift */
  deliveryType: DeliveryType;
  /** Language locale which'll be used during redeem process */
  locale: Scalars['String'];
  /** Username of the persone who'll get the gift */
  recipientUsername: Scalars['String'];
  /** If delivery type is EMAIL, it's the email where the gift'll be sent */
  recipientEmail?: Maybe<Scalars['String']>;
  /** If delivery type is EMAIL, it's when the email'll be sent */
  deliverAt?: Maybe<Scalars['Date']>;
  /** If delivery type is EMAIL, it's the timezone'll be used for the email delivery */
  timezone?: Maybe<Scalars['String']>;
  /** Layout associated to the gift. If delivery type is PRINT, it's the card layout associated to the gift */
  creativity: Scalars['String'];
  /** List of tree ids (tree id and registryId are both supported) which'll be associated to the gift */
  trees: Array<Scalars['String']>;
};

export type CreateTreecodePickerInput = {
  /** Quantity of treecodes to be generated */
  quantity: Scalars['Int'];
  /** Name associated with generation process */
  name: Scalars['String'];
  /** Expire date of treecodes */
  expiresAt: Scalars['Date'];
  /** If treecodes redeem's enabled or not */
  redeemEnabled: Scalars['Boolean'];
  /**
   * Message which'll be shown to the user during redeem process
   * If you haven't localized message, put the same for each language
   */
  redeemMessage: TranslationInput;
  /** If treecodes redeem will show a game */
  gameEnabled: Scalars['Boolean'];
  /** Expiration date of game associated with treecode */
  gameExpiresAt?: Maybe<Scalars['Date']>;
  /** Forest from where the user will pick the tree */
  forestId: Scalars['ID'];
  /**
   * Number of available redeems of treecodes.
   * If higher than one, treecode will be redeemable more than one time
   */
  availableRedeems: Scalars['Int'];
  /** Redeem type of treecodes */
  redeemType: TreecodeRedeemType;
  /** User who's the creator of the treecodes */
  createdBy: Scalars['ID'];
  /** User who's the gifter of trees */
  gifterId: Scalars['ID'];
  /** Filter on redeemable tree */
  redeemableTree?: Maybe<TreecodePickerRedeemableTreeInput>;
};

export type CreateTreecodeSimpleInput = {
  /** Name associated with generation process */
  name: Scalars['String'];
  /** Expire date of treecodes */
  expiresAt: Scalars['Date'];
  /** If treecodes redeem's enabled or not */
  redeemEnabled: Scalars['Boolean'];
  /**
   * Message which'll be shown to the user during redeem process
   * If you haven't localized message, put the same for each language
   */
  redeemMessage: TranslationInput;
  /** If treecodes redeem will show a game */
  gameEnabled: Scalars['Boolean'];
  /** Expiration date of game associated with treecode */
  gameExpiresAt?: Maybe<Scalars['Date']>;
  /** Forest of user where gifted trees will be picked */
  forestId?: Maybe<Scalars['ID']>;
  /** Redeem type of treecodes */
  redeemType: TreecodeRedeemType;
  /** User who's the creator of the treecodes */
  createdBy: Scalars['ID'];
  /** User who's the gifter of trees */
  gifterId: Scalars['ID'];
  /** Requested treecodes to be created */
  generationRequests: Array<TreecodeSimpleGenerationRequest>;
  /** Gift trees assigned from specific date only */
  treeAssignedOnFrom?: Maybe<Scalars['Date']>;
  /** Gift trees assigned until specific date only */
  treeAssignedOnTo?: Maybe<Scalars['Date']>;
};

export type CreateTreecodeVirginInput = {
  /** Quantity of treecodes to be generated */
  quantity: Scalars['Int'];
  /** Name associated with generation process */
  name: Scalars['String'];
  /** Expire date of treecodes */
  expiresAt: Scalars['Date'];
  /** If treecodes redeem's enabled or not */
  redeemEnabled: Scalars['Boolean'];
  /**
   * Message which'll be shown to the user during redeem process
   * If you haven't localized message, put the same for each language
   */
  redeemMessage: TranslationInput;
  /** User who will be represented as tree's planter */
  planterId?: Maybe<Scalars['ID']>;
  /** Forest where the user will plant tree */
  planterForestId?: Maybe<Scalars['ID']>;
  /**
   * Number of available redeems of treecodes.
   * If higher than one, treecode will be redeemable more than one time
   */
  availableRedeems: Scalars['Int'];
  /** Redeem type of treecodes */
  redeemType: TreecodeRedeemType;
  /** User who's the creator of the treecodes */
  createdBy: Scalars['ID'];
  /** List of tree's product user will get from redeem */
  redeemProducts: Array<TreecodeVirginRedeemProduct>;
};

export type CreateUserEmailAlreadyExistsProblem = Problem & {
  __typename?: 'CreateUserEmailAlreadyExistsProblem';
  message: Scalars['String'];
  email: Scalars['String'];
};

export type CreateUserInput = {
  identityProviderId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  userType: UserType;
  countryCode?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['Date']>;
  gender?: Maybe<Gender>;
  businessName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  socialIdentity?: Maybe<UserSocialIdentityInput>;
};

export type CreateUserMissingFieldProblem = Problem & {
  __typename?: 'CreateUserMissingFieldProblem';
  message: Scalars['String'];
  field: Scalars['String'];
};

export type CreateUserProblemUnknown = Problem & {
  __typename?: 'CreateUserProblemUnknown';
  message: Scalars['String'];
};

export type CreateUserResponse = User | CreateUserProblemUnknown | CreateUserMissingFieldProblem | CreateUserEmailAlreadyExistsProblem;

export type CustomerFeedbackCreateThreadResponse = CustomerFeedbackNotInitializedProblem | CustomerFeedbackUnknownProblem | Resource;

export type CustomerFeedbackMutation = {
  __typename?: 'CustomerFeedbackMutation';
  createThread: CustomerFeedbackCreateThreadResponse;
  prompt: CustomerFeedbackPromptResponse;
};


export type CustomerFeedbackMutationPromptArgs = {
  threadId: Scalars['ID'];
  query: Scalars['String'];
};

export type CustomerFeedbackNotInitializedProblem = Problem & {
  __typename?: 'CustomerFeedbackNotInitializedProblem';
  message: Scalars['String'];
};

export type CustomerFeedbackPromptResponse = CustomerFeedbackNotInitializedProblem | CustomerFeedbackUnknownProblem | Resource;

export type CustomerFeedbackUnknownProblem = Problem & {
  __typename?: 'CustomerFeedbackUnknownProblem';
  message: Scalars['String'];
};

export type CustomLineItem = {
  __typename?: 'CustomLineItem';
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  /** Money value of the Custom Line Item. */
  money: Maybe<Price>;
  /** Slug of the Custom Line Item. */
  slug: Maybe<Scalars['String']>;
  /** Total price of the Custom Line Item. */
  totalPrice: Maybe<Price>;
  /** Name of the Custom Line Item. */
  name: Maybe<Scalars['String']>;
};


export type CustomLineItemNameArgs = {
  locale: Scalars['String'];
};


export type DateInterval = {
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
};


export enum DayTime {
  Day = 'DAY',
  Night = 'NIGHT',
  Sunset = 'SUNSET',
  Sunrise = 'SUNRISE'
}

/** Response from deleting billing plan entry mutation. */
export type DeleteBillingPlanEntryResponse = DeleteBillingPlanEntrySuccessResponse | BillingPlanEntryUnknownProblem | BillingPlanEntryBillingPlanNotFoundProblem | BillingPlanEntryMinimumCycleProblem | BillingPlanEntryCyclesNotProgressiveProblem | BillingPlanEntryDelayNotPositiveProblem | BillingPlanEntryDelayNotProgressiveProblem | BillingPlanEntryDelayTooLongProblem | BillingPlanEntryNotValidProblem | BillingPlanEntryNotFoundProblem;

/** Response from successfully deleting billing plan entry. */
export type DeleteBillingPlanEntrySuccessResponse = {
  __typename?: 'DeleteBillingPlanEntrySuccessResponse';
  /** The identifier of the delete billing plan. */
  id: Scalars['ID'];
};

/** Response from deleting a subscription billing plan. */
export type DeleteBillingPlanResponse = Resource | BillingPlanUnknownProblem | BillingPlanNotFoundProblem | BillingPlanInUseProblem;

export type DeleteFeedActivityCommentInput = {
  activityId: Scalars['ID'];
  userId: Scalars['ID'];
  commentId: Scalars['ID'];
};

export type DeleteFeedActivityCommentLikeInput = {
  /** Comment id where from user want to remove like */
  commentId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type DeleteFeedActivityCommentLikeResponse = Resource | FeedActivityNotFoundProblem | FeedActivityUnknownErrorProblem | FeedActivityCommentNotFoundProblem | FeedActivityCommentLikeNotFoundProblem;

export type DeleteFeedActivityCommentResponse = Resource | FeedActivityUnknownErrorProblem | FeedActivityNotFoundProblem | FeedActivityCommentNotFoundProblem;

export type DeleteFeedActivityLikeInput = {
  activityId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type DeleteFeedActivityLikeResponse = Resource | FeedActivityUnknownErrorProblem | FeedActivityNotFoundProblem | FeedActivityLikeNotFoundProblem;

export type DeleteFeedBanInput = {
  userId: Scalars['ID'];
};

export type DeleteFeedBanNotFoundProblem = Problem & {
  __typename?: 'DeleteFeedBanNotFoundProblem';
  message: Scalars['String'];
};

export type DeleteFeedBanResponse = Resource | DeleteFeedBanNotFoundProblem | DeleteFeedBanUnknownErrorProblem;

export type DeleteFeedBanUnknownErrorProblem = Problem & {
  __typename?: 'DeleteFeedBanUnknownErrorProblem';
  message: Scalars['String'];
};

export type DeleteFeedPostIsPublishedProblem = Problem & {
  __typename?: 'DeleteFeedPostIsPublishedProblem';
  message: Scalars['String'];
};

export type DeleteFeedPostNotFoundProblem = Problem & {
  __typename?: 'DeleteFeedPostNotFoundProblem';
  message: Scalars['String'];
};

export type DeleteFeedPostResponse = Resource | DeleteFeedPostNotFoundProblem | DeleteFeedPostIsPublishedProblem | DeleteFeedPostUnknownProblem;

export type DeleteFeedPostUnknownProblem = Problem & {
  __typename?: 'DeleteFeedPostUnknownProblem';
  message: Scalars['String'];
};

/** A forest which is in draft can't be deleted */
export type DeleteForestInDraftProblem = Problem & {
  __typename?: 'DeleteForestInDraftProblem';
  message: Scalars['String'];
};

/** The forest with existing trees can't be deleted */
export type DeleteForestNotEmptyProblem = Problem & {
  __typename?: 'DeleteForestNotEmptyProblem';
  message: Scalars['String'];
};

/** The forest does not exits */
export type DeleteForestNotFoundProblem = Problem & {
  __typename?: 'DeleteForestNotFoundProblem';
  message: Scalars['String'];
};

export type DeleteForestResponse = Resource | DeleteForestNotFoundProblem | DeleteForestNotEmptyProblem | DeleteForestInDraftProblem | DeleteForestUserDoesNotOwnForestProblem | DeleteForestUnknownProblem;

/** Unknown error in forest delete forest mutation */
export type DeleteForestUnknownProblem = Problem & {
  __typename?: 'DeleteForestUnknownProblem';
  message: Scalars['String'];
};

/** A forest which is not owned by the requester can't be deleted */
export type DeleteForestUserDoesNotOwnForestProblem = Problem & {
  __typename?: 'DeleteForestUserDoesNotOwnForestProblem';
  message: Scalars['String'];
};

/** Problem that occurs when trying to delete product plan. */
export type DeletePlanProductProblem = Problem & {
  __typename?: 'DeletePlanProductProblem';
  message: Scalars['String'];
  code: PlanProductProblemCode;
};

/** Response from delete product plan. */
export type DeletePlanProductResponse = DeletePlanProductSuccessResponse | DeletePlanProductProblem;

/** Response from successfully deleting product plan. */
export type DeletePlanProductSuccessResponse = {
  __typename?: 'DeletePlanProductSuccessResponse';
  /** The identifier of the delete plan product. */
  id: Scalars['ID'];
};

/** Response from deleting a subscription assignment plan. */
export type DeletePlanResponse = Resource | PlanUnknownProblem | PlanNotFoundProblem | PlanInUseProblem;

/** The provided treecode is partial or entirely consumed */
export type DeleteTreecodeAlreadyConsumedProblem = Problem & {
  __typename?: 'DeleteTreecodeAlreadyConsumedProblem';
  message: Scalars['String'];
};

export type DeleteTreecodeInput = {
  id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

/** User is not authorized to delete the provided treecode */
export type DeleteTreecodeNotAuthorizedProblem = Problem & {
  __typename?: 'DeleteTreecodeNotAuthorizedProblem';
  message: Scalars['String'];
};

/** The provided treecode does not exists */
export type DeleteTreecodeNotExistsProblem = Problem & {
  __typename?: 'DeleteTreecodeNotExistsProblem';
  message: Scalars['String'];
};

/** The provided treecode has a retail associated and can not be deleted  */
export type DeleteTreecodeRetailAssociatedProblem = Problem & {
  __typename?: 'DeleteTreecodeRetailAssociatedProblem';
  message: Scalars['String'];
};

export enum DeliveryType {
  Direct = 'DIRECT',
  Email = 'EMAIL',
  Code = 'CODE',
  Print = 'PRINT'
}

export enum DisableReason {
  DuplicateProfile = 'DUPLICATE_PROFILE',
  PersonalReasons = 'PERSONAL_REASONS',
  TooManyCommunications = 'TOO_MANY_COMMUNICATIONS',
  Privacy = 'PRIVACY',
  Other = 'OTHER'
}

export type DisableUserInput = {
  reason: DisableReason;
  customMessage?: Maybe<Scalars['String']>;
};

export type DuplicatedUser = {
  __typename?: 'DuplicatedUser';
  id: Scalars['ID'];
  email: Scalars['String'];
  users: Array<User>;
};

export type DuplicatedUsersInput = {
  limit?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

export enum EcommerceCustomerGroup {
  Business = 'BUSINESS',
  Private = 'PRIVATE'
}

export enum EcommerceSort {
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  Co2Asc = 'CO2_ASC',
  Co2Desc = 'CO2_DESC'
}

export enum EcommerceSortOrder {
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  Co2Asc = 'CO2_ASC',
  Co2Desc = 'CO2_DESC'
}

export type Edge = {
  cursor: Maybe<Scalars['String']>;
};

export type ExpensesWhereConditionInput = {
  /** List of id which will be used to filter on */
  ids?: Maybe<Array<Scalars['ID']>>;
  /** List of supplier ids which will be used to filter on */
  supplierIds?: Maybe<Array<Scalars['ID']>>;
  /** List of project ids which will be used to filter on */
  projectIds?: Maybe<Array<Scalars['ID']>>;
  /** List of plan ids which will be used to filter on */
  planIds?: Maybe<Array<Scalars['ID']>>;
};

/** No treecodes found searching by args provided */
export type ExportTreecodeRedeemsListNotFoundProblem = Problem & {
  __typename?: 'ExportTreecodeRedeemsListNotFoundProblem';
  message: Scalars['String'];
};

export type ExportTreecodeRedeemsListRequestedByNotProvidedProblem = Problem & {
  __typename?: 'ExportTreecodeRedeemsListRequestedByNotProvidedProblem';
  message: Scalars['String'];
};

export type ExportTreecodeRedeemsListResponse = Resource | ExportTreecodeRedeemsListNotFoundProblem | ExportTreecodeRedeemsListUnknownProblem | ExportTreecodeRedeemsListRequestedByNotProvidedProblem;

/** Unknown error */
export type ExportTreecodeRedeemsListUnknownProblem = Problem & {
  __typename?: 'ExportTreecodeRedeemsListUnknownProblem';
  message: Scalars['String'];
};

/** No treecodes found searching by args provided */
export type ExportTreecodesListNotFoundProblem = Problem & {
  __typename?: 'ExportTreecodesListNotFoundProblem';
  message: Scalars['String'];
};

export type ExportTreecodesListRequestedByNotProvidedProblem = Problem & {
  __typename?: 'ExportTreecodesListRequestedByNotProvidedProblem';
  message: Scalars['String'];
};

export type ExportTreecodesListResponse = Resource | ExportTreecodesListNotFoundProblem | ExportTreecodesListUnknownProblem | ExportTreecodesListRequestedByNotProvidedProblem;

/** Unknown error */
export type ExportTreecodesListUnknownProblem = Problem & {
  __typename?: 'ExportTreecodesListUnknownProblem';
  message: Scalars['String'];
};

export enum ExternalDocumentType {
  Invoice = 'INVOICE',
  Receipt = 'RECEIPT',
  Other = 'OTHER'
}

export type FeaturedTree = {
  __typename?: 'FeaturedTree';
  tree: Tree;
  updatedAt: Scalars['DateTime'];
  kind: Array<FeaturedTreeKind>;
};

export enum FeaturedTreeKind {
  Redeem = 'REDEEM',
  Purchase = 'PURCHASE',
  Status = 'STATUS'
}

export type Feed = {
  key: Scalars['String'];
  followerCount: Scalars['Int'];
};

export type FeedActivity = {
  id: Scalars['ID'];
  publishDate: Scalars['DateTime'];
  origin: Feed;
};

export type FeedActivityCommentLikeMutation = {
  __typename?: 'FeedActivityCommentLikeMutation';
  create: Maybe<CreateFeedActivityCommentLikeResponse>;
  delete: Maybe<DeleteFeedActivityCommentLikeResponse>;
};


export type FeedActivityCommentLikeMutationCreateArgs = {
  input: CreateFeedActivityCommentLikeInput;
};


export type FeedActivityCommentLikeMutationDeleteArgs = {
  input: DeleteFeedActivityCommentLikeInput;
};

export type FeedActivityCommentLikeNotFoundProblem = Problem & {
  __typename?: 'FeedActivityCommentLikeNotFoundProblem';
  message: Scalars['String'];
};

export type FeedActivityCommentMutation = {
  __typename?: 'FeedActivityCommentMutation';
  create: CreateFeedActivityCommentResponse;
  delete: Maybe<DeleteFeedActivityCommentResponse>;
  like: Maybe<FeedActivityCommentLikeMutation>;
  reportAbuse: ReportAbuseCommentResponse;
  update: Maybe<UpdateFeedActivityCommentResponse>;
};


export type FeedActivityCommentMutationCreateArgs = {
  input: CreateFeedActivityCommentInput;
};


export type FeedActivityCommentMutationDeleteArgs = {
  input: DeleteFeedActivityCommentInput;
};


export type FeedActivityCommentMutationReportAbuseArgs = {
  input: ReportAbuseCommentInput;
};


export type FeedActivityCommentMutationUpdateArgs = {
  input: UpdateFeedActivityCommentInput;
};

export type FeedActivityCommentNotFoundProblem = Problem & {
  __typename?: 'FeedActivityCommentNotFoundProblem';
  message: Scalars['String'];
};

export type FeedActivityCommentUpdateNoChangesProblem = Problem & {
  __typename?: 'FeedActivityCommentUpdateNoChangesProblem';
  message: Scalars['String'];
};

export type FeedActivityLikeAlreadyExistentProblem = Problem & {
  __typename?: 'FeedActivityLikeAlreadyExistentProblem';
  message: Scalars['String'];
};

export type FeedActivityLikeMutation = {
  __typename?: 'FeedActivityLikeMutation';
  create: Maybe<CreateFeedActivityLikeResponse>;
  delete: Maybe<DeleteFeedActivityLikeResponse>;
};


export type FeedActivityLikeMutationCreateArgs = {
  input: CreateFeedActivityLikeInput;
};


export type FeedActivityLikeMutationDeleteArgs = {
  input: DeleteFeedActivityLikeInput;
};

export type FeedActivityLikeNotFoundProblem = Problem & {
  __typename?: 'FeedActivityLikeNotFoundProblem';
  message: Scalars['String'];
};

export type FeedActivityMutation = {
  __typename?: 'FeedActivityMutation';
  comment: FeedActivityCommentMutation;
  like: Maybe<FeedActivityLikeMutation>;
  quiz: Maybe<FeedActivityQuizMutation>;
  unfollow: UnfollowFeedActivityResponse;
};


export type FeedActivityMutationUnfollowArgs = {
  userId: Scalars['ID'];
  activityId: Scalars['ID'];
};

export type FeedActivityNotFoundProblem = Problem & {
  __typename?: 'FeedActivityNotFoundProblem';
  message: Scalars['String'];
};

export type FeedActivityNotValidTypeProblem = Problem & {
  __typename?: 'FeedActivityNotValidTypeProblem';
  message: Scalars['String'];
};

export type FeedActivityPost = FeedActivity & {
  __typename?: 'FeedActivityPost';
  id: Scalars['ID'];
  publishDate: Scalars['DateTime'];
  origin: Feed;
  author: FeedAuthor;
  /** List of activity comments. */
  comments: FeedActivityPostCommentsConnection;
  content: Maybe<FeedContent>;
  /** Indicates if user liked the activity */
  hasLike: Scalars['Boolean'];
  internalName: Scalars['String'];
  isAccessible: Scalars['Boolean'];
  isPlusContent: Scalars['Boolean'];
  /** List of activity likes. If you want to search for like of specific user, you can filter by where.userId. */
  likes: FeedActivityPostLikeConnection;
};


export type FeedActivityPostCommentsArgs = {
  where?: Maybe<FeedActivityPostCommentFilterInput>;
  pagination?: Maybe<PaginationInput>;
};


export type FeedActivityPostHasLikeArgs = {
  userId: Scalars['ID'];
};


export type FeedActivityPostLikesArgs = {
  where?: Maybe<FeedActivityPostLikeFilterInput>;
  pagination?: Maybe<PaginationInput>;
};

export type FeedActivityPostComment = {
  __typename?: 'FeedActivityPostComment';
  id: Scalars['ID'];
  /** Parent activityId of comment */
  activityId: Scalars['ID'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /**
   * **Not actually deprecated.**
   * 
   * Reference to the feed post that this comment is associated with.
   * 
   * This field should only be used by internal services.
   * 
   * ![Image for grabbing attention!](https://assets.treedom.net/image/upload/v1712567864/samples/warning.png)
   * @deprecated Read description for more information.
   */
  feedPostId: Scalars['ID'];
  /** Indicates if user liked the comment */
  hasLike: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  /** The user who posted the comment */
  user: User;
  /** List of comment likes. If you want to search for like of specific user, you can filter by where.userId. */
  likes: FeedActivityPostLikeConnection;
};


export type FeedActivityPostCommentHasLikeArgs = {
  userId: Scalars['ID'];
};


export type FeedActivityPostCommentLikesArgs = {
  where?: Maybe<FeedActivityPostCommentLikeFilterInput>;
  pagination?: Maybe<PaginationInput>;
};

export type FeedActivityPostCommentConnection = Connection & {
  __typename?: 'FeedActivityPostCommentConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<FeedActivityPostCommentConnectionEdge>>;
};

export type FeedActivityPostCommentConnectionEdge = Edge & {
  __typename?: 'FeedActivityPostCommentConnectionEdge';
  node: Maybe<FeedActivityPostComment>;
  cursor: Maybe<Scalars['String']>;
};

export type FeedActivityPostCommentEdge = Edge & {
  __typename?: 'FeedActivityPostCommentEdge';
  node: Maybe<FeedActivityPostComment>;
  cursor: Maybe<Scalars['String']>;
};

export type FeedActivityPostCommentFilterInput = {
  userId?: Maybe<Scalars['ID']>;
};

export type FeedActivityPostCommentLikeFilterInput = {
  userId?: Maybe<Scalars['ID']>;
};

export type FeedActivityPostCommentsConnection = StreamConnection & {
  __typename?: 'FeedActivityPostCommentsConnection';
  totalCount: Scalars['Int'];
  pageInfo: StreamPageInfo;
  edges: Array<Maybe<FeedActivityPostCommentEdge>>;
};

export type FeedActivityPostCommentsFilterInput = {
  feedPostId?: Maybe<Array<Scalars['ID']>>;
  userId?: Maybe<Array<Scalars['ID']>>;
  createdBefore?: Maybe<Scalars['DateTime']>;
};

export enum FeedActivityPostCommentsSortInput {
  /** Sort by creation, ascending. */
  CreationAsc = 'CREATION_ASC',
  /** Sort by creation, descending. */
  CreationDesc = 'CREATION_DESC',
  /** Sort by last abuse report date, descending. */
  LastAbuseReportDesc = 'LAST_ABUSE_REPORT_DESC',
  /** Sort by last abuse report date, ascending. */
  LastAbuseReportAsc = 'LAST_ABUSE_REPORT_ASC'
}

export type FeedActivityPostLike = {
  __typename?: 'FeedActivityPostLike';
  id: Scalars['ID'];
  user: User;
  createdAt: Scalars['DateTime'];
};

export type FeedActivityPostLikeConnection = StreamConnection & {
  __typename?: 'FeedActivityPostLikeConnection';
  totalCount: Scalars['Int'];
  pageInfo: StreamPageInfo;
  edges: Array<Maybe<FeedActivityPostLikeEdge>>;
};

export type FeedActivityPostLikeEdge = Edge & {
  __typename?: 'FeedActivityPostLikeEdge';
  node: Maybe<FeedActivityPostLike>;
  cursor: Maybe<Scalars['String']>;
};

export type FeedActivityPostLikeFilterInput = {
  userId?: Maybe<Scalars['ID']>;
};

export type FeedActivityQuizAnswerNotValidProblem = Problem & {
  __typename?: 'FeedActivityQuizAnswerNotValidProblem';
  message: Scalars['String'];
};

export type FeedActivityQuizMutation = {
  __typename?: 'FeedActivityQuizMutation';
  answer: Maybe<AnswerFeedActivityQuizResponse>;
};


export type FeedActivityQuizMutationAnswerArgs = {
  input: AnswerFeedActivityQuizInput;
};

export type FeedActivityReactionCounts = {
  __typename?: 'FeedActivityReactionCounts';
  like: Maybe<Scalars['Int']>;
  comment: Maybe<Scalars['Int']>;
};

export type FeedActivityUnknownErrorProblem = Problem & {
  __typename?: 'FeedActivityUnknownErrorProblem';
  message: Scalars['String'];
};

export type FeedAuthor = {
  __typename?: 'FeedAuthor';
  id: Scalars['ID'];
  /** If author was archived and is no more active */
  archived: Scalars['Boolean'];
  /** Avatar of author */
  avatar: Image;
  /** Get a signed upload url which could be used to upload a new avatar image */
  avatarUpload: FileUpload;
  createdAt: Scalars['DateTime'];
  /** Name of author */
  name: Scalars['String'];
  /** Role of author */
  role: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type FeedAuthorRoleArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type FeedAuthorConnection = Connection & {
  __typename?: 'FeedAuthorConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<FeedAuthorConnectionEdge>>;
};

export type FeedAuthorConnectionEdge = Edge & {
  __typename?: 'FeedAuthorConnectionEdge';
  node: Maybe<FeedAuthor>;
  cursor: Maybe<Scalars['String']>;
};

export type FeedAuthorMutation = {
  __typename?: 'FeedAuthorMutation';
  create: Maybe<CreateFeedAuthorResponse>;
  update: Maybe<UpdateFeedAuthorResponse>;
};


export type FeedAuthorMutationCreateArgs = {
  input: CreateFeedAuthorInput;
};


export type FeedAuthorMutationUpdateArgs = {
  id: Scalars['ID'];
  input: UpdateFeedAuthorInput;
};

export type FeedAuthorNotFoundProblem = Problem & {
  __typename?: 'FeedAuthorNotFoundProblem';
  message: Scalars['String'];
};

export type FeedAuthorQueryInput = {
  /** The ID of the feed author. */
  id: Scalars['ID'];
};

/** Filters for feed authors. */
export type FeedAuthorsFilterInput = {
  /** Filter by name. */
  name?: Maybe<Scalars['String']>;
  /** Filter by archived. */
  archived?: Maybe<Scalars['Boolean']>;
};

export type FeedAuthorUnknownErrorProblem = Problem & {
  __typename?: 'FeedAuthorUnknownErrorProblem';
  message: Scalars['String'];
};

export type FeedAuthorUpdateNoArgsProvidedProblem = Problem & {
  __typename?: 'FeedAuthorUpdateNoArgsProvidedProblem';
  message: Scalars['String'];
};

export type FeedBanMutation = {
  __typename?: 'FeedBanMutation';
  create: CreateFeedBanResponse;
  delete: DeleteFeedBanResponse;
};


export type FeedBanMutationCreateArgs = {
  input: CreateFeedBanInput;
};


export type FeedBanMutationDeleteArgs = {
  input: DeleteFeedBanInput;
};

export type FeedContent = {
  /** Content message */
  message: Maybe<Scalars['String']>;
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Feed content title */
  title: Maybe<Scalars['String']>;
};


export type FeedContentMessageArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type FeedContentTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type FeedContentGallery = FeedContent & {
  __typename?: 'FeedContentGallery';
  /** Feed post images gallery */
  gallery: Array<Image>;
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Content message */
  message: Maybe<Scalars['String']>;
  /** Feed content title */
  title: Maybe<Scalars['String']>;
};


export type FeedContentGalleryMessageArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type FeedContentGalleryTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type FeedContentGalleryStaged = FeedContentStaged & {
  __typename?: 'FeedContentGalleryStaged';
  /** Feed post images gallery */
  gallery: Maybe<Array<Image>>;
  /** Get a signed upload url which could be used to upload a new gallery image */
  galleryUploadUrl: FileUpload;
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Get a signed upload url which could be used to upload a new hero image */
  heroImageUploadUrl: FileUpload;
  /** Content message */
  message: Maybe<Scalars['String']>;
  /** Feed content title */
  title: Maybe<Scalars['String']>;
};


export type FeedContentGalleryStagedMessageArgs = {
  locale: Scalars['String'];
};


export type FeedContentGalleryStagedTitleArgs = {
  locale: Scalars['String'];
};

export type FeedContentQuiz = FeedContent & {
  __typename?: 'FeedContentQuiz';
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Content message */
  message: Maybe<Scalars['String']>;
  /** Feed post quiz answers */
  quizAnswers: Array<FeedQuizAnswer>;
  /** Feed content quiz question */
  quizQuestion: Scalars['String'];
  /** Feed content title */
  title: Maybe<Scalars['String']>;
};


export type FeedContentQuizMessageArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type FeedContentQuizQuizAnswersArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type FeedContentQuizQuizQuestionArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type FeedContentQuizTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type FeedContentQuizStaged = FeedContentStaged & {
  __typename?: 'FeedContentQuizStaged';
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Get a signed upload url which could be used to upload a new hero image */
  heroImageUploadUrl: FileUpload;
  /** Content message */
  message: Maybe<Scalars['String']>;
  /** Feed post quiz answers */
  quizAnswers: Array<FeedQuizAnswerStaged>;
  /** Feed content quiz question */
  quizQuestion: Maybe<Scalars['String']>;
  /** Feed content title */
  title: Maybe<Scalars['String']>;
};


export type FeedContentQuizStagedMessageArgs = {
  locale: Scalars['String'];
};


export type FeedContentQuizStagedQuizAnswersArgs = {
  locale: Scalars['String'];
};


export type FeedContentQuizStagedQuizQuestionArgs = {
  locale: Scalars['String'];
};


export type FeedContentQuizStagedTitleArgs = {
  locale: Scalars['String'];
};

export type FeedContentStaged = {
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Get a signed upload url which could be used to upload a new hero image */
  heroImageUploadUrl: FileUpload;
  /** Message content */
  message: Maybe<Scalars['String']>;
  /** Feed content title */
  title: Maybe<Scalars['String']>;
};


export type FeedContentStagedMessageArgs = {
  locale: Scalars['String'];
};


export type FeedContentStagedTitleArgs = {
  locale: Scalars['String'];
};

export type FeedContentText = FeedContent & {
  __typename?: 'FeedContentText';
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Content message */
  message: Maybe<Scalars['String']>;
  /** Feed content title */
  title: Maybe<Scalars['String']>;
};


export type FeedContentTextMessageArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type FeedContentTextTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type FeedContentTextStaged = FeedContentStaged & {
  __typename?: 'FeedContentTextStaged';
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Get a signed upload url which could be used to upload a new hero image */
  heroImageUploadUrl: FileUpload;
  /** Content message */
  message: Maybe<Scalars['String']>;
  /** Feed content title */
  title: Maybe<Scalars['String']>;
};


export type FeedContentTextStagedMessageArgs = {
  locale: Scalars['String'];
};


export type FeedContentTextStagedTitleArgs = {
  locale: Scalars['String'];
};

export type FeedContentVideo = FeedContent & {
  __typename?: 'FeedContentVideo';
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Content message */
  message: Maybe<Scalars['String']>;
  /** Feed content title */
  title: Maybe<Scalars['String']>;
  /** Feed content video */
  videoUrl: Scalars['String'];
};


export type FeedContentVideoMessageArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type FeedContentVideoTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type FeedContentVideoStaged = FeedContentStaged & {
  __typename?: 'FeedContentVideoStaged';
  /** Feed content image */
  heroImage: Maybe<Image>;
  /** Get a signed upload url which could be used to upload a new hero image */
  heroImageUploadUrl: FileUpload;
  /** Content message */
  message: Maybe<Scalars['String']>;
  /** Feed content title */
  title: Maybe<Scalars['String']>;
  /** Feed content video */
  videoUrl: Maybe<Scalars['String']>;
};


export type FeedContentVideoStagedMessageArgs = {
  locale: Scalars['String'];
};


export type FeedContentVideoStagedTitleArgs = {
  locale: Scalars['String'];
};

export type FeedCountry = Feed & {
  __typename?: 'FeedCountry';
  key: Scalars['String'];
  followerCount: Scalars['Int'];
  country: Country;
};

export type FeedForest = Feed & {
  __typename?: 'FeedForest';
  key: Scalars['String'];
  followerCount: Scalars['Int'];
  forest: Forest;
};

export enum FeedGroup {
  Country = 'COUNTRY',
  Forest = 'FOREST',
  Horoscope = 'HOROSCOPE',
  Impact = 'IMPACT',
  Organization = 'ORGANIZATION',
  Project = 'PROJECT',
  Specie = 'SPECIE',
  UserCategory = 'USER_CATEGORY'
}

export type FeedHoroscope = Feed & {
  __typename?: 'FeedHoroscope';
  key: Scalars['String'];
  followerCount: Scalars['Int'];
  horoscope: ZodiacSign;
};

export type FeedImpact = Feed & {
  __typename?: 'FeedImpact';
  key: Scalars['String'];
  followerCount: Scalars['Int'];
  impact: Impact;
};

export type FeedInput = {
  subject: Scalars['ID'];
  group: FeedGroup;
};

export type FeedNotificationMutation = {
  __typename?: 'FeedNotificationMutation';
  /** Marks the notifications as read. */
  markRead: MarkReadFeedNotificationResponse;
  /** Marks the notifications as seen. */
  markSeen: MarkSeenFeedNotificationResponse;
};


export type FeedNotificationMutationMarkReadArgs = {
  input: MarkReadFeedNotificationInput;
};


export type FeedNotificationMutationMarkSeenArgs = {
  input: MarkSeenFeedNotificationInput;
};

export type FeedOrganization = Feed & {
  __typename?: 'FeedOrganization';
  key: Scalars['String'];
  followerCount: Scalars['Int'];
  organization: User;
};

export type FeedPost = {
  __typename?: 'FeedPost';
  id: Scalars['ID'];
  contentType: FeedPostContentType;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  /** Feed post internal name */
  internalName: Scalars['String'];
  /** If feed post has changes that still need to be applied */
  isChanged: Scalars['Boolean'];
  /** If feed post is published */
  isPublished: Scalars['Boolean'];
  /** When publish is scheduled */
  publishScheduledAt: Maybe<Scalars['DateTime']>;
  published: Maybe<FeedPostPublished>;
  publishedBy: Maybe<User>;
  staged: FeedPostStaged;
  /** Feed post status */
  status: FeedPostStatus;
  /** When unpublish is scheduled */
  unpublishScheduledAt: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  updatedBy: User;
};

export type FeedPostAlreadyPublishedProblem = Problem & {
  __typename?: 'FeedPostAlreadyPublishedProblem';
  message: Scalars['String'];
};

export type FeedPostConnection = Connection & {
  __typename?: 'FeedPostConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<FeedPostConnectionEdge>>;
};

export type FeedPostConnectionEdge = Edge & {
  __typename?: 'FeedPostConnectionEdge';
  node: Maybe<FeedPost>;
  cursor: Maybe<Scalars['String']>;
};

export enum FeedPostContentType {
  Text = 'TEXT',
  Video = 'VIDEO',
  Gallery = 'GALLERY',
  Quiz = 'QUIZ'
}

export type FeedPostHasNoFeedsProblem = Problem & {
  __typename?: 'FeedPostHasNoFeedsProblem';
  message: Scalars['String'];
};

export type FeedPostMutation = {
  __typename?: 'FeedPostMutation';
  create: CreateFeedPostResponse;
  delete: DeleteFeedPostResponse;
  publish: Maybe<FeedPostPublishResponse>;
  unpublish: Maybe<FeedPostUnpublishResponse>;
  unschedulePublish: Maybe<UnschedulePublishResponse>;
  unscheduleUnpublish: Maybe<UnscheduleUnpublishResponse>;
  updateGallery: UpdateFeedPostGalleryResponse;
  updateQuiz: UpdateFeedPostQuizResponse;
  updateText: UpdateFeedPostTextResponse;
  updateVideo: UpdateFeedPostVideoResponse;
};


export type FeedPostMutationCreateArgs = {
  input: CreateFeedPostInput;
};


export type FeedPostMutationDeleteArgs = {
  id: Scalars['ID'];
};


export type FeedPostMutationPublishArgs = {
  id: Scalars['ID'];
  scheduleDate?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['ID']>;
};


export type FeedPostMutationUnpublishArgs = {
  id: Scalars['ID'];
  scheduleDate?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['ID']>;
};


export type FeedPostMutationUnschedulePublishArgs = {
  id: Scalars['ID'];
};


export type FeedPostMutationUnscheduleUnpublishArgs = {
  id: Scalars['ID'];
};


export type FeedPostMutationUpdateGalleryArgs = {
  id: Scalars['ID'];
  input: UpdateFeedPostGalleryInput;
};


export type FeedPostMutationUpdateQuizArgs = {
  id: Scalars['ID'];
  input: UpdateFeedPostQuizInput;
};


export type FeedPostMutationUpdateTextArgs = {
  id: Scalars['ID'];
  input: UpdateFeedPostTextInput;
};


export type FeedPostMutationUpdateVideoArgs = {
  id: Scalars['ID'];
  input: UpdateFeedPostVideoInput;
};

export type FeedPostNeedsUnpublishingFirstProblem = Problem & {
  __typename?: 'FeedPostNeedsUnpublishingFirstProblem';
  message: Scalars['String'];
};

export type FeedPostNotFoundProblem = Problem & {
  __typename?: 'FeedPostNotFoundProblem';
  message: Scalars['String'];
};

export type FeedPostNotPublishedProblem = Problem & {
  __typename?: 'FeedPostNotPublishedProblem';
  message: Scalars['String'];
};

export type FeedPostNotUnpublishedProblem = Problem & {
  __typename?: 'FeedPostNotUnpublishedProblem';
  message: Scalars['String'];
};

export type FeedPostPublished = {
  __typename?: 'FeedPostPublished';
  /** Feed post author */
  author: Maybe<FeedAuthor>;
  /** Feed post published content */
  content: Maybe<FeedContent>;
  feeds: Array<Feed>;
  /** If feed post is plus content */
  isPlusContent: Scalars['Boolean'];
  /** When feed post was published */
  publishDate: Scalars['DateTime'];
};

export type FeedPostPublishResponse = Resource | FeedPostNotFoundProblem | FeedPostAlreadyPublishedProblem | FeedPostNotPublishedProblem | FeedPostHasNoFeedsProblem | FeedPostNeedsUnpublishingFirstProblem;

/** Filters for feed posts. */
export type FeedPostsFilterInput = {
  /** Filter by title. */
  title?: Maybe<LocalizedFilterInput>;
  /** Filter by internal name. */
  internalName?: Maybe<Scalars['String']>;
  /** Filter by published status. */
  published?: Maybe<Scalars['Boolean']>;
  /** Filter by changes status. */
  changed?: Maybe<Scalars['Boolean']>;
};

export type FeedPostStaged = {
  __typename?: 'FeedPostStaged';
  /** Feed post author */
  author: Maybe<FeedAuthor>;
  /** Feed post staged content which has to be published */
  content: FeedContentStaged;
  feeds: Array<Feed>;
  /** If feed post is plus content */
  isPlusContent: Scalars['Boolean'];
  /** When feed post was published */
  publishDate: Maybe<Scalars['DateTime']>;
};

export enum FeedPostStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Changed = 'CHANGED'
}

export type FeedPostUnpublishResponse = Resource | FeedPostNotFoundProblem | FeedPostNotPublishedProblem | FeedPostNotUnpublishedProblem;

export type FeedProject = Feed & {
  __typename?: 'FeedProject';
  key: Scalars['String'];
  followerCount: Scalars['Int'];
  project: Project;
};

export type FeedQuizAnswer = {
  __typename?: 'FeedQuizAnswer';
  /** Key identifier of answer */
  key: Scalars['String'];
  /** Localized content of answer  */
  content: Scalars['String'];
  /** Localized reason of answer (additional information)  */
  reason: Scalars['String'];
  /** If answer is correct or not */
  isCorrect: Scalars['Boolean'];
  /** Indicates if user chose this answer */
  isUserAnswer: Scalars['Boolean'];
};


export type FeedQuizAnswerIsUserAnswerArgs = {
  userId: Scalars['ID'];
};

export type FeedQuizAnswerStaged = {
  __typename?: 'FeedQuizAnswerStaged';
  /** Key identifier of answer */
  key: Scalars['String'];
  /** Localized content of answer  */
  content: Maybe<Scalars['String']>;
  /** Localized reason of answer (additional information)  */
  reason: Maybe<Scalars['String']>;
  /** If answer is correct or not */
  isCorrect: Scalars['Boolean'];
};

export type FeedSpecie = Feed & {
  __typename?: 'FeedSpecie';
  key: Scalars['String'];
  followerCount: Scalars['Int'];
  specie: ScientificSpecie;
};

export type FeedUserCategory = Feed & {
  __typename?: 'FeedUserCategory';
  key: Scalars['String'];
  followerCount: Scalars['Int'];
  userCategory: UserCategory;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  /** Url to be used for the signed url file upload */
  url: Scalars['String'];
  /** Method to be used for the signed url file upload */
  method: FileUploadMethod;
};

export enum FileUploadMethod {
  Post = 'POST',
  Put = 'PUT'
}

export type FinanceExpense = {
  __typename?: 'FinanceExpense';
  id: Scalars['ID'];
  /** The procurement plan related to this expense */
  plan: ProcurementPlan;
  /** The project related to this expense */
  project: ProcurementProject;
  /** The project specie related to this expense */
  projectSpecie: ProjectSpecie;
  /** The total cost based on number of items and price of single item */
  totalCost: Maybe<Scalars['Float']>;
  /** The number of items for the combination of planId and projectSpecieId */
  totalItems: Scalars['Int'];
};

export type FinanceExpensesConnection = Connection & {
  __typename?: 'FinanceExpensesConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<FinanceExpensesEdge>>;
  pageInfo: PageInfo;
};

export type FinanceExpensesEdge = Edge & {
  __typename?: 'FinanceExpensesEdge';
  cursor: Scalars['String'];
  node: Maybe<FinanceExpense>;
};

export type FinancePayment = {
  __typename?: 'FinancePayment';
  id: Scalars['ID'];
  externalDocumentId: Maybe<Scalars['String']>;
  externalDocumentType: Maybe<ExternalDocumentType>;
  notes: Maybe<Scalars['String']>;
  paid: Maybe<Scalars['Float']>;
  plan: ProcurementPlan;
  supplier: Maybe<Supplier>;
};

export type FinancePaymentInsertMutationInput = {
  planId: Scalars['ID'];
  paid: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  externalDocumentId?: Maybe<Scalars['String']>;
  externalDocumentType?: Maybe<ExternalDocumentType>;
};

export type FinancePaymentInsertUnknownErrorProblem = Problem & {
  __typename?: 'FinancePaymentInsertUnknownErrorProblem';
  message: Scalars['String'];
};

export type FinancePaymentMutation = {
  __typename?: 'FinancePaymentMutation';
  insert: InsertFinancePaymentMutationResponse;
  update: UpdateFinancePaymentMutationResponse;
};


export type FinancePaymentMutationInsertArgs = {
  input: FinancePaymentInsertMutationInput;
};


export type FinancePaymentMutationUpdateArgs = {
  id: Scalars['ID'];
  input: FinancePaymentUpdateMutationInput;
};

export type FinancePaymentNotExistsProblem = Problem & {
  __typename?: 'FinancePaymentNotExistsProblem';
  message: Scalars['String'];
};

export type FinancePaymentProcurementPlanNotFoundProblem = Problem & {
  __typename?: 'FinancePaymentProcurementPlanNotFoundProblem';
  message: Scalars['String'];
};

export type FinancePaymentsConnection = Connection & {
  __typename?: 'FinancePaymentsConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<FinancePaymentsEdge>>;
  pageInfo: PageInfo;
};

export type FinancePaymentsEdge = Edge & {
  __typename?: 'FinancePaymentsEdge';
  cursor: Scalars['String'];
  node: Maybe<FinancePayment>;
};

export type FinancePaymentUpdateMutationInput = {
  planId?: Maybe<Scalars['ID']>;
  externalDocumentId?: Maybe<Scalars['String']>;
  externalDocumentType?: Maybe<ExternalDocumentType>;
  notes?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['Float']>;
};

export type FinancePaymentUpdateUnknownErrorProblem = Problem & {
  __typename?: 'FinancePaymentUpdateUnknownErrorProblem';
  message: Scalars['String'];
};

export type FinancePaymentUpdateVoidInputProblem = Problem & {
  __typename?: 'FinancePaymentUpdateVoidInputProblem';
  message: Scalars['String'];
};

export type FinancePriceMutation = {
  __typename?: 'FinancePriceMutation';
  upsert: UpsertFinancePriceMutationResponse;
};


export type FinancePriceMutationUpsertArgs = {
  input: FinancePriceMutationInput;
};

export type FinancePriceMutationInput = {
  planId: Scalars['ID'];
  projectSpecieId: Scalars['ID'];
  price: Scalars['Float'];
};

export type FinancePriceUpsertPriceTooHighProblem = Problem & {
  __typename?: 'FinancePriceUpsertPriceTooHighProblem';
  message: Scalars['String'];
};

export type FinancePriceUpsertProcurementPlanNotFoundProblem = Problem & {
  __typename?: 'FinancePriceUpsertProcurementPlanNotFoundProblem';
  message: Scalars['String'];
};

export type FinancePriceUpsertProjectSpecieNotFoundProblem = Problem & {
  __typename?: 'FinancePriceUpsertProjectSpecieNotFoundProblem';
  message: Scalars['String'];
};

export type FinancePriceUpsertUnknownErrorProblem = Problem & {
  __typename?: 'FinancePriceUpsertUnknownErrorProblem';
  message: Scalars['String'];
};

export type FinanceSupplierAlreadyExistsProblem = Problem & {
  __typename?: 'FinanceSupplierAlreadyExistsProblem';
  message: Scalars['String'];
};

export type FinanceSupplierInsertMutationInput = {
  name: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
};

export type FinanceSupplierInsertUnknownErrorProblem = Problem & {
  __typename?: 'FinanceSupplierInsertUnknownErrorProblem';
  message: Scalars['String'];
};

export type FinanceSupplierMutation = {
  __typename?: 'FinanceSupplierMutation';
  insert: InsertFinanceSupplierMutationResponse;
  update: UpdateFinanceSupplierMutationResponse;
};


export type FinanceSupplierMutationInsertArgs = {
  input: FinanceSupplierInsertMutationInput;
};


export type FinanceSupplierMutationUpdateArgs = {
  id: Scalars['ID'];
  input: FinanceSupplierUpdateMutationInput;
};

export type FinanceSupplierNameAlreadyExistsProblem = Problem & {
  __typename?: 'FinanceSupplierNameAlreadyExistsProblem';
  message: Scalars['String'];
};

export type FinanceSupplierNameEmptyProblem = Problem & {
  __typename?: 'FinanceSupplierNameEmptyProblem';
  message: Scalars['String'];
};

export type FinanceSupplierNotExistsProblem = Problem & {
  __typename?: 'FinanceSupplierNotExistsProblem';
  message: Scalars['String'];
};

export type FinanceSupplierProcurementProjectNotExistsProblem = Problem & {
  __typename?: 'FinanceSupplierProcurementProjectNotExistsProblem';
  message: Scalars['String'];
};

export type FinanceSupplierUpdateMutationInput = {
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['String']>;
  procurementProjectIds?: Maybe<Array<Scalars['ID']>>;
};

export type FinanceSupplierUpdateUnknownErrorProblem = Problem & {
  __typename?: 'FinanceSupplierUpdateUnknownErrorProblem';
  message: Scalars['String'];
};

export type FinanceSupplierUpdateVoidInputProblem = Problem & {
  __typename?: 'FinanceSupplierUpdateVoidInputProblem';
  message: Scalars['String'];
};

export type FootprintCalculation = {
  __typename?: 'FootprintCalculation';
  id: Scalars['ID'];
  country: Maybe<Country>;
  createdAt: Scalars['Date'];
  emissions: Array<FootprintCalculationEmission>;
  endAt: Scalars['Date'];
  label: Scalars['String'];
  locale: Maybe<Scalars['String']>;
  startAt: Scalars['Date'];
  status: FootprintCalculationStatus;
  surveyId: Scalars['String'];
  surveyType: FootprintCalculationSurveyType;
  tips: Array<FootprintCalculationTip>;
  totalCarbonEmissions: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Date'];
  user: User;
};


export type FootprintCalculationTipsArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type FootprintCalculationCarbonEmissionInput = {
  externalKey: Scalars['String'];
  category: FootprintCalculationEmissionCategory;
  scope: Scalars['Int'];
  carbonEmission: Scalars['Float'];
};

export type FootprintCalculationConnection = Connection & {
  __typename?: 'FootprintCalculationConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<FootprintCalculationConnectionEdge>>;
};

export type FootprintCalculationConnectionEdge = Edge & {
  __typename?: 'FootprintCalculationConnectionEdge';
  node: Maybe<FootprintCalculation>;
  cursor: Maybe<Scalars['String']>;
};

/** The input data used to create a new footprint calculation. */
export type FootprintCalculationCreateInput = {
  /** The label given to this footprint calculation by the user. */
  label: Scalars['String'];
  /** The start date of the period of reference for the footprint calculation. */
  startAt: Scalars['Date'];
  /** The end date of the period of reference for the footprint calculation. */
  endAt: Scalars['Date'];
  surveyType?: Maybe<FootprintCalculationSurveyType>;
};

export type FootprintCalculationCreateMutationResponse = Resource | FootprintCalculationCreateUnknownProblem;

export type FootprintCalculationCreateTokenCalculationNotFoundProblem = Problem & {
  __typename?: 'FootprintCalculationCreateTokenCalculationNotFoundProblem';
  message: Scalars['String'];
};

export type FootprintCalculationCreateTokenCalculationOwnerMismatchProblem = Problem & {
  __typename?: 'FootprintCalculationCreateTokenCalculationOwnerMismatchProblem';
  message: Scalars['String'];
};

export type FootprintCalculationCreateTokenResponse = FootPrintCalculationToken | FootprintCalculationCreateTokenCalculationNotFoundProblem | FootprintCalculationCreateTokenCalculationOwnerMismatchProblem;

/** Indicates that an unknown problem occurred while creating a footprint calculation. */
export type FootprintCalculationCreateUnknownProblem = Problem & {
  __typename?: 'FootprintCalculationCreateUnknownProblem';
  message: Scalars['String'];
};

export type FootprintCalculationEmission = {
  __typename?: 'FootprintCalculationEmission';
  category: Maybe<FootprintCalculationEmissionCategory>;
  /**
   * GHG Protocol Scopes
   * Scope 1 - direct emissions from sources owned or controlled by a company.
   * Scope 2 - indirect emissions from purchased electricity, steam, heat, and cooling.
   * Scope 3 - all other emissions associated with a company's activities.
   */
  scope: Maybe<Scalars['Int']>;
  carbonEmission: Maybe<Scalars['Float']>;
};

export enum FootprintCalculationEmissionCategory {
  CompanyFleet = 'COMPANY_FLEET',
  Trips = 'TRIPS',
  Commuting = 'COMMUTING',
  Heating = 'HEATING',
  Cooling = 'COOLING',
  Digital = 'DIGITAL',
  Electricity = 'ELECTRICITY',
  Consumables = 'CONSUMABLES',
  Other = 'OTHER'
}

export type FootprintCalculationInputData = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Problem that occurs when footprint calculation identifier isn't valid. */
export type FootprintCalculationInvalidIdentifierProblem = Problem & {
  __typename?: 'FootprintCalculationInvalidIdentifierProblem';
  message: Scalars['String'];
};

export type FootprintCalculationMutation = {
  __typename?: 'FootprintCalculationMutation';
  /** Create a new footprint calculation. */
  create: FootprintCalculationCreateMutationResponse;
  /** Update a footprint calculation */
  update: FootprintCalculationUpdateMutationResponse;
  /** Update a footprint calculation */
  updateEmissions: FootprintCalculationUpdateEmissionsMutationResponse;
  createToken: FootprintCalculationCreateTokenResponse;
};


export type FootprintCalculationMutationCreateArgs = {
  input: FootprintCalculationCreateInput;
};


export type FootprintCalculationMutationUpdateArgs = {
  id: Scalars['ID'];
  input: FootprintCalculationUpdateInput;
};


export type FootprintCalculationMutationUpdateEmissionsArgs = {
  id: Scalars['ID'];
  input: FootprintCalculationUpdateEmissionsInput;
};


export type FootprintCalculationMutationCreateTokenArgs = {
  calculationId: Scalars['ID'];
};

/** Indicates that calculation not found while doing operations on a footprint calculation. */
export type FootprintCalculationNotFoundProblem = Problem & {
  __typename?: 'FootprintCalculationNotFoundProblem';
  message: Scalars['String'];
};

export type FootprintCalculationsQueryWhereInput = {
  status?: Maybe<Array<FootprintCalculationStatus>>;
  userId?: Maybe<Array<Scalars['ID']>>;
};

export enum FootprintCalculationStatus {
  Initialized = 'INITIALIZED',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Neutralized = 'NEUTRALIZED'
}

export enum FootprintCalculationStatusInput {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED'
}

export enum FootprintCalculationSurveyType {
  CompanyFull = 'COMPANY_FULL'
}

export type FootprintCalculationsWhereInput = {
  status?: Maybe<Array<FootprintCalculationStatus>>;
};

export type FootprintCalculationTip = {
  __typename?: 'FootprintCalculationTip';
  message: Maybe<Scalars['String']>;
};

export type FootprintCalculationTipInput = {
  message: Array<LocalizedStringInput>;
};

export type FootPrintCalculationToken = {
  __typename?: 'FootPrintCalculationToken';
  token: Scalars['String'];
  expiresIn: Scalars['Int'];
};

/** Indicates that an unknown problem occurred while doing operations on a footprint calculation. */
export type FootprintCalculationUnknownProblem = Problem & {
  __typename?: 'FootprintCalculationUnknownProblem';
  message: Scalars['String'];
};

/** Problem that occurs when trying to update an already completed footprint calculation. */
export type FootprintCalculationUpdateEmissionsAlreadyCompletedProblem = Problem & {
  __typename?: 'FootprintCalculationUpdateEmissionsAlreadyCompletedProblem';
  message: Scalars['String'];
};

/** The input data used to update a footprint calculation. */
export type FootprintCalculationUpdateEmissionsInput = {
  /** Status of footprint calculation. */
  status: FootprintCalculationStatusInput;
  /** Survey identifier */
  surveyId: Scalars['String'];
  locale: Scalars['String'];
  countryCode: Scalars['String'];
  /** Total emissions of calculation */
  totalCarbonEmissions: Scalars['Float'];
  /** Tips for reduce footprint impact */
  tips: Array<FootprintCalculationTipInput>;
  /** Emissions used for calculation */
  carbonEmissions: Array<FootprintCalculationCarbonEmissionInput>;
  inputData: Array<FootprintCalculationInputData>;
};

export type FootprintCalculationUpdateEmissionsMutationResponse = Resource | FootprintCalculationNotFoundProblem | FootprintCalculationUpdateEmissionsAlreadyCompletedProblem | FootprintCalculationInvalidIdentifierProblem | FootprintCalculationUnknownProblem;

/** The input data used to update a footprint calculation. */
export type FootprintCalculationUpdateInput = {
  /** Label of the footprint calculation. */
  label?: Maybe<Scalars['String']>;
  /** Start date of the period of reference for the footprint calculation. */
  startAt?: Maybe<Scalars['Date']>;
  /** End date of the period of reference for the footprint calculation. */
  endAt?: Maybe<Scalars['Date']>;
};

export type FootprintCalculationUpdateInvalidInputProblem = Problem & {
  __typename?: 'FootprintCalculationUpdateInvalidInputProblem';
  /** The error message. */
  message: Scalars['String'];
};

export type FootprintCalculationUpdateMutationResponse = Resource | FootprintCalculationNotFoundProblem | FootprintCalculationInvalidIdentifierProblem | FootprintCalculationUnknownProblem | FootprintCalculationUpdateInvalidInputProblem;

export type Forest = {
  __typename?: 'Forest';
  id: Scalars['ID'];
  owner: User;
  /**
   * Requests a signed URL where to upload the background image of the forest.
   * The image must be provided in the 'file' parameter.
   */
  backgroundFileUpload: FileUpload;
  /**
   * Requests a signed URL where to upload the communication kit icon
   * The image must be provided in the 'file' parameter
   */
  iconFileUpload: FileUpload;
  avatar: Maybe<Image>;
  background: Maybe<Image>;
  /** Returns countries of Forest */
  countries: ForestCountriesConnection;
  createdOn: Scalars['DateTime'];
  /**
   * Users who have planted in the forest.
   * In case of rally forest the custodians are all the users which own a tree, including the forest owner, otherwise forest owner is excluded from the list.
   */
  custodians: UserConnection;
  description: Maybe<Scalars['String']>;
  draft: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  endDate: Maybe<Scalars['DateTime']>;
  endProgressive: Maybe<Scalars['DateTime']>;
  hideEmissions: Maybe<Scalars['Boolean']>;
  hideMap: Maybe<Scalars['Boolean']>;
  hidePeople: Maybe<Scalars['Boolean']>;
  hideProjects: Maybe<Scalars['Boolean']>;
  hideRedeem: Maybe<Scalars['Boolean']>;
  isFollowable: Maybe<Scalars['Boolean']>;
  isOpen: Maybe<Scalars['Boolean']>;
  isProgressive: Maybe<Scalars['Boolean']>;
  isRally: Maybe<Scalars['Boolean']>;
  letMeChoose: Maybe<Scalars['Boolean']>;
  map: ForestMap;
  name: Scalars['String'];
  projectSpecies: ForestProjectSpeciesConnection;
  published: Maybe<Scalars['Boolean']>;
  redeemBackground: Maybe<Image>;
  shareTreeImage: Maybe<Image>;
  slug: Scalars['String'];
  startDate: Maybe<Scalars['DateTime']>;
  totalEmissions: Maybe<Scalars['Int']>;
  totalFarmers: Maybe<Scalars['Int']>;
  treeProjects: TreeProjectConnection;
  trees: TreeConnection;
  /** @deprecated Use field ForestTypeV2 instead */
  type: ForestType;
  typeV2: Maybe<ForestTypeV2>;
  url: Scalars['String'];
};


export type ForestCustodiansArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type ForestDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type ForestMapArgs = {
  where?: Maybe<ForestMapWhereInput>;
};


export type ForestProjectSpeciesArgs = {
  where?: Maybe<ForestProjectSpeciesWhereInput>;
  pagination?: Maybe<PaginationInput>;
};


export type ForestTreeProjectsArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type ForestTreesArgs = {
  where?: Maybe<ForestTreesWhereConditionInput>;
  pagination?: Maybe<PaginationInput>;
};


export type ForestUrlArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type ForestBulkChangeOwnershipInput = {
  /** Current user owner of forests */
  sourceUserId: Scalars['ID'];
  /** Target user who will become the owner of forests */
  targetUserId: Scalars['ID'];
};

export type ForestBulkChangeOwnershipInvalidTargetUserProblem = Problem & {
  __typename?: 'ForestBulkChangeOwnershipInvalidTargetUserProblem';
  message: Scalars['String'];
};

export type ForestBulkChangeOwnershipResponse = ForestBulkChangeOwnershipResponseData | ForestBulkChangeOwnershipUnknownProblem | ForestBulkChangeOwnershipInvalidTargetUserProblem;

export type ForestBulkChangeOwnershipResponseData = {
  __typename?: 'ForestBulkChangeOwnershipResponseData';
  /** Total number of forest transferred from source to target user */
  totalForestsTransferred: Scalars['Int'];
};

export type ForestBulkChangeOwnershipUnknownProblem = Problem & {
  __typename?: 'ForestBulkChangeOwnershipUnknownProblem';
  message: Scalars['String'];
};

export type ForestConnection = Connection & {
  __typename?: 'ForestConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<ForestEdge>>;
  pageInfo: PageInfo;
};

export type ForestContribute = {
  __typename?: 'ForestContribute';
  forest: Forest;
  treesCount: Scalars['Int'];
  firstContributionDate: Scalars['DateTime'];
  lastContributionDate: Scalars['DateTime'];
};

export type ForestContributeEdge = Edge & {
  __typename?: 'ForestContributeEdge';
  cursor: Scalars['String'];
  node: Maybe<ForestContribute>;
};

export type ForestCountriesConnection = Connection & {
  __typename?: 'ForestCountriesConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<ForestCountriesEdge>>;
  pageInfo: PageInfo;
};

export type ForestCountriesEdge = Edge & {
  __typename?: 'ForestCountriesEdge';
  cursor: Scalars['String'];
  node: Maybe<ForestCountry>;
};

export type ForestCountry = {
  __typename?: 'ForestCountry';
  country: Country;
  treeCount: Scalars['Int'];
};

export type ForestEdge = Edge & {
  __typename?: 'ForestEdge';
  cursor: Scalars['String'];
  node: Maybe<Forest>;
};

export type ForestMap = {
  __typename?: 'ForestMap';
  pins: Array<MapPin>;
};

export type ForestMapWhereInput = {
  /** Filter by country code. */
  countryCode?: Maybe<Scalars['ID']>;
  /** Whether to include trees in nurseries. */
  inNursery?: Maybe<Scalars['Boolean']>;
  /** Zoom of the map. */
  zoom?: Maybe<Scalars['Int']>;
  /** Upper left bound of the map. */
  NE?: Maybe<MapPointInput>;
  /** Lower right bound of the map. */
  SW?: Maybe<MapPointInput>;
  /** Whether to force clustering when zoomed out. Must be used with `NE`/`SW`. */
  forceClustering?: Maybe<Scalars['Boolean']>;
};

export type ForestMutation = {
  __typename?: 'ForestMutation';
  /** Change ownership of forests */
  bulkChangeOwnership: Maybe<ForestBulkChangeOwnershipResponse>;
  create: ForestMutationResponse;
  delete: DeleteForestResponse;
  publish: PublishForestResponse;
  update: UpdateForestResponse;
};


export type ForestMutationBulkChangeOwnershipArgs = {
  input: ForestBulkChangeOwnershipInput;
};


export type ForestMutationCreateArgs = {
  name: Scalars['String'];
  forestTypeId: Scalars['ID'];
  isRally: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['ID']>;
};


export type ForestMutationDeleteArgs = {
  id: Scalars['ID'];
};


export type ForestMutationPublishArgs = {
  id: Scalars['ID'];
};


export type ForestMutationUpdateArgs = {
  id: Scalars['ID'];
  input: UpdateForestInput;
};

export type ForestMutationResponse = Resource | CreateForestUnpublishedForestAlreadyExistsProblem | CreateForestEventTypeDoesNotExistsProblem | CreateForestUnknownProblem;

export type ForestProjectSpecie = {
  __typename?: 'ForestProjectSpecie';
  projectSpecie: Maybe<ProjectSpecie>;
  treeCount: Maybe<Scalars['Int']>;
  absorbedCo2: Maybe<Scalars['Int']>;
};

export type ForestProjectSpeciesConnection = Connection & {
  __typename?: 'ForestProjectSpeciesConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<ForestProjectSpeciesEdge>>;
  pageInfo: PageInfo;
};

export type ForestProjectSpeciesEdge = Edge & {
  __typename?: 'ForestProjectSpeciesEdge';
  cursor: Scalars['String'];
  node: Maybe<ForestProjectSpecie>;
};

export type ForestProjectSpeciesWhereInput = {
  id?: Maybe<Array<Scalars['ID']>>;
};

export type ForestryTree = {
  __typename?: 'ForestryTree';
  id: Scalars['ID'];
  isAssignable: Maybe<Scalars['Boolean']>;
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  picture: Maybe<StandardMedia>;
  projectSpecie: Maybe<ProjectSpecie>;
  tree: Maybe<Tree>;
};


export type ForestryTreeIsAssignableArgs = {
  assignmentChannel: AssignmentChannel;
};

export type ForestryTreeConnection = Connection & {
  __typename?: 'ForestryTreeConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<ForestryTreeEdge>>;
  pageInfo: PageInfo;
};

export type ForestryTreeEdge = Edge & {
  __typename?: 'ForestryTreeEdge';
  node: Maybe<ForestryTree>;
  cursor: Scalars['String'];
};

export type ForestryTreesConnection = Connection & {
  __typename?: 'ForestryTreesConnection';
  totalCount: Scalars['Int'];
  pageInfo: Maybe<PageInfo>;
  edges: Array<ForestryTreesEdge>;
};

export type ForestryTreesEdge = Edge & {
  __typename?: 'ForestryTreesEdge';
  node: ForestryTree;
  cursor: Maybe<Scalars['String']>;
};

export type ForestryTreesWhereInput = {
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type ForestsContributesConnection = Connection & {
  __typename?: 'ForestsContributesConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<ForestContributeEdge>>;
  pageInfo: PageInfo;
};

export enum ForestsSearchFilterField {
  Slug = 'SLUG',
  Name = 'NAME'
}

export type ForestsSearchFiltersInput = {
  enabled?: Maybe<BooleanFilter>;
  published?: Maybe<BooleanFilter>;
};

export enum ForestsSortInput {
  /** Sort by created on, ascending. */
  CreatedOnAsc = 'CREATED_ON_ASC',
  /** Sort by created on, descending. */
  CreatedOnDesc = 'CREATED_ON_DESC'
}

export type ForestTreesWhereConditionInput = {
  /** Country code used to search trees */
  countryCode?: Maybe<Scalars['ID']>;
  /** Id of the user who planted the trees */
  planterId?: Maybe<Scalars['ID']>;
};

export enum ForestType {
  None = 'NONE',
  Birthday = 'BIRTHDAY',
  Birth = 'BIRTH',
  Wedding = 'WEDDING',
  Other = 'OTHER'
}

export type ForestTypeV2 = {
  __typename?: 'ForestTypeV2';
  id: Scalars['ID'];
  avatar: Maybe<Image>;
  background: Maybe<Image>;
  description: Scalars['String'];
  preview: Maybe<Image>;
};

export type ForestWhereConditionInput = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['ID']>;
  published?: Maybe<Scalars['Boolean']>;
  hasBusinessOwner?: Maybe<Scalars['Boolean']>;
};

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  NonBinary = 'NON_BINARY',
  NotSpecified = 'NOT_SPECIFIED',
  Other = 'OTHER'
}

export type GenerationProcess = {
  id: Scalars['ID'];
  name: Scalars['String'];
  expiresAt: Scalars['Date'];
  redeemEnabled: Scalars['Boolean'];
  redeemMessage: Translation;
  treecodeType: TreecodeType;
  createdBy: User;
  availableRedeems: Scalars['Int'];
  redeemType: TreecodeRedeemType;
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  requestedCodeQuantity: Scalars['Int'];
  generatedCodeQuantity: Scalars['Int'];
  generatedCodeErrors: Scalars['Int'];
  generationInError: Scalars['Boolean'];
};

export type GenerationProcessesFindInput = {
  /** Type of treecode generation process */
  treecodeType?: Maybe<TreecodeType>;
  /** The user who's requested the treecode generation */
  createdBy?: Maybe<Scalars['ID']>;
  /** Name of treecode generation process */
  name?: Maybe<Scalars['String']>;
  /**
   * User who's is gifting trees.
   * Filter available for following types:
   * - Simple
   * - Picker
   */
  gifterId?: Maybe<Scalars['String']>;
  /**
   * Forest where are planted gifted trees.
   * Filter available for following types:
   * - Simple
   * - Picker
   */
  forestId?: Maybe<Scalars['String']>;
};

export type GenerationProcessPicker = GenerationProcess & {
  __typename?: 'GenerationProcessPicker';
  id: Scalars['ID'];
  name: Scalars['String'];
  expiresAt: Scalars['Date'];
  redeemEnabled: Scalars['Boolean'];
  redeemMessage: Translation;
  treecodeType: TreecodeType;
  createdBy: User;
  availableRedeems: Scalars['Int'];
  redeemType: TreecodeRedeemType;
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  requestedCodeQuantity: Scalars['Int'];
  generatedCodeQuantity: Scalars['Int'];
  generatedCodeErrors: Scalars['Int'];
  generationInError: Scalars['Boolean'];
  forest: Forest;
  gifter: User;
  gameEnabled: Scalars['Boolean'];
  gameExpiresAt: Maybe<Scalars['Date']>;
};

export type GenerationProcessSimple = GenerationProcess & {
  __typename?: 'GenerationProcessSimple';
  id: Scalars['ID'];
  name: Scalars['String'];
  expiresAt: Scalars['Date'];
  redeemEnabled: Scalars['Boolean'];
  redeemMessage: Translation;
  treecodeType: TreecodeType;
  createdBy: User;
  availableRedeems: Scalars['Int'];
  redeemType: TreecodeRedeemType;
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  requestedCodeQuantity: Scalars['Int'];
  generatedCodeQuantity: Scalars['Int'];
  generatedCodeErrors: Scalars['Int'];
  generationInError: Scalars['Boolean'];
  gifter: User;
  forest: Maybe<Forest>;
  gameEnabled: Scalars['Boolean'];
  gameExpiresAt: Maybe<Scalars['Date']>;
  generationRequests: Array<TreecodeGenerationRequest>;
};

export type GenerationProcessVirgin = GenerationProcess & {
  __typename?: 'GenerationProcessVirgin';
  id: Scalars['ID'];
  name: Scalars['String'];
  expiresAt: Scalars['Date'];
  redeemEnabled: Scalars['Boolean'];
  redeemMessage: Translation;
  treecodeType: TreecodeType;
  createdBy: User;
  availableRedeems: Scalars['Int'];
  redeemType: TreecodeRedeemType;
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  requestedCodeQuantity: Scalars['Int'];
  generatedCodeQuantity: Scalars['Int'];
  generatedCodeErrors: Scalars['Int'];
  generationInError: Scalars['Boolean'];
  planter: Maybe<User>;
  planterForest: Maybe<Forest>;
  redeemProducts: Array<RedeemProduct>;
};

export type Gift = {
  __typename?: 'Gift';
  id: Scalars['ID'];
  delivery: GiftDeliveryType;
  /** @deprecated Use `creativity` */
  redeemBackground: Maybe<Image>;
  redeemMessage: Maybe<Scalars['String']>;
  redeemType: TreecodeRedeemType;
  /** Trees associated with gift */
  trees: Maybe<TreecodeTreeConnection>;
};


export type GiftRedeemMessageArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type GiftTreesArgs = {
  pagination: PaginationInput;
};

export type GiftableTree = {
  __typename?: 'GiftableTree';
  treeId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type GiftableTreesConnection = Connection & {
  __typename?: 'GiftableTreesConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<GiftableTreesEdge>>;
  pageInfo: PageInfo;
};

export type GiftableTreesEdge = Edge & {
  __typename?: 'GiftableTreesEdge';
  cursor: Scalars['String'];
  node: Maybe<GiftableTree>;
};

export type GiftDeliveryType = GiftDeliveryTypeEmail | GiftDeliveryTypeCode | GiftDeliveryTypeCard;

export type GiftDeliveryTypeCard = {
  __typename?: 'GiftDeliveryTypeCard';
  giftId: Scalars['ID'];
  creativity: Maybe<TreecodeCreativity>;
  locale: Scalars['String'];
  /** Username of user recipient */
  recipientUsername: Scalars['String'];
  type: DeliveryType;
  card: Pdf;
};

export type GiftDeliveryTypeCode = {
  __typename?: 'GiftDeliveryTypeCode';
  giftId: Scalars['ID'];
  creativity: Maybe<TreecodeCreativity>;
  locale: Scalars['String'];
  /** Username of user recipient */
  recipientUsername: Scalars['String'];
  type: DeliveryType;
};

export type GiftDeliveryTypeEmail = {
  __typename?: 'GiftDeliveryTypeEmail';
  giftId: Scalars['ID'];
  creativity: Maybe<TreecodeCreativity>;
  locale: Scalars['String'];
  /** Username of user recipient */
  recipientUsername: Scalars['String'];
  type: DeliveryType;
  /** Date-time of when treecode'll be sent */
  deliverAt: Maybe<Scalars['Date']>;
  /** Email recipient to send treecode */
  recipientEmail: Scalars['String'];
  timezone: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  /** The identifier of the image. */
  id: Scalars['ID'];
  /** The provider of the image. */
  provider: Maybe<ImageProvider>;
  /** Retrieve URL to image, with optional transformations. */
  url: Scalars['String'];
  /** @deprecated Not implemented. */
  contentType: Maybe<Scalars['String']>;
  /** @deprecated Not implemented. */
  fileName: Maybe<Scalars['String']>;
  /** @deprecated Not implemented. */
  size: Maybe<Scalars['Int']>;
  /** @deprecated Not implemented. */
  width: Maybe<Scalars['Int']>;
  /** @deprecated Not implemented. */
  height: Maybe<Scalars['Int']>;
};


export type ImageUrlArgs = {
  transform?: Maybe<ImageUrlTransformInput>;
};

export enum ImageFormat {
  Jpg = 'JPG',
  Png = 'PNG'
}

export enum ImageProvider {
  Treedom = 'TREEDOM',
  Cloudinary = 'CLOUDINARY',
  Contentful = 'CONTENTFUL',
  Commercetools = 'COMMERCETOOLS',
  Url = 'URL',
  CommercetoolsAws = 'COMMERCETOOLS_AWS'
}

export type ImageQueryInput = {
  /** The ID of the image. */
  id: Scalars['String'];
  /** The provider of the image. Defaults to Treedom. */
  provider?: Maybe<ImageProvider>;
  /** The context of the image. Defaults to 'legacy'. */
  context?: Maybe<Scalars['String']>;
};

/** Crop mode for image transformations. */
export enum ImageTransformCropMode {
  Crop = 'CROP',
  Fit = 'FIT',
  Limit = 'LIMIT'
}

/** Crop mode for image transformations. */
export enum ImageTransformResizeMode {
  Limit = 'LIMIT',
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   * Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageUrlTransformInput = {
  /** The image format to use for the transformed image. */
  format?: Maybe<ImageFormat>;
  /** The width of the transformed image. */
  width?: Maybe<Scalars['Int']>;
  /** The height of the transformed image. */
  height?: Maybe<Scalars['Int']>;
  /** The quality of the transformed image. */
  quality?: Maybe<Scalars['Int']>;
  /** The resize mode to use for the transformed image. */
  resizeMode?: Maybe<ImageTransformResizeMode>;
  /** Apply a max-radius transform to the image making it a circle. */
  circle?: Maybe<Scalars['Boolean']>;
};

export type Impact = {
  __typename?: 'Impact';
  /**
   * The primary key of the Impact.
   * This must be exactly equal in every service referencing the impact.
   */
  key: Scalars['ID'];
  /** The background color of the Impact. */
  backgroundColor: Scalars['String'];
  /** The main color of the Impact. */
  color: Scalars['String'];
  /** The description of the Impact. */
  description: Scalars['String'];
  /** The list of Goals for this Impact. */
  goals: Array<Maybe<ImpactGoal>>;
  /** The hero image of the Impact. */
  heroImage: Image;
  /** The name of the Impact. */
  name: Scalars['String'];
  /** The picture of the Impact. */
  picture: Maybe<Image>;
  /** The list of SDGs for this Impact. */
  sdgs: Array<Maybe<Sdg>>;
  /** The URL friendly slug of the Impact. */
  slug: Scalars['String'];
};


export type ImpactDescriptionArgs = {
  locale: Scalars['String'];
};


export type ImpactNameArgs = {
  locale: Scalars['String'];
};


export type ImpactSlugArgs = {
  locale: Scalars['String'];
};

export type ImpactGoal = {
  __typename?: 'ImpactGoal';
  /** This is the impact goal */
  key: Scalars['ID'];
  /** The cover (main) image of the impact goal. */
  cover: Image;
  /** The explanation/description of the ImpactGoal. */
  explanation: Scalars['String'];
  /** The name of the ImpactGoal. */
  name: Scalars['String'];
};


export type ImpactGoalExplanationArgs = {
  locale: Scalars['String'];
};


export type ImpactGoalNameArgs = {
  locale: Scalars['String'];
};

export type InsertFinancePaymentMutationResponse = Resource | FinancePaymentInsertUnknownErrorProblem | FinancePaymentProcurementPlanNotFoundProblem | FinancePaymentNotExistsProblem;

export type InsertFinanceSupplierMutationResponse = Resource | FinanceSupplierAlreadyExistsProblem | FinanceSupplierInsertUnknownErrorProblem | FinanceSupplierNameEmptyProblem;

export type Invoice = {
  __typename?: 'Invoice';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  currency: ShopCurrency;
  generated: Maybe<Scalars['Boolean']>;
  /** Invoice number. Ex.: 00002B */
  number: Scalars['String'];
  order: Maybe<Order>;
  paidAt: Scalars['DateTime'];
  total: Scalars['Int'];
  transactionId: Maybe<Scalars['String']>;
  treeCount: Maybe<Scalars['Int']>;
  type: InvoiceType;
  updatedAt: Maybe<Scalars['DateTime']>;
  user: User;
};

export type InvoiceConnection = Connection & {
  __typename?: 'InvoiceConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<InvoiceEdge>>;
};

export type InvoiceEdge = Edge & {
  __typename?: 'InvoiceEdge';
  node: Maybe<Invoice>;
  cursor: Scalars['String'];
};

export type InvoiceMutation = {
  __typename?: 'InvoiceMutation';
  /** Update an existing invoice. */
  update: UpdateInvoiceResponse;
};


export type InvoiceMutationUpdateArgs = {
  invoiceId: Scalars['ID'];
  input: UpdateInvoiceInput;
};

export type InvoiceOrderClause = {
  field: InvoiceOrderField;
  direction: SqlSortDirection;
};

export enum InvoiceOrderField {
  CreatedAt = 'CREATED_AT',
  PaidAt = 'PAID_AT'
}

export type InvoicesFilterInput = {
  /** Search the invoices where the paidAt field is in a given time interval. Start and end date are included. */
  paidAt?: Maybe<DateInterval>;
  /** Search the invoices where the createdAt field is in a given time interval. Start and end date are included. *\/ */
  createdAt?: Maybe<DateInterval>;
};

export enum InvoiceType {
  Pay = 'PAY',
  Refund = 'REFUND'
}

/** Problem that occurs when the invoice is not found. */
export type InvoiceUpdateNotFoundProblem = Problem & {
  __typename?: 'InvoiceUpdateNotFoundProblem';
  message: Scalars['String'];
};

/** Problem that occurs when something wrong happened. */
export type InvoiceUpdateUnknownProblem = Problem & {
  __typename?: 'InvoiceUpdateUnknownProblem';
  message: Scalars['String'];
};

/** The contact type of a lead. Indicates whether the lead was created online or offline. */
export enum LeadContactType {
  Online = 'ONLINE',
  Offline = 'OFFLINE'
}

/** Problem that occurs when the domain of the email is not allowed to create a lead. */
export type LeadCreateEmailDomainNotAllowedProblem = Problem & {
  __typename?: 'LeadCreateEmailDomainNotAllowedProblem';
  message: Scalars['String'];
};

/** The input data used to create a new lead. */
export type LeadCreateInput = {
  /** The source of the lead. */
  source: Scalars['String'];
  /** The lead typology of the lead. */
  leadType?: Maybe<LeadType>;
  /** The email of the lead. */
  email: Scalars['String'];
  /** Department of the lead. */
  department?: Maybe<BusinessDepartment>;
  /** The phone of the lead. */
  phone?: Maybe<Scalars['String']>;
  /** The company name of the lead. */
  companyName?: Maybe<Scalars['String']>;
  /** The company size of the lead. */
  companySize?: Maybe<CompanySize>;
  /** The language of the lead. */
  language: Scalars['String'];
  /** The country of the lead. */
  country?: Maybe<Scalars['String']>;
  /** The message that the company sent. */
  message?: Maybe<Scalars['String']>;
  /** The contact name of the lead. */
  contactName?: Maybe<Scalars['String']>;
  /** The contact surname of the lead. */
  contactSurname?: Maybe<Scalars['String']>;
};

export type LeadCreateMutationResponse = Resource | LeadCreateUnknownProblem | LeadCreatePrivateUserProblem | LeadCreateEmailDomainNotAllowedProblem;

/** Problem that occurs when a private user tries to create a lead. */
export type LeadCreatePrivateUserProblem = Problem & {
  __typename?: 'LeadCreatePrivateUserProblem';
  message: Scalars['String'];
};

/** Indicates that an unknown problem occurred while creating a lead. */
export type LeadCreateUnknownProblem = Problem & {
  __typename?: 'LeadCreateUnknownProblem';
  message: Scalars['String'];
};

export type LeadMutation = {
  __typename?: 'LeadMutation';
  /** Create a new lead. */
  create: LeadCreateMutationResponse;
};


export type LeadMutationCreateArgs = {
  input: LeadCreateInput;
};

export enum LeadType {
  ContactUs = 'CONTACT_US',
  SignUp = 'SIGN_UP',
  LandingPage = 'LANDING_PAGE'
}

export enum LegalNoticeIdentifier {
  PrivacyPolicy = 'PRIVACY_POLICY',
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
  CookiesPolicy = 'COOKIES_POLICY'
}

export type LinkSocialIdentityAlreadyLinkedProblem = Problem & {
  __typename?: 'LinkSocialIdentityAlreadyLinkedProblem';
  message: Scalars['String'];
};

export type LinkSocialIdentityAlreadyLinkedToAnotherAccountProblem = Problem & {
  __typename?: 'LinkSocialIdentityAlreadyLinkedToAnotherAccountProblem';
  message: Scalars['String'];
};

export type LinkSocialIdentityInput = {
  /** SocialIdentity Provider */
  socialIdentity: SocialIdentity;
  /** SocialIdentity authentication token */
  socialIdentityToken: Scalars['String'];
};

export type LinkSocialIdentityProblem = Problem & {
  __typename?: 'LinkSocialIdentityProblem';
  message: Scalars['String'];
};

export type LinkSocialIdentityResponse = Resource | LinkSocialIdentityProblem | LinkSocialIdentityTokenProblem | LinkSocialIdentityAlreadyLinkedProblem | LinkSocialIdentityAlreadyLinkedToAnotherAccountProblem;

export type LinkSocialIdentityTokenProblem = Problem & {
  __typename?: 'LinkSocialIdentityTokenProblem';
  message: Scalars['String'];
};

export type LocalizedFilterInput = {
  /** Filter by title. */
  text?: Maybe<Scalars['String']>;
  /** Locale to use when searching. */
  locale?: Maybe<Scalars['String']>;
};

export type LocalizedStringInput = {
  locale: Scalars['String'];
  value: Scalars['String'];
};

export type LocalizedValue = {
  __typename?: 'LocalizedValue';
  locale: Scalars['String'];
  value: Scalars['String'];
};

export type LocalizedValueInput = {
  locale: Scalars['String'];
  value: Scalars['String'];
};

export type MalformedInputProblem = Problem & {
  __typename?: 'MalformedInputProblem';
  message: Scalars['String'];
};

export type MapClusterPin = {
  __typename?: 'MapClusterPin';
  clusterId: Scalars['ID'];
  type: MapClusterPinType;
  point: MapPoint;
  count: Maybe<Scalars['Int']>;
};

export enum MapClusterPinType {
  Nursery = 'NURSERY',
  Trees = 'TREES'
}

export type MapPin = MapTreePin | MapClusterPin;

export type MapPoint = {
  __typename?: 'MapPoint';
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
};

export type MapPointInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type MapTreePin = {
  __typename?: 'MapTreePin';
  point: MapPoint;
  /** @deprecated Use `tree` instead. */
  treeId: Scalars['ID'];
  tree: Maybe<Tree>;
};

/** Input used when setting the marketing campaign data of the cart. */
export type MarketingCampaignDataInput = {
  utmSource?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  setAt: Scalars['DateTime'];
};

/** Input used when setting the marketing campaign data of the cart. */
export type MarketingCampaignInput = {
  cartId: Scalars['ID'];
  campaignData?: Maybe<MarketingCampaignDataInput>;
};

export type MarkReadFeedNotificationInput = {
  /** The user on which to mark the notifications as read. */
  userId: Scalars['ID'];
  /** The notifications to mark as read. */
  ids?: Maybe<Array<Scalars['ID']>>;
  /** Whether to mark all notifications as read, regardless of the IDs provided. */
  markAll?: Maybe<Scalars['Boolean']>;
};

export type MarkReadFeedNotificationInvalidInputProblem = Problem & {
  __typename?: 'MarkReadFeedNotificationInvalidInputProblem';
  message: Scalars['String'];
};

export type MarkReadFeedNotificationResponse = MarkReadFeedNotificationResult | MarkReadFeedNotificationUnknownProblem | MarkReadFeedNotificationInvalidInputProblem;

export type MarkReadFeedNotificationResult = {
  __typename?: 'MarkReadFeedNotificationResult';
  unreadCount: Scalars['Int'];
};

export type MarkReadFeedNotificationUnknownProblem = Problem & {
  __typename?: 'MarkReadFeedNotificationUnknownProblem';
  message: Scalars['String'];
};

export type MarkSeenFeedNotificationInput = {
  /** The user on which to mark the notifications as seen. */
  userId: Scalars['ID'];
  /** The notifications to mark as seen. */
  ids?: Maybe<Array<Scalars['ID']>>;
  /** Whether to mark all notifications as seen, regardless of the IDs provided. */
  markAll?: Maybe<Scalars['Boolean']>;
};

export type MarkSeenFeedNotificationInvalidInputProblem = Problem & {
  __typename?: 'MarkSeenFeedNotificationInvalidInputProblem';
  message: Scalars['String'];
};

export type MarkSeenFeedNotificationResponse = MarkSeenFeedNotificationResult | MarkSeenFeedNotificationUnknownProblem | MarkSeenFeedNotificationInvalidInputProblem;

export type MarkSeenFeedNotificationResult = {
  __typename?: 'MarkSeenFeedNotificationResult';
  unseenCount: Scalars['Int'];
};

export type MarkSeenFeedNotificationUnknownProblem = Problem & {
  __typename?: 'MarkSeenFeedNotificationUnknownProblem';
  message: Scalars['String'];
};

export type MediaGallery = {
  __typename?: 'MediaGallery';
  id: Scalars['ID'];
  items: Array<Asset>;
};

export type MergeUsersInput = {
  sourceUserId: Scalars['ID'];
  targetUserId: Scalars['ID'];
  skipData?: Maybe<Scalars['Boolean']>;
  force?: Maybe<Scalars['Boolean']>;
  dryRun?: Maybe<Scalars['Boolean']>;
};

export type MergeUsersResult = {
  __typename?: 'MergeUsersResult';
  messageId: Maybe<Scalars['String']>;
};

export type MoveTreeToUserForest = {
  __typename?: 'moveTreeToUserForest';
  message: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  assistant: AssistantMutation;
  capabilityGroup: CapabilityGroupMutation;
  footprintCalculation: FootprintCalculationMutation;
  lead: Maybe<LeadMutation>;
  originator: OriginatorMutation;
  perk: Maybe<PerkMutation>;
  user: Maybe<UserMutation>;
  abuseReport: Maybe<AbuseReportMutation>;
  communicationKit: Maybe<CommunicationKitMutation>;
  feedActivity: Maybe<FeedActivityMutation>;
  feedAuthor: Maybe<FeedAuthorMutation>;
  feedBan: Maybe<FeedBanMutation>;
  feedNotification: Maybe<FeedNotificationMutation>;
  feedPost: Maybe<FeedPostMutation>;
  projectSpecie: Maybe<ProjectSpecieMutation>;
  scientificSpecie: Maybe<ScientificSpecieMutation>;
  billingPlan: Maybe<BillingPlanMutation>;
  cart: Maybe<CartMutation>;
  invoice: Maybe<InvoiceMutation>;
  order: Maybe<OrderMutation>;
  paymentMethod: Maybe<PaymentMethodMutation>;
  plan: Maybe<PlanMutation>;
  subscription: Maybe<PlanSubscriptionMutation>;
  product: Maybe<ProductMutation>;
  quotation: Maybe<QuotationMutation>;
  financePayment: Maybe<FinancePaymentMutation>;
  planSpeciePrice: Maybe<FinancePriceMutation>;
  supplier: Maybe<FinanceSupplierMutation>;
  partner: PartnerMutation;
  admin: Maybe<AdminMutation>;
  forest: Maybe<ForestMutation>;
  /** Redeem Open Forest Tree */
  openForestRedeem: Maybe<OpenForestRedeem>;
  tree: Maybe<TreeMutation>;
  /**
   * Move Tree To User Forest
   * @deprecated use mutation { tree: setForest }
   */
  moveTreeToUserForest: Maybe<MoveTreeToUserForest>;
  treecode: Maybe<TreecodeMutation>;
};


export type MutationOpenForestRedeemArgs = {
  forestSlug: Scalars['String'];
  productId?: Maybe<Scalars['ID']>;
};


export type MutationMoveTreeToUserForestArgs = {
  treeId: Scalars['ID'];
  forestSlug: Scalars['String'];
};

export type Notification = {
  id: Scalars['ID'];
  /** If notification was seen by user */
  seen: Scalars['Boolean'];
  /** If notification was read by user */
  read: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
};

export type NotificationPost = Notification & {
  __typename?: 'NotificationPost';
  id: Scalars['ID'];
  /** Author who wrote the post */
  actor: FeedAuthor;
  /** Published post */
  object: FeedActivity;
  /** If notification was seen by user */
  seen: Scalars['Boolean'];
  /** If notification was read by user */
  read: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
};

export type NotificationPostReaction = Notification & {
  __typename?: 'NotificationPostReaction';
  id: Scalars['ID'];
  /** User who added the reactions */
  actor: User;
  /** Reaction type */
  verb: NotificationPostReactionVerb;
  /** If notification was seen by user */
  seen: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  /** If notification was read by user */
  read: Scalars['Boolean'];
  /** Target activity object of notification. Type could be FeedActivityPostComment if it's a comment-like, instead it will be FeedActivity */
  object: NotificationPostReactionObject;
  /** Number of times user did the same reaction */
  activityCount: Scalars['Int'];
};

export type NotificationPostReactionObject = FeedActivityPost | FeedActivityPostComment;

export enum NotificationPostReactionVerb {
  Like = 'LIKE',
  Comment = 'COMMENT'
}

export type NotificationStreamConnection = StreamConnection & {
  __typename?: 'NotificationStreamConnection';
  pageInfo: StreamPageInfo;
  edges: Array<Maybe<NotificationStreamEdge>>;
  /** Number of unseen notifications */
  unseenCount: Scalars['Int'];
  /** Number of unread notifications */
  unreadCount: Scalars['Int'];
};

export type NotificationStreamEdge = Edge & {
  __typename?: 'NotificationStreamEdge';
  node: Notification;
  cursor: Scalars['String'];
};

export type NotificationTreecodeRedeem = Notification & {
  __typename?: 'NotificationTreecodeRedeem';
  id: Scalars['ID'];
  /** If notification was seen by user */
  seen: Scalars['Boolean'];
  /** If notification was read by user */
  read: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  /** Redeemer user */
  actor: User;
  /** Target treecode of notification */
  object: Treecode;
  verb: Scalars['String'];
};

export type NotificationTreeStatusChange = Notification & {
  __typename?: 'NotificationTreeStatusChange';
  id: Scalars['ID'];
  /** If notification was seen by user */
  seen: Scalars['Boolean'];
  /** If notification was read by user */
  read: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  actor: Tree;
  /** Target tree of notification */
  object: Tree;
  /** New status of tree */
  verb: TreeStatus;
};


export type OpenForestProduct = {
  __typename?: 'OpenForestProduct';
  product: Product;
  tree: Tree;
};

export type OpenForestProducts = {
  __typename?: 'OpenForestProducts';
  message: Scalars['String'];
  openForestProducts: Maybe<Array<Maybe<OpenForestProduct>>>;
};

export type OpenForestRedeem = {
  __typename?: 'OpenForestRedeem';
  message: Scalars['String'];
  tree: Maybe<Tree>;
};

export type OptionalTranslationInput = {
  /** Italian field */
  it?: Maybe<Scalars['String']>;
  /** English field */
  en?: Maybe<Scalars['String']>;
  /** Spanish field */
  es?: Maybe<Scalars['String']>;
  /** German field */
  de?: Maybe<Scalars['String']>;
  /** French field */
  fr?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  customLineItems: Array<CustomLineItem>;
  forestryTrees: ForestryTreeConnection;
  /** @deprecated Use order.treeGifts. */
  gifts: TreeConnection;
  lineItems: Array<CartLineItem>;
  paymentMethodName: Scalars['String'];
  purchaseType: OrderPurchaseType;
  shipmentState: OrderShipmentState;
  /** Indicates the order shipping address */
  shippingAddress: Maybe<ShippingAddress>;
  state: OrderState;
  totalPrice: Price;
  treeGifts: ForestryTreeConnection;
  /** User that requested the order */
  user: Maybe<User>;
};


export type OrderForestryTreesArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type OrderGiftsArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type OrderTreeGiftsArgs = {
  pagination?: Maybe<PaginationInput>;
};

/** Order not found */
export type OrderAddShippingInfoOrderNotFoundProblem = Problem & {
  __typename?: 'OrderAddShippingInfoOrderNotFoundProblem';
  message: Scalars['String'];
};

export type OrderAddShippingInfoOrderUpdateProblem = {
  __typename?: 'OrderAddShippingInfoOrderUpdateProblem';
  message: Scalars['String'];
};

export type OrderAddShippingInfoSuccessResponse = {
  __typename?: 'OrderAddShippingInfoSuccessResponse';
  orderId: Scalars['ID'];
};

export enum OrderBy {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderConnection = Connection & {
  __typename?: 'OrderConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<OrderEdge>>;
};

export type OrderEdge = Edge & {
  __typename?: 'OrderEdge';
  node: Maybe<Order>;
  cursor: Scalars['String'];
};

export type OrderMutation = {
  __typename?: 'OrderMutation';
  /**
   * Add shipping info to an order. 
   * Shipping info are frequently updates on the shipping status with tracking information.
   */
  addShippingInfo: AddShippingInfoResponse;
};


export type OrderMutationAddShippingInfoArgs = {
  input: AddShippingInfoInput;
};

export enum OrderPurchaseType {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

export enum OrderShipmentState {
  Backorder = 'BACKORDER',
  Delayed = 'DELAYED',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Ready = 'READY',
  Shipped = 'SHIPPED'
}

export enum OrderState {
  Open = 'OPEN',
  Confirmed = 'CONFIRMED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE'
}

export enum OrganizationType {
  /** 0: Onlus/Fondazione/Associazione */
  NovatFoundation = 'NOVAT_FOUNDATION',
  /** 1: Azienda italiana/Titolare di P.IVA */
  VatItalian = 'VAT_ITALIAN',
  /** 2: Azienda estera senza P.IVA */
  NovatForeign = 'NOVAT_FOREIGN'
}

export type Originator = {
  __typename?: 'Originator';
  id: Scalars['ID'];
  avatar: Maybe<Image>;
  concluded: Scalars['Boolean'];
  country: Country;
  description: Scalars['String'];
  displayName: Maybe<Scalars['String']>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  nurseryPlace: Place;
  /** Signed upload url which could be used to upload a new avatar */
  avatarUploadUrl: FileUpload;
};

export type OriginatorConnection = Connection & {
  __typename?: 'OriginatorConnection';
  totalCount: Scalars['Int'];
  pageInfo: Maybe<PageInfo>;
  edges: Maybe<Array<Maybe<OriginatorEdge>>>;
};

export type OriginatorEdge = Edge & {
  __typename?: 'OriginatorEdge';
  node: Maybe<Originator>;
  cursor: Maybe<Scalars['String']>;
};

export type OriginatorMutation = {
  __typename?: 'OriginatorMutation';
  create: CreateOriginatorResponse;
  update: UpdateOriginatorResponse;
  setAvatar: SetOriginatorAvatarResponse;
};


export type OriginatorMutationCreateArgs = {
  input: CreateOriginatorInput;
};


export type OriginatorMutationUpdateArgs = {
  id: Scalars['ID'];
  input: UpdateOriginatorInput;
};


export type OriginatorMutationSetAvatarArgs = {
  id: Scalars['ID'];
  iconId: Scalars['String'];
};

export type OriginatorsFilterInput = {
  id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  name?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Array<Maybe<Scalars['String']>>>;
  countryCode?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']>;
  hasNextPage: Maybe<Scalars['Boolean']>;
};

/** Arguments used to query a connection. This mirrors the `PaginationInput` type. */
export type PaginationArguments = {
  __typename?: 'PaginationArguments';
  first: Maybe<Scalars['Int']>;
  after: Maybe<Scalars['String']>;
};

export type PaginationInput = {
  /**
   * Forward pagination
   * takes a non-negative integer of how many items you want
   */
  first?: Maybe<Scalars['Int']>;
  /**
   * Forward pagination
   * takes the cursor in the `cursor` or `endCursor` page field
   */
  after?: Maybe<Scalars['String']>;
};

export type PartnerClientCreatePoolNotFoundProblem = Problem & {
  __typename?: 'PartnerClientCreatePoolNotFoundProblem';
  message: Scalars['String'];
};

export type PartnerClientCreateResponse = PartnerClientCredentials | PartnerClientCreatePoolNotFoundProblem;

export type PartnerClientCredentials = {
  __typename?: 'PartnerClientCredentials';
  clientId: Scalars['String'];
  clientSecret: Scalars['String'];
};

export type PartnerClientMutation = {
  __typename?: 'PartnerClientMutation';
  /** Create a partner OAuth Client */
  create: PartnerClientCreateResponse;
};


export type PartnerClientMutationCreateArgs = {
  input: CreatePartnerClientInput;
};

export type PartnerCreateResponse = Resource;

export type PartnerMutation = {
  __typename?: 'PartnerMutation';
  client: PartnerClientMutation;
  pool: PoolMutation;
  /** Create a partner */
  create: PartnerCreateResponse;
};


export type PartnerMutationCreateArgs = {
  input: CreatePartnerInput;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** The id of the payment method */
  token: Scalars['String'];
  /** The brand of the card. */
  cardType: Maybe<Scalars['String']>;
  /** Number of the card masked using '*' */
  maskedNumber: Maybe<Scalars['String']>;
  /** Email associated to the card */
  email: Maybe<Scalars['String']>;
  /** Expiration date of the card (MM/YY) */
  expirationDate: Maybe<Scalars['String']>;
  /** Indicates if the card is expired */
  expired: Maybe<Scalars['Boolean']>;
  type: Maybe<Scalars['String']>;
  /** Name of the owner of the card */
  holderName: Maybe<Scalars['String']>;
};

export type PaymentMethodCancelAssociatedSubscriptionProblem = Problem & {
  __typename?: 'PaymentMethodCancelAssociatedSubscriptionProblem';
  message: Scalars['String'];
};

export type PaymentMethodCancelInvalidUserProblem = Problem & {
  __typename?: 'PaymentMethodCancelInvalidUserProblem';
  message: Scalars['String'];
};

export type PaymentMethodCancelNotFoundProblem = Problem & {
  __typename?: 'PaymentMethodCancelNotFoundProblem';
  message: Scalars['String'];
};

export type PaymentMethodCancelProblem = Problem & {
  __typename?: 'PaymentMethodCancelProblem';
  message: Scalars['String'];
};

export type PaymentMethodCancelResponse = PaymentMethodCancelSuccessResponse | PaymentMethodCancelProblem | PaymentMethodCancelInvalidUserProblem | PaymentMethodCancelNotFoundProblem | PaymentMethodCancelAssociatedSubscriptionProblem;

export type PaymentMethodCancelSuccessResponse = {
  __typename?: 'PaymentMethodCancelSuccessResponse';
  /** The identifier of the deleted payment method. */
  id: Scalars['ID'];
};

export type PaymentMethodMutation = {
  __typename?: 'PaymentMethodMutation';
  /** Cancel the provided payment method */
  cancel: PaymentMethodCancelResponse;
};


export type PaymentMethodMutationCancelArgs = {
  input: CancelPaymentMethodInput;
};

export type PaymentsWhereConditionInput = {
  /** List of id which will be used to filter on */
  ids?: Maybe<Array<Scalars['ID']>>;
  planIds?: Maybe<Array<Scalars['ID']>>;
  supplierIds?: Maybe<Array<Scalars['ID']>>;
  externalDocumentIds?: Maybe<Array<Scalars['String']>>;
  externalDocumentTypes?: Maybe<Array<ExternalDocumentType>>;
  notes?: Maybe<Scalars['String']>;
  projectIds?: Maybe<Array<Scalars['ID']>>;
};

export type Pdf = {
  __typename?: 'Pdf';
  url: Scalars['String'];
};

/** A perk is an unlockable feature that a user can obtain by satisfying certain rules. */
export type Perk = PerkInterface & {
  __typename?: 'Perk';
  /** The identifier of the perk. */
  id: Scalars['ID'];
  /** The internal name of the perk. */
  internalName: Scalars['String'];
  /** The type of the content referenced by this perk. */
  contentType: PerkContentType;
  /** The identifier of the content that this perk is targeting. */
  targetId: Scalars['ID'];
  /** Indicates whether this perk is enabled. */
  enabled: Scalars['Boolean'];
  /** Indicates the sorting value for the user visualization */
  sortingIndex: Scalars['Int'];
  /** The set of rules that must be met for the perk to be activated. */
  ruleSets: Array<PerkRuleSet>;
  /** The date and time when the perk was created. */
  createdAt: Scalars['Date'];
  /** The date and time when the perk was last updated. */
  updatedAt: Scalars['Date'];
};

/** A perk that unlocks access to a communication kit. */
export type PerkCommunicationKit = PerkInterface & {
  __typename?: 'PerkCommunicationKit';
  /** The identifier of the perk. */
  id: Scalars['ID'];
  /** The internal name of the perk. */
  internalName: Scalars['String'];
  /** The type of the content referenced by this perk. */
  contentType: PerkContentType;
  /** The identifier of the content that this perk is targeting. */
  targetId: Scalars['ID'];
  /** Indicates whether this perk is enabled. */
  enabled: Scalars['Boolean'];
  /** Indicates the sorting value for the user visualization */
  sortingIndex: Scalars['Int'];
  /** The set of rules that must be met for the perk to be activated. */
  ruleSets: Array<PerkRuleSet>;
  /** The date and time when the perk was created. */
  createdAt: Scalars['Date'];
  /** The date and time when the perk was last updated. */
  updatedAt: Scalars['Date'];
  /** The communication kit that is unlocked by this perk. */
  communicationKit: Maybe<CommunicationKit>;
};

export type PerkConnection = Connection & {
  __typename?: 'PerkConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<PerkConnectionEdge>>;
};

export type PerkConnectionEdge = Edge & {
  __typename?: 'PerkConnectionEdge';
  node: Maybe<PerkConnectionEdgeNode>;
  cursor: Maybe<Scalars['String']>;
};

export type PerkConnectionEdgeNode = Perk | PerkCommunicationKit;

/** The type of the content referenced by a perk. */
export enum PerkContentType {
  CommunicationKit = 'CommunicationKit',
  Badge = 'Badge'
}

/** The input data used to create a new perk. */
export type PerkCreateInput = {
  /** The internal name of the perk. */
  internalName: Scalars['String'];
  /** The type of the perk. */
  contentType: PerkContentType;
  /** The external reference ID of the perk. */
  contentId: Scalars['ID'];
  /** Whether the perk is enabled. */
  enabled: Scalars['Boolean'];
  /** The sorting index of the perk. */
  sortingIndex?: Maybe<Scalars['Int']>;
};

export type PerkCreateMutationResponse = Perk | PerkCreateUnknownProblem;

/** Indicates that an unknown problem occurred while creating a perk. */
export type PerkCreateUnknownProblem = Problem & {
  __typename?: 'PerkCreateUnknownProblem';
  message: Scalars['String'];
};

/** A perk is an unlockable feature that a user can obtain by satisfying certain rules. */
export type PerkInterface = {
  /** The identifier of the perk. */
  id: Scalars['ID'];
  /** The type of the content referenced by this perk. */
  contentType: PerkContentType;
  /** The date and time when the perk was created. */
  createdAt: Scalars['Date'];
  /** Indicates whether this perk is enabled. */
  enabled: Scalars['Boolean'];
  /** The internal name of the perk. */
  internalName: Scalars['String'];
  /** The set of rules that must be met for the perk to be activated. */
  ruleSets: Array<PerkRuleSet>;
  /** Indicates the sorting value for the user visualization */
  sortingIndex: Scalars['Int'];
  /** The identifier of the content that this perk is targeting. */
  targetId: Scalars['ID'];
  /** The date and time when the perk was last updated. */
  updatedAt: Scalars['Date'];
};

export type PerkMutation = {
  __typename?: 'PerkMutation';
  /** Create a new perk. */
  create: PerkCreateMutationResponse;
  /** Update a perk. */
  update: PerkUpdateMutationResponse;
  /** Add a rule set to a perk */
  addRuleSet: AddRuleSetMutationResponse;
  /** Remove a rule set from a perk */
  removeRuleSet: RemoveRuleSetMutationResponse;
  /** Update a rule set into a perk */
  updateRuleSet: UpdateRuleSetMutationResponse;
};


export type PerkMutationCreateArgs = {
  input: PerkCreateInput;
};


export type PerkMutationUpdateArgs = {
  id: Scalars['ID'];
  input: PerkUpdateInput;
};


export type PerkMutationAddRuleSetArgs = {
  perkId: Scalars['ID'];
  input: PerkRuleSetInput;
};


export type PerkMutationRemoveRuleSetArgs = {
  perkId: Scalars['ID'];
  ruleSetId: Scalars['ID'];
};


export type PerkMutationUpdateRuleSetArgs = {
  perkId: Scalars['ID'];
  ruleSetId: Scalars['ID'];
  input: PerkRuleSetInput;
};

export type PerkQueryInput = {
  /** The ID of the perk. */
  id: Scalars['ID'];
};

export type PerkRule = PerkRuleProduct | PerkRuleImpact | PerkRulePlan | PerkRuleTreeQuantity;

/** A rule that applies to an impact. */
export type PerkRuleImpact = PerkRuleInterface & {
  __typename?: 'PerkRuleImpact';
  id: Scalars['ID'];
  /** The key of the impact to which this rule applies. */
  key: Scalars['ID'];
};

export type PerkRuleImpactInput = {
  impactKey: Scalars['ID'];
};

export type PerkRuleInput = {
  product?: Maybe<PerkRuleProductInput>;
  impact?: Maybe<PerkRuleImpactInput>;
  plan?: Maybe<PerkRulePlanInput>;
  treeQuantity?: Maybe<PerkRuleTreeQuantityInput>;
};

/** A condition that must be met for a perk to be activated. */
export type PerkRuleInterface = {
  id: Scalars['ID'];
};

/** A rule that applies to a subscription plan. */
export type PerkRulePlan = PerkRuleInterface & {
  __typename?: 'PerkRulePlan';
  id: Scalars['ID'];
  /** The ID of the plan to which this rule applies. */
  planId: Scalars['ID'];
  /** The required lifetime of the subscription. */
  sinceMonths: Maybe<Scalars['Int']>;
};

export type PerkRulePlanInput = {
  planId: Scalars['ID'];
  sinceMonths?: Maybe<Scalars['Int']>;
};

/** A rule that applies to a product. */
export type PerkRuleProduct = PerkRuleInterface & {
  __typename?: 'PerkRuleProduct';
  id: Scalars['ID'];
  /** The product key to which this rule applies. */
  productKey: Maybe<Scalars['ID']>;
  /** The quantity needed to trigger the rule. */
  quantity: Scalars['Int'];
  /** The date range during which this rule is triggered. */
  from: Maybe<Scalars['Date']>;
  /** The date range during which this rule is triggered. */
  to: Maybe<Scalars['Date']>;
};

export type PerkRuleProductInput = {
  /** If the product key is not set, the rule will apply to any product key */
  productKey?: Maybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

/** A set of rules that must be met for a perk to be activated. */
export type PerkRuleSet = {
  __typename?: 'PerkRuleSet';
  id: Scalars['ID'];
  perkId: Scalars['ID'];
  rules: Array<PerkRule>;
};

export type PerkRuleSetInput = {
  rules: Array<PerkRuleInput>;
};

/** A rule that applies to the tree quantity. */
export type PerkRuleTreeQuantity = PerkRuleInterface & {
  __typename?: 'PerkRuleTreeQuantity';
  id: Scalars['ID'];
  /** The quantity needed to trigger the rule. */
  quantity: Scalars['Int'];
  /** The date range during which this rule is triggered. */
  from: Maybe<Scalars['Date']>;
  /** The date range during which this rule is triggered. */
  to: Maybe<Scalars['Date']>;
};

/** The quantity rule is based on tree quantity, that includes also trees in bundles */
export type PerkRuleTreeQuantityInput = {
  quantity: Scalars['Int'];
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

/** Filters for perks. */
export type PerksFilterInput = {
  /** Search by internal name. */
  internalName?: Maybe<Scalars['String']>;
  /** Filter by content type. */
  perkContentType?: Maybe<Array<PerkContentType>>;
  /** Filter by enabled status. */
  enabled?: Maybe<Scalars['Boolean']>;
};

export enum PerksOrderByField {
  InternalName = 'INTERNAL_NAME',
  PerkContentType = 'PERK_CONTENT_TYPE',
  Enabled = 'ENABLED',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  SortingIndex = 'SORTING_INDEX'
}

export type PerksOrderByInput = {
  /** Sorting field */
  field?: Maybe<PerksOrderByField>;
  /** Sorting order */
  order?: Maybe<OrderBy>;
};

/** The input data used to update a perk. */
export type PerkUpdateInput = {
  /** The internal name of the perk. */
  internalName?: Maybe<Scalars['String']>;
  /** Whether the perk is enabled. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Sorting index of the perk. This value is used to sort the perks. */
  sortingIndex?: Maybe<Scalars['Int']>;
};

/** Problem that occurs when the input data is invalid. */
export type PerkUpdateInvalidInputProblem = Problem & {
  __typename?: 'PerkUpdateInvalidInputProblem';
  message: Scalars['String'];
};

export type PerkUpdateMutationResponse = Perk | PerkUpdateUnknownProblem | PerkUpdateNotFoundProblem | PerkUpdateInvalidInputProblem;

/** Problem that occurs when the perk to update is not found. */
export type PerkUpdateNotFoundProblem = Problem & {
  __typename?: 'PerkUpdateNotFoundProblem';
  message: Scalars['String'];
};

/** Indicates that an unknown problem occurred while updating the perk. */
export type PerkUpdateUnknownProblem = Problem & {
  __typename?: 'PerkUpdateUnknownProblem';
  message: Scalars['String'];
};

/** A Pill is a short, digestible piece of content that is shown in the Explore section. */
export type Pill = {
  __typename?: 'Pill';
  id: Scalars['ID'];
  /** The title of the Pill. */
  title: Scalars['String'];
  /** The abstract of the Pill. */
  abstract: Scalars['String'];
  /** The body of the Pill. It contains Markdown formatted text. */
  body: Scalars['String'];
  /** The style of the Pill. */
  cardStyle: PillCardStyle;
  /** The image of the Pill. */
  heroImage: Image;
  /** The topic of the Pill. */
  topic: PillTopic;
  /** The date when the Pill was published. */
  publishDate: Scalars['DateTime'];
  /**
   * The shareable URL of the Pill.
   * @deprecated Mocked field, will be implemented later.
   */
  shareUrl: Scalars['String'];
};


/** A Pill is a short, digestible piece of content that is shown in the Explore section. */
export type PillTitleArgs = {
  locale: Scalars['String'];
};


/** A Pill is a short, digestible piece of content that is shown in the Explore section. */
export type PillAbstractArgs = {
  locale: Scalars['String'];
};


/** A Pill is a short, digestible piece of content that is shown in the Explore section. */
export type PillBodyArgs = {
  locale: Scalars['String'];
};


/** A Pill is a short, digestible piece of content that is shown in the Explore section. */
export type PillHeroImageArgs = {
  locale: Scalars['String'];
};

/** The style of a Pill. */
export enum PillCardStyle {
  FullImage = 'FULL_IMAGE',
  HalfImage = 'HALF_IMAGE',
  Icon = 'ICON'
}

export type PillConnection = Connection & {
  __typename?: 'PillConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<PillEdge>>;
};

export type PillEdge = Edge & {
  __typename?: 'PillEdge';
  node: Maybe<Pill>;
  cursor: Maybe<Scalars['String']>;
};

export type PillsFilterInput = {
  /** Filter pills by topic. */
  topics?: Maybe<Array<Scalars['String']>>;
};

/** A topic is a category of pills that can be used to group pills together. */
export type PillTopic = {
  __typename?: 'PillTopic';
  id: Scalars['ID'];
  /** The human readable identifier for the topic. */
  key: Scalars['String'];
  /** The name of the topic in the given locale. */
  name: Scalars['String'];
  /** The description of the topic in the given locale. */
  description: Maybe<Scalars['String']>;
};


/** A topic is a category of pills that can be used to group pills together. */
export type PillTopicNameArgs = {
  locale: Scalars['String'];
};


/** A topic is a category of pills that can be used to group pills together. */
export type PillTopicDescriptionArgs = {
  locale: Scalars['String'];
};

export type Place = {
  __typename?: 'Place';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  /** The place name in the given locale. */
  name: Scalars['String'];
  country: Maybe<Country>;
};


export type PlaceNameArgs = {
  locale: Scalars['String'];
};

export type PlaceInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  duration: Scalars['Int'];
  name: Scalars['String'];
  products: Array<PlanProduct>;
  renewLimit: Scalars['Int'];
  totalAssignments: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  /** Indicates whether the plan is in a valid state. */
  validation: PlanValidation;
};

export type PlanConnection = Connection & {
  __typename?: 'PlanConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<PlanEdge>>;
};

/** Problem that occurs when the plan does not have a valid duration. */
export type PlanDurationNotPositiveProblem = Problem & {
  __typename?: 'PlanDurationNotPositiveProblem';
  message: Scalars['String'];
};

export type PlanEdge = Edge & {
  __typename?: 'PlanEdge';
  node: Maybe<Plan>;
  cursor: Scalars['String'];
};

/** Problem that occurs when the plan has an invalid name. */
export type PlanEmptyNameProblem = Problem & {
  __typename?: 'PlanEmptyNameProblem';
  message: Scalars['String'];
};

export type PlanFinancialStatement = {
  __typename?: 'PlanFinancialStatement';
  id: Scalars['ID'];
  balance: Maybe<Scalars['Float']>;
  plan: ProcurementPlan;
  totalCost: Maybe<Scalars['Float']>;
  totalPaid: Maybe<Scalars['Float']>;
};

export type PlanFinancialStatementConnection = Connection & {
  __typename?: 'PlanFinancialStatementConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<PlanFinancialStatementEdge>>;
  pageInfo: PageInfo;
};

export type PlanFinancialStatementEdge = Edge & {
  __typename?: 'PlanFinancialStatementEdge';
  cursor: Scalars['String'];
  node: Maybe<PlanFinancialStatement>;
};

export type PlanFinancialStatementsWhereConditionInput = {
  /** List of plan ids which will be used to filter on */
  planIds?: Maybe<Array<Scalars['ID']>>;
};

/** Problem that occurs when the plan is referenced by some active subscription. */
export type PlanInUseProblem = Problem & {
  __typename?: 'PlanInUseProblem';
  message: Scalars['String'];
};

export type PlanMutation = {
  __typename?: 'PlanMutation';
  /** Create a new plan. */
  create: CreatePlanResponse;
  /** Delete a subscription assignment plan. */
  delete: DeletePlanResponse;
  product: PlanProductMutation;
  /**
   * Refresh an existing plan in the cache.
   * Optionally it can refresh billing and assignment plans.
   */
  refresh: RefreshPlanResponse;
  /** Update an existing plan. */
  update: UpdatePlanResponse;
};


export type PlanMutationCreateArgs = {
  input: CreatePlanInput;
};


export type PlanMutationDeleteArgs = {
  planId: Scalars['ID'];
};


export type PlanMutationRefreshArgs = {
  planId: Scalars['ID'];
  input?: Maybe<RefreshPlanInput>;
};


export type PlanMutationUpdateArgs = {
  planId: Scalars['ID'];
  input: UpdatePlanInput;
};

/** Problem that occurs when the plan is not found. */
export type PlanNotFoundProblem = Problem & {
  __typename?: 'PlanNotFoundProblem';
  message: Scalars['String'];
};

/** Problem codes that can occur when updating a plan. */
export enum PlanProblemCode {
  /** Unknown problem. */
  Unknown = 'UNKNOWN',
  /** The plan was not found. */
  PlanNotFound = 'PLAN_NOT_FOUND',
  /** The plan should have at least one assignment. */
  PlanMissingAssignments = 'PLAN_MISSING_ASSIGNMENTS',
  /** The plan should have at least one product. */
  PlanMissingProducts = 'PLAN_MISSING_PRODUCTS',
  /** The plan name is empty. */
  EmptyName = 'EMPTY_NAME',
  /** The duration must be greater than 0. */
  DurationNotPositive = 'DURATION_NOT_POSITIVE',
  /** The renew limit must be greater than -1. */
  InvalidRenewLimit = 'INVALID_RENEW_LIMIT'
}

export type PlanProduct = {
  __typename?: 'PlanProduct';
  id: Scalars['ID'];
  assignmentCycle: Scalars['Int'];
  delay: Scalars['Int'];
  product: Maybe<Product>;
  quantity: Scalars['Int'];
  /** @deprecated This field is deprecated. The information is not anymore part of type. */
  renewCycle: Scalars['Int'];
};

export type PlanProductMutation = {
  __typename?: 'PlanProductMutation';
  add: AddPlanProductResponse;
  delete: DeletePlanProductResponse;
  update: UpdatePlanProductResponse;
};


export type PlanProductMutationAddArgs = {
  planId: Scalars['ID'];
  input: AddPlanProductInput;
};


export type PlanProductMutationDeleteArgs = {
  id: Scalars['ID'];
};


export type PlanProductMutationUpdateArgs = {
  id: Scalars['ID'];
  input: UpdatePlanProductInput;
};

/** Problem codes that can occur when updating the product of a plan. */
export enum PlanProductProblemCode {
  /** Unknown problem. */
  Unknown = 'UNKNOWN',
  /** The plan product was not found. */
  PlanProductNotFound = 'PLAN_PRODUCT_NOT_FOUND',
  /** The plan was not found. */
  PlanNotFound = 'PLAN_NOT_FOUND',
  /** The current plan is being used by active subscriptions and the new products are less than the current product. */
  ActivePlanMinProductsNotMet = 'ACTIVE_PLAN_MIN_PRODUCTS_NOT_MET',
  /** The product assignment cycles are not progressive. */
  ProductAssignmentCyclesNotProgressive = 'PRODUCT_ASSIGNMENT_CYCLES_NOT_PROGRESSIVE',
  /** The product assignment delays are not positive. */
  ProductAssignmentDelayNotPositive = 'PRODUCT_ASSIGNMENT_DELAY_NOT_POSITIVE',
  /** The product assignment delays are not progressive. */
  ProductAssignmentDelayNotProgressive = 'PRODUCT_ASSIGNMENT_DELAY_NOT_PROGRESSIVE',
  /** The product assignment delays are not less than the plan duration. */
  ProductAssignmentDelayNotLessThanDuration = 'PRODUCT_ASSIGNMENT_DELAY_NOT_LESS_THAN_DURATION',
  /** One or more of the product assignment cycles are invalid. */
  InvalidProductAssignmentCycle = 'INVALID_PRODUCT_ASSIGNMENT_CYCLE'
}

export type PlanSpeciePrice = {
  __typename?: 'PlanSpeciePrice';
  /** ID of the supplier */
  id: Scalars['ID'];
  /** The procurement plan related to this price */
  plan: ProcurementPlan;
  /** The price related to this plan specie price */
  price: Scalars['Float'];
  /** The project specie related to this price */
  projectSpecie: ProjectSpecie;
};

export type PlanSpeciePriceConnection = Connection & {
  __typename?: 'PlanSpeciePriceConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<PlanSpeciePriceEdge>>;
  pageInfo: PageInfo;
};

export type PlanSpeciePriceEdge = Edge & {
  __typename?: 'PlanSpeciePriceEdge';
  cursor: Scalars['String'];
  node: Maybe<PlanSpeciePrice>;
};

export type PlanSpeciePriceWhereConditionInput = {
  /** List of plan ids which will be used to filter on */
  planIds?: Maybe<Array<Scalars['ID']>>;
  /** List of project specie ids which will be used to filter on */
  projectSpecieIds?: Maybe<Array<Scalars['ID']>>;
  /** List of plan specie price id which will be used to filter on */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type PlanSubscription = {
  __typename?: 'PlanSubscription';
  id: Scalars['ID'];
  assignedTreeCount: Scalars['Int'];
  assignments: PlanSubscriptionAssignmentConnection;
  billingPlan: BillingPlan;
  billings: PlanSubscriptionBillingConnection;
  createdAt: Scalars['DateTime'];
  expiresAt: Maybe<Scalars['String']>;
  nextPaymentDate: Scalars['DateTime'];
  order: Maybe<Order>;
  paymentMethod: Maybe<PaymentMethod>;
  paymentMethodId: Scalars['String'];
  plan: Plan;
  price: Price;
  product: Product;
  productVariant: ProductVariant;
  state: PlanSubscriptionState;
  updatedAt: Scalars['DateTime'];
  user: User;
};


export type PlanSubscriptionAssignmentsArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type PlanSubscriptionBillingsArgs = {
  pagination?: Maybe<PaginationInput>;
};

export type PlanSubscriptionAssignment = {
  __typename?: 'PlanSubscriptionAssignment';
  id: Scalars['ID'];
  assignmentCycle: Scalars['Int'];
  product: Maybe<Product>;
  quantity: Scalars['Int'];
};

export type PlanSubscriptionAssignmentConnection = Connection & {
  __typename?: 'PlanSubscriptionAssignmentConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<PlanSubscriptionAssignmentEdge>>;
};

export type PlanSubscriptionAssignmentEdge = Edge & {
  __typename?: 'PlanSubscriptionAssignmentEdge';
  node: Maybe<PlanSubscriptionAssignment>;
  cursor: Scalars['String'];
};

export type PlanSubscriptionBadge = {
  __typename?: 'PlanSubscriptionBadge';
  type: PlanSubscriptionBadgeType;
  startedAt: Maybe<Scalars['DateTime']>;
};

export enum PlanSubscriptionBadgeType {
  OneActiveSubscription = 'ONE_ACTIVE_SUBSCRIPTION'
}

export type PlanSubscriptionBilling = {
  __typename?: 'PlanSubscriptionBilling';
  id: Scalars['ID'];
};

export type PlanSubscriptionBillingConnection = Connection & {
  __typename?: 'PlanSubscriptionBillingConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<PlanSubscriptionBillingEdge>>;
};

export type PlanSubscriptionBillingEdge = Edge & {
  __typename?: 'PlanSubscriptionBillingEdge';
  node: Maybe<PlanSubscriptionBilling>;
  cursor: Scalars['String'];
};

export type PlanSubscriptionCancelAlreadyCanceledProblem = Problem & {
  __typename?: 'PlanSubscriptionCancelAlreadyCanceledProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionCancelExpireDateNotValidProblem = Problem & {
  __typename?: 'PlanSubscriptionCancelExpireDateNotValidProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionCancelNotAuthorizedProblem = Problem & {
  __typename?: 'PlanSubscriptionCancelNotAuthorizedProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionCancelNotFoundProblem = Problem & {
  __typename?: 'PlanSubscriptionCancelNotFoundProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionCancelResponse = Resource | PlanSubscriptionCancelNotFoundProblem | PlanSubscriptionCancelNotAuthorizedProblem | PlanSubscriptionCancelAlreadyCanceledProblem | PlanSubscriptionCancelExpireDateNotValidProblem;

export type PlanSubscriptionChangePaymentMethodAlreadyPresentProblem = Problem & {
  __typename?: 'PlanSubscriptionChangePaymentMethodAlreadyPresentProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionChangePaymentMethodCanceledProblem = Problem & {
  __typename?: 'PlanSubscriptionChangePaymentMethodCanceledProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionChangePaymentMethodNotAuthorizedProblem = Problem & {
  __typename?: 'PlanSubscriptionChangePaymentMethodNotAuthorizedProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionChangePaymentMethodPaymentMethodExpiredProblem = Problem & {
  __typename?: 'PlanSubscriptionChangePaymentMethodPaymentMethodExpiredProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionChangePaymentMethodPaymentMethodNotFoundProblem = Problem & {
  __typename?: 'PlanSubscriptionChangePaymentMethodPaymentMethodNotFoundProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionChangePaymentMethodResponse = CheckoutSessionResponse | PlanSubscriptionChangePaymentMethodPaymentMethodNotFoundProblem | PlanSubscriptionChangePaymentMethodSubscriptionNotFoundProblem | PlanSubscriptionChangePaymentMethodAlreadyPresentProblem | PlanSubscriptionChangePaymentMethodNotAuthorizedProblem | PlanSubscriptionChangePaymentMethodCanceledProblem | PlanSubscriptionChangePaymentMethodPaymentMethodExpiredProblem;

export type PlanSubscriptionChangePaymentMethodSubscriptionNotFoundProblem = Problem & {
  __typename?: 'PlanSubscriptionChangePaymentMethodSubscriptionNotFoundProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionConnection = Connection & {
  __typename?: 'PlanSubscriptionConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<PlanSubscriptionEdge>>;
};

export type PlanSubscriptionEdge = Edge & {
  __typename?: 'PlanSubscriptionEdge';
  node: Maybe<PlanSubscription>;
  cursor: Scalars['String'];
};

export type PlanSubscriptionMutation = {
  __typename?: 'PlanSubscriptionMutation';
  /** Adds a survey that is filled out when a subscription is canceled. */
  addCancelationSurvey: AddSubscriptionCancelationSurveyResponse;
  /**
   * Request the cancelation of provided Subscription, setting state as PENDING_CANCELATION
   * Parameter `expireDate` can be used to set a custom expiration date, when subscription will be definitively dead.
   */
  cancel: PlanSubscriptionCancelResponse;
  /** Update active payment method of Subscription */
  changePaymentMethod: PlanSubscriptionChangePaymentMethodResponse;
  /**
   * Request the reactivation of provided Subscription.
   * The mutation works only for subscriptions in the PENDING_CANCELATION state
   */
  reactivate: PlanSubscriptionReactivateResponse;
  /** Set details of previously created payment. */
  setSubscriptionPaymentDetails: SetSubscriptionPaymentDetailsResponse;
};


export type PlanSubscriptionMutationAddCancelationSurveyArgs = {
  subscriptionId: Scalars['ID'];
  input: AddSubscriptionCancelationSurveyInput;
};


export type PlanSubscriptionMutationCancelArgs = {
  id: Scalars['ID'];
  expireDate?: Maybe<Scalars['DateTime']>;
};


export type PlanSubscriptionMutationChangePaymentMethodArgs = {
  input: ChangePaymentMethodInput;
};


export type PlanSubscriptionMutationReactivateArgs = {
  id: Scalars['ID'];
};


export type PlanSubscriptionMutationSetSubscriptionPaymentDetailsArgs = {
  input: SetSubscriptionPaymentDetailsInput;
};

export type PlanSubscriptionReactivateNotAuthorizedProblem = Problem & {
  __typename?: 'PlanSubscriptionReactivateNotAuthorizedProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionReactivateNotFoundProblem = Problem & {
  __typename?: 'PlanSubscriptionReactivateNotFoundProblem';
  message: Scalars['String'];
};

export type PlanSubscriptionReactivateResponse = Resource | PlanSubscriptionReactivateNotFoundProblem | PlanSubscriptionReactivateNotAuthorizedProblem | PlanSubscriptionReactivateWrongStateProblem;

export type PlanSubscriptionReactivateWrongStateProblem = Problem & {
  __typename?: 'PlanSubscriptionReactivateWrongStateProblem';
  message: Scalars['String'];
};

export enum PlanSubscriptionState {
  Initializing = 'INITIALIZING',
  Active = 'ACTIVE',
  FailedRenewal = 'FAILED_RENEWAL',
  PastDue = 'PAST_DUE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  PendingCancelation = 'PENDING_CANCELATION'
}

/** Problem that occurs when something wrong happened. */
export type PlanUnknownProblem = Problem & {
  __typename?: 'PlanUnknownProblem';
  message: Scalars['String'];
};

export type PlanValidation = {
  __typename?: 'PlanValidation';
  /** A list of errors that are preventing the plan from being activated. */
  errors: Array<PlanValidationError>;
  /** Indicates whether the plan is valid and can be activated. */
  isValid: Scalars['Boolean'];
};

export type PlanValidationError = {
  __typename?: 'PlanValidationError';
  /**
   * Indicates the type of error.
   * Possible values come from: PlanProblemCode and PlanProductProblemCode
   */
  code: Scalars['String'];
  /** The resource that the error pertains to. */
  resource: Maybe<PlanValidationErrorResource>;
};

export type PlanValidationErrorResource = Plan | PlanProduct;

export type PoolCreatePartnerNotFoundProblem = Problem & {
  __typename?: 'PoolCreatePartnerNotFoundProblem';
  message: Scalars['String'];
};

export type PoolCreateResponse = Resource | PoolCreatePartnerNotFoundProblem;

export type PoolMutation = {
  __typename?: 'PoolMutation';
  /** Create a partner Pool */
  create: PoolCreateResponse;
};


export type PoolMutationCreateArgs = {
  input: CreatePoolInput;
};

export type PrecipitationIntensity = {
  __typename?: 'PrecipitationIntensity';
  /**
   * The precipitation level is an indicator of the intensity
   * <= 0.1: LIGHT
   * > 0.1 & < 1.0: NORMAL
   * >= 1.0: STRONG
   */
  level: Maybe<PrecipitationLevel>;
  /** Volume of the intensity in the last hour */
  value: Maybe<Scalars['Float']>;
};

export enum PrecipitationLevel {
  Light = 'LIGHT',
  Normal = 'NORMAL',
  Strong = 'STRONG'
}

export type Price = {
  __typename?: 'Price';
  /** Currency code follows the ISO4217 standard (e.g "EUR", "USD") */
  currencyCode: Maybe<Scalars['String']>;
  /** Price in cent amount */
  centAmount: Maybe<Scalars['Int']>;
  /** Number of decimal positions in the centAmount value */
  fractionDigits: Maybe<Scalars['Int']>;
  /** Country code */
  country: Maybe<Scalars['String']>;
  /** The customer group related to this price. If empty, it's a guest price. */
  customerGroup: Maybe<EcommerceCustomerGroup>;
};

export type PriceSelectorInput = {
  currency: ShopCurrency;
  countryCode?: Maybe<Scalars['String']>;
  customerGroup?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
};

export type PrivacyFlags = {
  __typename?: 'PrivacyFlags';
  showInSearch: Maybe<Scalars['Boolean']>;
  showFromHome: Maybe<Scalars['Boolean']>;
  showLocation: Maybe<Scalars['Boolean']>;
  showBirthday: Maybe<Scalars['Boolean']>;
  showWall: Maybe<Scalars['Boolean']>;
  showPeople: Maybe<Scalars['Boolean']>;
};

export type Problem = {
  message: Scalars['String'];
};

/** The forestry plan managed by the procurement service */
export type ProcurementPlan = {
  __typename?: 'ProcurementPlan';
  id: Scalars['ID'];
  expiredAt: Scalars['DateTime'];
  name: Scalars['String'];
  /** The projects related to this ProcurementPlan */
  project: Maybe<ProcurementProject>;
  startedAt: Scalars['DateTime'];
  state: ProcurementPlanState;
};

export type ProcurementPlansConnection = Connection & {
  __typename?: 'ProcurementPlansConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<ProcurementPlansEdge>>;
  pageInfo: PageInfo;
};

export type ProcurementPlansEdge = Edge & {
  __typename?: 'ProcurementPlansEdge';
  cursor: Scalars['String'];
  node: Maybe<ProcurementPlan>;
};

export enum ProcurementPlanState {
  Pending = 'PENDING',
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export type ProcurementPlansWhereConditionInput = {
  /** List of id which will be used to filter on */
  ids?: Maybe<Array<Scalars['ID']>>;
};

/** The forestry project managed by the procurement service */
export type ProcurementProject = {
  __typename?: 'ProcurementProject';
  id: Scalars['ID'];
  /** The project's country */
  country: Country;
  /** The project's name */
  name: Scalars['String'];
};

export type Product = {
  /** The id of the product */
  id: Scalars['ID'];
  /** Commerce Tools id of the product */
  ctId: Scalars['ID'];
  /** SKU of the product */
  sku: Scalars['String'];
  /** Friendly identifier of the product */
  slug: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Maybe<Scalars['String']>;
  /** Description of the product */
  description: Maybe<Scalars['String']>;
  /** Multi-currency prices with possible discount applied on the product */
  prices: Array<Price>;
  /** Multi-currency prices without applied discounts */
  fullPrices: Array<Price>;
  /** Multi-currency prices without any filters */
  unfilteredPrices: Array<Price>;
  /** Icon of the product */
  icon: Maybe<Image>;
  variants: Array<ProductVariant>;
};


export type ProductSlugArgs = {
  locale: Scalars['String'];
};


export type ProductNameArgs = {
  locale: Scalars['String'];
};


export type ProductDescriptionArgs = {
  locale: Scalars['String'];
};


export type ProductPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductFullPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductUnfilteredPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};

/** Used when retrieving alternative products for a product. */
export type ProductAlternativesInput = {
  /** The maximum number of alternative products to return. */
  limit?: Maybe<Scalars['Int']>;
};

export type ProductBadge = {
  __typename?: 'ProductBadge';
  /** Key of the product badge */
  key: ProductBadgeKey;
  /** The validUntil it's a specification that comes with the following keys: UNTIL */
  validUntil: Maybe<Scalars['DateTime']>;
};

export enum ProductBadgeKey {
  /** The product is new  */
  New = 'NEW',
  /** The product will be available soon */
  ComingSoon = 'COMING_SOON',
  /** The product is no longer available */
  SoldOut = 'SOLD_OUT',
  /** The product will be available until the expiresAt date provided */
  Until = 'UNTIL',
  /** The product will be available only in Italian market (only visually speaking) */
  ItalyOnly = 'ITALY_ONLY',
  /** The product has limited stock */
  LimitedStock = 'LIMITED_STOCK',
  /** The product is a best seller */
  BestSeller = 'BEST_SELLER',
  /** There is a flash deal for this product */
  FlashDeal = 'FLASH_DEAL',
  /** The product is a gift idea */
  GiftIdea = 'GIFT_IDEA'
}

export enum ProductBenefit {
  EconomicGrowth = 'ECONOMIC_GROWTH',
  FoodSafety = 'FOOD_SAFETY',
  EnvironmentProtection = 'ENVIRONMENT_PROTECTION',
  Co2Absorption = 'CO2_ABSORPTION'
}

export type ProductBenefits = {
  __typename?: 'ProductBenefits';
  socialEconomic: Maybe<Scalars['Int']>;
  environmental: Maybe<Scalars['Int']>;
};

export type ProductBeverageBrewing = Product & {
  __typename?: 'ProductBeverageBrewing';
  /** The id of the product */
  id: Scalars['ID'];
  /** Commerce Tools id of the product */
  ctId: Scalars['ID'];
  /** SKU of the product */
  sku: Scalars['String'];
  /** Friendly identifier of the product */
  slug: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Maybe<Scalars['String']>;
  /** Description of the product */
  description: Maybe<Scalars['String']>;
  /** Multi-currency prices with possible discount applied on the product */
  prices: Array<Price>;
  /** Multi-currency prices without applied discounts */
  fullPrices: Array<Price>;
  /** Multi-currency prices without any filters */
  unfilteredPrices: Array<Price>;
  /** Flag that indicates if the product is available */
  isAvailable: Scalars['Boolean'];
  /**
   * Quantity of stock available.
   * When is null means the availability should not be shown
   */
  stockAvailability: Maybe<Scalars['Int']>;
  /** Gallery of images. */
  gallery: Array<Maybe<Image>>;
  /** Badge for the product */
  badge: Maybe<ProductBadge>;
  /** Caption for the product */
  caption: Maybe<Scalars['String']>;
  /** Color for text of caption (hexadecimal, e.g. #FF0000 for red)  */
  captionTextColor: Maybe<Scalars['String']>;
  /** Icon of the product */
  icon: Maybe<Image>;
  /** Beverage brewing partner: the partner for this kind of product */
  partner: Maybe<BeverageBrewingPartnerEnum>;
  /** Shipping information */
  shippingInfo: Maybe<Scalars['String']>;
  /** Tree-types products list linked to this physical product */
  trees: Maybe<Array<Maybe<ProductBundleTreeItem>>>;
  /** Unit of measure */
  unitOfMeasure: Maybe<UnitOfMeasureEnum>;
  variants: Array<ProductBeverageBrewingVariant>;
};


export type ProductBeverageBrewingSlugArgs = {
  locale: Scalars['String'];
};


export type ProductBeverageBrewingNameArgs = {
  locale: Scalars['String'];
};


export type ProductBeverageBrewingDescriptionArgs = {
  locale: Scalars['String'];
};


export type ProductBeverageBrewingPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductBeverageBrewingFullPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductBeverageBrewingUnfilteredPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductBeverageBrewingCaptionArgs = {
  locale: Scalars['String'];
};


export type ProductBeverageBrewingShippingInfoArgs = {
  locale: Scalars['String'];
};

export type ProductBeverageBrewingVariant = ProductVariant & {
  __typename?: 'ProductBeverageBrewingVariant';
  key: Scalars['ID'];
  fullPrices: Array<Price>;
  /**
   * Retrieve variant images.
   * The images GraphQL field utilizes an optional selector argument, operating as a simplified regex filter for precise image label retrieval. (gallery*, ga*lery)
   */
  images: Array<Image>;
  prices: Array<Price>;
  quantity: Maybe<Scalars['Int']>;
  sku: Scalars['String'];
};


export type ProductBeverageBrewingVariantImagesArgs = {
  selector?: Maybe<Scalars['String']>;
};

export type ProductBundleTree = Product & {
  __typename?: 'ProductBundleTree';
  /** The id of the product */
  id: Scalars['ID'];
  /** Commerce Tools id of the product */
  ctId: Scalars['ID'];
  /** SKU of the product */
  sku: Scalars['String'];
  /** Friendly identifier of the product */
  slug: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Maybe<Scalars['String']>;
  /** Description of the product */
  description: Maybe<Scalars['String']>;
  /** Caption for the product */
  caption: Maybe<Scalars['String']>;
  /** Color for text of caption (hexadecimal, e.g. #FF0000 for red)  */
  captionTextColor: Maybe<Scalars['String']>;
  /** Multi-currency prices with possible discount applied on the product */
  prices: Array<Price>;
  /** Multi-currency prices without applied discounts */
  fullPrices: Array<Price>;
  /** Multi-currency prices without any filters */
  unfilteredPrices: Array<Price>;
  /** Flag that indicates if the product is available */
  isAvailable: Scalars['Boolean'];
  /**
   * Quantity of stock available.
   * When is null means the availability should not be shown
   */
  stockAvailability: Maybe<Scalars['Int']>;
  /** Badge for the product */
  badge: Maybe<ProductBadge>;
  /** Flag that indicates that this is a coupled product */
  coupled: Scalars['Boolean'];
  /** Products list of the bundle product */
  products: Array<ProductBundleTreeItem>;
  /** Project species of the products list */
  scientificSpecies: Array<Maybe<ScientificSpecie>>;
  /** Kg of Co2 that the product will absorb in 10 years */
  co2: Maybe<Scalars['Int']>;
  /** Main benefit of the product */
  mainBenefit: Maybe<ProductBenefit>;
  /** List of alternative products for this product. */
  alternatives: Array<Maybe<Product>>;
  /** Benefits of the product */
  benefits: Maybe<ProductBenefits>;
  /** Icon of the product */
  icon: Maybe<Image>;
  variants: Array<ProductBundleTreeVariant>;
};


export type ProductBundleTreeSlugArgs = {
  locale: Scalars['String'];
};


export type ProductBundleTreeNameArgs = {
  locale: Scalars['String'];
};


export type ProductBundleTreeDescriptionArgs = {
  locale: Scalars['String'];
};


export type ProductBundleTreeCaptionArgs = {
  locale: Scalars['String'];
};


export type ProductBundleTreePricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductBundleTreeFullPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductBundleTreeUnfilteredPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductBundleTreeAlternativesArgs = {
  collection?: Maybe<Scalars['String']>;
  input?: Maybe<ProductAlternativesInput>;
};

export type ProductBundleTreeItem = {
  __typename?: 'ProductBundleTreeItem';
  product: Maybe<Product>;
  quantity: Scalars['Int'];
};

export type ProductBundleTreeVariant = ProductVariant & {
  __typename?: 'ProductBundleTreeVariant';
  key: Scalars['ID'];
  fullPrices: Array<Price>;
  /**
   * Retrieve variant images.
   * The images GraphQL field utilizes an optional selector argument, operating as a simplified regex filter for precise image label retrieval. (gallery*, ga*lery)
   */
  images: Array<Image>;
  prices: Array<Price>;
  quantity: Maybe<Scalars['Int']>;
  sku: Scalars['String'];
};


export type ProductBundleTreeVariantImagesArgs = {
  selector?: Maybe<Scalars['String']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  key: Maybe<Scalars['String']>;
  /** Name of the category */
  name: Maybe<Scalars['String']>;
  /**
   * Represents the count of products in this category that have been bought by users.
   * If an orderId is provided, it filters the count to include only products bought in the specified order.
   */
  productsSoldCount: Maybe<Scalars['Int']>;
};


export type ProductCategoryNameArgs = {
  locale: Scalars['String'];
};


export type ProductCategoryProductsSoldCountArgs = {
  orderId?: Maybe<Scalars['ID']>;
};

export type ProductConnection = Connection & {
  __typename?: 'ProductConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<ProductEdge>>;
  facets: ProductsFacets;
};


export type ProductConnectionFacetsArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type ProductContent = SubscriptionImpactContent;

export type ProductEdge = Edge & {
  __typename?: 'ProductEdge';
  node: Maybe<Product>;
  cursor: Scalars['String'];
};

export type ProductFilterInput = {
  /** Filter by product identifiers. */
  id?: Maybe<Array<Scalars['ID']>>;
  /** Fuzzy search by product name, description, and slug. */
  textSearch?: Maybe<ProductFilterTextSearchInput>;
  /** Filter by scientific species. This can also be used to filter by meanings. */
  scientificSpecie?: Maybe<Array<Scalars['ID']>>;
  /** Filter by project species. */
  projectSpecie?: Maybe<Array<Scalars['ID']>>;
  /** Filter by badges, also known as "usages". */
  badge?: Maybe<Array<Scalars['ID']>>;
  /** Filter by product types. */
  productType?: Maybe<Array<ProductType>>;
  /** Filter by countries. */
  country?: Maybe<Array<Scalars['ID']>>;
  /** Filter by zodiac signs. */
  zodiacSign?: Maybe<Array<ZodiacSign>>;
  /** Filter by product tags. */
  tag?: Maybe<Array<Scalars['String']>>;
  /** Filter by product benefits. */
  mainBenefit?: Maybe<Array<ProductBenefit>>;
  /** Show only products that can be gifted. */
  giftable?: Maybe<Scalars['Boolean']>;
  /** Show only products that can be assigned to a forest. */
  inForest?: Maybe<Scalars['Boolean']>;
  /** Show unpublished products. */
  showUnpublished?: Maybe<Scalars['Boolean']>;
  /** Filter by partner. */
  partner?: Maybe<Array<ClothingPartnerEnum>>;
  /** Filter by fit, for clothing products only. */
  clothingFit?: Maybe<Array<ClothingFit>>;
};

/** Arguments used to fuzzy search the products connection. */
export type ProductFilterTextSearchInput = {
  /** Locale to use for the search. */
  locale: Scalars['String'];
  /** Text to search for. */
  text: Scalars['String'];
};

export type ProductHoroscopeTree = Product & {
  __typename?: 'ProductHoroscopeTree';
  /** The id of the product */
  id: Scalars['ID'];
  /** Commerce Tools id of the product */
  ctId: Scalars['ID'];
  /** SKU of the product */
  sku: Scalars['String'];
  /** Friendly identifier of the product */
  slug: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Maybe<Scalars['String']>;
  /** Description of the product */
  description: Maybe<Scalars['String']>;
  /** Caption for the product */
  caption: Maybe<Scalars['String']>;
  /** Color for text of caption (hexadecimal, e.g. #FF0000 for red)  */
  captionTextColor: Maybe<Scalars['String']>;
  /** Multi-currency prices with possible discount applied on the product */
  prices: Array<Price>;
  /** Multi-currency prices without applied discounts */
  fullPrices: Array<Price>;
  /** Multi-currency prices without any filters */
  unfilteredPrices: Array<Price>;
  /** Flag that indicates if the product is available */
  isAvailable: Scalars['Boolean'];
  /**
   * Quantity of stock available.
   * When is null means the availability should not be shown
   */
  stockAvailability: Maybe<Scalars['Int']>;
  /** Gallery of images */
  gallery: Array<Maybe<Image>>;
  /** Badge for the product */
  badge: Maybe<ProductBadge>;
  /** Project species of the product */
  projectSpecie: Maybe<ProjectSpecie>;
  /** Zodiac sign that the product refers to */
  zodiacSign: Maybe<ZodiacSign>;
  /** Zodiac sign period (e.g. "April 21 - May 20") */
  zodiacSignPeriod: Maybe<Scalars['String']>;
  /** Kg of Co2 that the product will absorb in 10 years */
  co2: Maybe<Scalars['Int']>;
  /** Main benefit of the product */
  mainBenefit: Maybe<ProductBenefit>;
  /** Scientific specie of the product */
  scientificSpecie: Maybe<ScientificSpecie>;
  /** List of alternative products for this product. */
  alternatives: Array<Maybe<Product>>;
  /** Benefits of the product */
  benefits: Maybe<ProductBenefits>;
  /** Icon of the product */
  icon: Maybe<Image>;
  variants: Array<ProductHoroscopeTreeVariant>;
};


export type ProductHoroscopeTreeSlugArgs = {
  locale: Scalars['String'];
};


export type ProductHoroscopeTreeNameArgs = {
  locale: Scalars['String'];
};


export type ProductHoroscopeTreeDescriptionArgs = {
  locale: Scalars['String'];
};


export type ProductHoroscopeTreeCaptionArgs = {
  locale: Scalars['String'];
};


export type ProductHoroscopeTreePricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductHoroscopeTreeFullPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductHoroscopeTreeUnfilteredPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductHoroscopeTreeZodiacSignPeriodArgs = {
  locale: Scalars['String'];
};


export type ProductHoroscopeTreeAlternativesArgs = {
  collection?: Maybe<Scalars['String']>;
  input?: Maybe<ProductAlternativesInput>;
};

export type ProductHoroscopeTreeVariant = ProductVariant & {
  __typename?: 'ProductHoroscopeTreeVariant';
  key: Scalars['ID'];
  fullPrices: Array<Price>;
  /**
   * Retrieve variant images.
   * The images GraphQL field utilizes an optional selector argument, operating as a simplified regex filter for precise image label retrieval. (gallery*, ga*lery)
   */
  images: Array<Image>;
  prices: Array<Price>;
  quantity: Maybe<Scalars['Int']>;
  sku: Scalars['String'];
};


export type ProductHoroscopeTreeVariantImagesArgs = {
  selector?: Maybe<Scalars['String']>;
};

export type ProductMutation = {
  __typename?: 'ProductMutation';
  /** Request notification when product will back in stock */
  requestBackInStockNotification: RequestBackInStockNotificationResponse;
};


export type ProductMutationRequestBackInStockNotificationArgs = {
  input: RequestBackInStockNotificationInput;
};

export type ProductsFacets = {
  __typename?: 'ProductsFacets';
  badges: Array<ProductsFacetsBadge>;
  countries: Array<ProductsFacetsCountry>;
  scientificSpecies: Array<ProductsFacetsScientificSpecie>;
  tags: Array<ProductsFacetsTag>;
  mainBenefits: Array<ProductsFacetsMainBenefit>;
  productTypes: Array<ProductsFacetsType>;
};

export type ProductsFacetsBadge = {
  __typename?: 'ProductsFacetsBadge';
  key: Scalars['ID'];
  resultCount: Scalars['Int'];
  ref: Maybe<ProjectSpecieLocalUsage>;
};

export type ProductsFacetsCountry = {
  __typename?: 'ProductsFacetsCountry';
  key: Scalars['ID'];
  resultCount: Scalars['Int'];
  ref: Maybe<Country>;
};

export type ProductsFacetsMainBenefit = {
  __typename?: 'ProductsFacetsMainBenefit';
  key: Scalars['ID'];
  resultCount: Scalars['Int'];
  ref: Maybe<ProductBenefit>;
};

export type ProductsFacetsScientificSpecie = {
  __typename?: 'ProductsFacetsScientificSpecie';
  key: Scalars['ID'];
  resultCount: Scalars['Int'];
  ref: Maybe<ScientificSpecie>;
};

export type ProductsFacetsTag = {
  __typename?: 'ProductsFacetsTag';
  key: Scalars['ID'];
  resultCount: Scalars['Int'];
  ref: Maybe<ProductTag>;
};

export type ProductsFacetsType = {
  __typename?: 'ProductsFacetsType';
  key: Scalars['ID'];
  resultCount: Scalars['Int'];
  ref: Maybe<ProductType>;
};

export type ProductSubscription = Product & {
  __typename?: 'ProductSubscription';
  /** The id of the product */
  id: Scalars['ID'];
  /** SKU of the product */
  sku: Scalars['String'];
  content: Maybe<ProductContent>;
  /** Commerce Tools id of the product */
  ctId: Scalars['ID'];
  /** Friendly identifier of the product */
  slug: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Maybe<Scalars['String']>;
  /** Description of the product */
  description: Maybe<Scalars['String']>;
  /** Multi-currency prices with possible discount applied on the product */
  prices: Array<Price>;
  /** Multi-currency prices without applied discounts */
  fullPrices: Array<Price>;
  /** Multi-currency prices without any filters */
  unfilteredPrices: Array<Price>;
  /** Icon of the product */
  icon: Maybe<Image>;
  /** Products list of the subscription */
  products: Array<ProductSubscriptionItem>;
  /**
   * Statistics related to trees, assignments and billings in a specific time interval.
   * If no interval is specified, then the yearly interval is the default one.
   * IMPORTANT:
   *  - currently, the YEARLY interval is based on 360 days (12 * 30-days), not 365!
   *  - currently, the MONTHLY interval is based on 30 days
   * @deprecated statistics is deprecated. Use variant statistics instead.
   */
  statistics: ProductSubscriptionStatistics;
  /**
   * A subscription product can have a sibling. This mostly means that an yearly-billing product has
   * a monthly-billing product as sibling, and vice-versa.
   */
  sibling: Maybe<Product>;
  /** Impacts that the subscription contribute to */
  impacts: Maybe<Array<Impact>>;
  cause: Maybe<SubscriptionCause>;
  variants: Array<ProductSubscriptionVariant>;
};


export type ProductSubscriptionContentArgs = {
  locale: Scalars['String'];
};


export type ProductSubscriptionSlugArgs = {
  locale: Scalars['String'];
};


export type ProductSubscriptionNameArgs = {
  locale: Scalars['String'];
};


export type ProductSubscriptionDescriptionArgs = {
  locale: Scalars['String'];
};


export type ProductSubscriptionPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductSubscriptionFullPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductSubscriptionUnfilteredPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductSubscriptionStatisticsArgs = {
  intervals?: Maybe<Array<SubscriptionStatisticsIntervals>>;
};

export enum ProductSubscriptionCauseKey {
  Animals = 'ANIMALS',
  Climate = 'CLIMATE',
  People = 'PEOPLE'
}

export type ProductSubscriptionItem = {
  __typename?: 'ProductSubscriptionItem';
  product: Maybe<Product>;
  quantity: Scalars['Int'];
};

export type ProductSubscriptionStatistics = {
  __typename?: 'ProductSubscriptionStatistics';
  intervals: Array<SubscriptionStatisticsCounter>;
  total: SubscriptionStatisticsCounter;
};

export type ProductSubscriptionVariant = ProductVariant & {
  __typename?: 'ProductSubscriptionVariant';
  key: Scalars['ID'];
  fullPrices: Array<Price>;
  /**
   * Retrieve variant images.
   * The images GraphQL field utilizes an optional selector argument, operating as a simplified regex filter for precise image label retrieval. (gallery*, ga*lery)
   */
  images: Array<Image>;
  plan: Plan;
  prices: Array<Price>;
  quantity: Maybe<Scalars['Int']>;
  sku: Scalars['String'];
  statistics: ProductSubscriptionStatistics;
};


export type ProductSubscriptionVariantImagesArgs = {
  selector?: Maybe<Scalars['String']>;
};


export type ProductSubscriptionVariantStatisticsArgs = {
  intervals?: Maybe<Array<SubscriptionStatisticsIntervals>>;
};

export type ProductTag = {
  __typename?: 'ProductTag';
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Maybe<Scalars['String']>;
  image: Maybe<Image>;
};


export type ProductTagNameArgs = {
  locale: Scalars['String'];
};


export type ProductTagDescriptionArgs = {
  locale: Scalars['String'];
};

export type ProductTree = Product & {
  __typename?: 'ProductTree';
  /** The id of the product */
  id: Scalars['ID'];
  /** Commerce Tools id of the product */
  ctId: Scalars['ID'];
  /** SKU of the product */
  sku: Scalars['String'];
  /** Friendly identifier of the product */
  slug: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Maybe<Scalars['String']>;
  /** Description of the product */
  description: Maybe<Scalars['String']>;
  /** Caption for the product */
  caption: Maybe<Scalars['String']>;
  /** Color for text of caption (hexadecimal, e.g. #FF0000 for red)  */
  captionTextColor: Maybe<Scalars['String']>;
  /** Multi-currency prices with possible discount applied on the product */
  prices: Array<Price>;
  /** Multi-currency prices without applied discounts */
  fullPrices: Array<Price>;
  /** Multi-currency prices without any filters */
  unfilteredPrices: Array<Price>;
  /** Flag that indicates if the product is available */
  isAvailable: Scalars['Boolean'];
  /**
   * Quantity of stock available.
   * When is null means the availability should not be shown
   */
  stockAvailability: Maybe<Scalars['Int']>;
  /** Gallery of images. */
  gallery: Array<Maybe<Image>>;
  /** Badge for the product */
  badge: Maybe<ProductBadge>;
  /** Flag that indicates if the product is a special edition */
  specialEdition: Scalars['Boolean'];
  /** Project species of the product */
  projectSpecie: Maybe<ProjectSpecie>;
  /** List of alternative products for this product. */
  alternatives: Array<Maybe<Product>>;
  /** Kg of Co2 that the product will absorb in 10 years */
  co2: Maybe<Scalars['Int']>;
  /** Main benefit of the product */
  mainBenefit: Maybe<ProductBenefit>;
  /** Scientific specie of the product */
  scientificSpecie: Maybe<ScientificSpecie>;
  /** Benefits of the product */
  benefits: Maybe<ProductBenefits>;
  /** Icon of the product */
  icon: Maybe<Image>;
  variants: Array<ProductTreeVariant>;
};


export type ProductTreeSlugArgs = {
  locale: Scalars['String'];
};


export type ProductTreeNameArgs = {
  locale: Scalars['String'];
};


export type ProductTreeDescriptionArgs = {
  locale: Scalars['String'];
};


export type ProductTreeCaptionArgs = {
  locale: Scalars['String'];
};


export type ProductTreePricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductTreeFullPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductTreeUnfilteredPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductTreeAlternativesArgs = {
  collection?: Maybe<Scalars['String']>;
  input?: Maybe<ProductAlternativesInput>;
};

export type ProductTreeVariant = ProductVariant & {
  __typename?: 'ProductTreeVariant';
  key: Scalars['ID'];
  fullPrices: Array<Price>;
  /**
   * Retrieve variant images.
   * The images GraphQL field utilizes an optional selector argument, operating as a simplified regex filter for precise image label retrieval. (gallery*, ga*lery)
   */
  images: Array<Image>;
  prices: Array<Price>;
  quantity: Maybe<Scalars['Int']>;
  sku: Scalars['String'];
};


export type ProductTreeVariantImagesArgs = {
  selector?: Maybe<Scalars['String']>;
};

export enum ProductType {
  Bundle = 'BUNDLE',
  Horoscope = 'HOROSCOPE',
  Tree = 'TREE',
  Subscription = 'SUBSCRIPTION',
  SpecialEdition = 'SPECIAL_EDITION',
  ClothingUpperwear = 'CLOTHING_UPPERWEAR',
  BeverageBrewing = 'BEVERAGE_BREWING'
}

export type ProductUpperWear = Product & {
  __typename?: 'ProductUpperWear';
  /** The id of the product */
  id: Scalars['ID'];
  /** Commerce Tools id of the product */
  ctId: Scalars['ID'];
  /** SKU of the product */
  sku: Scalars['String'];
  /** Friendly identifier of the product */
  slug: Maybe<Scalars['String']>;
  /** Name of the product */
  name: Maybe<Scalars['String']>;
  /** Description of the product */
  description: Maybe<Scalars['String']>;
  /** Multi-currency prices with possible discount applied on the product */
  prices: Array<Price>;
  /** Multi-currency prices without applied discounts */
  fullPrices: Array<Price>;
  /** Multi-currency prices without any filters */
  unfilteredPrices: Array<Price>;
  /** Flag that indicates if the product is available */
  isAvailable: Scalars['Boolean'];
  /**
   * Quantity of stock available.
   * When is null means the availability should not be shown
   */
  stockAvailability: Maybe<Scalars['Int']>;
  /** Gallery of images. */
  gallery: Array<Maybe<Image>>;
  /** Badge for the product */
  badge: Maybe<ProductBadge>;
  /** Caption for the product */
  caption: Maybe<Scalars['String']>;
  /** Color for text of caption (hexadecimal, e.g. #FF0000 for red)  */
  captionTextColor: Maybe<Scalars['String']>;
  /** Value that indicate the fit value: how clothing conforms to the body */
  fit: Maybe<ClothingFit>;
  /** Icon of the product */
  icon: Maybe<Image>;
  /** Materials: list of materials. Ex.: 50% cotton, 50% polyester */
  materials: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Clothing partner: the partner for this kind of product */
  partner: Maybe<ClothingPartnerEnum>;
  /** Shipping information */
  shippingInfo: Maybe<Scalars['String']>;
  /** Tree-types products list linked to this physical product */
  trees: Maybe<Array<Maybe<ProductBundleTreeItem>>>;
  variants: Array<ProductUpperWearVariant>;
};


export type ProductUpperWearSlugArgs = {
  locale: Scalars['String'];
};


export type ProductUpperWearNameArgs = {
  locale: Scalars['String'];
};


export type ProductUpperWearDescriptionArgs = {
  locale: Scalars['String'];
};


export type ProductUpperWearPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductUpperWearFullPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductUpperWearUnfilteredPricesArgs = {
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  country?: Maybe<Scalars['String']>;
};


export type ProductUpperWearCaptionArgs = {
  locale: Scalars['String'];
};


export type ProductUpperWearMaterialsArgs = {
  locale: Scalars['String'];
};


export type ProductUpperWearShippingInfoArgs = {
  locale: Scalars['String'];
};

export type ProductUpperWearVariant = ProductVariant & {
  __typename?: 'ProductUpperWearVariant';
  key: Scalars['ID'];
  colors: Maybe<Array<Maybe<ClothingColorEnum>>>;
  fullPrices: Array<Price>;
  /**
   * Retrieve variant images.
   * The images GraphQL field utilizes an optional selector argument, operating as a simplified regex filter for precise image label retrieval. (gallery*, ga*lery)
   */
  images: Array<Image>;
  prices: Array<Price>;
  quantity: Maybe<Scalars['Int']>;
  size: Maybe<ClothingSizeEnum>;
  sku: Scalars['String'];
};


export type ProductUpperWearVariantImagesArgs = {
  selector?: Maybe<Scalars['String']>;
};

export type ProductVariant = {
  key: Scalars['ID'];
  fullPrices: Array<Price>;
  /**
   * Retrieve variant images.
   * The images GraphQL field utilizes an optional selector argument, operating as a simplified regex filter for precise image label retrieval. (gallery*, ga*lery)
   */
  images: Array<Image>;
  prices: Array<Price>;
  quantity: Maybe<Scalars['Int']>;
  sku: Scalars['String'];
};


export type ProductVariantImagesArgs = {
  selector?: Maybe<Scalars['String']>;
};

export type ProfileBadge = {
  __typename?: 'ProfileBadge';
  id: Scalars['ID'];
  background: Maybe<Image>;
  color: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  howToGet: Maybe<Scalars['String']>;
  image: Maybe<Image>;
  slug: Scalars['String'];
  special: Scalars['Boolean'];
  title: Maybe<Scalars['String']>;
};


export type ProfileBadgeDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type ProfileBadgeHowToGetArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type ProfileBadgeTitleArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type ProfileBadgesWhereInput = {
  enabled?: Maybe<Scalars['Boolean']>;
};

export type ProfileDisableImpactAlreadyDisabledProblem = Problem & {
  __typename?: 'ProfileDisableImpactAlreadyDisabledProblem';
  message: Scalars['String'];
};

export type ProfileDisableImpactProfileNotFoundProblem = Problem & {
  __typename?: 'ProfileDisableImpactProfileNotFoundProblem';
  message: Scalars['String'];
};

export type ProfileEnableImpactAlreadyEnabledProblem = Problem & {
  __typename?: 'ProfileEnableImpactAlreadyEnabledProblem';
  message: Scalars['String'];
};

export type ProfileEnableImpactProfileNotFoundProblem = Problem & {
  __typename?: 'ProfileEnableImpactProfileNotFoundProblem';
  message: Scalars['String'];
};

export type ProfileMutation = {
  __typename?: 'ProfileMutation';
  /** Disable an impact for the profile */
  disableImpact: ProfileMutationDisableImpactResult;
  /** Enable an impact for the profile */
  enableImpact: ProfileMutationEnableImpactResult;
  setPreferences: UserSetPreferencesResponse;
};


export type ProfileMutationDisableImpactArgs = {
  userId: Scalars['ID'];
  key: Scalars['String'];
};


export type ProfileMutationEnableImpactArgs = {
  userId: Scalars['ID'];
  key: Scalars['String'];
};


export type ProfileMutationSetPreferencesArgs = {
  id: Scalars['ID'];
  input: SetPreferencesInput;
};

export type ProfileMutationDisableImpactResult = UserProfileImpact | ProfileDisableImpactProfileNotFoundProblem | ProfileDisableImpactAlreadyDisabledProblem;

export type ProfileMutationEnableImpactResult = UserProfileImpact | ProfileEnableImpactProfileNotFoundProblem | ProfileEnableImpactAlreadyEnabledProblem;

export enum ProfilesSearchFilterField {
  UserId = 'USER_ID',
  Slug = 'SLUG',
  Email = 'EMAIL',
  DisplayName = 'DISPLAY_NAME'
}

export type ProfilesSearchFiltersInput = {
  userType?: Maybe<Array<UserType>>;
};

export type Project = {
  __typename?: 'Project';
  /** ID of the project */
  id: Scalars['ID'];
  /** The project of the specie */
  country: Country;
  /** Current location of the tree */
  locationAlias: Maybe<Scalars['String']>;
  /** The project's name */
  name: Scalars['String'];
  nurseryLocation: Maybe<Place>;
};

export type ProjectsConnection = Connection & {
  __typename?: 'ProjectsConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<ProjectsEdge>>;
  pageInfo: PageInfo;
};

export type ProjectsEdge = Edge & {
  __typename?: 'ProjectsEdge';
  cursor: Scalars['String'];
  node: Maybe<ProcurementProject>;
};

export type ProjectSpecie = {
  __typename?: 'ProjectSpecie';
  /** The id of the project specie */
  id: Scalars['ID'];
  /** Signed upload url which could be used to upload a new avatar */
  galleryImageUploadUrl: FileUpload;
  /** CO2 that the specie it's able to absorb in 10 years */
  co2: Scalars['Int'];
  cost: Maybe<Scalars['Float']>;
  /** Description of the project specie */
  description: Scalars['String'];
  /** True if the species is at risk of extinction, false otherwise */
  extinctionRisk: Maybe<Scalars['Boolean']>;
  /** Gallery of media for the specie */
  gallery: Maybe<MediaGallery>;
  /** Icon related to the project specie */
  icon: Maybe<Image>;
  /** The impacts of the specie */
  impacts: Array<Impact>;
  /** Name of the project specie */
  name: Scalars['String'];
  /** Nursery Gallery of media for the specie */
  nurseryGallery: Maybe<MediaGallery>;
  /** Location of the nursery */
  nurseryLocation: Maybe<Place>;
  /** The estimate of the profit in dollars from one kilogram produced by the project specie */
  pricePerKg: Maybe<Scalars['Float']>;
  /**
   * The project of the specie
   * TODO: missing implementation
   */
  project: Project;
  /** The scientific specie */
  scientificSpecie: ScientificSpecie;
  /** The estimate of the number of trees of the species that can be planted in one hectare */
  treesPerHa: Maybe<Scalars['Int']>;
  /** A yield coefficient in annual kilograms per hectare */
  yieldPerHa: Maybe<Scalars['Float']>;
  localUsages: Array<ProjectSpecieLocalUsage>;
};


export type ProjectSpecieDescriptionArgs = {
  locale: Scalars['String'];
};


export type ProjectSpecieNameArgs = {
  locale: Scalars['String'];
};

export type ProjectSpecieConnection = Connection & {
  __typename?: 'ProjectSpecieConnection';
  totalCount: Scalars['Int'];
  pageInfo: Maybe<PageInfo>;
  edges: Maybe<Array<Maybe<ProjectSpecieEdge>>>;
};

export type ProjectSpecieEdge = Edge & {
  __typename?: 'ProjectSpecieEdge';
  node: Maybe<ProjectSpecie>;
  cursor: Maybe<Scalars['String']>;
};

export type ProjectSpecieLocalUsage = {
  __typename?: 'ProjectSpecieLocalUsage';
  id: Scalars['ID'];
  icon: Image;
  description: Scalars['String'];
  name: Scalars['String'];
};


export type ProjectSpecieLocalUsageDescriptionArgs = {
  locale: Scalars['String'];
};


export type ProjectSpecieLocalUsageNameArgs = {
  locale: Scalars['String'];
};

export type ProjectSpecieMutation = {
  __typename?: 'ProjectSpecieMutation';
  setNurseryGallery: SetProjectSpecieNurseryGalleryResponse;
  update: ProjectSpecieUpdateMutationResponse;
};


export type ProjectSpecieMutationSetNurseryGalleryArgs = {
  id: Scalars['ID'];
  input: SetProjectSpecieNurseryGalleryInput;
};


export type ProjectSpecieMutationUpdateArgs = {
  id: Scalars['ID'];
  input: ProjectSpecieUpdateMutationInput;
};

export type ProjectSpecieUpdateMutationInput = {
  /** The estimate of the profit selling one kilogram produced by the species */
  pricePerKg?: Maybe<Scalars['Float']>;
  /** A yield coefficient in annual kilograms per hectare */
  yieldPerHa?: Maybe<Scalars['Float']>;
  /** True if the species is at risk of extinction, false otherwise */
  extinctionRisk?: Maybe<Scalars['Boolean']>;
  /** The estimate of the number of trees of the species that can be planted in one hectare */
  treesPerHa?: Maybe<Scalars['Int']>;
  /** Impact keys assigned to project specie */
  impactKeyIds?: Maybe<Array<Scalars['ID']>>;
};

export type ProjectSpecieUpdateMutationResponse = Resource | UpdateProjectSpecieUnknownProblem | UpdateProjectSpecieVoidInputProblem | UpdateProjectSpecieDoesNotExistsProblem | UpdateProjectSpeciePriceNotAllowedProblem | UpdateProjectSpecieYieldNotAllowedProblem | UpdateProjectSpecieTreesPerHaNotAllowedProblem;

export type ProjectSpecieWhereInput = {
  ids?: Maybe<Array<Scalars['ID']>>;
  countryCodes?: Maybe<Array<Scalars['ID']>>;
  impactKeys?: Maybe<Array<Scalars['String']>>;
};

export type ProjectsWhereConditionInput = {
  /** List of id which will be used to filter on */
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type PublishForestNotAllowedProblem = Problem & {
  __typename?: 'PublishForestNotAllowedProblem';
  message: Scalars['String'];
};

export type PublishForestNotFoundProblem = Problem & {
  __typename?: 'PublishForestNotFoundProblem';
  message: Scalars['String'];
};

export type PublishForestNotPayedProblem = Problem & {
  __typename?: 'PublishForestNotPayedProblem';
  message: Scalars['String'];
};

export type PublishForestResponse = Resource | PublishForestNotFoundProblem | PublishForestUserDoesNotOwnForestProblem | PublishForestNotPayedProblem | PublishForestNotAllowedProblem | PublishForestUnknownProblem;

export type PublishForestUnknownProblem = Problem & {
  __typename?: 'PublishForestUnknownProblem';
  message: Scalars['String'];
};

export type PublishForestUserDoesNotOwnForestProblem = Problem & {
  __typename?: 'PublishForestUserDoesNotOwnForestProblem';
  message: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  assistant: AssistantQuery;
  /** Get a list of all the emails that have multiple accounts registered. */
  duplicatedUsers: Array<DuplicatedUser>;
  footprintCalculation: Maybe<FootprintCalculation>;
  footprintCalculations: FootprintCalculationConnection;
  me: Maybe<User>;
  originator: Maybe<Originator>;
  originators: OriginatorConnection;
  /** Retrieve a perk by ID. */
  perk: Maybe<PerkInterface>;
  /** Retrieve a list of perks. */
  perks: PerkConnection;
  /** Get profiles by title, slug or email */
  profiles: UserConnection;
  /** Get profiles search by input text */
  profilesSearch: UserConnection;
  /** All the roles available on the Treedom GraphQL Next API */
  roles: Array<Scalars['String']>;
  /** Retrieve Treedom total numbers */
  stats: Maybe<TreedomStats>;
  /** Retrieve a list of users ordered by the number of tress planted in a given time window */
  treePlantersRanking: Array<Maybe<TreePlanterRankingItem>>;
  /** Get user by id, slug or identityProviderId. At least one must be provided */
  user: Maybe<User>;
  abuseReports: Maybe<AbuseReportConnection>;
  blogPosts: Maybe<BlogPostConnection>;
  /**
   * Retrieve an BusinessLanding by slug.
   * The locale is required because the slug is unique per locale
   */
  businessLanding: Maybe<BusinessLanding>;
  /** Retrieve a communication kit by ID. */
  communicationKit: Maybe<CommunicationKit>;
  /** Retrieve a list of communication kits. */
  communicationKits: CommunicationKitConnection;
  /** Retrieve a Country by code or slug. */
  country: Maybe<Country>;
  feedActivityPostComment: Maybe<FeedActivityPostComment>;
  /** Retrieve a list of feed activity post comment. */
  feedActivityPostComments: FeedActivityPostCommentConnection;
  /** Retrieve a FeedAuthor by ID. */
  feedAuthor: Maybe<FeedAuthor>;
  /** Retrieve a list of feed authors. */
  feedAuthors: FeedAuthorConnection;
  feedPost: Maybe<FeedPost>;
  /** Retrieve a list of feed posts. */
  feedPosts: FeedPostConnection;
  /** Retrieve an Image by ID. */
  image: Maybe<Image>;
  /** Retrieve list of impacts. */
  impacts: Array<Maybe<Impact>>;
  /** Retrieve a list of pills. */
  pills: PillConnection;
  /** Retrieve a Place by latitude and longitude. */
  place: Place;
  /** Retrieve list of profile badges */
  profileBadges: Array<ProfileBadge>;
  /** Get a billing plan by its identifier. */
  billingPlan: Maybe<BillingPlan>;
  /** Plans that define the billing strategy for subscriptions. */
  billingPlans: BillingPlanConnection;
  /**
   * Return cart by an anonymous cart ID.
   * If request is authenticated, the anonymous cart will be assigned (or merged if user already has a cart) to the authenticated user.
   */
  cart: Maybe<Cart>;
  /** Get an invoice by its identifier. */
  invoice: Maybe<Invoice>;
  /** Invoices for all the b2b small business users. */
  invoices: Maybe<InvoiceConnection>;
  order: Maybe<Order>;
  /** Get a plan by its identifier. */
  plan: Maybe<Plan>;
  /** Get a plan subscription by its identifier. */
  planSubscription: Maybe<PlanSubscription>;
  /** Plans that users can subscribe to. */
  plans: Maybe<PlanConnection>;
  product: Maybe<Product>;
  /** Return a product Category by its ID. */
  productCategory: Maybe<ProductCategory>;
  products: ProductConnection;
  /** Get a quotation by its identifier. */
  quotation: Maybe<Quotation>;
  /** Quotes list. */
  quotations: Maybe<QuotationConnection>;
  subscriptionTreesForecast: Array<SubscriptionTreesForecast>;
  expenses: FinanceExpensesConnection;
  financePayments: FinancePaymentsConnection;
  planFinancialStatements: PlanFinancialStatementConnection;
  planSpeciePrices: PlanSpeciePriceConnection;
  supplierFinancialStatements: SupplierFinancialStatementConnection;
  suppliers: SupplierConnection;
  forestryTrees: Maybe<ResultForestryTrees>;
  projectSpecie: Maybe<ProjectSpecie>;
  projectSpecies: ProjectSpecieConnection;
  scientificSpecie: Maybe<ScientificSpecie>;
  scientificSpecies: ScientificSpecieConnection;
  treeProject: Maybe<Project>;
  treeProjects: TreeProjectsConnection;
  procurementPlans: ProcurementPlansConnection;
  procurementProjects: ProjectsConnection;
  admin: Maybe<AdminQuery>;
  forest: Maybe<Forest>;
  /** Retrieve a user's trees plantable (movable) in a forest */
  forestPlantableUserTrees: TreeConnection;
  forestTypesV2: Array<ForestTypeV2>;
  forests: ForestConnection;
  forestsSearch: ForestConnection;
  /** Retrieve Open Forest Products */
  openForestProducts: Maybe<OpenForestProducts>;
  /** Retrieve a Tree by ID or registryId. At least one must be provided */
  tree: Maybe<Tree>;
  /** It gets the sold project species together with the number of sold items for each specie */
  treeProjectSpeciesSold: Maybe<Array<TreeProjectSpecieSold>>;
  /**
   * Retrieve a trees by multiple filters.
   * The treeId and registryId filter are mutual exclusive, if both are received a problem will be returned
   */
  trees: Maybe<TreesResponse>;
  /**
   * Retrieve trees by multiple filters.
   * The treeId and registryId filter are mutually exclusive, if both are received a problem will be returned
   */
  treesSearch: Maybe<TreesSearchConnection>;
  treecodeCreativities: Maybe<TreecodeCreativityConnection>;
  generationProcess: Maybe<GenerationProcess>;
  generationProcesses: Maybe<TreecodeGenerationProcessConnection>;
  treecodeRedeemStatus: Maybe<TreecodeRedeem>;
  treecode: Maybe<Treecode>;
  /** Search treecodes */
  treecodes: Maybe<TreecodeConnection>;
  /**
   * Retrieve all IDs of user's trees already gifted, included gifts not yet redeemed.
   * WARNING: This request can't be done by normal user.    
   */
  userGiftedTrees: Array<Scalars['ID']>;
  /**
   * Retrieve all IDs of user's redeemed trees.
   * WARNING: This request can't be done by normal user.    
   */
  userRedeemedTrees: Array<Scalars['ID']>;
};


export type QueryDuplicatedUsersArgs = {
  input?: Maybe<DuplicatedUsersInput>;
};


export type QueryFootprintCalculationArgs = {
  id: Scalars['ID'];
};


export type QueryFootprintCalculationsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<FootprintCalculationsQueryWhereInput>;
};


export type QueryOriginatorArgs = {
  id: Scalars['ID'];
};


export type QueryOriginatorsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<OriginatorsFilterInput>;
};


export type QueryPerkArgs = {
  input: PerkQueryInput;
};


export type QueryPerksArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<PerksFilterInput>;
  orderBy?: Maybe<PerksOrderByInput>;
};


export type QueryProfilesArgs = {
  pagination?: Maybe<PaginationInput>;
  legacyUserId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  type?: Maybe<UserType>;
};


export type QueryProfilesSearchArgs = {
  pagination?: Maybe<PaginationInput>;
  query: Scalars['String'];
  fields?: Maybe<Array<ProfilesSearchFilterField>>;
  filters?: Maybe<ProfilesSearchFiltersInput>;
};


export type QueryTreePlantersRankingArgs = {
  where?: Maybe<TreePlantersRankingInput>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};


export type QueryAbuseReportsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<AbuseReportFilterInput>;
};


export type QueryBlogPostsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<BlogPostFilterInput>;
};


export type QueryBusinessLandingArgs = {
  slug?: Maybe<BusinessLandingBySlugInput>;
};


export type QueryCommunicationKitArgs = {
  input: CommunicationKitQueryInput;
};


export type QueryCommunicationKitsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<CommunicationKitsFilterInput>;
};


export type QueryCountryArgs = {
  code?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};


export type QueryFeedActivityPostCommentArgs = {
  id: Scalars['ID'];
};


export type QueryFeedActivityPostCommentsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<FeedActivityPostCommentsFilterInput>;
  sort?: Maybe<FeedActivityPostCommentsSortInput>;
};


export type QueryFeedAuthorArgs = {
  input: FeedAuthorQueryInput;
};


export type QueryFeedAuthorsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<FeedAuthorsFilterInput>;
};


export type QueryFeedPostArgs = {
  id: Scalars['ID'];
};


export type QueryFeedPostsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<FeedPostsFilterInput>;
};


export type QueryImageArgs = {
  input: ImageQueryInput;
};


export type QueryImpactsArgs = {
  locale?: Maybe<Scalars['String']>;
};


export type QueryPillsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<PillsFilterInput>;
};


export type QueryPlaceArgs = {
  input: PlaceInput;
};


export type QueryProfileBadgesArgs = {
  where?: Maybe<ProfileBadgesWhereInput>;
};


export type QueryBillingPlanArgs = {
  id: Scalars['ID'];
};


export type QueryBillingPlansArgs = {
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<BillingPlanSortInput>;
  where?: Maybe<BillingPlanFilterInput>;
};


export type QueryCartArgs = {
  id: Scalars['ID'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryInvoicesArgs = {
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<Array<Maybe<InvoiceOrderClause>>>;
  where?: Maybe<Array<Maybe<InvoicesFilterInput>>>;
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryPlanArgs = {
  id: Scalars['ID'];
};


export type QueryPlanSubscriptionArgs = {
  id: Scalars['ID'];
};


export type QueryPlansArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryProductsArgs = {
  collection?: Maybe<Scalars['String']>;
  customerGroup?: Maybe<EcommerceCustomerGroup>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<EcommerceSortOrder>;
  where?: Maybe<ProductFilterInput>;
};


export type QueryQuotationArgs = {
  id: Scalars['ID'];
};


export type QueryQuotationsArgs = {
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<Array<Maybe<QuotationOrderClause>>>;
  where?: Maybe<QuotationsFilterInput>;
};


export type QuerySubscriptionTreesForecastArgs = {
  input?: Maybe<SubscriptionTreesForecastInput>;
};


export type QueryExpensesArgs = {
  where: ExpensesWhereConditionInput;
  pagination?: Maybe<PaginationInput>;
};


export type QueryFinancePaymentsArgs = {
  where: PaymentsWhereConditionInput;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPlanFinancialStatementsArgs = {
  where: PlanFinancialStatementsWhereConditionInput;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPlanSpeciePricesArgs = {
  where: PlanSpeciePriceWhereConditionInput;
  pagination?: Maybe<PaginationInput>;
};


export type QuerySupplierFinancialStatementsArgs = {
  where: SupplierFinancialStatementsWhereConditionInput;
  pagination?: Maybe<PaginationInput>;
};


export type QuerySuppliersArgs = {
  where?: Maybe<SupplierWhereConditionInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryForestryTreesArgs = {
  where: ForestryTreesWhereInput;
  pagination?: Maybe<PaginationInput>;
};


export type QueryProjectSpecieArgs = {
  id: Scalars['ID'];
};


export type QueryProjectSpeciesArgs = {
  where?: Maybe<ProjectSpecieWhereInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryScientificSpecieArgs = {
  id: Scalars['ID'];
};


export type QueryScientificSpeciesArgs = {
  where?: Maybe<ScientificSpecieWhereInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryTreeProjectArgs = {
  id: Scalars['ID'];
};


export type QueryTreeProjectsArgs = {
  where?: Maybe<TreeProjectsWhereInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryProcurementPlansArgs = {
  where?: Maybe<ProcurementPlansWhereConditionInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryProcurementProjectsArgs = {
  where?: Maybe<ProjectsWhereConditionInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryForestArgs = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['ID']>;
};


export type QueryForestPlantableUserTreesArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type QueryForestsArgs = {
  where?: Maybe<ForestWhereConditionInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<ForestsSortInput>;
};


export type QueryForestsSearchArgs = {
  query: Scalars['String'];
  fields?: Maybe<Array<ForestsSearchFilterField>>;
  filters?: Maybe<ForestsSearchFiltersInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryOpenForestProductsArgs = {
  forestSlug: Scalars['String'];
};


export type QueryTreeArgs = {
  id?: Maybe<Scalars['ID']>;
  registryId?: Maybe<Scalars['String']>;
};


export type QueryTreesArgs = {
  where: TreesWhereConditionInput;
  pagination?: Maybe<PaginationInput>;
};


export type QueryTreesSearchArgs = {
  query?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Maybe<TreesSearchFields>>>;
  filters?: Maybe<TreesSearchFiltersInput>;
  sort?: Maybe<TreesSearchSortField>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryTreecodeCreativitiesArgs = {
  category: Scalars['String'];
  pagination: PaginationInput;
};


export type QueryGenerationProcessArgs = {
  id: Scalars['ID'];
};


export type QueryGenerationProcessesArgs = {
  pagination?: Maybe<PaginationInput>;
  where: GenerationProcessesFindInput;
};


export type QueryTreecodeRedeemStatusArgs = {
  redeemTraceId: Scalars['ID'];
};


export type QueryTreecodeArgs = {
  where: TreecodeFindInput;
};


export type QueryTreecodesArgs = {
  where?: Maybe<TreecodesFindInput>;
  sort?: Maybe<TreecodesSortInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryUserGiftedTreesArgs = {
  userId: Scalars['ID'];
};


export type QueryUserRedeemedTreesArgs = {
  userId: Scalars['ID'];
};

export type Quotation = {
  __typename?: 'Quotation';
  id: Scalars['ID'];
  /** The Customer (i.e.: a sales) that has approved this quotation */
  approvedBy: Maybe<User>;
  cart: Maybe<Cart>;
  createdAt: Scalars['DateTime'];
  /** The Customer (i.e.: a sales) that has created this quote */
  createdBy: Maybe<User>;
  currency: ShopCurrency;
  customLineItems: Array<CustomLineItem>;
  /** The Customer (client) linked to this quote */
  customer: Maybe<User>;
  expiresAt: Maybe<Scalars['DateTime']>;
  giveAway: Scalars['Boolean'];
  lineItems: Array<CartLineItem>;
  number: Maybe<Scalars['String']>;
  order: Maybe<Order>;
  sellerComment: Maybe<Scalars['String']>;
  state: QuotationState;
  /** Total price of entire cart items */
  totalPrice: Price;
};

/** An unknown problem occurred */
export type QuotationApproveUnknownProblem = Problem & {
  __typename?: 'QuotationApproveUnknownProblem';
  message: Scalars['String'];
};

export enum QuotationBillingType {
  Regular = 'REGULAR',
  GiveAway = 'GIVE_AWAY'
}

/** An unknown problem occurred */
export type QuotationCancelUnknownProblem = Problem & {
  __typename?: 'QuotationCancelUnknownProblem';
  message: Scalars['String'];
};

/** We cannot create a quote for a cart that does not exist */
export type QuotationCartNotFoundProblem = Problem & {
  __typename?: 'QuotationCartNotFoundProblem';
  message: Scalars['String'];
};

/** An error occurred updating the cart associated with the quote */
export type QuotationCartUpdateProblem = Problem & {
  __typename?: 'QuotationCartUpdateProblem';
  message: Scalars['String'];
};

export type QuotationConnection = Connection & {
  __typename?: 'QuotationConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<QuotationEdge>>;
};

export type QuotationEdge = Edge & {
  __typename?: 'QuotationEdge';
  node: Maybe<Quotation>;
  cursor: Scalars['String'];
};

/** The expiration days should be a positive integer, if present */
export type QuotationInvalidExpirationProblem = Problem & {
  __typename?: 'QuotationInvalidExpirationProblem';
  message: Scalars['String'];
};

export type QuotationMutation = {
  __typename?: 'QuotationMutation';
  /** Approve a quotation. */
  approve: ApproveQuotationResponse;
  /** Cancel a quotation. */
  cancel: CancelQuotationResponse;
  /** Create a new quotation. */
  create: CreateQuotationResponse;
};


export type QuotationMutationApproveArgs = {
  quotationId: Scalars['ID'];
};


export type QuotationMutationCancelArgs = {
  input: CancelQuotationInput;
};


export type QuotationMutationCreateArgs = {
  input: CreateQuotationInput;
};

/** Quotation not found problem */
export type QuotationNotFoundProblem = Problem & {
  __typename?: 'QuotationNotFoundProblem';
  message: Scalars['String'];
};

export type QuotationOrderClause = {
  field: QuotationOrderField;
  direction: SqlSortDirection;
};

export enum QuotationOrderField {
  CreatedAt = 'CREATED_AT',
  ExpiresAt = 'EXPIRES_AT'
}

export type QuotationsFilterInput = {
  /** Search the quotes where the quoteState field is in a given array of states. Default: all states */
  quoteStates?: Maybe<Array<QuotationState>>;
  /** Search the quotes related to a given customer. This is the client user. */
  userId?: Maybe<Scalars['ID']>;
  /**
   * Search the quotes with a specific billing type.
   * The quotes can be:
   *  - regular quote, with a payment performed offline
   *  - give-away quotes, mostly related to customer care gifts
   *  Default: both.
   */
  billingType?: Maybe<QuotationBillingType>;
};

export enum QuotationState {
  /** A state indicating that the Seller submitted the Quote to the Buyer, but the Buyer has not replied yet. */
  Pending = 'PENDING',
  /** A state indicating that the Buyer has declined the Quote. */
  Declined = 'DECLINED',
  /** A state indicating that the Buyer has declined and requested to renegotiate the Quote */
  DeclinedForRenegotiation = 'DECLINED_FOR_RENEGOTIATION',
  /** A state indicating that the Seller has created a new Quote after a renegotiation has been requested. */
  RenegotiationAddressed = 'RENEGOTIATION_ADDRESSED',
  /** A state indicating that the Buyer has accepted the Quote. */
  Accepted = 'ACCEPTED',
  /** A state indicating that the Seller has withdrawn the Quote before the Buyer has accepted it. */
  Withdrawn = 'WITHDRAWN'
}

/** An unknown problem occurred */
export type QuotationUnknownProblem = Problem & {
  __typename?: 'QuotationUnknownProblem';
  message: Scalars['String'];
};

/** The quote can be canceled only if in the Pending state */
export type QuotationWrongStateProblem = Problem & {
  __typename?: 'QuotationWrongStateProblem';
  message: Scalars['String'];
};

export type Quote = {
  __typename?: 'Quote';
  id: Scalars['ID'];
  /** Quote */
  quote: Maybe<Scalars['String']>;
  /** Author of quote */
  author: Scalars['String'];
  /** Author's job of quote */
  authorJob: Maybe<Scalars['String']>;
  /** Author's picture of quote */
  authorPicture: Maybe<Image>;
  /** Description of quote */
  description: Scalars['String'];
};


export type QuoteQuoteArgs = {
  locale: Scalars['String'];
};


export type QuoteAuthorArgs = {
  locale: Scalars['String'];
};


export type QuoteAuthorJobArgs = {
  locale: Scalars['String'];
};


export type QuoteAuthorPictureArgs = {
  locale: Scalars['String'];
};


export type QuoteDescriptionArgs = {
  locale: Scalars['String'];
};

export type RecalculateCartInput = {
  /** Id of the cart */
  cartId?: Maybe<Scalars['ID']>;
  /** Channel that will own the cart (app, web, ...) */
  channel?: Maybe<CartChannel>;
};

/** Cart not found */
export type RecalculateCartNotFoundProblem = Problem & {
  __typename?: 'RecalculateCartNotFoundProblem';
  message: Scalars['String'];
};

export type RecalculateCartResponse = RecalculateCartSuccess | RecalculateCartNotFoundProblem | RecalculateCartUpdateProblem;

/** Cart representation */
export type RecalculateCartSuccess = {
  __typename?: 'RecalculateCartSuccess';
  id: Scalars['ID'];
  soldOutLineItemIds: Array<Scalars['ID']>;
};

/** Cart update problem */
export type RecalculateCartUpdateProblem = Problem & {
  __typename?: 'RecalculateCartUpdateProblem';
  message: Scalars['String'];
};

export type Redeem = {
  __typename?: 'Redeem';
  /** Redeem process identifier */
  redeemId: Scalars['ID'];
  /** When the user started the redeem process */
  redeemStartedAt: Maybe<Scalars['Date']>;
  /** When the user redeemed the gift */
  redeemedAt: Maybe<Scalars['Date']>;
  /** User who redeemed the gift (same as user owner) */
  redeemer: User;
  /** Redeemed trees */
  trees: Maybe<Array<Tree>>;
};

export type RedeemableTree = {
  __typename?: 'RedeemableTree';
  /** Redeem tree assigned from specific date only */
  assignedOnFrom: Maybe<Scalars['Date']>;
  /** Redeem tree assigned until specific date only */
  assignedOnTo: Maybe<Scalars['Date']>;
};

export type RedeemProduct = {
  __typename?: 'RedeemProduct';
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

/** The provided treecode is already consumed */
export type RedeemTreecodeAlreadyConsumedProblem = Problem & {
  __typename?: 'RedeemTreecodeAlreadyConsumedProblem';
  message: Scalars['String'];
};

/** The provided treecode is expired */
export type RedeemTreecodeExpiredProblem = Problem & {
  __typename?: 'RedeemTreecodeExpiredProblem';
  message: Scalars['String'];
};

export type RedeemTreecodeInput = {
  id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
  /** If treecode redeemed type is picker, it's the product picked  */
  pickedProductId?: Maybe<Scalars['ID']>;
  /** [ServerToServer] Specify the redeemer user id */
  redeemerId?: Maybe<Scalars['ID']>;
};

/** Missing picker product */
export type RedeemTreecodeMissingPickedProductProblem = Problem & {
  __typename?: 'RedeemTreecodeMissingPickedProductProblem';
  message: Scalars['String'];
};

/** Missing redeemer user id */
export type RedeemTreecodeMissingRedeemerIdProblem = Problem & {
  __typename?: 'RedeemTreecodeMissingRedeemerIdProblem';
  message: Scalars['String'];
};

/** Missing tree availability */
export type RedeemTreecodeMissingTreesAvailabilityProblem = Problem & {
  __typename?: 'RedeemTreecodeMissingTreesAvailabilityProblem';
  message: Scalars['String'];
};

/** User is not authorized to redeem the provided treecode */
export type RedeemTreecodeNotAuthorizedProblem = Problem & {
  __typename?: 'RedeemTreecodeNotAuthorizedProblem';
  message: Scalars['String'];
};

/** The provided treecode is not enabled */
export type RedeemTreecodeNotEnabledProblem = Problem & {
  __typename?: 'RedeemTreecodeNotEnabledProblem';
  message: Scalars['String'];
};

/** The provided treecode does not exists */
export type RedeemTreecodeNotExistsProblem = Problem & {
  __typename?: 'RedeemTreecodeNotExistsProblem';
  message: Scalars['String'];
};

/** Input for refreshing a billing plan. */
export type RefreshBillingInput = {
  refreshEntries?: Maybe<Scalars['Boolean']>;
};

/** Problem that occurs when trying to refresh a billing plan. */
export type RefreshBillingProblem = Problem & {
  __typename?: 'RefreshBillingProblem';
  message: Scalars['String'];
};

/** Response from refreshing a billing plan. */
export type RefreshBillingResponse = BillingPlan | RefreshBillingProblem;

/** Input for refreshing a plan. */
export type RefreshPlanInput = {
  refreshProducts?: Maybe<Scalars['Boolean']>;
};

/** Problem that occurs when trying to refresh a plan. */
export type RefreshPlanProblem = Problem & {
  __typename?: 'RefreshPlanProblem';
  message: Scalars['String'];
  code: PlanProblemCode;
};

/** Response from refreshing a plan. */
export type RefreshPlanResponse = Plan | RefreshPlanProblem;

export type ReleaseItemsInput = {
  /** The identifier of the cart from which to release the items. */
  cartId?: Maybe<Scalars['ID']>;
};

/** Response from releasing items in the cart. */
export type ReleaseItemsResponse = Resource | CartReleaseItemsCartNotFoundProblem;

/** Input used when removing a discount from the cart. */
export type RemoveDiscountInput = {
  discountCodeId: Scalars['ID'];
  cartId?: Maybe<Scalars['ID']>;
};

export type RemoveDiscountResponse = Resource | CartRemoveDiscountCartNotFoundProblem | CartRemoveDiscountIncorrectDiscountCodeProblem | CartRemoveDiscountUserMismatchProblem;

export type RemoveItemInput = {
  /**
   * Cart where item'll be removed from
   * Can be leaved empty if request is authenticated (will default to logged-in user's active cart)
   */
  cartId?: Maybe<Scalars['ID']>;
};

export type RemoveItemResponse = Resource | CartRemoveItemCartNotFoundProblem | CartRemoveItemMissingCartProblem;

export type RemoveRuleSetMutationResponse = Perk | RemoveRuleSetPerkNotFoundProblem | RemoveRuleSetNotFoundProblem;

export type RemoveRuleSetNotFoundProblem = Problem & {
  __typename?: 'RemoveRuleSetNotFoundProblem';
  message: Scalars['String'];
};

export type RemoveRuleSetPerkNotFoundProblem = Problem & {
  __typename?: 'RemoveRuleSetPerkNotFoundProblem';
  message: Scalars['String'];
};

export type ReportAbuseCommentInput = {
  commentId: Scalars['ID'];
  reporterId: Scalars['ID'];
  reason: AbuseReportReason;
};

export type ReportAbuseCommentNotFoundProblem = Problem & {
  __typename?: 'ReportAbuseCommentNotFoundProblem';
  message: Scalars['String'];
};

export type ReportAbuseCommentResponse = Resource | ReportAbuseCommentUnknownProblem | ReportAbuseCommentNotFoundProblem;

export type ReportAbuseCommentUnknownProblem = Problem & {
  __typename?: 'ReportAbuseCommentUnknownProblem';
  message: Scalars['String'];
};

export type RequestBackInStockNotificationInput = {
  /** User to be notified */
  userId: Scalars['ID'];
  /** Expected product to be checked for back in stock notification */
  productId: Scalars['ID'];
};

export type RequestBackInStockNotificationProductNotFoundProblem = Problem & {
  __typename?: 'RequestBackInStockNotificationProductNotFoundProblem';
  message: Scalars['String'];
};

export type RequestBackInStockNotificationResponse = Resource | RequestBackInStockNotificationProductNotFoundProblem | RequestBackInStockNotificationUnknownProblem;

export type RequestBackInStockNotificationUnknownProblem = Problem & {
  __typename?: 'RequestBackInStockNotificationUnknownProblem';
  message: Scalars['String'];
};

export type RequestChangeEmailInput = {
  newEmail: Scalars['String'];
};

export type RequestChangeEmailInvalidEmailProblem = Problem & {
  __typename?: 'RequestChangeEmailInvalidEmailProblem';
  message: Scalars['String'];
};

export type RequestChangeEmailResponse = Resource | RequestChangeEmailInvalidEmailProblem;

export type RequestGiftsSummaryInput = {
  uuid: Array<Scalars['ID']>;
};

/** The provided treecodes do not exist */
export type RequestGiftsSummaryNotExistProblem = Problem & {
  __typename?: 'RequestGiftsSummaryNotExistProblem';
  message: Scalars['String'];
  treecodes: Array<Scalars['ID']>;
};

export type RequestGiftsSummaryResponse = Resources | RequestGiftsSummaryNotExistProblem;

export type ReserveItemsInput = {
  /** The identifier of the cart for which to reserve the items. */
  cartId?: Maybe<Scalars['ID']>;
};

export type ReserveItemsResponse = Resource | CartReserveItemsCartNotFoundProblem | CartReserveItemsMissingRequiredShippingAddressProblem;

export type Resource = {
  __typename?: 'Resource';
  id: Scalars['ID'];
};

export type Resources = {
  __typename?: 'Resources';
  resources: Array<Resource>;
};

export type ResultForestryTrees = ForestryTreesConnection | MalformedInputProblem;

export type ScientificSpecie = {
  __typename?: 'ScientificSpecie';
  /** ID of the scientific specie */
  id: Scalars['ID'];
  /** Signed upload url which could be used to upload a new facebook icon */
  facebookIconUploadUrl: FileUpload;
  /** Signed upload url which could be used to upload a new avatar */
  galleryImageUploadUrl: FileUpload;
  /** Signed upload url which could be used to upload a new icon */
  iconUploadUrl: FileUpload;
  badges: Array<TreeBadge>;
  /** Benefits of the specie */
  benefits: ScientificSpecieBenefits;
  /** A biodiversity description of the scientific specie */
  biodiversityDescription: Maybe<Scalars['String']>;
  /** Description of the scientific specie */
  description: Maybe<Scalars['String']>;
  /** True if the species is at risk of extinction, false otherwise */
  extinctionRisk: Maybe<Scalars['Boolean']>;
  facebookIcon: Maybe<Image>;
  /** Gallery of media for the scientific specie */
  gallery: Maybe<MediaGallery>;
  /** Icon related to the scientific specie */
  icon: Maybe<Image>;
  /** Meaning of the scientific specie */
  meaning: Maybe<Scalars['String']>;
  /** Meaning description of the scientific specie */
  meaningDescription: Maybe<Scalars['String']>;
  /** Name of the specie */
  name: Scalars['String'];
  /** The estimate of the profit in dollars from one kilogram produced by the scientific specie */
  pricePerKg: Maybe<Scalars['Float']>;
  /** Scientific name of the specie */
  scientificName: Scalars['String'];
  /** The estimate of the number of trees of the species that can be planted in one hectare */
  treesPerHa: Maybe<Scalars['Int']>;
  /** A yield coefficient in annual kilograms per hectare */
  yieldPerHa: Maybe<Scalars['Float']>;
};


export type ScientificSpecieBiodiversityDescriptionArgs = {
  locale: Scalars['String'];
};


export type ScientificSpecieDescriptionArgs = {
  locale: Scalars['String'];
};


export type ScientificSpecieMeaningArgs = {
  locale: Scalars['String'];
};


export type ScientificSpecieMeaningDescriptionArgs = {
  locale: Scalars['String'];
};


export type ScientificSpecieNameArgs = {
  locale: Scalars['String'];
};

export type ScientificSpecieBenefits = {
  __typename?: 'ScientificSpecieBenefits';
  /** Specie’s CO2 absorption power. Values between 0 and 100. */
  co2Power: Maybe<Scalars['Int']>;
  /** Specie’s Food Security power. Values between 0 and 100. */
  foodSecurityPower: Maybe<Scalars['Int']>;
  /** Specie’s Soil consolidation power. Values between 0 and 100. */
  soilPower: Maybe<Scalars['Int']>;
  /** Specie’s Incomes power. Values between 0 and 100. */
  incomePower: Maybe<Scalars['Int']>;
};

export type ScientificSpecieConnection = Connection & {
  __typename?: 'ScientificSpecieConnection';
  totalCount: Scalars['Int'];
  pageInfo: Maybe<PageInfo>;
  edges: Maybe<Array<Maybe<ScientificSpecieEdge>>>;
};

export type ScientificSpecieEdge = Edge & {
  __typename?: 'ScientificSpecieEdge';
  node: Maybe<ScientificSpecie>;
  cursor: Maybe<Scalars['String']>;
};

export type ScientificSpecieMutation = {
  __typename?: 'ScientificSpecieMutation';
  setFacebookIcon: SetScientificSpecieFacebookIconResponse;
  setGallery: SetScientificSpecieGalleryResponse;
  setIcon: SetScientificSpecieIconResponse;
  update: Maybe<UpdateScientificSpecieMutationResponse>;
};


export type ScientificSpecieMutationSetFacebookIconArgs = {
  id: Scalars['ID'];
  iconId: Scalars['String'];
};


export type ScientificSpecieMutationSetGalleryArgs = {
  id: Scalars['ID'];
  input: SetScientificSpecieGalleryInput;
};


export type ScientificSpecieMutationSetIconArgs = {
  id: Scalars['ID'];
  iconId: Scalars['String'];
};


export type ScientificSpecieMutationUpdateArgs = {
  id: Scalars['ID'];
  input: ScientificSpecieUpdateMutationInput;
};

export type ScientificSpecieUpdateMutationInput = {
  biodiversityDescription?: Maybe<Array<LocalizedValueInput>>;
  /** The estimate of the profit from one kilogram produced by the species */
  pricePerKg?: Maybe<Scalars['Float']>;
  /** A yield coefficient in annual kilograms per hectare */
  yieldPerHa?: Maybe<Scalars['Float']>;
  /** True if the species is at risk of extinction, false otherwise */
  extinctionRisk?: Maybe<Scalars['Boolean']>;
  /** The estimate of the number of trees of the species that can be planted in one hectare */
  treesPerHa?: Maybe<Scalars['Int']>;
};

export type ScientificSpecieWhereInput = {
  ids?: Maybe<Array<Scalars['ID']>>;
  name?: Maybe<Scalars['String']>;
};

export type Sdg = {
  __typename?: 'Sdg';
  /** This is the official SDG number from https://sdgs.un.org/goals */
  key: Scalars['ID'];
  /** The description of the SDG. */
  description: Scalars['String'];
  /** The icon of the SDG. */
  icon: Image;
  /** The name of the SDG. */
  name: Scalars['String'];
};


export type SdgDescriptionArgs = {
  locale: Scalars['String'];
};


export type SdgNameArgs = {
  locale: Scalars['String'];
};

export type SetCapabilityGroupCapabilitiesResponse = Resource | UpdateCapabilityGroupCapabilitiesCapabilityGroupNotFoundProblem | UpdateCapabilityGroupCapabilitiesMalformedCapabilityProblem;

export type SetConsentsInput = {
  legalNotices: Array<ConsentLegalNoticeInput>;
  proofs: Array<ConsentProofInput>;
  preferences: ConsentPreferencesInput;
};

export type SetConsentsNotAcceptedProblem = Problem & {
  __typename?: 'SetConsentsNotAcceptedProblem';
  message: Scalars['String'];
  field: Maybe<Scalars['String']>;
};

export type SetConsentsResponse = Resource | SetConsentsNotAcceptedProblem | SetConsentsUserNotFoundProblem;

export type SetConsentsUserNotFoundProblem = Problem & {
  __typename?: 'SetConsentsUserNotFoundProblem';
  message: Scalars['String'];
  userId: Scalars['ID'];
};

export type SetForestForestNotFoundProblem = Problem & {
  __typename?: 'SetForestForestNotFoundProblem';
  message: Scalars['String'];
};

export type SetForestInput = {
  /** Destination forest slug */
  forestSlug: Scalars['String'];
};

export type SetForestResponse = Resource | SetForestUserDoesNotOwnForestProblem | SetForestUserDoesNotOwnTreeProblem | SetForestTreeAlreadyInForestProblem | SetForestTreeNotFoundProblem | SetForestForestNotFoundProblem;

export type SetForestTreeAlreadyInForestProblem = Problem & {
  __typename?: 'SetForestTreeAlreadyInForestProblem';
  message: Scalars['String'];
};

export type SetForestTreeNotFoundProblem = Problem & {
  __typename?: 'SetForestTreeNotFoundProblem';
  message: Scalars['String'];
};

export type SetForestUserDoesNotOwnForestProblem = Problem & {
  __typename?: 'SetForestUserDoesNotOwnForestProblem';
  message: Scalars['String'];
};

export type SetForestUserDoesNotOwnTreeProblem = Problem & {
  __typename?: 'SetForestUserDoesNotOwnTreeProblem';
  message: Scalars['String'];
};

export type SetOriginatorAvatarNotFoundProblem = Problem & {
  __typename?: 'SetOriginatorAvatarNotFoundProblem';
  message: Scalars['String'];
};

export type SetOriginatorAvatarResponse = Resource | SetOriginatorAvatarNotFoundProblem;

/** Problem that occurs when the cart is not found while setting payment details. */
export type SetPaymentDetailsCartNotFoundProblem = Problem & {
  __typename?: 'SetPaymentDetailsCartNotFoundProblem';
  message: Scalars['String'];
};

export type SetPaymentDetailsInput = {
  /** The identifier of the cart for which to set payment details. */
  cartId: Scalars['ID'];
  details: AdyenPaymentDetailsInput;
};

/** Response from setting payment details. */
export type SetPaymentDetailsResponse = SetPaymentDetailsSuccessResponse | SetPaymentDetailsCartNotFoundProblem;

/** Response from successfully setting payment details. */
export type SetPaymentDetailsSuccessResponse = {
  __typename?: 'SetPaymentDetailsSuccessResponse';
  /** The identifier of the cart. */
  id: Scalars['ID'];
  /** The identifier of the payment. */
  transactionId: Scalars['ID'];
  /** The payment status. */
  status: AdyenPaymentState;
};

export type SetPreferencesInput = {
  hideEmissions?: Maybe<Scalars['Boolean']>;
  hideUsers?: Maybe<Scalars['Boolean']>;
};

export type SetProjectSpecieNurseryGalleryInput = {
  imageIds?: Maybe<Array<Scalars['String']>>;
};

export type SetProjectSpecieNurseryGalleryNotFoundProblem = Problem & {
  __typename?: 'SetProjectSpecieNurseryGalleryNotFoundProblem';
  message: Scalars['String'];
};

export type SetProjectSpecieNurseryGalleryResponse = Resource | SetProjectSpecieNurseryGalleryNotFoundProblem;

export type SetScientificSpecieFacebookIconNotFoundProblem = Problem & {
  __typename?: 'SetScientificSpecieFacebookIconNotFoundProblem';
  message: Scalars['String'];
};

export type SetScientificSpecieFacebookIconResponse = Resource | SetScientificSpecieFacebookIconNotFoundProblem;

export type SetScientificSpecieGalleryInput = {
  imageIds?: Maybe<Array<Scalars['String']>>;
};

export type SetScientificSpecieGalleryNotFoundProblem = Problem & {
  __typename?: 'SetScientificSpecieGalleryNotFoundProblem';
  message: Scalars['String'];
};

export type SetScientificSpecieGalleryResponse = Resource | SetScientificSpecieGalleryNotFoundProblem;

export type SetScientificSpecieIconNotFoundProblem = Problem & {
  __typename?: 'SetScientificSpecieIconNotFoundProblem';
  message: Scalars['String'];
};

export type SetScientificSpecieIconResponse = Resource | SetScientificSpecieIconNotFoundProblem;

export type SetSocialIdentityInput = {
  provider: SocialIdentity;
  providerUserId: Scalars['String'];
};

export type SetSocialIdentityInputResponse = Resource | SetSocialIdentityResponseProblem;

export type SetSocialIdentityResponseProblem = Problem & {
  __typename?: 'SetSocialIdentityResponseProblem';
  message: Scalars['String'];
};

export type SetSubscriptionPaymentDetailsInput = {
  /** The identifier of the cart for which to set payment details. */
  subscriptionId: Scalars['ID'];
  details: AdyenPaymentDetailsInput;
};

/** Problem that occurs when the cart is not found while setting payment details. */
export type SetSubscriptionPaymentDetailsNotFoundProblem = Problem & {
  __typename?: 'SetSubscriptionPaymentDetailsNotFoundProblem';
  message: Scalars['String'];
};

/** Response from setting payment details. */
export type SetSubscriptionPaymentDetailsResponse = SetSubscriptionPaymentDetailsSuccessResponse | SetSubscriptionPaymentDetailsNotFoundProblem;

/** Response from successfully setting payment details. */
export type SetSubscriptionPaymentDetailsSuccessResponse = {
  __typename?: 'SetSubscriptionPaymentDetailsSuccessResponse';
  /** The identifier of the cart. */
  id: Scalars['ID'];
  /** The identifier of the payment. */
  transactionId: Scalars['ID'];
  /** The payment status. */
  status: AdyenPaymentState;
};

export type SetUserCapabilitiesMalformedCapabilityProblem = Problem & {
  __typename?: 'SetUserCapabilitiesMalformedCapabilityProblem';
  message: Scalars['String'];
};

export type SetUserCapabilitiesReponse = SetUserCapabilitiesUserNotFoundProblem | SetUserCapabilitiesMalformedCapabilityProblem | Resource;

export type SetUserCapabilitiesUserNotFoundProblem = Problem & {
  __typename?: 'SetUserCapabilitiesUserNotFoundProblem';
  message: Scalars['String'];
};

export type SetUserCapabilityGroupsReponse = SetUserCapabilityGroupsUserNotFoundProblem | Resource;

export type SetUserCapabilityGroupsUserNotFoundProblem = Problem & {
  __typename?: 'SetUserCapabilityGroupsUserNotFoundProblem';
  message: Scalars['String'];
};

export type SetUserTypeResponse = Resource | SetUserTypeUserNotFoundProblem;

export type SetUserTypeUserNotFoundProblem = Problem & {
  __typename?: 'SetUserTypeUserNotFoundProblem';
  message: Scalars['String'];
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  /** The ID is optional as within a Cart/Order is possible to set an address that hasn't been stored within the Customer entity. */
  id: Maybe<Scalars['ID']>;
  /** True if this is the default shipping address */
  isDefault: Scalars['Boolean'];
  country: Country;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  company: Maybe<Scalars['String']>;
  email: Scalars['String'];
  postalCode: Scalars['String'];
  city: Scalars['String'];
  streetName: Scalars['String'];
  streetNumber: Maybe<Scalars['String']>;
  region: Maybe<Scalars['String']>;
  /** Should include the prefix in the form +39 */
  phone: Maybe<Scalars['String']>;
  /** Further information on the street address */
  notes: Maybe<Scalars['String']>;
  /** State/province */
  state: Maybe<Scalars['String']>;
};

/** Input used when setting the shipping address of the cart. */
export type ShippingAddressInput = {
  cartId: Scalars['ID'];
  shippingAddress: CartShippingAddressInput;
};

export type ShippingStatus = {
  date: Scalars['DateTime'];
  status: ShippingStatuses;
};

export enum ShippingStatuses {
  PickedUp = 'PICKED_UP',
  InTransit = 'IN_TRANSIT',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Delivered = 'DELIVERED',
  Unknown = 'UNKNOWN'
}

export type ShippingTrackingInfo = {
  carrier?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
};

export enum ShopCurrency {
  Eur = 'EUR',
  Usd = 'USD',
  Gbp = 'GBP'
}

export type SimpleProductBadge = {
  __typename?: 'SimpleProductBadge';
  key: Scalars['String'];
};

export enum SocialIdentity {
  Google = 'GOOGLE',
  Facebook = 'FACEBOOK',
  Apple = 'APPLE'
}

export type SocialLinks = {
  __typename?: 'SocialLinks';
  /** Link to user's Facebook profile */
  facebook: Maybe<Scalars['String']>;
  /** Link to user's Instagram profile */
  instagram: Maybe<Scalars['String']>;
  /** Link to user's Linkedin profile */
  linkedin: Maybe<Scalars['String']>;
  /** Link to user's Pinterest profile */
  pinterest: Maybe<Scalars['String']>;
  /** Link to user's Tiktok profile */
  tiktok: Maybe<Scalars['String']>;
  /** Link to user's Twitter profile */
  twitter: Maybe<Scalars['String']>;
  /** Link to user's Youtube profile */
  youtube: Maybe<Scalars['String']>;
};

export enum SqlSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StandardMedia = {
  __typename?: 'StandardMedia';
  id: Scalars['ID'];
};

export type StreamConnection = {
  pageInfo: StreamPageInfo;
};

export type StreamPageInfo = {
  __typename?: 'StreamPageInfo';
  endCursor: Maybe<Scalars['String']>;
  /** @deprecated Not implemented, it'll be deleted soon */
  hasNextPage: Maybe<Scalars['Boolean']>;
};

export enum SubscriptionCancelationSurveyReason {
  Cost = 'COST',
  FoundAlternative = 'FOUND_ALTERNATIVE',
  NotEnoughValue = 'NOT_ENOUGH_VALUE',
  LackOfCustomization = 'LACK_OF_CUSTOMIZATION',
  Other = 'OTHER'
}

export type SubscriptionCause = {
  __typename?: 'SubscriptionCause';
  /** Key of the subscription cause */
  key: ProductSubscriptionCauseKey;
};

export type SubscriptionImpactContent = {
  __typename?: 'SubscriptionImpactContent';
  id: Scalars['ID'];
  background: Image;
  /** The list of Goals for this Impact Content. */
  goals: Array<Maybe<ImpactGoal>>;
  images: Array<Maybe<Image>>;
  quotes: Maybe<Array<Maybe<Quote>>>;
  /** Title */
  title: Scalars['String'];
  videos: Maybe<Array<Maybe<VideoUrl>>>;
};


export type SubscriptionImpactContentBackgroundArgs = {
  locale: Scalars['String'];
};


export type SubscriptionImpactContentImagesArgs = {
  locale: Scalars['String'];
};


export type SubscriptionImpactContentQuotesArgs = {
  locale: Scalars['String'];
};


export type SubscriptionImpactContentTitleArgs = {
  locale: Scalars['String'];
};


export type SubscriptionImpactContentVideosArgs = {
  locale: Scalars['String'];
};

export type SubscriptionStatisticsCounter = {
  __typename?: 'SubscriptionStatisticsCounter';
  interval: Maybe<SubscriptionStatisticsIntervals>;
  trees: Scalars['Int'];
  assignments: Scalars['Int'];
  billings: Scalars['Int'];
};

export enum SubscriptionStatisticsIntervals {
  /** 360 days based */
  Yearly = 'YEARLY',
  /** 30 days */
  Monthly = 'MONTHLY',
  Daily = 'DAILY'
}

export type SubscriptionTreesForecast = {
  __typename?: 'SubscriptionTreesForecast';
  projectSpecieId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type SubscriptionTreesForecastInput = {
  fromDate?: Maybe<Scalars['DateTime']>;
  months?: Maybe<Scalars['Int']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  /** ID of the supplier */
  id: Scalars['ID'];
  address: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** The projects related to this supplier */
  projects: Maybe<Array<Maybe<ProcurementProject>>>;
  vat: Maybe<Scalars['String']>;
};

export type SupplierConnection = Connection & {
  __typename?: 'SupplierConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<SupplierEdge>>;
  pageInfo: PageInfo;
};

export type SupplierEdge = Edge & {
  __typename?: 'SupplierEdge';
  cursor: Scalars['String'];
  node: Maybe<Supplier>;
};

export type SupplierFinancialStatement = {
  __typename?: 'SupplierFinancialStatement';
  id: Scalars['ID'];
  balance: Maybe<Scalars['Float']>;
  supplier: Supplier;
  totalCost: Maybe<Scalars['Float']>;
  totalPaid: Maybe<Scalars['Float']>;
};

export type SupplierFinancialStatementConnection = Connection & {
  __typename?: 'SupplierFinancialStatementConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<SupplierFinancialStatementEdge>>;
  pageInfo: PageInfo;
};

export type SupplierFinancialStatementEdge = Edge & {
  __typename?: 'SupplierFinancialStatementEdge';
  cursor: Scalars['String'];
  node: Maybe<SupplierFinancialStatement>;
};

export type SupplierFinancialStatementsWhereConditionInput = {
  /** List of supplier ids which will be used to filter on */
  supplierIds?: Maybe<Array<Scalars['ID']>>;
};

export type SupplierWhereConditionInput = {
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type Temperature = {
  __typename?: 'Temperature';
  fahrenheit: Maybe<Scalars['Float']>;
  celsius: Maybe<Scalars['Float']>;
};

/** Input used when setting the giftable status of line items in a given cart */
export type ToggleLineItemsGiftableInput = {
  cartId?: Maybe<Scalars['ID']>;
  giftable: Scalars['Boolean'];
};

export type ToggleLineItemsGiftableResponse = Resource | CartToggleLineItemsGiftableCartNotFoundProblem | CartToggleLineItemsGiftableUserMismatchProblem | CartToggleLineItemsGiftableUpdateProblem;

export type Translation = {
  __typename?: 'Translation';
  /** Italian field */
  it: Scalars['String'];
  /** German field */
  de: Scalars['String'];
  /** English field */
  en: Scalars['String'];
  /** Spanish field */
  es: Scalars['String'];
  /** French field */
  fr: Scalars['String'];
};

export type TranslationInput = {
  /** Italian field */
  it: Scalars['String'];
  /** English field */
  en: Scalars['String'];
  /** Spanish field */
  es: Scalars['String'];
  /** German field */
  de: Scalars['String'];
  /** French field */
  fr: Scalars['String'];
};

/**
 * Treedom Tree
 * 
 * this entity represents a Tree related to a user
 */
export type Tree = {
  __typename?: 'Tree';
  /** Identifier of the tree */
  id: Scalars['ID'];
  /** Ecommerce related product */
  product: Maybe<Product>;
  /** Name of the tree set by the owner */
  name: Maybe<Scalars['String']>;
  /** Photo of the tree */
  photo: Maybe<Image>;
  /**
   * Name to use in the Tree profile
   * locale format: "xx-YY" ex. "en-US"
   */
  profileName: Scalars['String'];
  /** Picture to use in the Tree profile */
  profilePicture: Maybe<Image>;
  /** Icon of the tree */
  icon: Maybe<Image>;
  /** Location of the planted tree */
  plantingLocation: Maybe<Place>;
  /** Project specie of the tree */
  projectSpecie: ProjectSpecie;
  /** Tree's benefits */
  benefits: TreeBenefits;
  /** Current location of the tree */
  location: Maybe<Place>;
  /** When the tree was assigned or gifted owner */
  assignedAt: Maybe<Scalars['DateTime']>;
  /** CO2 statistics of  the tree */
  co2: TreeCo2;
  /** Old feature that relates two trees  */
  coupledWith: Maybe<Tree>;
  /** When the tree was created by the planter  */
  createdAt: Maybe<Scalars['DateTime']>;
  /** Forest of the tree */
  forest: Maybe<Forest>;
  /** If not empty, it's the date until tree will be giftable */
  giftableUntil: Maybe<Scalars['DateTime']>;
  /** Latest update of the status */
  lastStatusUpdate: Maybe<Scalars['DateTime']>;
  /** When the tree is in the nursery */
  nurseryAt: Maybe<Scalars['DateTime']>;
  /** Photo of the tree in the nursery */
  nurseryPicture: Maybe<Image>;
  /** The current owner of the tree */
  owner: User;
  /** When the photo is published */
  photoAt: Maybe<Scalars['DateTime']>;
  /** When the tree is planted */
  plantedAt: Maybe<Scalars['DateTime']>;
  /** The user that has planted the tree  */
  planter: User;
  /** Friendly ID used in tree registry */
  registryId: Scalars['String'];
  /**
   * Share url of tree. 
   * You must specify the locale with which the url will be localized.    
   */
  shareUrl: Scalars['String'];
  /** Status of the tree */
  status: TreeStatus;
  /** Weather information on site where the tree is located */
  weather: Maybe<Weather>;
  /** Gift which contains the tree */
  gift: Maybe<Treecode>;
  /** Indicates whether the tree can be gifted or not. */
  isGiftable: Scalars['Boolean'];
};


/**
 * Treedom Tree
 * 
 * this entity represents a Tree related to a user
 */
export type TreeProfileNameArgs = {
  locale: Scalars['String'];
};


/**
 * Treedom Tree
 * 
 * this entity represents a Tree related to a user
 */
export type TreeShareUrlArgs = {
  locale: Scalars['String'];
};

export type TreeBadge = {
  __typename?: 'TreeBadge';
  id: Scalars['ID'];
};

export type TreeBenefits = {
  __typename?: 'TreeBenefits';
  /** Tree’s CO2 absorption power. Values between 0 and 100. */
  co2: Scalars['Int'];
  /** Tree’s Food Security power. Values between 0 and 100. */
  foodSecurity: Scalars['Int'];
  /** Tree’s Soil consolidation power. Values between 0 and 100. */
  soil: Scalars['Int'];
  /** Tree’s Incomes power. Values between 0 and 100. */
  income: Scalars['Int'];
  /** Tree’s social impact. Values between 0 and 100. */
  social: Scalars['Int'];
  /** Tree’s environmental impact. Values between 0 and 100. */
  environmental: Scalars['Int'];
};

/** The argument "input.assignedOnFrom" must be a valid date */
export type TreeBulkChangeGiftableUntilAssignedOnFromNotValidProblem = Problem & {
  __typename?: 'TreeBulkChangeGiftableUntilAssignedOnFromNotValidProblem';
  message: Scalars['String'];
};

/** The argument "input.assignedOnTo" must be a valid date */
export type TreeBulkChangeGiftableUntilAssignedOnToNotValidProblem = Problem & {
  __typename?: 'TreeBulkChangeGiftableUntilAssignedOnToNotValidProblem';
  message: Scalars['String'];
};

export type TreeBulkChangeGiftableUntilFindInput = {
  /** Filter by user owner of trees */
  ownerId: Scalars['ID'];
  /** Filter by trees assigned from specific date-time */
  assignedOnFrom: Scalars['DateTime'];
  /** Filter by trees assigned until specific date-time */
  assignedOnTo: Scalars['DateTime'];
};

export type TreeBulkChangeGiftableUntilInput = {
  /** New giftableUntil value to be set on tree */
  giftableUntil: Scalars['DateTime'];
};

/** The argument "input.giftableUntil" must be a valid date */
export type TreeBulkChangeGiftableUntilNotValidProblem = Problem & {
  __typename?: 'TreeBulkChangeGiftableUntilNotValidProblem';
  message: Scalars['String'];
};

export type TreeBulkChangeGiftableUntilResponse = TreeBulkChangeGiftableUntilResponseData | TreeBulkChangeGiftableUntilNotValidProblem | TreeBulkChangeGiftableUntilAssignedOnFromNotValidProblem | TreeBulkChangeGiftableUntilAssignedOnToNotValidProblem | TreeBulkChangeGiftableUntilUnknownProblem;

export type TreeBulkChangeGiftableUntilResponseData = {
  __typename?: 'TreeBulkChangeGiftableUntilResponseData';
  /** Total number of trees affected by giftableUntil change */
  treesUpdated: Scalars['Int'];
};

/** Unknown problem */
export type TreeBulkChangeGiftableUntilUnknownProblem = Problem & {
  __typename?: 'TreeBulkChangeGiftableUntilUnknownProblem';
  message: Scalars['String'];
};

export type TreeBulkChangeOwnershipInput = {
  /** Current user owner of trees */
  sourceUserId: Scalars['ID'];
  /** Target user who will become the owner of trees */
  targetUserId: Scalars['ID'];
};

export type TreeBulkChangeOwnershipInvalidTargetUserProblem = Problem & {
  __typename?: 'TreeBulkChangeOwnershipInvalidTargetUserProblem';
  message: Scalars['String'];
};

export type TreeBulkChangeOwnershipResponse = TreeBulkChangeOwnershipResponseData | TreeBulkChangeOwnershipUnknownProblem | TreeBulkChangeOwnershipInvalidTargetUserProblem;

export type TreeBulkChangeOwnershipResponseData = {
  __typename?: 'TreeBulkChangeOwnershipResponseData';
  /** Total number of trees transferred from source to target user */
  totalTreesTransferred: Scalars['Int'];
};

export type TreeBulkChangeOwnershipUnknownProblem = Problem & {
  __typename?: 'TreeBulkChangeOwnershipUnknownProblem';
  message: Scalars['String'];
};

export type TreeBulkChangePlanterInput = {
  /** Current user planter of trees */
  sourceUserId: Scalars['ID'];
  /** Target user who will become the planter of trees */
  targetUserId: Scalars['ID'];
};

export type TreeBulkChangePlanterInvalidTargetUserProblem = Problem & {
  __typename?: 'TreeBulkChangePlanterInvalidTargetUserProblem';
  message: Scalars['String'];
};

export type TreeBulkChangePlanterResponse = TreeBulkChangePlanterResponseData | TreeBulkChangePlanterUnknownProblem | TreeBulkChangePlanterInvalidTargetUserProblem;

export type TreeBulkChangePlanterResponseData = {
  __typename?: 'TreeBulkChangePlanterResponseData';
  /** Total number of trees transferred from source to target user */
  totalTreesTransferred: Scalars['Int'];
};

export type TreeBulkChangePlanterUnknownProblem = Problem & {
  __typename?: 'TreeBulkChangePlanterUnknownProblem';
  message: Scalars['String'];
};

/** The argument "name" can't be an empty string */
export type TreeChangeNameEmptyNameProblem = Problem & {
  __typename?: 'TreeChangeNameEmptyNameProblem';
  message: Scalars['String'];
};

export type TreeChangeNameInput = {
  /** The new name of the tree */
  name: Scalars['String'];
};

/** The tree does not belong to the user */
export type TreeChangeNameNotAuthorizedProblem = Problem & {
  __typename?: 'TreeChangeNameNotAuthorizedProblem';
  message: Scalars['String'];
};

export type TreeChangeNameResponse = Resource | TreeChangeNameNotAuthorizedProblem | TreeChangeNameEmptyNameProblem;

export type TreeCo2 = {
  __typename?: 'TreeCO2';
  total: Scalars['Int'];
  absorbed: Scalars['Int'];
  left: Scalars['Int'];
};

export type Treecode = {
  id: Scalars['ID'];
  uuid: Scalars['ID'];
  code: Scalars['String'];
  traceId: Maybe<Scalars['ID']>;
  type: TreecodeType;
  label: Maybe<Scalars['String']>;
  /** If treecode is still enabled */
  enabled: Scalars['Boolean'];
  /** Date until treecode will be valid */
  expireDate: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  owner: User;
  creator: User;
  /** How many remaining available redeems on treecode */
  availableRedeems: Scalars['Int'];
  /** How many redeems done on treecode */
  completedRedeems: Scalars['Int'];
  /** How many total redeems on treecode (completed+available) */
  totalRedeems: Scalars['Int'];
  /** If treecode is still redeemable */
  redeemable: Scalars['Boolean'];
  /** If treecode is no more redeemable */
  exhaust: Scalars['Boolean'];
  /** Indicates whether the treecode has a custom redeem flow (web site is needed to redeem). */
  isCustomRedeemFlow: Scalars['Boolean'];
  gift: Gift;
  /** List of redeems */
  redeems: Array<Redeem>;
  shareUrl: Scalars['String'];
};

export type TreecodeBaseConnection = {
  totalCount: Scalars['Int'];
  pageInfo: Maybe<TreecodePageInfo>;
};

export type TreecodeConnection = BaseConnection & {
  __typename?: 'TreecodeConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<TreecodeEdge>>;
};

export type TreecodeCreateMutation = {
  __typename?: 'TreecodeCreateMutation';
  gift: Maybe<TreecodeGiftCreateResponse>;
  picker: Maybe<TreecodePickerCreateResponse>;
  simple: Maybe<TreecodeSimpleCreateResponse>;
  virgin: Maybe<TreecodeVirginCreateResponse>;
};


export type TreecodeCreateMutationGiftArgs = {
  input: CreateTreecodeGiftInput;
};


export type TreecodeCreateMutationPickerArgs = {
  input: CreateTreecodePickerInput;
};


export type TreecodeCreateMutationSimpleArgs = {
  input: CreateTreecodeSimpleInput;
};


export type TreecodeCreateMutationVirginArgs = {
  input: CreateTreecodeVirginInput;
};

export type TreecodeCreativity = {
  __typename?: 'TreecodeCreativity';
  id: Scalars['String'];
  image: Image;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type TreecodeCreativityConnection = BaseConnection & {
  __typename?: 'TreecodeCreativityConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Array<Maybe<TreecodeCreativityEdge>>;
};

export type TreecodeCreativityEdge = Edge & {
  __typename?: 'TreecodeCreativityEdge';
  cursor: Scalars['String'];
  node: Maybe<TreecodeCreativity>;
};

export type TreecodeDeleteResponse = Resource | DeleteTreecodeNotExistsProblem | DeleteTreecodeRetailAssociatedProblem | DeleteTreecodeAlreadyConsumedProblem | DeleteTreecodeNotAuthorizedProblem;

export type TreecodeEdge = Edge & {
  __typename?: 'TreecodeEdge';
  cursor: Scalars['String'];
  node: Maybe<Treecode>;
};

export type TreecodeFindInput = {
  id?: Maybe<Scalars['ID']>;
  uuid?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
};

export type TreecodeGame = {
  __typename?: 'TreecodeGame';
  id: Scalars['ID'];
  /** Data of game completion by specific user */
  completionResult: Maybe<TreecodeGameCompletionResult>;
  /** Expire date of game */
  expireDate: Scalars['Date'];
  /** If case of reward expected on completion, it's the product inside of it  */
  rewardProduct: Maybe<Product>;
  /** If user will receive a reward on game completion */
  triggerReward: Scalars['Boolean'];
};


export type TreecodeGameCompletionResultArgs = {
  userId: Scalars['ID'];
};

export type TreecodeGameCompleteAlreadyCompletedProblem = Problem & {
  __typename?: 'TreecodeGameCompleteAlreadyCompletedProblem';
  message: Scalars['String'];
};

export type TreecodeGameCompleteGameExpiredProblem = Problem & {
  __typename?: 'TreecodeGameCompleteGameExpiredProblem';
  message: Scalars['String'];
};

export type TreecodeGameCompleteGameNotFoundProblem = Problem & {
  __typename?: 'TreecodeGameCompleteGameNotFoundProblem';
  message: Scalars['String'];
};

export type TreecodeGameCompleteInput = {
  /** Treecode which user completed the game */
  code: Scalars['String'];
  /** Result of game completion */
  result: Scalars['Int'];
};

export type TreecodeGameCompleteResponse = Resource | TreecodeGameCompleteGameExpiredProblem | TreecodeGameCompleteAlreadyCompletedProblem | TreecodeGameCompleteTreecodeNotFoundProblem | TreecodeGameCompleteGameNotFoundProblem | TreecodeGameCompleteTreecodeNotRedeemedProblem | TreecodeGameCompleteUnknownProblem;

export type TreecodeGameCompleteTreecodeNotFoundProblem = Problem & {
  __typename?: 'TreecodeGameCompleteTreecodeNotFoundProblem';
  message: Scalars['String'];
};

export type TreecodeGameCompleteTreecodeNotRedeemedProblem = Problem & {
  __typename?: 'TreecodeGameCompleteTreecodeNotRedeemedProblem';
  message: Scalars['String'];
};

export type TreecodeGameCompleteUnknownProblem = Problem & {
  __typename?: 'TreecodeGameCompleteUnknownProblem';
  message: Scalars['String'];
};

export type TreecodeGameCompletionResult = {
  __typename?: 'TreecodeGameCompletionResult';
  id: Scalars['ID'];
  user: User;
  /** User game completion result */
  result: Scalars['Int'];
  /** If game should give a reward, it's the treecode got by user */
  rewardTreecode: Maybe<Treecode>;
};

export type TreecodeGameMutation = {
  __typename?: 'TreecodeGameMutation';
  complete: Maybe<TreecodeGameCompleteResponse>;
};


export type TreecodeGameMutationCompleteArgs = {
  input: TreecodeGameCompleteInput;
};

export type TreecodeGenerationProcessConnection = TreecodeBaseConnection & {
  __typename?: 'TreecodeGenerationProcessConnection';
  totalCount: Scalars['Int'];
  pageInfo: TreecodePageInfo;
  edges: Array<Maybe<TreecodeGenerationProcessEdge>>;
};

export type TreecodeGenerationProcessEdge = Edge & {
  __typename?: 'TreecodeGenerationProcessEdge';
  cursor: Scalars['String'];
  node: Maybe<GenerationProcess>;
};

export type TreecodeGenerationRequest = {
  __typename?: 'TreecodeGenerationRequest';
  quantity: Scalars['Int'];
  redeemProducts: Array<RedeemProduct>;
};

/**
 * mutation: gift
 * action: create
 * problem: Gift associated with tree already exists
 */
export type TreecodeGiftCreateAlreadyExistentProblem = Problem & {
  __typename?: 'TreecodeGiftCreateAlreadyExistentProblem';
  message: Scalars['String'];
  trees: Array<Scalars['String']>;
};

/**
 * mutation: gift
 * action: create
 * problem: Field creatorId not provided
 */
export type TreecodeGiftCreateMissingCreatorIdProblem = Problem & {
  __typename?: 'TreecodeGiftCreateMissingCreatorIdProblem';
  message: Scalars['String'];
};

/**
 * mutation: gift
 * action: create
 * problem: Missing email delivery field
 */
export type TreecodeGiftCreateMissingEmailDeliveryFieldProblem = Problem & {
  __typename?: 'TreecodeGiftCreateMissingEmailDeliveryFieldProblem';
  message: Scalars['String'];
};

/**
 * mutation: gift
 * action: create
 * problem: Field gifterId not provided
 */
export type TreecodeGiftCreateMissingGifterIdProblem = Problem & {
  __typename?: 'TreecodeGiftCreateMissingGifterIdProblem';
  message: Scalars['String'];
};

export type TreecodeGiftCreateResponse = Resource | TreecodeGiftCreateTreesNotAvailableProblem | TreecodeGiftCreateMissingEmailDeliveryFieldProblem | TreecodeGiftCreateMissingGifterIdProblem | TreecodeGiftCreateMissingCreatorIdProblem | TreecodeGiftCreateAlreadyExistentProblem;

/**
 * mutation: gift
 * action: create
 * problem: Trees not available
 */
export type TreecodeGiftCreateTreesNotAvailableProblem = Problem & {
  __typename?: 'TreecodeGiftCreateTreesNotAvailableProblem';
  message: Scalars['String'];
};

export type TreecodeMutation = {
  __typename?: 'TreecodeMutation';
  /** Change ownership of gifts created and redeemed  */
  bulkChangeOwnership: Maybe<BulkChangeOwnershipResponse>;
  /** Delete treecodes which haven't any linked redeem  */
  bulkDelete: BulkDeleteTreecodeResponse;
  /** Update treecodes */
  bulkUpdate: BulkUpdateTreecodeResponse;
  changeAvailableRedeems: Maybe<ChangeAvailableRedeemsResponse>;
  changeRedeemableTree: Maybe<ChangeRedeemableTreeResponse>;
  create: Maybe<TreecodeCreateMutation>;
  delete: Maybe<TreecodeDeleteResponse>;
  exportRedeems: Maybe<ExportTreecodeRedeemsListResponse>;
  exportTreecodesList: Maybe<ExportTreecodesListResponse>;
  game: Maybe<TreecodeGameMutation>;
  redeem: Maybe<TreecodeRedeemResponse>;
  requestGiftsSummary: Maybe<RequestGiftsSummaryResponse>;
  update: Maybe<TreecodeUpdateResponse>;
};


export type TreecodeMutationBulkChangeOwnershipArgs = {
  input: BulkChangeOwnershipInput;
};


export type TreecodeMutationBulkDeleteArgs = {
  where: BulkDeleteTreecodeFindInput;
};


export type TreecodeMutationBulkUpdateArgs = {
  input: BulkUpdateTreecodeInput;
  where: BulkUpdateTreecodeFindInput;
};


export type TreecodeMutationChangeAvailableRedeemsArgs = {
  input: ChangeAvailableRedeemsInput;
};


export type TreecodeMutationChangeRedeemableTreeArgs = {
  input: ChangeRedeemableTreeInput;
  where: ChangeRedeemableTreeFindInput;
};


export type TreecodeMutationDeleteArgs = {
  input: DeleteTreecodeInput;
};


export type TreecodeMutationExportRedeemsArgs = {
  input: TreecodesFindInput;
  requestedBy?: Maybe<Scalars['ID']>;
};


export type TreecodeMutationExportTreecodesListArgs = {
  input: TreecodesFindInput;
  requestedBy?: Maybe<Scalars['ID']>;
};


export type TreecodeMutationRedeemArgs = {
  input: RedeemTreecodeInput;
};


export type TreecodeMutationRequestGiftsSummaryArgs = {
  input: RequestGiftsSummaryInput;
};


export type TreecodeMutationUpdateArgs = {
  input: UpdateTreecodeInput;
  where: UpdateTreecodeFindInput;
};

export type TreecodePageInfo = {
  __typename?: 'TreecodePageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Maybe<Scalars['Boolean']>;
  startCursor: Maybe<Scalars['String']>;
  endCursor: Maybe<Scalars['String']>;
};

export type TreecodePickableProduct = {
  __typename?: 'TreecodePickableProduct';
  product: Product;
  quantity: Scalars['Int'];
};

export type TreecodePicker = Treecode & {
  __typename?: 'TreecodePicker';
  id: Scalars['ID'];
  forest: Forest;
  owner: User;
  /** Information about the redeemable tree */
  redeemableTree: Maybe<RedeemableTree>;
  /** List of available tree products inside forest */
  pickableProducts: Array<Maybe<TreecodePickableProduct>>;
  /** How many remaining available redeems on treecode */
  availableRedeems: Scalars['Int'];
  code: Scalars['String'];
  /** How many redeems done on treecode */
  completedRedeems: Scalars['Int'];
  createdAt: Scalars['Date'];
  creator: User;
  /** If treecode is still enabled */
  enabled: Scalars['Boolean'];
  /** If treecode is no more redeemable */
  exhaust: Scalars['Boolean'];
  /** Date until treecode will be valid */
  expireDate: Maybe<Scalars['Date']>;
  gift: Gift;
  /** Indicates whether the treecode has a custom redeem flow (web site is needed to redeem). */
  isCustomRedeemFlow: Scalars['Boolean'];
  label: Maybe<Scalars['String']>;
  /** If treecode is still redeemable */
  redeemable: Scalars['Boolean'];
  /** List of redeems */
  redeems: Array<Redeem>;
  shareUrl: Scalars['String'];
  /** How many total redeems on treecode (completed+available) */
  totalRedeems: Scalars['Int'];
  traceId: Maybe<Scalars['ID']>;
  type: TreecodeType;
  updatedAt: Scalars['Date'];
  uuid: Scalars['ID'];
  /** Game data of treecode */
  game: Maybe<TreecodeGame>;
  multiple: Scalars['Boolean'];
};

export type TreecodePickerCreateExpiresAtNotValidProblem = Problem & {
  __typename?: 'TreecodePickerCreateExpiresAtNotValidProblem';
  message: Scalars['String'];
};

export type TreecodePickerCreateForestNotFoundProblem = Problem & {
  __typename?: 'TreecodePickerCreateForestNotFoundProblem';
  message: Scalars['String'];
};

export type TreecodePickerCreateGameExpiresAtNotValidProblem = Problem & {
  __typename?: 'TreecodePickerCreateGameExpiresAtNotValidProblem';
  message: Scalars['String'];
};

export type TreecodePickerCreateGifterNotValidProblem = Problem & {
  __typename?: 'TreecodePickerCreateGifterNotValidProblem';
  message: Scalars['String'];
};

export type TreecodePickerCreateMissingGameExpiresAtProblem = Problem & {
  __typename?: 'TreecodePickerCreateMissingGameExpiresAtProblem';
  message: Scalars['String'];
};

export type TreecodePickerCreateRedeemableTreeAssignedOnFromNotValidProblem = Problem & {
  __typename?: 'TreecodePickerCreateRedeemableTreeAssignedOnFromNotValidProblem';
  message: Scalars['String'];
};

export type TreecodePickerCreateRedeemableTreeAssignedOnToNotValidProblem = Problem & {
  __typename?: 'TreecodePickerCreateRedeemableTreeAssignedOnToNotValidProblem';
  message: Scalars['String'];
};

export type TreecodePickerCreateResponse = Resource | TreecodePickerCreateForestNotFoundProblem | TreecodePickerCreateGifterNotValidProblem | TreecodePickerCreateUnknownErrorProblem | TreecodePickerCreateMissingGameExpiresAtProblem | TreecodePickerCreateExpiresAtNotValidProblem | TreecodePickerCreateGameExpiresAtNotValidProblem | TreecodePickerCreateRedeemableTreeAssignedOnFromNotValidProblem | TreecodePickerCreateRedeemableTreeAssignedOnToNotValidProblem;

export type TreecodePickerCreateUnknownErrorProblem = Problem & {
  __typename?: 'TreecodePickerCreateUnknownErrorProblem';
  message: Scalars['String'];
};

export type TreecodePickerRedeemableTreeInput = {
  /** Redeem tree assigned from specific date only */
  assignedOnFrom?: Maybe<Scalars['Date']>;
  /** Redeem tree assigned until specific date only */
  assignedOnTo?: Maybe<Scalars['Date']>;
};

export type TreecodeRedeem = {
  __typename?: 'TreecodeRedeem';
  status: TreecodeRedeemStatus;
  /** Trees assigned by redeem of treecode */
  trees: Array<Maybe<Tree>>;
};

export type TreecodeRedeemResponse = Resource | RedeemTreecodeNotExistsProblem | RedeemTreecodeAlreadyConsumedProblem | RedeemTreecodeNotEnabledProblem | RedeemTreecodeNotAuthorizedProblem | RedeemTreecodeExpiredProblem | RedeemTreecodeMissingPickedProductProblem | RedeemTreecodeMissingRedeemerIdProblem | RedeemTreecodeMissingTreesAvailabilityProblem;

export enum TreecodeRedeemStatus {
  InProgress = 'IN_PROGRESS',
  Error = 'ERROR',
  Complete = 'COMPLETE'
}

export enum TreecodeRedeemType {
  Standard = 'STANDARD',
  BusinessNoGift = 'BUSINESS_NO_GIFT'
}

export type TreecodesFindInput = {
  /**
   * Filter by gifter user.
   * Working for following treecode types only:
   * - Simple
   *    - Picker
   */
  gifterId?: Maybe<Scalars['ID']>;
  /** Filter by creator user.	 */
  creatorId?: Maybe<Scalars['ID']>;
  /**
   * Filter by forest where gifted trees are planted.
   * Working for following treecode types only:
   *    - Picker
   */
  forestId?: Maybe<Scalars['ID']>;
  /**
   * Filter by product of gifted trees.
   * Working for following treecode types only:
   * - Simple
   *    - Virgin
   */
  productId?: Maybe<Scalars['ID']>;
  /** Filter by multiple treecode ids */
  id?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by multiple treecodes */
  treecodes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by treecodes redeemed by specific user */
  redeemerId?: Maybe<Scalars['ID']>;
  /**
   * Filter by gifted trees
   * Working for following treecode types only:
   * - Simple
   */
  giftedTreeIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** Filter by name of generation process (old naming code block) */
  generationProcessName?: Maybe<Scalars['String']>;
  /** Filter by treecode types (OPEN is no more supported and will not work) */
  types?: Maybe<Array<Maybe<TreecodeType>>>;
  /** Filter by redeemable status */
  redeemable?: Maybe<Scalars['Boolean']>;
  /** Filter by treecodes redeemed at least one time */
  redeemed?: Maybe<Scalars['Boolean']>;
  /** Filter by enabled status */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Filter by expired status */
  expired?: Maybe<Scalars['Boolean']>;
  /** Filter by expire date range From */
  expireDateFrom?: Maybe<Scalars['Date']>;
  /** Filter by expire date range To */
  expireDateTo?: Maybe<Scalars['Date']>;
  /** Filter by create date range From */
  creationDateFrom?: Maybe<Scalars['Date']>;
  /** Filter by create date range To */
  creationDateTo?: Maybe<Scalars['Date']>;
  /** Filter by generation process ids */
  generationProcessId?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type TreecodeSimple = Treecode & {
  __typename?: 'TreecodeSimple';
  id: Scalars['ID'];
  /** How many remaining available redeems on treecode */
  availableRedeems: Scalars['Int'];
  code: Scalars['String'];
  /** How many redeems done on treecode */
  completedRedeems: Scalars['Int'];
  createdAt: Scalars['Date'];
  creator: User;
  /** If treecode is still enabled */
  enabled: Scalars['Boolean'];
  /** If treecode is no more redeemable */
  exhaust: Scalars['Boolean'];
  /** Date until treecode will be valid */
  expireDate: Maybe<Scalars['Date']>;
  gift: Gift;
  /** Indicates whether the treecode has a custom redeem flow (web site is needed to redeem). */
  isCustomRedeemFlow: Scalars['Boolean'];
  label: Maybe<Scalars['String']>;
  owner: User;
  /** If treecode is still redeemable */
  redeemable: Scalars['Boolean'];
  /** List of redeems */
  redeems: Array<Redeem>;
  shareUrl: Scalars['String'];
  /** How many total redeems on treecode (completed+available) */
  totalRedeems: Scalars['Int'];
  traceId: Maybe<Scalars['ID']>;
  type: TreecodeType;
  updatedAt: Scalars['Date'];
  uuid: Scalars['ID'];
  /** Game data of treecode */
  game: Maybe<TreecodeGame>;
  /** List of products contained by simple treecode */
  products: Array<Maybe<TreecodeSimpleProduct>>;
  redeem: Maybe<Redeem>;
};

export type TreecodeSimpleCreateExpiresAtNotValidProblem = Problem & {
  __typename?: 'TreecodeSimpleCreateExpiresAtNotValidProblem';
  message: Scalars['String'];
};

export type TreecodeSimpleCreateGameExpiresAtNotValidProblem = Problem & {
  __typename?: 'TreecodeSimpleCreateGameExpiresAtNotValidProblem';
  message: Scalars['String'];
};

export type TreecodeSimpleCreateGenerationInProgressProblem = Problem & {
  __typename?: 'TreecodeSimpleCreateGenerationInProgressProblem';
  message: Scalars['String'];
};

export type TreecodeSimpleCreateMissingGameExpiresAtProblem = Problem & {
  __typename?: 'TreecodeSimpleCreateMissingGameExpiresAtProblem';
  message: Scalars['String'];
};

export type TreecodeSimpleCreateResponse = Resource | TreecodeSimpleCreateUnknownErrorProblem | TreecodeSimpleCreateMissingGameExpiresAtProblem | TreecodeSimpleCreateExpiresAtNotValidProblem | TreecodeSimpleCreateGameExpiresAtNotValidProblem | TreecodeSimpleCreateGenerationInProgressProblem | TreecodeSimpleTreesNotAvailableErrorProblem | TreecodeSimpleCreateTreeAssignedOnFromNotValidProblem | TreecodeSimpleCreateTreeAssignedOnToNotValidProblem;

export type TreecodeSimpleCreateTreeAssignedOnFromNotValidProblem = Problem & {
  __typename?: 'TreecodeSimpleCreateTreeAssignedOnFromNotValidProblem';
  message: Scalars['String'];
};

export type TreecodeSimpleCreateTreeAssignedOnToNotValidProblem = Problem & {
  __typename?: 'TreecodeSimpleCreateTreeAssignedOnToNotValidProblem';
  message: Scalars['String'];
};

export type TreecodeSimpleCreateUnknownErrorProblem = Problem & {
  __typename?: 'TreecodeSimpleCreateUnknownErrorProblem';
  message: Scalars['String'];
};

export type TreecodeSimpleGenerationRequest = {
  /** Quantity of treecode to be generated */
  quantity: Scalars['Int'];
  /** Products of trees which will be redeemed */
  redeemProducts: Array<Maybe<TreecodeSimpleRedeemProduct>>;
};

export type TreecodeSimpleProduct = {
  __typename?: 'TreecodeSimpleProduct';
  product: Product;
  quantity: Scalars['Int'];
};

export type TreecodeSimpleRedeemProduct = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type TreecodeSimpleTreesNotAvailableErrorProblem = Problem & {
  __typename?: 'TreecodeSimpleTreesNotAvailableErrorProblem';
  message: Scalars['String'];
};

export enum TreecodesSortInput {
  /** Sort by creation, ascending. */
  CreationAsc = 'CREATION_ASC',
  /** Sort by creation, descending. */
  CreationDesc = 'CREATION_DESC'
}

export type TreecodeTreeConnection = TreecodeBaseConnection & {
  __typename?: 'TreecodeTreeConnection';
  totalCount: Scalars['Int'];
  pageInfo: TreecodePageInfo;
  edges: Array<Maybe<TreecodeTreeEdge>>;
};

export type TreecodeTreeEdge = Edge & {
  __typename?: 'TreecodeTreeEdge';
  cursor: Scalars['String'];
  node: Maybe<Tree>;
};

export enum TreecodeType {
  Picker = 'PICKER',
  Virgin = 'VIRGIN',
  Open = 'OPEN',
  Simple = 'SIMPLE'
}

export type TreecodeUpdateResponse = Resource | UpdateTreecodeNotExistsProblem | UpdateTreecodeMissingInputFieldProblem | UpdateTreecodeExpiresAtNotValidProblem | UpdateTreecodeMissingWhereFieldProblem | UpdateTreecodeUnknownErrorProblem;

export type TreecodeVirgin = Treecode & {
  __typename?: 'TreecodeVirgin';
  id: Scalars['ID'];
  /** How many remaining available redeems on treecode */
  availableRedeems: Scalars['Int'];
  code: Scalars['String'];
  /** How many redeems done on treecode */
  completedRedeems: Scalars['Int'];
  createdAt: Scalars['Date'];
  creator: User;
  /** If treecode is still enabled */
  enabled: Scalars['Boolean'];
  /** If treecode is no more redeemable */
  exhaust: Scalars['Boolean'];
  /** Date until treecode will be valid */
  expireDate: Maybe<Scalars['Date']>;
  gift: Gift;
  /** Indicates whether the treecode has a custom redeem flow (web site is needed to redeem). */
  isCustomRedeemFlow: Scalars['Boolean'];
  label: Maybe<Scalars['String']>;
  owner: User;
  /** If treecode is still redeemable */
  redeemable: Scalars['Boolean'];
  /** List of redeems */
  redeems: Array<Redeem>;
  shareUrl: Scalars['String'];
  /** How many total redeems on treecode (completed+available) */
  totalRedeems: Scalars['Int'];
  traceId: Maybe<Scalars['ID']>;
  type: TreecodeType;
  updatedAt: Scalars['Date'];
  uuid: Scalars['ID'];
  /** List of products contained by virgin treecode */
  products: Array<Maybe<TreecodeVirginProduct>>;
};

export type TreecodeVirginCreateExpiresAtNotValidProblem = Problem & {
  __typename?: 'TreecodeVirginCreateExpiresAtNotValidProblem';
  message: Scalars['String'];
};

export type TreecodeVirginCreateForestNotFoundProblem = Problem & {
  __typename?: 'TreecodeVirginCreateForestNotFoundProblem';
  message: Scalars['String'];
};

export type TreecodeVirginCreateMissingPlanterProblem = Problem & {
  __typename?: 'TreecodeVirginCreateMissingPlanterProblem';
  message: Scalars['String'];
};

export type TreecodeVirginCreatePlanterNotValidProblem = Problem & {
  __typename?: 'TreecodeVirginCreatePlanterNotValidProblem';
  message: Scalars['String'];
};

export type TreecodeVirginCreateResponse = Resource | TreecodeVirginCreateUnknownErrorProblem | TreecodeVirginCreateExpiresAtNotValidProblem | TreecodeVirginCreateForestNotFoundProblem | TreecodeVirginCreatePlanterNotValidProblem | TreecodeVirginCreateMissingPlanterProblem;

export type TreecodeVirginCreateUnknownErrorProblem = Problem & {
  __typename?: 'TreecodeVirginCreateUnknownErrorProblem';
  message: Scalars['String'];
};

export type TreecodeVirginProduct = {
  __typename?: 'TreecodeVirginProduct';
  product: Product;
  quantity: Scalars['Int'];
};

export type TreecodeVirginRedeemProduct = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type TreeConnection = Connection & {
  __typename?: 'TreeConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<TreeEdge>>;
  pageInfo: PageInfo;
};

export enum TreedomImageFormat {
  Jpg = 'JPG',
  Png = 'PNG'
}

export type TreedomStats = {
  __typename?: 'TreedomStats';
  totalPrivateUsers: Scalars['Int'];
  totalBusinessUsers: Scalars['Int'];
  totalProjectsCountries: Scalars['Int'];
  totalAssignedTrees: Scalars['Int'];
  totalFarmers: Scalars['Int'];
  totalCo2Absorbed: Scalars['Int'];
  totalPrivatePlanters: Scalars['Int'];
};

export type TreeEdge = Edge & {
  __typename?: 'TreeEdge';
  node: Maybe<Tree>;
  cursor: Scalars['String'];
};

export type TreeMutation = {
  __typename?: 'TreeMutation';
  /** Assign forestry trees already preassigned or not. It support multiple flows each one with specific validation rules . */
  assignForestryTrees: AssignForestryTreesResponse;
  /** Change the giftableUntil of the tree */
  bulkChangeGiftableUntil: TreeBulkChangeGiftableUntilResponse;
  /** Change ownership of trees */
  bulkChangeOwnership: Maybe<TreeBulkChangeOwnershipResponse>;
  /** Change planter of trees */
  bulkChangePlanter: Maybe<TreeBulkChangePlanterResponse>;
  /** Change the name of the tree */
  changeName: TreeChangeNameResponse;
  /** Revert the ownership of the tree to the original planter user */
  revertOwnership: TreeRevertOwnershipResponse;
  /** Move the tree into a forest */
  setForest: Maybe<SetForestResponse>;
  /**
   * Mutation which unassign the tree.
   * An user id is required and can be received from the token, in case of user calls, or from the input in case of s2s calls.
   */
  unassign: TreeUnassignResponse;
  /** Unset forest from a tree */
  unsetForest: Maybe<UnsetForestResponse>;
};


export type TreeMutationAssignForestryTreesArgs = {
  input: AssignForestryInput;
};


export type TreeMutationBulkChangeGiftableUntilArgs = {
  where: TreeBulkChangeGiftableUntilFindInput;
  input: TreeBulkChangeGiftableUntilInput;
};


export type TreeMutationBulkChangeOwnershipArgs = {
  input: TreeBulkChangeOwnershipInput;
};


export type TreeMutationBulkChangePlanterArgs = {
  input: TreeBulkChangePlanterInput;
};


export type TreeMutationChangeNameArgs = {
  id: Scalars['ID'];
  input: TreeChangeNameInput;
};


export type TreeMutationRevertOwnershipArgs = {
  id: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};


export type TreeMutationSetForestArgs = {
  id: Scalars['ID'];
  input: SetForestInput;
};


export type TreeMutationUnassignArgs = {
  id: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};


export type TreeMutationUnsetForestArgs = {
  id: Scalars['ID'];
};

export type TreePlanterRankingItem = {
  __typename?: 'TreePlanterRankingItem';
  user: User;
  treeCount: Scalars['Int'];
};

/**
 * Filters for tree planters.
 * Year and month have a complex meaning, depending on the their values:
 *  - If year is not passed, year is the current year.
 *  - If both year and month are passed, then the ranking covers the specified month
 *  - If month is not passed, then the ranking covers the last 30 days
 */
export type TreePlantersRankingInput = {
  /** Year. Default: current year */
  year?: Maybe<Scalars['Int']>;
  /** Month. If month is not passed as an argument, the last 30 days are taken into account */
  month?: Maybe<Scalars['Int']>;
  /** User type. Default: Private */
  userType?: Maybe<UserType>;
};

export type TreeProjectConnection = Connection & {
  __typename?: 'TreeProjectConnection';
  totalCount: Scalars['Int'];
  pageInfo: PageInfo;
  edges: Maybe<Array<TreeProjectEdge>>;
};

export type TreeProjectEdge = Edge & {
  __typename?: 'TreeProjectEdge';
  cursor: Scalars['String'];
  node: Project;
};

export type TreeProjectsConnection = Connection & {
  __typename?: 'TreeProjectsConnection';
  totalCount: Scalars['Int'];
  pageInfo: Maybe<PageInfo>;
  edges: Maybe<Array<Maybe<TreeProjectsEdge>>>;
};

export type TreeProjectsEdge = Edge & {
  __typename?: 'TreeProjectsEdge';
  node: Maybe<Project>;
  cursor: Maybe<Scalars['String']>;
};

export type TreeProjectSpecieSold = {
  __typename?: 'TreeProjectSpecieSold';
  specie: ProjectSpecie;
  total: Scalars['Int'];
};

export type TreeProjectsWhereInput = {
  id?: Maybe<Array<Scalars['ID']>>;
  name?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Array<Scalars['String']>>;
};

/** The tree does not exists, revert ownership can't be executed */
export type TreeRevertOwnershipNotFoundProblem = Problem & {
  __typename?: 'TreeRevertOwnershipNotFoundProblem';
  message: Scalars['String'];
};

export type TreeRevertOwnershipResponse = Resource | TreeRevertOwnershipNotFoundProblem | TreeRevertOwnershipWrongOwnershipProblem | TreeRevertOwnershipUnknownProblem;

/** Unknown error, revert ownership can't be executed */
export type TreeRevertOwnershipUnknownProblem = Problem & {
  __typename?: 'TreeRevertOwnershipUnknownProblem';
  message: Scalars['String'];
};

/** The tree is owned and planted by the same user. Is not possible to execute revert */
export type TreeRevertOwnershipWrongOwnershipProblem = Problem & {
  __typename?: 'TreeRevertOwnershipWrongOwnershipProblem';
  message: Scalars['String'];
};

export type TreesInvalidInputProblem = Problem & {
  __typename?: 'TreesInvalidInputProblem';
  message: Scalars['String'];
};

export type TreesResponse = TreeConnection | TreesInvalidInputProblem;

export type TreesSearchConnection = Connection & {
  __typename?: 'TreesSearchConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<TreesSearchEdge>>;
  pageInfo: PageInfo;
  facets: Maybe<TreesSearchFacets>;
};

export type TreesSearchEdge = Edge & {
  __typename?: 'TreesSearchEdge';
  cursor: Scalars['String'];
  node: Maybe<Tree>;
};

export type TreesSearchFacets = {
  __typename?: 'TreesSearchFacets';
  years: Maybe<Array<TreesSearchFacetsYear>>;
  scientificSpecies: Maybe<Array<TreesSearchFacetsScientificSpecie>>;
  countries: Maybe<Array<TreesSearchFacetsCountry>>;
  status: Maybe<Array<TreesSearchFacetsStatus>>;
};

export type TreesSearchFacetsCountry = {
  __typename?: 'TreesSearchFacetsCountry';
  key: Scalars['ID'];
  resultCount: Scalars['Int'];
  ref: Maybe<Country>;
};

export type TreesSearchFacetsScientificSpecie = {
  __typename?: 'TreesSearchFacetsScientificSpecie';
  key: Scalars['ID'];
  resultCount: Scalars['Int'];
  ref: Maybe<ScientificSpecie>;
};

export type TreesSearchFacetsStatus = {
  __typename?: 'TreesSearchFacetsStatus';
  key: TreeStatus;
  resultCount: Scalars['Int'];
};

export type TreesSearchFacetsYear = {
  __typename?: 'TreesSearchFacetsYear';
  key: Scalars['Int'];
  resultCount: Scalars['Int'];
};

export enum TreesSearchFields {
  TreeId = 'TREE_ID',
  RegistryId = 'REGISTRY_ID',
  TreeName = 'TREE_NAME'
}

export type TreesSearchFiltersInput = {
  /** The id of the users which currently own the tree */
  ownerIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** The id of the users which has planted the tree */
  planterIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** The id of the desired project species */
  projectSpecieIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** The id of the desired scientific species */
  scientificSpecieIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** The id of the desired projects */
  projectIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** The id of the desired countries */
  countryCodes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** The desired year (format: YYYY) */
  year?: Maybe<Scalars['Int']>;
};

export enum TreesSearchSortField {
  Id = 'ID',
  AssignedAt = 'ASSIGNED_AT'
}

export enum TreeStatus {
  Seed = 'SEED',
  Nursery = 'NURSERY',
  Planted = 'PLANTED',
  Photo = 'PHOTO'
}

export type TreesWhereConditionInput = {
  /** The unique id of the tree */
  treeId?: Maybe<Scalars['ID']>;
  /** The unique tree code */
  registryId?: Maybe<Scalars['ID']>;
  /** The id of the user which currently own the tree */
  ownerId?: Maybe<Scalars['ID']>;
  /** The id of the user which has planted the tree */
  planterId?: Maybe<Scalars['ID']>;
  /** The id of the desired project specie */
  projectSpecieId?: Maybe<Scalars['ID']>;
};

/** The tree owner is not the same of the planter, unassign can't be executed */
export type TreeUnassignOwnershipProblem = Problem & {
  __typename?: 'TreeUnassignOwnershipProblem';
  message: Scalars['String'];
};

export type TreeUnassignResponse = Resource | TreeUnassignTreeNotFoundProblem | TreeUnassignOwnershipProblem | TreeUnassignUnknownProblem;

/** The tree is not found, unassign can't be executed */
export type TreeUnassignTreeNotFoundProblem = Problem & {
  __typename?: 'TreeUnassignTreeNotFoundProblem';
  message: Scalars['String'];
};

/** Unknown problem, unassign can't be executed */
export type TreeUnassignUnknownProblem = Problem & {
  __typename?: 'TreeUnassignUnknownProblem';
  message: Scalars['String'];
};

export type UnfollowFeedActivityResponse = Resource | FeedActivityNotFoundProblem | FeedActivityUnknownErrorProblem;

export enum UnitOfMeasureEnum {
  Gram = 'Gram',
  Liter = 'Liter'
}

export type UnlinkSocialIdentityInput = {
  /** SocialIdentity Provider */
  socialIdentity: SocialIdentity;
};

export type UnlinkSocialIdentityResponse = Resource;

export type UnschedulePublishResponse = Resource | FeedPostNotFoundProblem;

export type UnscheduleUnpublishResponse = Resource | FeedPostNotFoundProblem;

export type UnsetForestResponse = Resource | UnsetForestTreeNotFoundProblem | UnsetsetForestTreeNotInForestProblem;

export type UnsetForestTreeNotFoundProblem = Problem & {
  __typename?: 'UnsetForestTreeNotFoundProblem';
  message: Scalars['String'];
};

export type UnsetsetForestTreeNotInForestProblem = Problem & {
  __typename?: 'UnsetsetForestTreeNotInForestProblem';
  message: Scalars['String'];
};

export type UntilProductBadge = {
  __typename?: 'UntilProductBadge';
  key: Scalars['String'];
  date: Scalars['DateTime'];
};

/** Input for update a billing plan entry. */
export type UpdateBillingPlanEntryInput = {
  billingCycle: Scalars['Int'];
  delay: Scalars['Int'];
};

/** Response from update billing plan entry mutation. */
export type UpdateBillingPlanEntryResponse = BillingPlanEntry | BillingPlanEntryUnknownProblem | BillingPlanEntryNotFoundProblem | BillingPlanEntryBillingPlanNotFoundProblem | BillingPlanEntryMinimumCycleProblem | BillingPlanEntryCyclesNotProgressiveProblem | BillingPlanEntryDelayNotPositiveProblem | BillingPlanEntryDelayNotProgressiveProblem | BillingPlanEntryDelayTooLongProblem | BillingPlanEntryNotValidProblem;

/** Input for updating a billing plan. */
export type UpdateBillingPlanInput = {
  name?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
};

/** Response from updating a billing plan. */
export type UpdateBillingPlanResponse = BillingPlan | BillingPlanUnknownProblem | BillingPlanNotFoundProblem | BillingPlanMissingEntriesProblem | BillingPlanEmptyNameProblem | BillingPlanDurationNotPositiveProblem | BillingPlanInvalidRenewLimitProblem;

export type UpdateCapabilityGroupCapabilitiesCapabilityGroupNotFoundProblem = Problem & {
  __typename?: 'UpdateCapabilityGroupCapabilitiesCapabilityGroupNotFoundProblem';
  message: Scalars['String'];
};

export type UpdateCapabilityGroupCapabilitiesMalformedCapabilityProblem = Problem & {
  __typename?: 'UpdateCapabilityGroupCapabilitiesMalformedCapabilityProblem';
  message: Scalars['String'];
};

export type UpdateCommunicationKitCtaExternalReferenceInput = {
  locale: Scalars['String'];
  externalReference: Scalars['String'];
};

export type UpdateCommunicationKitCtaLabelInput = {
  locale: Scalars['String'];
  label: Scalars['String'];
};

export type UpdateCommunicationKitDescriptionInput = {
  locale: Scalars['String'];
  description: Scalars['String'];
};

export type UpdateCommunicationKitInput = {
  internalName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  title?: Maybe<Array<UpdateCommunicationKitTitleInput>>;
  description?: Maybe<Array<UpdateCommunicationKitDescriptionInput>>;
  activeCtaLabel?: Maybe<Array<UpdateCommunicationKitCtaLabelInput>>;
  /**
   * Changes active cta type.
   * Deletes all references and files present, this operation is irreversible
   */
  activeCtaType?: Maybe<CommunicationKitCtaType>;
  /**
   * Sets the cta external reference url. Can only be provided when changing cta type to EXTERNAL_REFERENCE or
   * the cta already has that type
   */
  activeCtaExternalReference?: Maybe<Array<UpdateCommunicationKitCtaExternalReferenceInput>>;
  inactiveCtaLabel?: Maybe<Array<UpdateCommunicationKitCtaLabelInput>>;
  /**
   * Changes inactive cta type.
   * Deletes all references and files present, this operation is irreversible
   */
  inactiveCtaType?: Maybe<CommunicationKitCtaType>;
  /**
   * Sets the cta external reference url. Can only be provided when changing cta type to EXTERNAL_REFERENCE or
   * the cta already has that type
   */
  inactiveCtaExternalReference?: Maybe<Array<UpdateCommunicationKitCtaExternalReferenceInput>>;
};

export type UpdateCommunicationKitResponse = Resource | CommunicationKitNotFoundProblem | CommunicationKitCtaTypeMismatchProblem | CommunicationKitInvalidLocaleProblem | CommunicationKitInvalidCategoryProblem;

export type UpdateCommunicationKitTitleInput = {
  locale: Scalars['String'];
  title: Scalars['String'];
};

export type UpdateFeedActivityCommentInput = {
  commentId: Scalars['ID'];
  userId: Scalars['ID'];
  content?: Maybe<Scalars['String']>;
};

export type UpdateFeedActivityCommentResponse = Resource | FeedActivityUnknownErrorProblem | FeedActivityNotFoundProblem | FeedActivityCommentNotFoundProblem | FeedActivityCommentUpdateNoChangesProblem;

export type UpdateFeedAuthorInput = {
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Array<LocalizedValueInput>>;
  archived?: Maybe<Scalars['Boolean']>;
  avatarId?: Maybe<Scalars['String']>;
};

export type UpdateFeedAuthorResponse = Resource | FeedAuthorNotFoundProblem | FeedAuthorUnknownErrorProblem | FeedAuthorUpdateNoArgsProvidedProblem;

export type UpdateFeedPostContentGalleryInput = {
  gallery?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Array<LocalizedValueInput>>;
  title?: Maybe<Array<LocalizedValueInput>>;
  heroImageId?: Maybe<Scalars['String']>;
};

export type UpdateFeedPostContentQuizAnswerInput = {
  key: Scalars['String'];
  content?: Maybe<Array<LocalizedValueInput>>;
  reason?: Maybe<Array<LocalizedValueInput>>;
  isCorrect?: Maybe<Scalars['Boolean']>;
};

export type UpdateFeedPostContentQuizInput = {
  message?: Maybe<Array<LocalizedValueInput>>;
  title?: Maybe<Array<LocalizedValueInput>>;
  quizQuestion?: Maybe<Array<LocalizedValueInput>>;
  quizAnswers?: Maybe<Array<UpdateFeedPostContentQuizAnswerInput>>;
  heroImageId?: Maybe<Scalars['String']>;
};

export type UpdateFeedPostContentTextInput = {
  message?: Maybe<Array<LocalizedValueInput>>;
  title?: Maybe<Array<LocalizedValueInput>>;
  heroImageId?: Maybe<Scalars['String']>;
};

export type UpdateFeedPostContentVideoInput = {
  message?: Maybe<Array<LocalizedValueInput>>;
  title?: Maybe<Array<LocalizedValueInput>>;
  videoUrl?: Maybe<Scalars['String']>;
  heroImageId?: Maybe<Scalars['String']>;
};

export type UpdateFeedPostGalleryInput = {
  internalName?: Maybe<Scalars['String']>;
  isPlusContent?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  authorId?: Maybe<Scalars['ID']>;
  feeds?: Maybe<Array<FeedInput>>;
  content?: Maybe<UpdateFeedPostContentGalleryInput>;
};

export type UpdateFeedPostGalleryResponse = Resource | UpdateFeedPostNotFoundProblem | UpdateFeedPostInvalidContentProblem | UpdateFeedPostInvalidContentTypeProblem;

export type UpdateFeedPostInvalidContentProblem = Problem & {
  __typename?: 'UpdateFeedPostInvalidContentProblem';
  message: Scalars['String'];
};

export type UpdateFeedPostInvalidContentTypeProblem = Problem & {
  __typename?: 'UpdateFeedPostInvalidContentTypeProblem';
  message: Scalars['String'];
};

export type UpdateFeedPostNotFoundProblem = Problem & {
  __typename?: 'UpdateFeedPostNotFoundProblem';
  message: Scalars['String'];
};

export type UpdateFeedPostQuizInput = {
  internalName?: Maybe<Scalars['String']>;
  isPlusContent?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  authorId?: Maybe<Scalars['ID']>;
  feeds?: Maybe<Array<FeedInput>>;
  content?: Maybe<UpdateFeedPostContentQuizInput>;
};

export type UpdateFeedPostQuizResponse = Resource | UpdateFeedPostNotFoundProblem | UpdateFeedPostInvalidContentProblem | UpdateFeedPostInvalidContentTypeProblem;

export type UpdateFeedPostTextInput = {
  internalName?: Maybe<Scalars['String']>;
  isPlusContent?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  authorId?: Maybe<Scalars['ID']>;
  feeds?: Maybe<Array<FeedInput>>;
  content?: Maybe<UpdateFeedPostContentTextInput>;
};

export type UpdateFeedPostTextResponse = Resource | UpdateFeedPostNotFoundProblem | UpdateFeedPostInvalidContentProblem | UpdateFeedPostInvalidContentTypeProblem;

export type UpdateFeedPostVideoInput = {
  internalName?: Maybe<Scalars['String']>;
  isPlusContent?: Maybe<Scalars['Boolean']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  authorId?: Maybe<Scalars['ID']>;
  feeds?: Maybe<Array<FeedInput>>;
  content?: Maybe<UpdateFeedPostContentVideoInput>;
};

export type UpdateFeedPostVideoResponse = Resource | UpdateFeedPostNotFoundProblem | UpdateFeedPostInvalidContentProblem | UpdateFeedPostInvalidContentTypeProblem;

export type UpdateFinancePaymentMutationResponse = Resource | FinancePaymentNotExistsProblem | FinancePaymentUpdateUnknownErrorProblem | FinancePaymentUpdateVoidInputProblem | FinancePaymentProcurementPlanNotFoundProblem;

export type UpdateFinanceSupplierMutationResponse = Resource | FinanceSupplierNotExistsProblem | FinanceSupplierUpdateUnknownErrorProblem | FinanceSupplierNameAlreadyExistsProblem | FinanceSupplierUpdateVoidInputProblem | FinanceSupplierProcurementProjectNotExistsProblem;

/** No forest can be updated cause the requested event type does not exits */
export type UpdateForestEventTypeDoesNotExistsProblem = Problem & {
  __typename?: 'UpdateForestEventTypeDoesNotExistsProblem';
  message: Scalars['String'];
};

export type UpdateForestInput = {
  forestTypeId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<TranslationInput>;
  draft?: Maybe<Scalars['Int']>;
  /**  ownerId input is handle just for internal user  */
  ownerId?: Maybe<Scalars['ID']>;
  /**  slug input is handle just for internal user  */
  slug?: Maybe<Scalars['String']>;
  /**  enabled input is handle just for internal user  */
  enabled?: Maybe<Scalars['Boolean']>;
  /**  published input is handle just for internal user  */
  published?: Maybe<Scalars['Boolean']>;
  isRally?: Maybe<Scalars['Boolean']>;
  /**  isOpen input is handle just for internal user  */
  isOpen?: Maybe<Scalars['Boolean']>;
  /**  letMeChoose input is handle just for internal user  */
  letMeChoose?: Maybe<Scalars['Boolean']>;
  /**  hideRedeem input is handle just for internal user  */
  hideRedeem?: Maybe<Scalars['Boolean']>;
  /**  hidePeople input is handle just for internal user  */
  hidePeople?: Maybe<Scalars['Boolean']>;
};

/** The forest does not exits */
export type UpdateForestNotFoundProblem = Problem & {
  __typename?: 'UpdateForestNotFoundProblem';
  message: Scalars['String'];
};

export type UpdateForestOwnerNotFoundProblem = Problem & {
  __typename?: 'UpdateForestOwnerNotFoundProblem';
  message: Scalars['String'];
};

export type UpdateForestResponse = Resource | UpdateForestNotFoundProblem | UpdateForestUserDoesNotOwnForestProblem | UpdateForestUnknownProblem | UpdateForestEventTypeDoesNotExistsProblem | UpdateForestOwnerNotFoundProblem | UpdateForestSlugNotUniqueProblem;

export type UpdateForestSlugNotUniqueProblem = Problem & {
  __typename?: 'UpdateForestSlugNotUniqueProblem';
  message: Scalars['String'];
};

/** Unknown error in forest update forest mutation */
export type UpdateForestUnknownProblem = Problem & {
  __typename?: 'UpdateForestUnknownProblem';
  message: Scalars['String'];
};

/** The forest is now owned by the requester user */
export type UpdateForestUserDoesNotOwnForestProblem = Problem & {
  __typename?: 'UpdateForestUserDoesNotOwnForestProblem';
  message: Scalars['String'];
};

/** Input for updating a invoice. */
export type UpdateInvoiceInput = {
  /** New currency of the invoice. Default: EUR. */
  currency: ShopCurrency;
  /** The new amount in cents (smallest indivisible unit of a currency), such as (for EUR): 500 = 5 EUR */
  amount: Scalars['Int'];
};

/** Response from updating a invoice. */
export type UpdateInvoiceResponse = Invoice | InvoiceUpdateUnknownProblem | InvoiceUpdateNotFoundProblem;

export type UpdateItemInput = {
  /**
   * Cart where item'll be update
   * Can be leaved empty if request is authenticated (will default to logged-in user's active cart)
   */
  cartId?: Maybe<Scalars['ID']>;
  /** New quantity to be inserted on cart item */
  quantity: Scalars['Int'];
};

export type UpdateItemResponse = Resource | CartUpdateItemCartNotFoundProblem | CartUpdateItemCartItemNotFoundProblem | CartUpdateItemMissingCartProblem | CartUpdateItemProductNotAvailableProblem | CartUpdateItemProductQuantityNotAvailableProblem;

export type UpdateOriginatorInput = {
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  nurseryPlace?: Maybe<PlaceInput>;
  enabled?: Maybe<Scalars['Boolean']>;
  concluded?: Maybe<Scalars['Boolean']>;
};

export type UpdateOriginatorNotFoundProblem = Problem & {
  __typename?: 'UpdateOriginatorNotFoundProblem';
  message: Scalars['String'];
};

export type UpdateOriginatorResponse = Resource | UpdateOriginatorNotFoundProblem;

/** Input for updating a plan. */
export type UpdatePlanInput = {
  name?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  renewLimit?: Maybe<Scalars['Int']>;
};

/** Problem that occurs when trying to update a plan. */
export type UpdatePlanProblem = Problem & {
  __typename?: 'UpdatePlanProblem';
  message: Scalars['String'];
  code: PlanProblemCode;
};

/** Input to update a product plan. */
export type UpdatePlanProductInput = {
  assignmentCycle: Scalars['Int'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  delay: Scalars['Int'];
};

/** Problem that occurs when trying to update product plan. */
export type UpdatePlanProductProblem = Problem & {
  __typename?: 'UpdatePlanProductProblem';
  message: Scalars['String'];
  code: PlanProductProblemCode;
};

/** Response from update product plan. */
export type UpdatePlanProductResponse = PlanProduct | UpdatePlanProductProblem;

/** Response from updating a plan. */
export type UpdatePlanResponse = Plan | UpdatePlanProblem;

export type UpdateProjectSpecieDoesNotExistsProblem = Problem & {
  __typename?: 'UpdateProjectSpecieDoesNotExistsProblem';
  message: Scalars['String'];
};

export type UpdateProjectSpeciePriceNotAllowedProblem = Problem & {
  __typename?: 'UpdateProjectSpeciePriceNotAllowedProblem';
  message: Scalars['String'];
};

export type UpdateProjectSpecieTreesPerHaNotAllowedProblem = Problem & {
  __typename?: 'UpdateProjectSpecieTreesPerHaNotAllowedProblem';
  message: Scalars['String'];
};

export type UpdateProjectSpecieUnknownProblem = Problem & {
  __typename?: 'UpdateProjectSpecieUnknownProblem';
  message: Scalars['String'];
};

export type UpdateProjectSpecieVoidInputProblem = Problem & {
  __typename?: 'UpdateProjectSpecieVoidInputProblem';
  message: Scalars['String'];
};

export type UpdateProjectSpecieYieldNotAllowedProblem = Problem & {
  __typename?: 'UpdateProjectSpecieYieldNotAllowedProblem';
  message: Scalars['String'];
};

export type UpdateRuleSetMissingRuleTypeProblem = Problem & {
  __typename?: 'UpdateRuleSetMissingRuleTypeProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type UpdateRuleSetMoreThanOneRuleTypeProblem = Problem & {
  __typename?: 'UpdateRuleSetMoreThanOneRuleTypeProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type UpdateRuleSetMutationResponse = PerkRuleSet | UpdateRuleSetNotFoundProblem | UpdateRuleSetPerkNotFoundProblem | UpdateRuleSetProductProblem | UpdateRuleSetPlanProblem | UpdateRuleSetMoreThanOneRuleTypeProblem | UpdateRuleSetMissingRuleTypeProblem | UpdateRuleSetTreeQuantityProblem;

export type UpdateRuleSetNotFoundProblem = Problem & {
  __typename?: 'UpdateRuleSetNotFoundProblem';
  message: Scalars['String'];
};

export type UpdateRuleSetPerkNotFoundProblem = Problem & {
  __typename?: 'UpdateRuleSetPerkNotFoundProblem';
  message: Scalars['String'];
};

export type UpdateRuleSetPlanProblem = Problem & {
  __typename?: 'UpdateRuleSetPlanProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type UpdateRuleSetProductProblem = Problem & {
  __typename?: 'UpdateRuleSetProductProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type UpdateRuleSetTreeQuantityProblem = Problem & {
  __typename?: 'UpdateRuleSetTreeQuantityProblem';
  message: Scalars['String'];
  index: Scalars['Int'];
};

export type UpdateScientificSpecieDoesNotExistsProblem = Problem & {
  __typename?: 'UpdateScientificSpecieDoesNotExistsProblem';
  message: Scalars['String'];
};

export type UpdateScientificSpecieMutationResponse = Resource | UpdateScientificSpecieUnknownProblem | UpdateScientificSpecieDoesNotExistsProblem | UpdateScientificSpecieVoidInputProblem | UpdateScientificUnsupportedLanguagesProblem | UpdateScientificSpeciePriceNotAllowedProblem | UpdateScientificSpecieYieldNotAllowedProblem | UpdateScientificSpecieTreesPerHaNotAllowedProblem;

export type UpdateScientificSpeciePriceNotAllowedProblem = Problem & {
  __typename?: 'UpdateScientificSpeciePriceNotAllowedProblem';
  message: Scalars['String'];
};

export type UpdateScientificSpecieTreesPerHaNotAllowedProblem = Problem & {
  __typename?: 'UpdateScientificSpecieTreesPerHaNotAllowedProblem';
  message: Scalars['String'];
};

export type UpdateScientificSpecieUnknownProblem = Problem & {
  __typename?: 'UpdateScientificSpecieUnknownProblem';
  message: Scalars['String'];
};

export type UpdateScientificSpecieVoidInputProblem = Problem & {
  __typename?: 'UpdateScientificSpecieVoidInputProblem';
  message: Scalars['String'];
};

export type UpdateScientificSpecieYieldNotAllowedProblem = Problem & {
  __typename?: 'UpdateScientificSpecieYieldNotAllowedProblem';
  message: Scalars['String'];
};

export type UpdateScientificUnsupportedLanguagesProblem = Problem & {
  __typename?: 'UpdateScientificUnsupportedLanguagesProblem';
  message: Scalars['String'];
};

export type UpdateTreecodeExpiresAtNotValidProblem = Problem & {
  __typename?: 'UpdateTreecodeExpiresAtNotValidProblem';
  message: Scalars['String'];
};

export type UpdateTreecodeFindInput = {
  id?: Maybe<Scalars['ID']>;
  code?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['ID']>;
};

export type UpdateTreecodeInput = {
  /** Set an expire date */
  expiresAt?: Maybe<Scalars['Date']>;
  /** Change the enabled status */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Change the redeem type */
  redeemType?: Maybe<TreecodeRedeemType>;
};

/** At least one field to update is required */
export type UpdateTreecodeMissingInputFieldProblem = Problem & {
  __typename?: 'UpdateTreecodeMissingInputFieldProblem';
  message: Scalars['String'];
};

/** At least one field to search treecode for is required */
export type UpdateTreecodeMissingWhereFieldProblem = Problem & {
  __typename?: 'UpdateTreecodeMissingWhereFieldProblem';
  message: Scalars['String'];
};

/** The provided treecode does not exist */
export type UpdateTreecodeNotExistsProblem = Problem & {
  __typename?: 'UpdateTreecodeNotExistsProblem';
  message: Scalars['String'];
};

export type UpdateTreecodeUnknownErrorProblem = Problem & {
  __typename?: 'UpdateTreecodeUnknownErrorProblem';
  message: Scalars['String'];
};

export type UpsertFinancePriceMutationResponse = Resource | FinancePriceUpsertProjectSpecieNotFoundProblem | FinancePriceUpsertProcurementPlanNotFoundProblem | FinancePriceUpsertUnknownErrorProblem | FinancePriceUpsertPriceTooHighProblem;

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  capabilities: Array<UserCapability>;
  capabilityGroups: Array<CapabilityGroup>;
  confirmationStatus: UserConfirmationStatus;
  /**
   * User communication preferences
   * 
   * Readable only by self or privileged access
   */
  consentFlags: Maybe<ConsentFlags>;
  createdAt: Scalars['Date'];
  disabledReason: Maybe<UserDisabledReason>;
  /** User following the user */
  followers: UserConnection;
  /** Users followed by the user */
  following: UserConnection;
  footprintCalculations: FootprintCalculationConnection;
  /**
   * Connected social identities
   * 
   * Readable only by self or privileged access
   */
  identities: Array<UserIdentity>;
  /** @deprecated identityProviderId should not be used to identify an user anymore */
  identityProviderId: Maybe<Scalars['String']>;
  isDisabled: Scalars['Boolean'];
  /** @deprecated Field no longer supported */
  migrationStatus: UserMigrationStatus;
  /**
   * User privacy preferences
   * 
   * Readable only by self or privileged access
   */
  privacyFlags: Maybe<PrivacyFlags>;
  profile: UserProfile;
  /** Readable only by self or privileged access */
  roles: Array<Scalars['String']>;
  /**
   * Treedom User type
   * @deprecated Use type
   */
  userType: UserType;
  /** Treedom User type */
  type: UserType;
  updatedAt: Scalars['Date'];
  /** User feed */
  feed: UserFeedConnection;
  /** Load specific feed activity of user */
  feedActivity: Maybe<FeedActivity>;
  /** User notifications */
  notifications: NotificationStreamConnection;
  /** Cart currently open and assigned to User */
  cart: Maybe<Cart>;
  /** Invoices for all the b2b small business users. */
  invoices: Maybe<InvoiceConnection>;
  /** User Orders. */
  orders: Maybe<OrderConnection>;
  paymentMethods: Array<PaymentMethod>;
  /**
   * User subscriptions-related badges
   * If you are looking for the active subscriptions, you should probably consider the following states:
   *  - INITIALIZING
   *  - ACTIVE
   *  - FAILED_RENEWAL
   */
  subscriptionBadges: Array<PlanSubscriptionBadge>;
  /** List of trees got by subscription */
  subscriptionTrees: Maybe<TreeConnection>;
  /**
   * User subscriptions
   * Possible subscription states are:
   *  - INITIALIZING: the subscription has been created and is going to change its status soon to ACTIVE or FAILED_RENEWAL
   *  - ACTIVE: the subscription is healthy: all the payments are on time and the assignments will proceed as planned
   *  - FAILED_RENEWAL: the payment of a billing cycle has failed. It will be retried different times. If it will succeed the subscription will go back to ACTIVE. Otherwise it will go to PAST_DUE.
   *  - PAST_DUE: Too much payments have failed, the subscription is considered over.
   *  - EXPIRED: Some subscriptions has an expiration date (like 2 years from the time is started). When this expiration date is passed, the subscription becomes EXPIRED.
   *  - CANCELED: The user (or an op) explicitly canceled the subscription.
   * 
   * If you are looking for the active subscriptions, you should probably consider the following states:
   *  - INITIALIZING
   *  - ACTIVE
   *  - FAILED_RENEWAL
   */
  subscriptions: Maybe<PlanSubscriptionConnection>;
  /** Returns countries where the user has trees */
  countries: UserCountriesConnection;
  /** Users who have trees previously owned by the current user */
  custodians: UserConnection;
  /** Array of featured trees */
  featuredTrees: Array<FeaturedTree>;
  forests: ForestConnection;
  forestsContributes: ForestsContributesConnection;
  /** Giftable trees owned by user */
  giftableTrees: TreeConnection;
  /** Sum of Co2 Kgs currently absorbed by all trees gifted by the user */
  giftedTreesAbsorbedCo2: Maybe<Scalars['Int']>;
  /** Aggregated benefits of trees bought and gifted by the user */
  giftedTreesBenefits: Maybe<UserTreesBenefits>;
  /** Sum of Co2 Kgs by all trees gifted by the user */
  giftedTreesTotalCo2: Maybe<Scalars['Int']>;
  map: UserMap;
  /** @deprecated Use field trees instead with ownershipType OWNED */
  ownedTrees: TreeConnection;
  /** Sum of Co2 Kgs currently absorbed by all trees owned by the user */
  ownedTreesAbsorbedCo2: Maybe<Scalars['Int']>;
  /** Aggregated benefits of trees owned by the user */
  ownedTreesBenefits: Maybe<UserTreesBenefits>;
  /** Sum of Co2 Kgs absorbed by all trees owned by the user. */
  ownedTreesTotalCo2: Maybe<Scalars['Int']>;
  /**
   * Trees planted by user (includes gived away trees too)
   * @deprecated Use field trees instead with ownershipType PLANTED
   */
  plantedTrees: TreeConnection;
  /** Sum of Co2 Kgs currently absorbed by all trees planted by the user */
  plantedTreesAbsorbedCo2: Maybe<Scalars['Int']>;
  projectSpecies: UserProjectSpeciesConnection;
  /** Rank of the user based on the number of trees they have planted. */
  rankByPlantedTrees: Maybe<Scalars['Int']>;
  scientificSpecies: ScientificSpecieConnection;
  totalFarmers: Maybe<Scalars['Int']>;
  treeProducts: Array<UserTreeProducts>;
  treeProjects: TreeProjectConnection;
  /** Trees related to the user  */
  trees: UserTreeConnection;
  /** User's trees already gifted and redeemed. */
  giftedTrees: Maybe<TreecodeTreeConnection>;
  /** Gifts associated with user */
  gifts: Maybe<TreecodeConnection>;
};


export type UserFollowersArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserFollowingArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserFootprintCalculationsArgs = {
  pagination?: Maybe<PaginationInput>;
  where?: Maybe<FootprintCalculationsWhereInput>;
};


export type UserFeedArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserFeedActivityArgs = {
  id: Scalars['ID'];
};


export type UserNotificationsArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserCartArgs = {
  cartType?: Maybe<CartType>;
  mergeWith?: Maybe<Scalars['ID']>;
};


export type UserInvoicesArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserOrdersArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserSubscriptionTreesArgs = {
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<UserSubscriptionTreesSortInput>;
};


export type UserSubscriptionsArgs = {
  states?: Maybe<Array<PlanSubscriptionState>>;
  pagination?: Maybe<PaginationInput>;
};


export type UserCountriesArgs = {
  where?: Maybe<UserCountriesWhereInput>;
};


export type UserCustodiansArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserForestsArgs = {
  input?: Maybe<UserForestInput>;
  pagination?: Maybe<PaginationInput>;
};


export type UserForestsContributesArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserGiftableTreesArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserMapArgs = {
  where?: Maybe<UserMapWhereInput>;
};


export type UserOwnedTreesArgs = {
  where?: Maybe<UserTreesWhereInput>;
  pagination?: Maybe<PaginationInput>;
};


export type UserPlantedTreesArgs = {
  where?: Maybe<UserPlantedTreesWhereInput>;
  pagination?: Maybe<PaginationInput>;
};


export type UserProjectSpeciesArgs = {
  where?: Maybe<UserProjectSpeciesWhereInput>;
  pagination?: Maybe<PaginationInput>;
};


export type UserScientificSpeciesArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserTreeProductsArgs = {
  where?: Maybe<UserTreeProductsFindInput>;
};


export type UserTreeProjectsArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserTreesArgs = {
  where?: Maybe<UserTreesWhereConditionInput>;
  pagination?: Maybe<PaginationInput>;
};


export type UserGiftedTreesArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type UserGiftsArgs = {
  pagination: PaginationInput;
  sort?: Maybe<UserGiftsSortInput>;
};

export type UserAlreadyDisabledProblem = Problem & {
  __typename?: 'UserAlreadyDisabledProblem';
  message: Scalars['String'];
};

export type UserCapability = {
  __typename?: 'UserCapability';
  capability: Scalars['String'];
};

export enum UserCategory {
  Private = 'PRIVATE',
  Business = 'BUSINESS',
  Global = 'GLOBAL',
  Plus = 'PLUS'
}

export type UserCommonDataLayer = {
  __typename?: 'UserCommonDataLayer';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  birthday: Maybe<Scalars['String']>;
  gender: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  /** Used only on facebook */
  externalId: Maybe<Scalars['String']>;
};

export enum UserConfirmationStatus {
  /** The user is not present in the authentication service */
  Missing = 'MISSING',
  /** User has been created but not confirmed */
  Unconfirmed = 'UNCONFIRMED',
  /** User has been confirmed */
  Confirmed = 'CONFIRMED',
  /** The user is confirmed and the user can sign in using a temporary password, but on first sign-in, the user must change their password to a new value before doing anything else */
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  /** User is confirmed, but the user must request a code and reset their password before they can sign in */
  ResetRequired = 'RESET_REQUIRED',
  /** User status isn't known */
  Unknown = 'UNKNOWN',
  /** (Not available) User has been archived */
  Archived = 'ARCHIVED',
  /** (Not available) User's username and password have been compromised elsewhere */
  Compromised = 'COMPROMISED'
}

export type UserConnection = Connection & {
  __typename?: 'UserConnection';
  totalCount: Scalars['Int'];
  pageInfo: Maybe<PageInfo>;
  edges: Maybe<Array<Maybe<UserEdge>>>;
};

export type UserCountriesConnection = Connection & {
  __typename?: 'UserCountriesConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<UserCountriesEdge>>;
  pageInfo: PageInfo;
};

export type UserCountriesEdge = Edge & {
  __typename?: 'UserCountriesEdge';
  cursor: Scalars['String'];
  node: Maybe<UserCountry>;
};

/** It represents the applicable filter to the User.countries field */
export enum UserCountriesTreeType {
  Owned = 'OWNED',
  Planted = 'PLANTED',
  All = 'ALL'
}

export type UserCountriesWhereInput = {
  treeType?: Maybe<UserCountriesTreeType>;
};

export type UserCountry = {
  __typename?: 'UserCountry';
  country: Country;
  treeCount: Scalars['Int'];
};

export type UserDataLayer = {
  __typename?: 'UserDataLayer';
  facebook: Maybe<UserCommonDataLayer>;
  google: Maybe<UserCommonDataLayer>;
};

export type UserDisabledReason = {
  __typename?: 'UserDisabledReason';
  reason: DisableReason;
  customMessage: Maybe<Scalars['String']>;
};

export type UserDisableResponse = Resource | UserAlreadyDisabledProblem;

export type UserEdge = Edge & {
  __typename?: 'UserEdge';
  node: Maybe<User>;
  cursor: Maybe<Scalars['String']>;
};

export type UserFeedConnection = StreamConnection & {
  __typename?: 'UserFeedConnection';
  /** @deprecated Total count isn't implemented */
  totalCount: Scalars['Int'];
  pageInfo: StreamPageInfo;
  edges: Array<Maybe<UserFeedEdge>>;
};

export type UserFeedEdge = Edge & {
  __typename?: 'UserFeedEdge';
  node: Maybe<FeedActivity>;
  cursor: Maybe<Scalars['String']>;
};

export type UserForestInput = {
  isPayed?: Maybe<Scalars['Boolean']>;
  isDraft?: Maybe<Scalars['Boolean']>;
};

export enum UserGiftsSortInput {
  /** Sort by creation, ascending. */
  CreationAsc = 'CREATION_ASC',
  /** Sort by creation, descending. */
  CreationDesc = 'CREATION_DESC'
}

export type UserIdentity = {
  __typename?: 'UserIdentity';
  provider: SocialIdentity;
  providerUserId: Scalars['String'];
};

export type UserIdentityInput = {
  provider: SocialIdentity;
  providerUserId: Scalars['String'];
};

export type UserMap = {
  __typename?: 'UserMap';
  pins: Array<MapPin>;
};

export type UserMapWhereInput = {
  /** Filter by tree ownership, empty array means no records in response. */
  ownershipType?: Maybe<Array<UserTreesTreeType>>;
  /** Filter by country code. */
  countryCode?: Maybe<Scalars['ID']>;
  /** Whether to include trees in nurseries. */
  inNursery?: Maybe<Scalars['Boolean']>;
  /** Zoom of the map. */
  zoom?: Maybe<Scalars['Int']>;
  /** Upper left bound of the map. */
  NE?: Maybe<MapPointInput>;
  /** Lower right bound of the map. */
  SW?: Maybe<MapPointInput>;
  /** Whether to force clustering when zoomed out. Must be used with `NE`/`SW`. */
  forceClustering?: Maybe<Scalars['Boolean']>;
};

export enum UserMigrationStatus {
  /** User is still contained in the legacy authentication system and can proceed to a standard login */
  NotImported = 'NOT_IMPORTED',
  /** User has been imported into new authentication system and has to follow import login strategy */
  Imported = 'IMPORTED',
  /** User has been fully migrated to the new authentication system and can proceed to a standard login */
  Migrated = 'MIGRATED',
  /** Users whose identityProviderId is not found in the Cognito userPool */
  Misaligned = 'MISALIGNED'
}

export type UserMutation = {
  __typename?: 'UserMutation';
  /** Update user profile */
  changeBusinessInfo: Maybe<ChangeBusinessInfoResponse>;
  /** @deprecated Use setConsents mutation */
  changeConsentFlags: Maybe<ChangeConsentFlagsResponse>;
  /** @deprecated Use setConsents mutation */
  setConsentFlags: Maybe<ChangeConsentFlagsResponse>;
  changeIdentityProviderId: ChangeIdentityProfilerIdResponse;
  /** Update user password */
  changePassword: Maybe<ChangePasswordResponse>;
  changePrivacyFlags: Maybe<ChangePrivacyFlagsResponse>;
  /** Update user profile */
  changeProfile: Maybe<ChangeProfileResponse>;
  /** Requests a signed URL where to upload the user profile picture */
  changeProfilePicture: Maybe<ChangeProfilePictureResponse>;
  /** Create user */
  create: Maybe<CreateUserResponse>;
  /** Update user profile */
  disable: Maybe<UserDisableResponse>;
  /** Link social identity to the authenticated user */
  linkSocialIdentity: Maybe<LinkSocialIdentityResponse>;
  /**
   * Merge two user accounts.
   * It moves all related resources (tree, gifts, forests) to the target account.
   */
  mergeUsers: MergeUsersResult;
  profile: ProfileMutation;
  /** Change and confirm user email */
  requestChangeEmail: Maybe<RequestChangeEmailResponse>;
  /**
   * Request a new confirmation email to be sent to the user identified by email or id.
   * If none of those is provided, the user will be inferred from the authentication
   */
  requestConfirmEmail: Maybe<UserRequestConfirmEmailResponse>;
  setCapabilities: SetUserCapabilitiesReponse;
  setCapabilityGroups: SetUserCapabilityGroupsReponse;
  /** Change User Commitment start and end date */
  setCommitment: UserSetCommitmentResponse;
  setConsents: SetConsentsResponse;
  /** Sets a temporary, recovery password to the user */
  setRecoveryPassword: UserSetRecoveryPasswordResponse;
  setRoles: UserSetRolesResponse;
  /** Set social identity */
  setSocialIdentity: SetSocialIdentityInputResponse;
  setType: SetUserTypeResponse;
  /** Confirm email */
  submitConfirmEmail: Maybe<UserSubmitConfirmEmailResponse>;
  /**
   * Unlink social identity of the authenticated user
   * The id field is optional and reserved only for administrative usage
   */
  unlinkSocialIdentity: Maybe<UnlinkSocialIdentityResponse>;
};


export type UserMutationChangeBusinessInfoArgs = {
  id?: Maybe<Scalars['ID']>;
  input: ChangeBusinessInfoInput;
};


export type UserMutationChangeConsentFlagsArgs = {
  id?: Maybe<Scalars['ID']>;
  input: ChangeConsentFlagsInput;
};


export type UserMutationSetConsentFlagsArgs = {
  id?: Maybe<Scalars['ID']>;
  input: ChangeConsentFlagsInput;
};


export type UserMutationChangeIdentityProviderIdArgs = {
  id: Scalars['ID'];
  input: ChangeIdentityProviderIdInput;
};


export type UserMutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type UserMutationChangePrivacyFlagsArgs = {
  id?: Maybe<Scalars['ID']>;
  input: ChangePrivacyFlagsInput;
};


export type UserMutationChangeProfileArgs = {
  id?: Maybe<Scalars['ID']>;
  input: ChangeProfileInput;
};


export type UserMutationChangeProfilePictureArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type UserMutationCreateArgs = {
  input: CreateUserInput;
};


export type UserMutationDisableArgs = {
  id?: Maybe<Scalars['ID']>;
  input: DisableUserInput;
};


export type UserMutationLinkSocialIdentityArgs = {
  input: LinkSocialIdentityInput;
};


export type UserMutationMergeUsersArgs = {
  input: MergeUsersInput;
};


export type UserMutationRequestChangeEmailArgs = {
  id?: Maybe<Scalars['ID']>;
  input: RequestChangeEmailInput;
};


export type UserMutationRequestConfirmEmailArgs = {
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};


export type UserMutationSetCapabilitiesArgs = {
  id: Scalars['ID'];
  capabilities: Array<Scalars['String']>;
};


export type UserMutationSetCapabilityGroupsArgs = {
  id: Scalars['ID'];
  capabilityGroups: Array<Scalars['String']>;
};


export type UserMutationSetCommitmentArgs = {
  id: Scalars['ID'];
  startAt: Scalars['Date'];
  endAt: Scalars['Date'];
};


export type UserMutationSetConsentsArgs = {
  userId: Scalars['ID'];
  input: SetConsentsInput;
};


export type UserMutationSetRecoveryPasswordArgs = {
  id: Scalars['ID'];
};


export type UserMutationSetRolesArgs = {
  id: Scalars['ID'];
  roles: Array<Scalars['String']>;
};


export type UserMutationSetSocialIdentityArgs = {
  id: Scalars['ID'];
  input: SetSocialIdentityInput;
};


export type UserMutationSetTypeArgs = {
  id: Scalars['ID'];
  type: UserType;
};


export type UserMutationSubmitConfirmEmailArgs = {
  verificationToken: Scalars['String'];
};


export type UserMutationUnlinkSocialIdentityArgs = {
  id?: Maybe<Scalars['ID']>;
  input: UnlinkSocialIdentityInput;
};

/** Perks that a user can have. */
export type UserPerk = UserPerkCommunicationKit;

/** A communication kit rewarded to a user when a perk is unlocked. */
export type UserPerkCommunicationKit = CommunicationKitInterface & {
  __typename?: 'UserPerkCommunicationKit';
  /** The ID of the user perk. */
  id: Scalars['ID'];
  status: UserPerkStatus;
  /** The category of the communication kit. */
  category: Scalars['String'];
  /** The icon image of the user perk. */
  icon: Image;
  /** The title of the user perk. */
  title: Scalars['String'];
  /** The description of the user perk. */
  description: Scalars['String'];
  /** The CTA of the communication kit. */
  cta: CommunicationKitCta;
  /** The type of the communication kit. Defines the behavior of the CTA. */
  ctaType: CommunicationKitCtaType;
};


/** A communication kit rewarded to a user when a perk is unlocked. */
export type UserPerkCommunicationKitTitleArgs = {
  locale: Scalars['String'];
};


/** A communication kit rewarded to a user when a perk is unlocked. */
export type UserPerkCommunicationKitDescriptionArgs = {
  locale: Scalars['String'];
};


/** A communication kit rewarded to a user when a perk is unlocked. */
export type UserPerkCommunicationKitCtaArgs = {
  locale: Scalars['String'];
};

/** The status of a perk. */
export enum UserPerkStatus {
  /** The perk is partially unlocked. */
  Active = 'ACTIVE',
  /** The perk is locked. */
  Inactive = 'INACTIVE',
  /** The perk is partially unlocked. */
  Partial = 'PARTIAL'
}

export type UserPlantedTreesWhereInput = {
  countryCode?: Maybe<Scalars['ID']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  id: Scalars['ID'];
  avatar: Maybe<Image>;
  badges: Array<UserProfileBadge>;
  /** Billing address of user, contains value in case of business user */
  billingAddress: Maybe<Scalars['String']>;
  birthdate: Maybe<Scalars['Date']>;
  /** The name of the user, values in the case of business user */
  businessName: Maybe<Scalars['String']>;
  /** The certified email for the business user */
  certifiedEmail: Maybe<Scalars['String']>;
  /** The registered city of the business user */
  city: Maybe<Scalars['String']>;
  commitmentEndAt: Maybe<Scalars['Date']>;
  commitmentStartAt: Maybe<Scalars['Date']>;
  communicationKits: Array<UserPerkCommunicationKit>;
  /** The employee number in the company */
  companySize: Maybe<CompanySize>;
  /** The country code for the user */
  countryCode: Maybe<Scalars['String']>;
  /** Datalayer data */
  datalayer: Maybe<UserDataLayer>;
  /** The department in the company where the user works */
  department: Maybe<BusinessDepartment>;
  /** The description for the business user */
  description: Maybe<Scalars['String']>;
  /** Derived display name for the user or ocmpany name for the business user */
  displayName: Scalars['String'];
  email: Scalars['String'];
  emailConfirmed: Scalars['Boolean'];
  firstName: Scalars['String'];
  /** Gender, when specified, of the private user */
  gender: Maybe<Gender>;
  /** Impacts of the user profile */
  impacts: Array<UserProfileImpact>;
  isPlus: Scalars['Boolean'];
  /** Visibility/Enable flag of user  */
  isVisible: Scalars['Boolean'];
  /**
   * User preferred language
   * ISO639-1 two-letter codes
   */
  language: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  /** Treedom User organization type (business users only) */
  organizationType: Maybe<OrganizationType>;
  /** The phone number */
  phone: Maybe<Scalars['String']>;
  /** The recipient code for the business user */
  recipientCode: Maybe<Scalars['String']>;
  /** The business sector for the company */
  sector: Maybe<BusinessSector>;
  /** Visibility flag of emissions section */
  showEmissions: Scalars['Boolean'];
  /** Visibility flag of forests section */
  showForests: Scalars['Boolean'];
  /** Visibility flag of name field */
  showName: Scalars['Boolean'];
  /** Visibility flag of people section */
  showPeople: Scalars['Boolean'];
  /** Visibility flag of projects section */
  showProjects: Scalars['Boolean'];
  /** Visibility flag of redeem section */
  showRedeem: Scalars['Boolean'];
  /** Visibility flag of trees section */
  showTrees: Scalars['Boolean'];
  /** Visibility flag of wall section */
  showWall: Scalars['Boolean'];
  /** Unique user url-friendly identifier */
  slug: Scalars['String'];
  /** The user's social links */
  socialLinks: SocialLinks;
  taxId: Maybe<Scalars['String']>;
  vatNumber: Maybe<Scalars['String']>;
  /** The website of the business user */
  websiteUrl: Maybe<Scalars['String']>;
  /** Shipping addresses for the user profile */
  shippingAddresses: Maybe<Array<ShippingAddress>>;
};


export type UserProfileDescriptionArgs = {
  locale?: Maybe<Scalars['String']>;
};

export type UserProfileBadge = {
  __typename?: 'UserProfileBadge';
  unlockedAt: Maybe<Scalars['Date']>;
  unlocked: Scalars['Boolean'];
  badge: Maybe<ProfileBadge>;
};

export type UserProfileImpact = {
  __typename?: 'UserProfileImpact';
  /** Impact name */
  impact: Maybe<Impact>;
  /** Status of the impact for the profile */
  status: UserProfileImpactStatus;
  /** Date when the impact was added to the profile */
  createdAt: Maybe<Scalars['Date']>;
  /** Subscription related to the impact */
  subscription: Maybe<PlanSubscription>;
  /** Date when the impact was expired/removed from the profile */
  canceledAt: Maybe<Scalars['Date']>;
};

export enum UserProfileImpactStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type UserProjectSpecie = {
  __typename?: 'UserProjectSpecie';
  projectSpecie: Maybe<ProjectSpecie>;
  treeCount: Maybe<Scalars['Int']>;
  absorbedCo2: Maybe<Scalars['Int']>;
};

export type UserProjectSpeciesConnection = Connection & {
  __typename?: 'UserProjectSpeciesConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<UserProjectSpeciesEdge>>;
  pageInfo: PageInfo;
};

export type UserProjectSpeciesEdge = Edge & {
  __typename?: 'UserProjectSpeciesEdge';
  cursor: Scalars['String'];
  node: Maybe<UserProjectSpecie>;
};

export type UserProjectSpeciesWhereInput = {
  id?: Maybe<Array<Scalars['ID']>>;
  /** Tree ownership type used to search project species, empty array means no records in response */
  ownershipType?: Maybe<Array<UserTreesTreeType>>;
};

/** The given account email is already confirmed */
export type UserRequestConfirmEmailAlreadyConfirmedProblem = Problem & {
  __typename?: 'UserRequestConfirmEmailAlreadyConfirmedProblem';
  message: Scalars['String'];
};

export type UserRequestConfirmEmailResponse = Resource | UserRequestConfirmEmailAlreadyConfirmedProblem;

export type UserSetCommitmentNotFoundProblem = Problem & {
  __typename?: 'UserSetCommitmentNotFoundProblem';
  message: Scalars['String'];
};

export type UserSetCommitmentResponse = Resource | UserSetCommitmentNotFoundProblem;

export type UserSetPreferencesArgsNotProvided = Problem & {
  __typename?: 'UserSetPreferencesArgsNotProvided';
  message: Scalars['String'];
};

export type UserSetPreferencesResponse = Resource | UserSetPreferencesUserNotFoundProblem | UserSetPreferencesArgsNotProvided;

export type UserSetPreferencesUserNotFoundProblem = Problem & {
  __typename?: 'UserSetPreferencesUserNotFoundProblem';
  message: Scalars['String'];
};

export type UserSetRecoveryPassword = {
  __typename?: 'UserSetRecoveryPassword';
  password: Scalars['String'];
};

export type UserSetRecoveryPasswordNotFoundProblem = Problem & {
  __typename?: 'UserSetRecoveryPasswordNotFoundProblem';
  message: Scalars['String'];
};

export type UserSetRecoveryPasswordResponse = UserSetRecoveryPassword | UserSetRecoveryPasswordNotFoundProblem;

export type UserSetRolesNotFoundProblem = Problem & {
  __typename?: 'UserSetRolesNotFoundProblem';
  message: Scalars['String'];
};

export type UserSetRolesResponse = Resource | UserSetRolesNotFoundProblem;

export type UserSocialIdentityInput = {
  provider: SocialIdentity;
  providerUserId: Scalars['String'];
};

/** The given email is already confirmed */
export type UserSubmitConfirmEmailAlreadyConfirmedProblem = Problem & {
  __typename?: 'UserSubmitConfirmEmailAlreadyConfirmedProblem';
  message: Scalars['String'];
};

export type UserSubmitConfirmEmailResponse = Resource | UserSubmitConfirmEmailAlreadyConfirmedProblem | UserSubmitConfirmEmailVerificationTokenNotValidProblem | UserSubmitConfirmEmailVerificationTokenExpiredProblem | UserSubmitConfirmEmailVerificationTokenNotFoundProblem;

/** The provided verificationToken is expired */
export type UserSubmitConfirmEmailVerificationTokenExpiredProblem = Problem & {
  __typename?: 'UserSubmitConfirmEmailVerificationTokenExpiredProblem';
  message: Scalars['String'];
};

/** The provided verificationToken does not exists */
export type UserSubmitConfirmEmailVerificationTokenNotFoundProblem = Problem & {
  __typename?: 'UserSubmitConfirmEmailVerificationTokenNotFoundProblem';
  message: Scalars['String'];
};

/** The provided verificationToken is not valid */
export type UserSubmitConfirmEmailVerificationTokenNotValidProblem = Problem & {
  __typename?: 'UserSubmitConfirmEmailVerificationTokenNotValidProblem';
  message: Scalars['String'];
};

export enum UserSubscriptionTreesSortInput {
  /** Sort by assigned on, ascending. */
  AssignedOnAsc = 'ASSIGNED_ON_ASC',
  /** Sort by assigned on, descending. */
  AssignedOnDesc = 'ASSIGNED_ON_DESC'
}

export type UserTreeConnection = Connection & {
  __typename?: 'UserTreeConnection';
  totalCount: Scalars['Int'];
  edges: Array<Maybe<TreeEdge>>;
  pageInfo: PageInfo;
};

export type UserTreeEdge = Edge & {
  __typename?: 'UserTreeEdge';
  cursor: Scalars['String'];
  node: Maybe<Tree>;
};

export type UserTreeProducts = {
  __typename?: 'UserTreeProducts';
  product: Product;
  quantity: Scalars['Int'];
};

export type UserTreeProductsFindInput = {
  /** Filter by giftable trees only */
  giftable?: Maybe<Scalars['Boolean']>;
  /** Filter by trees of specific forest */
  forestId?: Maybe<Scalars['ID']>;
  /** Filter by trees without forest only */
  withoutForest?: Maybe<Scalars['Boolean']>;
  /** Filter by trees assigned from specific date only */
  treeAssignedOnFrom?: Maybe<Scalars['Date']>;
  /** Filter by trees assigned until specific date only */
  treeAssignedOnTo?: Maybe<Scalars['Date']>;
};

/** Aggregated benefits derived from Tree statistics */
export type UserTreesBenefits = {
  __typename?: 'UserTreesBenefits';
  /** co2 absorption benefit expressed in cents */
  co2Benefit: Scalars['Int'];
  /** Economic benefit expressed in cents */
  incomeBenefit: Scalars['Int'];
  /** Food production benefit expressed in cents */
  foodBenefit: Scalars['Int'];
  /** Environmental benefit expressed in cents */
  soilBenefit: Scalars['Int'];
};

export enum UserTreesTreeType {
  /** Trees currently owned by the user */
  Owned = 'OWNED',
  /** Trees planted by the user */
  Planted = 'PLANTED',
  /** Trees whose ownership has been moved to another user */
  Transferred = 'TRANSFERRED',
  /** Trees whose ownership has been received from another user */
  Acquired = 'ACQUIRED'
}

export type UserTreesWhereConditionInput = {
  /** Country code used to search trees */
  countryCode?: Maybe<Scalars['ID']>;
  /** Tree ownership type used to search trees, empty array means no records in response */
  ownershipType?: Maybe<Array<UserTreesTreeType>>;
};

export type UserTreesWhereInput = {
  countryCode?: Maybe<Scalars['ID']>;
};

export enum UserType {
  Private = 'PRIVATE',
  Business = 'BUSINESS',
  BusinessPremium = 'BUSINESS_PREMIUM'
}

export type VideoUrl = {
  __typename?: 'VideoUrl';
  id: Scalars['ID'];
  /** Description of video */
  description: Scalars['String'];
  /** PosterUrl of video */
  posterUrl: Scalars['String'];
  /** Title of video */
  title: Scalars['String'];
  /** Url of video */
  url: Scalars['String'];
};


export type VideoUrlDescriptionArgs = {
  locale: Scalars['String'];
};


export type VideoUrlPosterUrlArgs = {
  locale: Scalars['String'];
};


export type VideoUrlTitleArgs = {
  locale: Scalars['String'];
};


export type VideoUrlUrlArgs = {
  locale: Scalars['String'];
};

export type Weather = {
  __typename?: 'Weather';
  /** Status of the weather */
  status: WeatherStatus;
  /** Status of the day in the location */
  dayTime: DayTime;
  /** Timezone  */
  timezone: Scalars['String'];
  /** Last update of the weather */
  lastUpdate: Scalars['DateTime'];
  /** Temperature in the location */
  temperature: Temperature;
  /**
   * Intensity of the precipitation
   * NOTE: Evaluated only when raining or snowing
   */
  precipitationIntensity: Maybe<PrecipitationIntensity>;
  /** Wind speed in meters/s */
  windSpeed: Maybe<Scalars['Float']>;
  /** Wind direction in degrees */
  windDirection: Maybe<Scalars['Int']>;
  /** Cloudiness in percentage */
  cloudiness: Maybe<Scalars['Int']>;
};

export enum WeatherStatus {
  Thunderstorm = 'THUNDERSTORM',
  Drizzle = 'DRIZZLE',
  Rain = 'RAIN',
  Snow = 'SNOW',
  Clear = 'CLEAR',
  Clouds = 'CLOUDS',
  Mist = 'MIST'
}

export enum ZodiacSign {
  Aries = 'ARIES',
  Taurus = 'TAURUS',
  Gemini = 'GEMINI',
  Cancer = 'CANCER',
  Leo = 'LEO',
  Virgo = 'VIRGO',
  Libra = 'LIBRA',
  Scorpio = 'SCORPIO',
  Sagittarius = 'SAGITTARIUS',
  Capricorn = 'CAPRICORN',
  Aquarius = 'AQUARIUS',
  Pisces = 'PISCES'
}

export type TreeNameUpdateMutationVariables = {
  treeId: Scalars['ID'];
  name: Scalars['String'];
};


export type TreeNameUpdateMutation = (
  { __typename?: 'Mutation' }
  & { tree: Maybe<(
    { __typename?: 'TreeMutation' }
    & { changeName: (
      { __typename: 'Resource' }
      & Pick<Resource, 'id'>
    ) | { __typename: 'TreeChangeNameNotAuthorizedProblem' } | { __typename: 'TreeChangeNameEmptyNameProblem' } }
  )> }
);

export type CompleteGameMutationVariables = {
  input: TreecodeGameCompleteInput;
};


export type CompleteGameMutation = (
  { __typename?: 'Mutation' }
  & { treecode: Maybe<(
    { __typename?: 'TreecodeMutation' }
    & { game: Maybe<(
      { __typename?: 'TreecodeGameMutation' }
      & { complete: Maybe<(
        { __typename?: 'Resource' }
        & Pick<Resource, 'id'>
      ) | (
        { __typename?: 'TreecodeGameCompleteGameExpiredProblem' }
        & Pick<TreecodeGameCompleteGameExpiredProblem, 'message'>
      ) | (
        { __typename?: 'TreecodeGameCompleteAlreadyCompletedProblem' }
        & Pick<TreecodeGameCompleteAlreadyCompletedProblem, 'message'>
      ) | (
        { __typename?: 'TreecodeGameCompleteTreecodeNotFoundProblem' }
        & Pick<TreecodeGameCompleteTreecodeNotFoundProblem, 'message'>
      ) | (
        { __typename?: 'TreecodeGameCompleteGameNotFoundProblem' }
        & Pick<TreecodeGameCompleteGameNotFoundProblem, 'message'>
      ) | (
        { __typename?: 'TreecodeGameCompleteTreecodeNotRedeemedProblem' }
        & Pick<TreecodeGameCompleteTreecodeNotRedeemedProblem, 'message'>
      ) | (
        { __typename?: 'TreecodeGameCompleteUnknownProblem' }
        & Pick<TreecodeGameCompleteUnknownProblem, 'message'>
      )> }
    )> }
  )> }
);

export type BusinessSubscriptionCertificateQueryVariables = {};


export type BusinessSubscriptionCertificateQuery = (
  { __typename?: 'Query' }
  & { me: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id'>
    & { subscriptions: Maybe<(
      { __typename?: 'PlanSubscriptionConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'PlanSubscriptionEdge' }
        & { node: Maybe<(
          { __typename?: 'PlanSubscription' }
          & Pick<PlanSubscription, 'id' | 'state' | 'createdAt'>
          & { product: (
            { __typename?: 'ProductBeverageBrewing' }
            & Pick<ProductBeverageBrewing, 'sku'>
          ) | (
            { __typename?: 'ProductBundleTree' }
            & Pick<ProductBundleTree, 'sku'>
          ) | (
            { __typename?: 'ProductHoroscopeTree' }
            & Pick<ProductHoroscopeTree, 'sku'>
          ) | (
            { __typename?: 'ProductSubscription' }
            & Pick<ProductSubscription, 'sku'>
          ) | (
            { __typename?: 'ProductTree' }
            & Pick<ProductTree, 'sku'>
          ) | (
            { __typename?: 'ProductUpperWear' }
            & Pick<ProductUpperWear, 'sku'>
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type MeSubscriptionsQueryVariables = {};


export type MeSubscriptionsQuery = (
  { __typename?: 'Query' }
  & { me: Maybe<(
    { __typename?: 'User' }
    & { subscriptions: Maybe<(
      { __typename?: 'PlanSubscriptionConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'PlanSubscriptionEdge' }
        & { node: Maybe<(
          { __typename?: 'PlanSubscription' }
          & Pick<PlanSubscription, 'createdAt' | 'state'>
          & { product: (
            { __typename?: 'ProductBeverageBrewing' }
            & { identifier: ProductBeverageBrewing['sku'] }
          ) | (
            { __typename?: 'ProductBundleTree' }
            & { identifier: ProductBundleTree['sku'] }
          ) | (
            { __typename?: 'ProductHoroscopeTree' }
            & { identifier: ProductHoroscopeTree['sku'] }
          ) | (
            { __typename?: 'ProductSubscription' }
            & { identifier: ProductSubscription['sku'] }
          ) | (
            { __typename?: 'ProductTree' }
            & { identifier: ProductTree['sku'] }
          ) | (
            { __typename?: 'ProductUpperWear' }
            & { identifier: ProductUpperWear['sku'] }
          ) }
        )> }
      )>> }
    )> }
  )> }
);

export type TreeCode_ByQueryVariables = {
  where: TreecodeFindInput;
};


export type TreeCode_ByQuery = (
  { __typename?: 'Query' }
  & { treecode: Maybe<(
    { __typename?: 'TreecodePicker' }
    & Pick<TreecodePicker, 'uuid' | 'code'>
    & { forest: (
      { __typename?: 'Forest' }
      & Pick<Forest, 'id' | 'slug'>
      & { owner: (
        { __typename?: 'User' }
        & Pick<User, 'id'>
        & { profile: (
          { __typename?: 'UserProfile' }
          & Pick<UserProfile, 'displayName' | 'slug'>
        ) }
      ) }
    ), owner: (
      { __typename?: 'User' }
      & { profile: (
        { __typename?: 'UserProfile' }
        & Pick<UserProfile, 'displayName'>
      ) }
    ) }
  ) | (
    { __typename?: 'TreecodeSimple' }
    & Pick<TreecodeSimple, 'uuid' | 'code'>
    & { owner: (
      { __typename?: 'User' }
      & { profile: (
        { __typename?: 'UserProfile' }
        & Pick<UserProfile, 'displayName'>
      ) }
    ) }
  ) | (
    { __typename?: 'TreecodeVirgin' }
    & Pick<TreecodeVirgin, 'uuid' | 'code'>
    & { owner: (
      { __typename?: 'User' }
      & { profile: (
        { __typename?: 'UserProfile' }
        & Pick<UserProfile, 'displayName'>
      ) }
    ) }
  )> }
);

export type TreeCode_GameQueryVariables = {
  where: TreecodeFindInput;
  userId: Scalars['ID'];
};


export type TreeCode_GameQuery = (
  { __typename?: 'Query' }
  & { treecode: Maybe<(
    { __typename?: 'TreecodePicker' }
    & { game: Maybe<(
      { __typename?: 'TreecodeGame' }
      & Pick<TreecodeGame, 'expireDate' | 'triggerReward'>
      & { completionResult: Maybe<(
        { __typename?: 'TreecodeGameCompletionResult' }
        & Pick<TreecodeGameCompletionResult, 'result'>
        & { rewardTreecode: Maybe<(
          { __typename?: 'TreecodePicker' }
          & Pick<TreecodePicker, 'code'>
        ) | (
          { __typename?: 'TreecodeSimple' }
          & Pick<TreecodeSimple, 'code'>
        ) | (
          { __typename?: 'TreecodeVirgin' }
          & Pick<TreecodeVirgin, 'code'>
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TreecodeSimple' }
    & { game: Maybe<(
      { __typename?: 'TreecodeGame' }
      & Pick<TreecodeGame, 'expireDate' | 'triggerReward'>
      & { completionResult: Maybe<(
        { __typename?: 'TreecodeGameCompletionResult' }
        & Pick<TreecodeGameCompletionResult, 'result'>
        & { rewardTreecode: Maybe<(
          { __typename?: 'TreecodePicker' }
          & Pick<TreecodePicker, 'code'>
        ) | (
          { __typename?: 'TreecodeSimple' }
          & Pick<TreecodeSimple, 'code'>
        ) | (
          { __typename?: 'TreecodeVirgin' }
          & Pick<TreecodeVirgin, 'code'>
        )> }
      )> }
    )> }
  ) | { __typename?: 'TreecodeVirgin' }> }
);

export type UserImpactsQueryVariables = {
  id: Scalars['ID'];
};


export type UserImpactsQuery = (
  { __typename?: 'Query' }
  & { user: Maybe<(
    { __typename?: 'User' }
    & { profile: (
      { __typename?: 'UserProfile' }
      & { impacts: Array<(
        { __typename?: 'UserProfileImpact' }
        & Pick<UserProfileImpact, 'status'>
      )> }
    ) }
  )> }
);

export type UserInfoFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'createdAt' | 'roles' | 'type'>
  & { trees: (
    { __typename?: 'UserTreeConnection' }
    & Pick<UserTreeConnection, 'totalCount'>
  ), profile: (
    { __typename?: 'UserProfile' }
    & Pick<UserProfile, 'displayName' | 'firstName' | 'lastName' | 'slug' | 'countryCode' | 'language' | 'emailConfirmed'>
    & { datalayer: Maybe<(
      { __typename?: 'UserDataLayer' }
      & { facebook: Maybe<(
        { __typename?: 'UserCommonDataLayer' }
        & Pick<UserCommonDataLayer, 'birthday' | 'country' | 'email' | 'externalId' | 'firstName' | 'gender' | 'lastName'>
      )>, google: Maybe<(
        { __typename?: 'UserCommonDataLayer' }
        & Pick<UserCommonDataLayer, 'birthday' | 'country' | 'email' | 'firstName' | 'gender' | 'lastName'>
      )> }
    )>, avatar: Maybe<(
      { __typename?: 'Image' }
      & Pick<Image, 'url'>
    )> }
  ) }
);

export type UserInfoQueryVariables = {
  slug?: Maybe<Scalars['String']>;
};


export type UserInfoQuery = (
  { __typename?: 'Query' }
  & { user: Maybe<(
    { __typename?: 'User' }
    & UserInfoFragment
  )> }
);

export type UserSubscriptionBadgesQueryVariables = {
  id: Scalars['ID'];
};


export type UserSubscriptionBadgesQuery = (
  { __typename?: 'Query' }
  & { user: Maybe<(
    { __typename?: 'User' }
    & { subscriptionBadges: Array<(
      { __typename?: 'PlanSubscriptionBadge' }
      & Pick<PlanSubscriptionBadge, 'type' | 'startedAt'>
    )>, subscriptions: Maybe<(
      { __typename?: 'PlanSubscriptionConnection' }
      & Pick<PlanSubscriptionConnection, 'totalCount'>
      & { edges: Array<Maybe<(
        { __typename?: 'PlanSubscriptionEdge' }
        & { node: Maybe<(
          { __typename?: 'PlanSubscription' }
          & Pick<PlanSubscription, 'id' | 'state'>
        )> }
      )>> }
    )> }
  )> }
);

export type MutateUserBusinessMutationVariables = {
  id: Scalars['ID'];
  input: ChangeBusinessInfoInput;
};


export type MutateUserBusinessMutation = (
  { __typename?: 'Mutation' }
  & { user: Maybe<(
    { __typename?: 'UserMutation' }
    & { changeBusinessInfo: Maybe<(
      { __typename: 'Resource' }
      & Pick<Resource, 'id'>
    ) | (
      { __typename: 'ChangeBusinessInfoInvalidInputProblem' }
      & Pick<ChangeBusinessInfoInvalidInputProblem, 'message'>
    )> }
  )> }
);

export type BusinessInfoQueryVariables = {};


export type BusinessInfoQuery = (
  { __typename?: 'Query' }
  & { me: Maybe<(
    { __typename?: 'User' }
    & { profile: (
      { __typename?: 'UserProfile' }
      & Pick<UserProfile, 'companySize' | 'department' | 'phone' | 'sector'>
    ) }
  )> }
);

export const UserInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"trees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datalayer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"google"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"emailConfirmed"}}]}}]}}]} as unknown as DocumentNode<UserInfoFragment, unknown>;
export const TreeNameUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TreeNameUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"treeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tree"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"treeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TreeNameUpdateMutation, TreeNameUpdateMutationVariables>;
export const CompleteGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeGameCompleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"treecode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeGameCompleteGameExpiredProblem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeGameCompleteAlreadyCompletedProblem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeGameCompleteTreecodeNotFoundProblem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeGameCompleteGameNotFoundProblem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeGameCompleteTreecodeNotRedeemedProblem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeGameCompleteUnknownProblem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompleteGameMutation, CompleteGameMutationVariables>;
export const BusinessSubscriptionCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BusinessSubscriptionCertificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BusinessSubscriptionCertificateQuery, BusinessSubscriptionCertificateQueryVariables>;
export const MeSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeSubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"identifier"},"name":{"kind":"Name","value":"sku"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeSubscriptionsQuery, MeSubscriptionsQueryVariables>;
export const TreeCode_ByDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TreeCode_By"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeFindInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"treecode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodePicker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TreeCode_ByQuery, TreeCode_ByQueryVariables>;
export const TreeCode_GameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TreeCode_Game"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeFindInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"treecode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodeSimple"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expireDate"}},{"kind":"Field","name":{"kind":"Name","value":"triggerReward"}},{"kind":"Field","name":{"kind":"Name","value":"completionResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"rewardTreecode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreecodePicker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"game"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expireDate"}},{"kind":"Field","name":{"kind":"Name","value":"triggerReward"}},{"kind":"Field","name":{"kind":"Name","value":"completionResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"rewardTreecode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TreeCode_GameQuery, TreeCode_GameQueryVariables>;
export const UserImpactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserImpacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserImpactsQuery, UserImpactsQueryVariables>;
export const UserInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"trees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"datalayer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facebook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"google"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"emailConfirmed"}}]}}]}}]} as unknown as DocumentNode<UserInfoQuery, UserInfoQueryVariables>;
export const UserSubscriptionBadgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSubscriptionBadges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionBadges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<UserSubscriptionBadgesQuery, UserSubscriptionBadgesQueryVariables>;
export const MutateUserBusinessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mutateUserBusiness"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeBusinessInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeBusinessInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeBusinessInfoInvalidInputProblem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MutateUserBusinessMutation, MutateUserBusinessMutationVariables>;
export const BusinessInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BusinessInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companySize"}},{"kind":"Field","name":{"kind":"Name","value":"department"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"sector"}}]}}]}}]}}]} as unknown as DocumentNode<BusinessInfoQuery, BusinessInfoQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AbuseReportResponse": [
      "Resource",
      "AbuseReportNotFoundProblem",
      "AbuseReportUnknownErrorProblem"
    ],
    "AddBillingPlanEntryResponse": [
      "BillingPlanEntry",
      "BillingPlanEntryUnknownProblem",
      "BillingPlanEntryNotFoundProblem",
      "BillingPlanEntryBillingPlanNotFoundProblem",
      "BillingPlanEntryMinimumCycleProblem",
      "BillingPlanEntryCyclesNotProgressiveProblem",
      "BillingPlanEntryDelayNotPositiveProblem",
      "BillingPlanEntryDelayNotProgressiveProblem",
      "BillingPlanEntryDelayTooLongProblem",
      "BillingPlanEntryNotValidProblem"
    ],
    "AddDiscountResponse": [
      "Resource",
      "CartAddDiscountCartNotFoundProblem",
      "CartAddDiscountIncorrectDiscountCodeProblem",
      "CartAddDiscountUserMismatchProblem"
    ],
    "AddItemResponse": [
      "CartAddItemSuccessResponse",
      "CartAddItemProductNotSellableProblem",
      "CartAddItemProductNotFoundProblem",
      "CartAddItemProductVariantNotFoundProblem",
      "CartAddItemProductNotAvailableProblem",
      "CartAddItemProductOutOfStockProblem",
      "CartAddItemCurrencyMismatchProblem",
      "CartAddItemCartTypeMismatchProblem",
      "CartAddItemUnauthorizedProductProblem"
    ],
    "AddPlanProductResponse": [
      "PlanProduct",
      "AddPlanProductProblem"
    ],
    "AddRuleSetMutationResponse": [
      "PerkRuleSet",
      "AddRuleSetProductProblem",
      "AddRuleSetPlanProblem",
      "AddRuleSetMoreThanOneRuleTypeProblem",
      "AddRuleSetMissingRuleTypeProblem",
      "AddRuleSetTreeQuantityProblem"
    ],
    "AddShippingInfoResponse": [
      "OrderAddShippingInfoSuccessResponse",
      "OrderAddShippingInfoOrderNotFoundProblem",
      "OrderAddShippingInfoOrderUpdateProblem"
    ],
    "AddSubscriptionCancelationSurveyResponse": [
      "AddSubscriptionCancelationSurveySuccessResponse",
      "AddSubscriptionCancelationSurveyInvalidInputProblem",
      "AddSubscriptionCancelationSurveyNotFoundProblem",
      "AddSubscriptionCancelationSurveyUnknownProblem"
    ],
    "AnswerFeedActivityQuizResponse": [
      "Resource",
      "FeedActivityUnknownErrorProblem",
      "FeedActivityNotFoundProblem",
      "FeedActivityNotValidTypeProblem",
      "FeedActivityQuizAnswerNotValidProblem"
    ],
    "ApproveQuotationResponse": [
      "Quotation",
      "QuotationNotFoundProblem",
      "QuotationApproveUnknownProblem"
    ],
    "Asset": [
      "Image"
    ],
    "AssignForestryTreesResponse": [
      "AssignForestryTreesPositiveResponse",
      "AssignForestryTreesProductProblem",
      "AssignForestryTreesUserProblem",
      "AssignForestryForestProblem",
      "AssignForestryUnknownProblem",
      "AssignForestryTreesRetrievesTreesProblem",
      "AssignForestryTreesForestryTreeProblem",
      "AssignForestryTreesSeedUntilNotAllowedProblem"
    ],
    "BaseConnection": [
      "TreecodeConnection",
      "TreecodeCreativityConnection"
    ],
    "BulkChangeOwnershipResponse": [
      "BulkChangeOwnershipResponseData",
      "BulkChangeOwnershipUnknownProblem",
      "BulkChangeOwnershipInvalidTargetUserProblem"
    ],
    "BulkDeleteTreecodeResponse": [
      "BulkDeleteTreecodeResponseData",
      "BulkDeleteTreecodeCreationDateFromNotValidProblem",
      "BulkDeleteTreecodeCreationDateToNotValidProblem",
      "BulkDeleteTreecodeUnknownProblem",
      "BulkDeleteTreecodeGenerationProcessNameNotValidProblem"
    ],
    "BulkUpdateTreecodeResponse": [
      "BulkUpdateTreecodeResponseData",
      "BulkUpdateTreecodeCreationDateFromNotValidProblem",
      "BulkUpdateTreecodeCreationDateToNotValidProblem",
      "BulkUpdateTreecodeUnknownProblem",
      "BulkUpdateTreecodeGenerationProcessNameNotValidProblem",
      "BulkUpdateTreecodeMissingInputFieldProblem",
      "BulkUpdateTreecodeUpdateRedeemableTreeNotAvailable",
      "BulkUpdateTreecodeRedeemableTreeAssignedOnFromNotValid",
      "BulkUpdateTreecodeRedeemableTreeAssignedOnToNotValid"
    ],
    "CancelQuotationResponse": [
      "Quotation",
      "QuotationNotFoundProblem",
      "QuotationCancelUnknownProblem",
      "QuotationWrongStateProblem"
    ],
    "CartDeleteResponse": [
      "Resource",
      "CartDeleteNotFoundProblem"
    ],
    "CartDiscountRequirement": [
      "CartDiscountRequirementMissingProduct",
      "CartDiscountRequirementExpectedMinPrice"
    ],
    "CartSetMarketingCampaignResponse": [
      "Resource",
      "CartSetMarketingCampaignCartNotFound",
      "CartSetMarketingCampaignUpdateProblem",
      "CartSetMarketingCampaignUserMismatchProblem"
    ],
    "CartSetShippingAddressResponse": [
      "Resource",
      "CartShippingAddressCartNotFound",
      "CartShippingAddressUserMismatchProblem",
      "CartShippingAddressMissingRequiredFieldsProblem",
      "CartShippingAddressInvalidFieldsProblem",
      "CartShippingAddressSetUpdateProblem",
      "CartShippingAddressSetCustomerDefaultAddressProblem"
    ],
    "ChangeAvailableRedeemsResponse": [
      "Resource",
      "ChangeAvailableRedeemsNotExistsProblem",
      "ChangeAvailableRedeemsNotUpdatable",
      "ChangeAvailableRedeemsQuantityNotValid"
    ],
    "ChangeBusinessInfoResponse": [
      "Resource",
      "ChangeBusinessInfoInvalidInputProblem"
    ],
    "ChangeCommunicationKitCtaFileUploadResponse": [
      "FileUpload",
      "CommunicationKitCtaTypeMismatchProblem",
      "CommunicationKitInvalidLocaleProblem"
    ],
    "ChangeConsentFlagsResponse": [
      "Resource"
    ],
    "ChangeCurrencyResponse": [
      "Resource",
      "ChangeCurrencyUserStandardCartNotFoundProblem",
      "ChangeCurrencyCartNotFoundProblem"
    ],
    "ChangeGiftItemResponse": [
      "Resource",
      "CartChangeGiftItemCartNotFoundProblem",
      "CartChangeGiftItemCartItemNotFoundProblem",
      "CartChangeGiftItemMissingCartProblem",
      "CartChangeGiftItemSameStatusProblem"
    ],
    "ChangeIdentityProfilerIdResponse": [
      "Resource",
      "ChangeIdentityProviderIdUserNotFoundProblem"
    ],
    "ChangePasswordResponse": [
      "Resource",
      "ChangePasswordInvalidProblem",
      "ChangePasswordProblem"
    ],
    "ChangePrivacyFlagsResponse": [
      "Resource"
    ],
    "ChangeProfileResponse": [
      "Resource",
      "ChangeProfileDuplicatedFieldProblem",
      "ChangeProfileInvalidFieldProblem",
      "ChangeProfileUserNotFoundProblem"
    ],
    "ChangeRedeemableTreeResponse": [
      "Resource",
      "ChangeRedeemableTreeNotExistsProblem",
      "ChangeRedeemableTreeAssignedOnFromNotValid",
      "ChangeRedeemableTreeAssignedOnToNotValid",
      "ChangeRedeemableTreeNotUpdatable",
      "ChangeRedeemableTreeNoInputProvided",
      "ChangeRedeemableTreeUnknownProblem"
    ],
    "CheckoutResponse": [
      "CheckoutSessionResponse",
      "CartCheckoutAdyenCreateSessionProblem",
      "CartCheckoutNoCartForCustomerProblem",
      "CartCheckoutUpdateUserProblem",
      "CartCheckoutWrongCartOwnerProblem",
      "CartCheckoutSubscriptionAlreadyActiveProblem",
      "CartCheckoutUpdateCartProblem"
    ],
    "CommunicationKitIconFileUploadResponse": [
      "FileUpload",
      "CommunicationKitNotFoundProblem"
    ],
    "CommunicationKitInterface": [
      "CommunicationKit",
      "UserPerkCommunicationKit"
    ],
    "Connection": [
      "AbuseReportConnection",
      "AssistantThreadMessagesConnection",
      "BillingPlanConnection",
      "BlogPostConnection",
      "CommunicationKitConnection",
      "FeedActivityPostCommentConnection",
      "FeedAuthorConnection",
      "FeedPostConnection",
      "FinanceExpensesConnection",
      "FinancePaymentsConnection",
      "FootprintCalculationConnection",
      "ForestConnection",
      "ForestCountriesConnection",
      "ForestProjectSpeciesConnection",
      "ForestryTreeConnection",
      "ForestryTreesConnection",
      "ForestsContributesConnection",
      "GiftableTreesConnection",
      "InvoiceConnection",
      "OrderConnection",
      "OriginatorConnection",
      "PerkConnection",
      "PillConnection",
      "PlanConnection",
      "PlanFinancialStatementConnection",
      "PlanSpeciePriceConnection",
      "PlanSubscriptionAssignmentConnection",
      "PlanSubscriptionBillingConnection",
      "PlanSubscriptionConnection",
      "ProcurementPlansConnection",
      "ProductConnection",
      "ProjectsConnection",
      "ProjectSpecieConnection",
      "QuotationConnection",
      "ScientificSpecieConnection",
      "SupplierConnection",
      "SupplierFinancialStatementConnection",
      "TreeConnection",
      "TreeProjectConnection",
      "TreeProjectsConnection",
      "TreesSearchConnection",
      "UserConnection",
      "UserCountriesConnection",
      "UserProjectSpeciesConnection",
      "UserTreeConnection"
    ],
    "CreateBillingPlanResponse": [
      "BillingPlan",
      "BillingPlanUnknownProblem",
      "BillingPlanNotFoundProblem",
      "BillingPlanMissingEntriesProblem",
      "BillingPlanEmptyNameProblem",
      "BillingPlanDurationNotPositiveProblem",
      "BillingPlanInvalidRenewLimitProblem"
    ],
    "CreateCapabilityGroupResponse": [
      "Resource",
      "CreateCapabilityGroupAlreadyExistsProblem",
      "CreateCapabilityGroupMalformedCapabilityProblem"
    ],
    "CreateCommunicationKitResponse": [
      "Resource",
      "CommunicationKitInvalidCategoryProblem"
    ],
    "CreateFeedActivityCommentLikeResponse": [
      "Resource",
      "FeedActivityNotFoundProblem",
      "FeedActivityUnknownErrorProblem",
      "FeedActivityCommentNotFoundProblem",
      "FeedActivityLikeAlreadyExistentProblem"
    ],
    "CreateFeedActivityCommentResponse": [
      "Resource",
      "FeedActivityUnknownErrorProblem",
      "FeedActivityNotFoundProblem"
    ],
    "CreateFeedActivityLikeResponse": [
      "Resource",
      "FeedActivityUnknownErrorProblem",
      "FeedActivityNotFoundProblem",
      "FeedActivityLikeAlreadyExistentProblem"
    ],
    "CreateFeedAuthorResponse": [
      "Resource",
      "FeedAuthorUnknownErrorProblem"
    ],
    "CreateFeedBanResponse": [
      "Resource",
      "CreateFeedBanAlreadyExistsErrorProblem",
      "CreateFeedBanUnknownErrorProblem"
    ],
    "CreateFeedPostResponse": [
      "Resource",
      "CreateFeedPostUnknownProblem"
    ],
    "CreateOriginatorResponse": [
      "Resource"
    ],
    "CreatePlanResponse": [
      "Plan",
      "CreatePlanProblem"
    ],
    "CreateQuotationResponse": [
      "Quotation",
      "QuotationUnknownProblem",
      "QuotationCartNotFoundProblem",
      "QuotationCartUpdateProblem",
      "QuotationInvalidExpirationProblem"
    ],
    "CreateUserResponse": [
      "User",
      "CreateUserProblemUnknown",
      "CreateUserMissingFieldProblem",
      "CreateUserEmailAlreadyExistsProblem"
    ],
    "CustomerFeedbackCreateThreadResponse": [
      "CustomerFeedbackNotInitializedProblem",
      "CustomerFeedbackUnknownProblem",
      "Resource"
    ],
    "CustomerFeedbackPromptResponse": [
      "CustomerFeedbackNotInitializedProblem",
      "CustomerFeedbackUnknownProblem",
      "Resource"
    ],
    "DeleteBillingPlanEntryResponse": [
      "DeleteBillingPlanEntrySuccessResponse",
      "BillingPlanEntryUnknownProblem",
      "BillingPlanEntryBillingPlanNotFoundProblem",
      "BillingPlanEntryMinimumCycleProblem",
      "BillingPlanEntryCyclesNotProgressiveProblem",
      "BillingPlanEntryDelayNotPositiveProblem",
      "BillingPlanEntryDelayNotProgressiveProblem",
      "BillingPlanEntryDelayTooLongProblem",
      "BillingPlanEntryNotValidProblem",
      "BillingPlanEntryNotFoundProblem"
    ],
    "DeleteBillingPlanResponse": [
      "Resource",
      "BillingPlanUnknownProblem",
      "BillingPlanNotFoundProblem",
      "BillingPlanInUseProblem"
    ],
    "DeleteFeedActivityCommentLikeResponse": [
      "Resource",
      "FeedActivityNotFoundProblem",
      "FeedActivityUnknownErrorProblem",
      "FeedActivityCommentNotFoundProblem",
      "FeedActivityCommentLikeNotFoundProblem"
    ],
    "DeleteFeedActivityCommentResponse": [
      "Resource",
      "FeedActivityUnknownErrorProblem",
      "FeedActivityNotFoundProblem",
      "FeedActivityCommentNotFoundProblem"
    ],
    "DeleteFeedActivityLikeResponse": [
      "Resource",
      "FeedActivityUnknownErrorProblem",
      "FeedActivityNotFoundProblem",
      "FeedActivityLikeNotFoundProblem"
    ],
    "DeleteFeedBanResponse": [
      "Resource",
      "DeleteFeedBanNotFoundProblem",
      "DeleteFeedBanUnknownErrorProblem"
    ],
    "DeleteFeedPostResponse": [
      "Resource",
      "DeleteFeedPostNotFoundProblem",
      "DeleteFeedPostIsPublishedProblem",
      "DeleteFeedPostUnknownProblem"
    ],
    "DeleteForestResponse": [
      "Resource",
      "DeleteForestNotFoundProblem",
      "DeleteForestNotEmptyProblem",
      "DeleteForestInDraftProblem",
      "DeleteForestUserDoesNotOwnForestProblem",
      "DeleteForestUnknownProblem"
    ],
    "DeletePlanProductResponse": [
      "DeletePlanProductSuccessResponse",
      "DeletePlanProductProblem"
    ],
    "DeletePlanResponse": [
      "Resource",
      "PlanUnknownProblem",
      "PlanNotFoundProblem",
      "PlanInUseProblem"
    ],
    "Edge": [
      "AbuseReportEdge",
      "AssistantThreadMessageEdge",
      "BillingPlanEdge",
      "BlogPostEdge",
      "CommunicationKitConnectionEdge",
      "FeedActivityPostCommentConnectionEdge",
      "FeedActivityPostCommentEdge",
      "FeedActivityPostLikeEdge",
      "FeedAuthorConnectionEdge",
      "FeedPostConnectionEdge",
      "FinanceExpensesEdge",
      "FinancePaymentsEdge",
      "FootprintCalculationConnectionEdge",
      "ForestContributeEdge",
      "ForestCountriesEdge",
      "ForestEdge",
      "ForestProjectSpeciesEdge",
      "ForestryTreeEdge",
      "ForestryTreesEdge",
      "GiftableTreesEdge",
      "InvoiceEdge",
      "NotificationStreamEdge",
      "OrderEdge",
      "OriginatorEdge",
      "PerkConnectionEdge",
      "PillEdge",
      "PlanEdge",
      "PlanFinancialStatementEdge",
      "PlanSpeciePriceEdge",
      "PlanSubscriptionAssignmentEdge",
      "PlanSubscriptionBillingEdge",
      "PlanSubscriptionEdge",
      "ProcurementPlansEdge",
      "ProductEdge",
      "ProjectsEdge",
      "ProjectSpecieEdge",
      "QuotationEdge",
      "ScientificSpecieEdge",
      "SupplierEdge",
      "SupplierFinancialStatementEdge",
      "TreecodeCreativityEdge",
      "TreecodeEdge",
      "TreecodeGenerationProcessEdge",
      "TreecodeTreeEdge",
      "TreeEdge",
      "TreeProjectEdge",
      "TreeProjectsEdge",
      "TreesSearchEdge",
      "UserCountriesEdge",
      "UserEdge",
      "UserFeedEdge",
      "UserProjectSpeciesEdge",
      "UserTreeEdge"
    ],
    "ExportTreecodeRedeemsListResponse": [
      "Resource",
      "ExportTreecodeRedeemsListNotFoundProblem",
      "ExportTreecodeRedeemsListUnknownProblem",
      "ExportTreecodeRedeemsListRequestedByNotProvidedProblem"
    ],
    "ExportTreecodesListResponse": [
      "Resource",
      "ExportTreecodesListNotFoundProblem",
      "ExportTreecodesListUnknownProblem",
      "ExportTreecodesListRequestedByNotProvidedProblem"
    ],
    "Feed": [
      "FeedCountry",
      "FeedForest",
      "FeedHoroscope",
      "FeedImpact",
      "FeedOrganization",
      "FeedProject",
      "FeedSpecie",
      "FeedUserCategory"
    ],
    "FeedActivity": [
      "FeedActivityPost"
    ],
    "FeedContent": [
      "FeedContentGallery",
      "FeedContentQuiz",
      "FeedContentText",
      "FeedContentVideo"
    ],
    "FeedContentStaged": [
      "FeedContentGalleryStaged",
      "FeedContentQuizStaged",
      "FeedContentTextStaged",
      "FeedContentVideoStaged"
    ],
    "FeedPostPublishResponse": [
      "Resource",
      "FeedPostNotFoundProblem",
      "FeedPostAlreadyPublishedProblem",
      "FeedPostNotPublishedProblem",
      "FeedPostHasNoFeedsProblem",
      "FeedPostNeedsUnpublishingFirstProblem"
    ],
    "FeedPostUnpublishResponse": [
      "Resource",
      "FeedPostNotFoundProblem",
      "FeedPostNotPublishedProblem",
      "FeedPostNotUnpublishedProblem"
    ],
    "FootprintCalculationCreateMutationResponse": [
      "Resource",
      "FootprintCalculationCreateUnknownProblem"
    ],
    "FootprintCalculationCreateTokenResponse": [
      "FootPrintCalculationToken",
      "FootprintCalculationCreateTokenCalculationNotFoundProblem",
      "FootprintCalculationCreateTokenCalculationOwnerMismatchProblem"
    ],
    "FootprintCalculationUpdateEmissionsMutationResponse": [
      "Resource",
      "FootprintCalculationNotFoundProblem",
      "FootprintCalculationUpdateEmissionsAlreadyCompletedProblem",
      "FootprintCalculationInvalidIdentifierProblem",
      "FootprintCalculationUnknownProblem"
    ],
    "FootprintCalculationUpdateMutationResponse": [
      "Resource",
      "FootprintCalculationNotFoundProblem",
      "FootprintCalculationInvalidIdentifierProblem",
      "FootprintCalculationUnknownProblem",
      "FootprintCalculationUpdateInvalidInputProblem"
    ],
    "ForestBulkChangeOwnershipResponse": [
      "ForestBulkChangeOwnershipResponseData",
      "ForestBulkChangeOwnershipUnknownProblem",
      "ForestBulkChangeOwnershipInvalidTargetUserProblem"
    ],
    "ForestMutationResponse": [
      "Resource",
      "CreateForestUnpublishedForestAlreadyExistsProblem",
      "CreateForestEventTypeDoesNotExistsProblem",
      "CreateForestUnknownProblem"
    ],
    "GenerationProcess": [
      "GenerationProcessPicker",
      "GenerationProcessSimple",
      "GenerationProcessVirgin"
    ],
    "GiftDeliveryType": [
      "GiftDeliveryTypeEmail",
      "GiftDeliveryTypeCode",
      "GiftDeliveryTypeCard"
    ],
    "InsertFinancePaymentMutationResponse": [
      "Resource",
      "FinancePaymentInsertUnknownErrorProblem",
      "FinancePaymentProcurementPlanNotFoundProblem",
      "FinancePaymentNotExistsProblem"
    ],
    "InsertFinanceSupplierMutationResponse": [
      "Resource",
      "FinanceSupplierAlreadyExistsProblem",
      "FinanceSupplierInsertUnknownErrorProblem",
      "FinanceSupplierNameEmptyProblem"
    ],
    "LeadCreateMutationResponse": [
      "Resource",
      "LeadCreateUnknownProblem",
      "LeadCreatePrivateUserProblem",
      "LeadCreateEmailDomainNotAllowedProblem"
    ],
    "LinkSocialIdentityResponse": [
      "Resource",
      "LinkSocialIdentityProblem",
      "LinkSocialIdentityTokenProblem",
      "LinkSocialIdentityAlreadyLinkedProblem",
      "LinkSocialIdentityAlreadyLinkedToAnotherAccountProblem"
    ],
    "MapPin": [
      "MapTreePin",
      "MapClusterPin"
    ],
    "MarkReadFeedNotificationResponse": [
      "MarkReadFeedNotificationResult",
      "MarkReadFeedNotificationUnknownProblem",
      "MarkReadFeedNotificationInvalidInputProblem"
    ],
    "MarkSeenFeedNotificationResponse": [
      "MarkSeenFeedNotificationResult",
      "MarkSeenFeedNotificationUnknownProblem",
      "MarkSeenFeedNotificationInvalidInputProblem"
    ],
    "Notification": [
      "NotificationPost",
      "NotificationPostReaction",
      "NotificationTreecodeRedeem",
      "NotificationTreeStatusChange"
    ],
    "NotificationPostReactionObject": [
      "FeedActivityPost",
      "FeedActivityPostComment"
    ],
    "PartnerClientCreateResponse": [
      "PartnerClientCredentials",
      "PartnerClientCreatePoolNotFoundProblem"
    ],
    "PartnerCreateResponse": [
      "Resource"
    ],
    "PaymentMethodCancelResponse": [
      "PaymentMethodCancelSuccessResponse",
      "PaymentMethodCancelProblem",
      "PaymentMethodCancelInvalidUserProblem",
      "PaymentMethodCancelNotFoundProblem",
      "PaymentMethodCancelAssociatedSubscriptionProblem"
    ],
    "PerkConnectionEdgeNode": [
      "Perk",
      "PerkCommunicationKit"
    ],
    "PerkCreateMutationResponse": [
      "Perk",
      "PerkCreateUnknownProblem"
    ],
    "PerkInterface": [
      "Perk",
      "PerkCommunicationKit"
    ],
    "PerkRule": [
      "PerkRuleProduct",
      "PerkRuleImpact",
      "PerkRulePlan",
      "PerkRuleTreeQuantity"
    ],
    "PerkRuleInterface": [
      "PerkRuleImpact",
      "PerkRulePlan",
      "PerkRuleProduct",
      "PerkRuleTreeQuantity"
    ],
    "PerkUpdateMutationResponse": [
      "Perk",
      "PerkUpdateUnknownProblem",
      "PerkUpdateNotFoundProblem",
      "PerkUpdateInvalidInputProblem"
    ],
    "PlanSubscriptionCancelResponse": [
      "Resource",
      "PlanSubscriptionCancelNotFoundProblem",
      "PlanSubscriptionCancelNotAuthorizedProblem",
      "PlanSubscriptionCancelAlreadyCanceledProblem",
      "PlanSubscriptionCancelExpireDateNotValidProblem"
    ],
    "PlanSubscriptionChangePaymentMethodResponse": [
      "CheckoutSessionResponse",
      "PlanSubscriptionChangePaymentMethodPaymentMethodNotFoundProblem",
      "PlanSubscriptionChangePaymentMethodSubscriptionNotFoundProblem",
      "PlanSubscriptionChangePaymentMethodAlreadyPresentProblem",
      "PlanSubscriptionChangePaymentMethodNotAuthorizedProblem",
      "PlanSubscriptionChangePaymentMethodCanceledProblem",
      "PlanSubscriptionChangePaymentMethodPaymentMethodExpiredProblem"
    ],
    "PlanSubscriptionReactivateResponse": [
      "Resource",
      "PlanSubscriptionReactivateNotFoundProblem",
      "PlanSubscriptionReactivateNotAuthorizedProblem",
      "PlanSubscriptionReactivateWrongStateProblem"
    ],
    "PlanValidationErrorResource": [
      "Plan",
      "PlanProduct"
    ],
    "PoolCreateResponse": [
      "Resource",
      "PoolCreatePartnerNotFoundProblem"
    ],
    "Problem": [
      "AbuseReportNotFoundProblem",
      "AbuseReportUnknownErrorProblem",
      "AddPlanProductProblem",
      "AddRuleSetMissingRuleTypeProblem",
      "AddRuleSetMoreThanOneRuleTypeProblem",
      "AddRuleSetPlanProblem",
      "AddRuleSetProductProblem",
      "AddRuleSetTreeQuantityProblem",
      "AddSubscriptionCancelationSurveyInvalidInputProblem",
      "AddSubscriptionCancelationSurveyNotFoundProblem",
      "AddSubscriptionCancelationSurveyUnknownProblem",
      "AssignForestryForestProblem",
      "AssignForestryTreesForestryTreeProblem",
      "AssignForestryTreesProductProblem",
      "AssignForestryTreesRetrievesTreesProblem",
      "AssignForestryTreesSeedUntilNotAllowedProblem",
      "AssignForestryTreesUserProblem",
      "AssignForestryUnknownProblem",
      "BillingPlanDurationNotPositiveProblem",
      "BillingPlanEmptyNameProblem",
      "BillingPlanEntryBillingPlanNotFoundProblem",
      "BillingPlanEntryCyclesNotProgressiveProblem",
      "BillingPlanEntryDelayNotPositiveProblem",
      "BillingPlanEntryDelayNotProgressiveProblem",
      "BillingPlanEntryDelayTooLongProblem",
      "BillingPlanEntryMinimumCycleProblem",
      "BillingPlanEntryNotFoundProblem",
      "BillingPlanEntryNotValidProblem",
      "BillingPlanEntryUnknownProblem",
      "BillingPlanInUseProblem",
      "BillingPlanInvalidRenewLimitProblem",
      "BillingPlanMissingEntriesProblem",
      "BillingPlanNotFoundProblem",
      "BillingPlanUnknownProblem",
      "BulkChangeOwnershipInvalidTargetUserProblem",
      "BulkChangeOwnershipUnknownProblem",
      "BulkDeleteTreecodeCreationDateFromNotValidProblem",
      "BulkDeleteTreecodeCreationDateToNotValidProblem",
      "BulkDeleteTreecodeGenerationProcessNameNotValidProblem",
      "BulkDeleteTreecodeUnknownProblem",
      "BulkUpdateTreecodeCreationDateFromNotValidProblem",
      "BulkUpdateTreecodeCreationDateToNotValidProblem",
      "BulkUpdateTreecodeGenerationProcessNameNotValidProblem",
      "BulkUpdateTreecodeMissingInputFieldProblem",
      "BulkUpdateTreecodeRedeemableTreeAssignedOnFromNotValid",
      "BulkUpdateTreecodeRedeemableTreeAssignedOnToNotValid",
      "BulkUpdateTreecodeUnknownProblem",
      "BulkUpdateTreecodeUpdateRedeemableTreeNotAvailable",
      "CartAddDiscountCartNotFoundProblem",
      "CartAddDiscountIncorrectDiscountCodeProblem",
      "CartAddDiscountUserMismatchProblem",
      "CartAddItemCartTypeMismatchProblem",
      "CartAddItemCurrencyMismatchProblem",
      "CartAddItemProductNotAvailableProblem",
      "CartAddItemProductNotFoundProblem",
      "CartAddItemProductNotSellableProblem",
      "CartAddItemProductOutOfStockProblem",
      "CartAddItemProductVariantNotFoundProblem",
      "CartAddItemUnauthorizedProductProblem",
      "CartChangeGiftItemCartItemNotFoundProblem",
      "CartChangeGiftItemCartNotFoundProblem",
      "CartChangeGiftItemMissingCartProblem",
      "CartChangeGiftItemSameStatusProblem",
      "CartCheckoutAdyenCreateSessionProblem",
      "CartCheckoutNoCartForCustomerProblem",
      "CartCheckoutSubscriptionAlreadyActiveProblem",
      "CartCheckoutUpdateCartProblem",
      "CartCheckoutUpdateUserProblem",
      "CartCheckoutWrongCartOwnerProblem",
      "CartDeleteNotFoundProblem",
      "CartReleaseItemsCartNotFoundProblem",
      "CartRemoveDiscountCartNotFoundProblem",
      "CartRemoveDiscountIncorrectDiscountCodeProblem",
      "CartRemoveDiscountUserMismatchProblem",
      "CartRemoveItemCartNotFoundProblem",
      "CartRemoveItemMissingCartProblem",
      "CartReserveItemsCartNotFoundProblem",
      "CartReserveItemsMissingRequiredShippingAddressProblem",
      "CartSetMarketingCampaignCartNotFound",
      "CartSetMarketingCampaignUpdateProblem",
      "CartSetMarketingCampaignUserMismatchProblem",
      "CartShippingAddressCartNotFound",
      "CartShippingAddressInvalidFieldsProblem",
      "CartShippingAddressMissingRequiredFieldsProblem",
      "CartShippingAddressSetCustomerDefaultAddressProblem",
      "CartShippingAddressSetUpdateProblem",
      "CartShippingAddressUserMismatchProblem",
      "CartToggleLineItemsGiftableCartNotFoundProblem",
      "CartToggleLineItemsGiftableUpdateProblem",
      "CartToggleLineItemsGiftableUserMismatchProblem",
      "CartUpdateItemCartItemNotFoundProblem",
      "CartUpdateItemCartNotFoundProblem",
      "CartUpdateItemMissingCartProblem",
      "CartUpdateItemProductNotAvailableProblem",
      "CartUpdateItemProductQuantityNotAvailableProblem",
      "ChangeAvailableRedeemsNotExistsProblem",
      "ChangeAvailableRedeemsNotUpdatable",
      "ChangeAvailableRedeemsQuantityNotValid",
      "ChangeBusinessInfoInvalidInputProblem",
      "ChangeCurrencyCartNotFoundProblem",
      "ChangeCurrencyUserStandardCartNotFoundProblem",
      "ChangeIdentityProviderIdUserNotFoundProblem",
      "ChangePasswordInvalidProblem",
      "ChangePasswordProblem",
      "ChangeProfileDuplicatedFieldProblem",
      "ChangeProfileInvalidFieldProblem",
      "ChangeProfileUserNotFoundProblem",
      "ChangeRedeemableTreeAssignedOnFromNotValid",
      "ChangeRedeemableTreeAssignedOnToNotValid",
      "ChangeRedeemableTreeNoInputProvided",
      "ChangeRedeemableTreeNotExistsProblem",
      "ChangeRedeemableTreeNotUpdatable",
      "ChangeRedeemableTreeUnknownProblem",
      "CommunicationKitCtaTypeMismatchProblem",
      "CommunicationKitInvalidCategoryProblem",
      "CommunicationKitInvalidLocaleProblem",
      "CommunicationKitNotFoundProblem",
      "CreateCapabilityGroupAlreadyExistsProblem",
      "CreateCapabilityGroupMalformedCapabilityProblem",
      "CreateFeedActivityCommentUnknownProblem",
      "CreateFeedBanAlreadyExistsErrorProblem",
      "CreateFeedBanUnknownErrorProblem",
      "CreateFeedPostUnknownProblem",
      "CreateForestEventTypeDoesNotExistsProblem",
      "CreateForestUnknownProblem",
      "CreateForestUnpublishedForestAlreadyExistsProblem",
      "CreatePlanProblem",
      "CreateUserEmailAlreadyExistsProblem",
      "CreateUserMissingFieldProblem",
      "CreateUserProblemUnknown",
      "CustomerFeedbackNotInitializedProblem",
      "CustomerFeedbackUnknownProblem",
      "DeleteFeedBanNotFoundProblem",
      "DeleteFeedBanUnknownErrorProblem",
      "DeleteFeedPostIsPublishedProblem",
      "DeleteFeedPostNotFoundProblem",
      "DeleteFeedPostUnknownProblem",
      "DeleteForestInDraftProblem",
      "DeleteForestNotEmptyProblem",
      "DeleteForestNotFoundProblem",
      "DeleteForestUnknownProblem",
      "DeleteForestUserDoesNotOwnForestProblem",
      "DeletePlanProductProblem",
      "DeleteTreecodeAlreadyConsumedProblem",
      "DeleteTreecodeNotAuthorizedProblem",
      "DeleteTreecodeNotExistsProblem",
      "DeleteTreecodeRetailAssociatedProblem",
      "ExportTreecodeRedeemsListNotFoundProblem",
      "ExportTreecodeRedeemsListRequestedByNotProvidedProblem",
      "ExportTreecodeRedeemsListUnknownProblem",
      "ExportTreecodesListNotFoundProblem",
      "ExportTreecodesListRequestedByNotProvidedProblem",
      "ExportTreecodesListUnknownProblem",
      "FeedActivityCommentLikeNotFoundProblem",
      "FeedActivityCommentNotFoundProblem",
      "FeedActivityCommentUpdateNoChangesProblem",
      "FeedActivityLikeAlreadyExistentProblem",
      "FeedActivityLikeNotFoundProblem",
      "FeedActivityNotFoundProblem",
      "FeedActivityNotValidTypeProblem",
      "FeedActivityQuizAnswerNotValidProblem",
      "FeedActivityUnknownErrorProblem",
      "FeedAuthorNotFoundProblem",
      "FeedAuthorUnknownErrorProblem",
      "FeedAuthorUpdateNoArgsProvidedProblem",
      "FeedPostAlreadyPublishedProblem",
      "FeedPostHasNoFeedsProblem",
      "FeedPostNeedsUnpublishingFirstProblem",
      "FeedPostNotFoundProblem",
      "FeedPostNotPublishedProblem",
      "FeedPostNotUnpublishedProblem",
      "FinancePaymentInsertUnknownErrorProblem",
      "FinancePaymentNotExistsProblem",
      "FinancePaymentProcurementPlanNotFoundProblem",
      "FinancePaymentUpdateUnknownErrorProblem",
      "FinancePaymentUpdateVoidInputProblem",
      "FinancePriceUpsertPriceTooHighProblem",
      "FinancePriceUpsertProcurementPlanNotFoundProblem",
      "FinancePriceUpsertProjectSpecieNotFoundProblem",
      "FinancePriceUpsertUnknownErrorProblem",
      "FinanceSupplierAlreadyExistsProblem",
      "FinanceSupplierInsertUnknownErrorProblem",
      "FinanceSupplierNameAlreadyExistsProblem",
      "FinanceSupplierNameEmptyProblem",
      "FinanceSupplierNotExistsProblem",
      "FinanceSupplierProcurementProjectNotExistsProblem",
      "FinanceSupplierUpdateUnknownErrorProblem",
      "FinanceSupplierUpdateVoidInputProblem",
      "FootprintCalculationCreateTokenCalculationNotFoundProblem",
      "FootprintCalculationCreateTokenCalculationOwnerMismatchProblem",
      "FootprintCalculationCreateUnknownProblem",
      "FootprintCalculationInvalidIdentifierProblem",
      "FootprintCalculationNotFoundProblem",
      "FootprintCalculationUnknownProblem",
      "FootprintCalculationUpdateEmissionsAlreadyCompletedProblem",
      "FootprintCalculationUpdateInvalidInputProblem",
      "ForestBulkChangeOwnershipInvalidTargetUserProblem",
      "ForestBulkChangeOwnershipUnknownProblem",
      "InvoiceUpdateNotFoundProblem",
      "InvoiceUpdateUnknownProblem",
      "LeadCreateEmailDomainNotAllowedProblem",
      "LeadCreatePrivateUserProblem",
      "LeadCreateUnknownProblem",
      "LinkSocialIdentityAlreadyLinkedProblem",
      "LinkSocialIdentityAlreadyLinkedToAnotherAccountProblem",
      "LinkSocialIdentityProblem",
      "LinkSocialIdentityTokenProblem",
      "MalformedInputProblem",
      "MarkReadFeedNotificationInvalidInputProblem",
      "MarkReadFeedNotificationUnknownProblem",
      "MarkSeenFeedNotificationInvalidInputProblem",
      "MarkSeenFeedNotificationUnknownProblem",
      "OrderAddShippingInfoOrderNotFoundProblem",
      "PartnerClientCreatePoolNotFoundProblem",
      "PaymentMethodCancelAssociatedSubscriptionProblem",
      "PaymentMethodCancelInvalidUserProblem",
      "PaymentMethodCancelNotFoundProblem",
      "PaymentMethodCancelProblem",
      "PerkCreateUnknownProblem",
      "PerkUpdateInvalidInputProblem",
      "PerkUpdateNotFoundProblem",
      "PerkUpdateUnknownProblem",
      "PlanDurationNotPositiveProblem",
      "PlanEmptyNameProblem",
      "PlanInUseProblem",
      "PlanNotFoundProblem",
      "PlanSubscriptionCancelAlreadyCanceledProblem",
      "PlanSubscriptionCancelExpireDateNotValidProblem",
      "PlanSubscriptionCancelNotAuthorizedProblem",
      "PlanSubscriptionCancelNotFoundProblem",
      "PlanSubscriptionChangePaymentMethodAlreadyPresentProblem",
      "PlanSubscriptionChangePaymentMethodCanceledProblem",
      "PlanSubscriptionChangePaymentMethodNotAuthorizedProblem",
      "PlanSubscriptionChangePaymentMethodPaymentMethodExpiredProblem",
      "PlanSubscriptionChangePaymentMethodPaymentMethodNotFoundProblem",
      "PlanSubscriptionChangePaymentMethodSubscriptionNotFoundProblem",
      "PlanSubscriptionReactivateNotAuthorizedProblem",
      "PlanSubscriptionReactivateNotFoundProblem",
      "PlanSubscriptionReactivateWrongStateProblem",
      "PlanUnknownProblem",
      "PoolCreatePartnerNotFoundProblem",
      "ProfileDisableImpactAlreadyDisabledProblem",
      "ProfileDisableImpactProfileNotFoundProblem",
      "ProfileEnableImpactAlreadyEnabledProblem",
      "ProfileEnableImpactProfileNotFoundProblem",
      "PublishForestNotAllowedProblem",
      "PublishForestNotFoundProblem",
      "PublishForestNotPayedProblem",
      "PublishForestUnknownProblem",
      "PublishForestUserDoesNotOwnForestProblem",
      "QuotationApproveUnknownProblem",
      "QuotationCancelUnknownProblem",
      "QuotationCartNotFoundProblem",
      "QuotationCartUpdateProblem",
      "QuotationInvalidExpirationProblem",
      "QuotationNotFoundProblem",
      "QuotationUnknownProblem",
      "QuotationWrongStateProblem",
      "RecalculateCartNotFoundProblem",
      "RecalculateCartUpdateProblem",
      "RedeemTreecodeAlreadyConsumedProblem",
      "RedeemTreecodeExpiredProblem",
      "RedeemTreecodeMissingPickedProductProblem",
      "RedeemTreecodeMissingRedeemerIdProblem",
      "RedeemTreecodeMissingTreesAvailabilityProblem",
      "RedeemTreecodeNotAuthorizedProblem",
      "RedeemTreecodeNotEnabledProblem",
      "RedeemTreecodeNotExistsProblem",
      "RefreshBillingProblem",
      "RefreshPlanProblem",
      "RemoveRuleSetNotFoundProblem",
      "RemoveRuleSetPerkNotFoundProblem",
      "ReportAbuseCommentNotFoundProblem",
      "ReportAbuseCommentUnknownProblem",
      "RequestBackInStockNotificationProductNotFoundProblem",
      "RequestBackInStockNotificationUnknownProblem",
      "RequestChangeEmailInvalidEmailProblem",
      "RequestGiftsSummaryNotExistProblem",
      "SetConsentsNotAcceptedProblem",
      "SetConsentsUserNotFoundProblem",
      "SetForestForestNotFoundProblem",
      "SetForestTreeAlreadyInForestProblem",
      "SetForestTreeNotFoundProblem",
      "SetForestUserDoesNotOwnForestProblem",
      "SetForestUserDoesNotOwnTreeProblem",
      "SetOriginatorAvatarNotFoundProblem",
      "SetPaymentDetailsCartNotFoundProblem",
      "SetProjectSpecieNurseryGalleryNotFoundProblem",
      "SetScientificSpecieFacebookIconNotFoundProblem",
      "SetScientificSpecieGalleryNotFoundProblem",
      "SetScientificSpecieIconNotFoundProblem",
      "SetSocialIdentityResponseProblem",
      "SetSubscriptionPaymentDetailsNotFoundProblem",
      "SetUserCapabilitiesMalformedCapabilityProblem",
      "SetUserCapabilitiesUserNotFoundProblem",
      "SetUserCapabilityGroupsUserNotFoundProblem",
      "SetUserTypeUserNotFoundProblem",
      "TreeBulkChangeGiftableUntilAssignedOnFromNotValidProblem",
      "TreeBulkChangeGiftableUntilAssignedOnToNotValidProblem",
      "TreeBulkChangeGiftableUntilNotValidProblem",
      "TreeBulkChangeGiftableUntilUnknownProblem",
      "TreeBulkChangeOwnershipInvalidTargetUserProblem",
      "TreeBulkChangeOwnershipUnknownProblem",
      "TreeBulkChangePlanterInvalidTargetUserProblem",
      "TreeBulkChangePlanterUnknownProblem",
      "TreeChangeNameEmptyNameProblem",
      "TreeChangeNameNotAuthorizedProblem",
      "TreecodeGameCompleteAlreadyCompletedProblem",
      "TreecodeGameCompleteGameExpiredProblem",
      "TreecodeGameCompleteGameNotFoundProblem",
      "TreecodeGameCompleteTreecodeNotFoundProblem",
      "TreecodeGameCompleteTreecodeNotRedeemedProblem",
      "TreecodeGameCompleteUnknownProblem",
      "TreecodeGiftCreateAlreadyExistentProblem",
      "TreecodeGiftCreateMissingCreatorIdProblem",
      "TreecodeGiftCreateMissingEmailDeliveryFieldProblem",
      "TreecodeGiftCreateMissingGifterIdProblem",
      "TreecodeGiftCreateTreesNotAvailableProblem",
      "TreecodePickerCreateExpiresAtNotValidProblem",
      "TreecodePickerCreateForestNotFoundProblem",
      "TreecodePickerCreateGameExpiresAtNotValidProblem",
      "TreecodePickerCreateGifterNotValidProblem",
      "TreecodePickerCreateMissingGameExpiresAtProblem",
      "TreecodePickerCreateRedeemableTreeAssignedOnFromNotValidProblem",
      "TreecodePickerCreateRedeemableTreeAssignedOnToNotValidProblem",
      "TreecodePickerCreateUnknownErrorProblem",
      "TreecodeSimpleCreateExpiresAtNotValidProblem",
      "TreecodeSimpleCreateGameExpiresAtNotValidProblem",
      "TreecodeSimpleCreateGenerationInProgressProblem",
      "TreecodeSimpleCreateMissingGameExpiresAtProblem",
      "TreecodeSimpleCreateTreeAssignedOnFromNotValidProblem",
      "TreecodeSimpleCreateTreeAssignedOnToNotValidProblem",
      "TreecodeSimpleCreateUnknownErrorProblem",
      "TreecodeSimpleTreesNotAvailableErrorProblem",
      "TreecodeVirginCreateExpiresAtNotValidProblem",
      "TreecodeVirginCreateForestNotFoundProblem",
      "TreecodeVirginCreateMissingPlanterProblem",
      "TreecodeVirginCreatePlanterNotValidProblem",
      "TreecodeVirginCreateUnknownErrorProblem",
      "TreeRevertOwnershipNotFoundProblem",
      "TreeRevertOwnershipUnknownProblem",
      "TreeRevertOwnershipWrongOwnershipProblem",
      "TreesInvalidInputProblem",
      "TreeUnassignOwnershipProblem",
      "TreeUnassignTreeNotFoundProblem",
      "TreeUnassignUnknownProblem",
      "UnsetForestTreeNotFoundProblem",
      "UnsetsetForestTreeNotInForestProblem",
      "UpdateCapabilityGroupCapabilitiesCapabilityGroupNotFoundProblem",
      "UpdateCapabilityGroupCapabilitiesMalformedCapabilityProblem",
      "UpdateFeedPostInvalidContentProblem",
      "UpdateFeedPostInvalidContentTypeProblem",
      "UpdateFeedPostNotFoundProblem",
      "UpdateForestEventTypeDoesNotExistsProblem",
      "UpdateForestNotFoundProblem",
      "UpdateForestOwnerNotFoundProblem",
      "UpdateForestSlugNotUniqueProblem",
      "UpdateForestUnknownProblem",
      "UpdateForestUserDoesNotOwnForestProblem",
      "UpdateOriginatorNotFoundProblem",
      "UpdatePlanProblem",
      "UpdatePlanProductProblem",
      "UpdateProjectSpecieDoesNotExistsProblem",
      "UpdateProjectSpeciePriceNotAllowedProblem",
      "UpdateProjectSpecieTreesPerHaNotAllowedProblem",
      "UpdateProjectSpecieUnknownProblem",
      "UpdateProjectSpecieVoidInputProblem",
      "UpdateProjectSpecieYieldNotAllowedProblem",
      "UpdateRuleSetMissingRuleTypeProblem",
      "UpdateRuleSetMoreThanOneRuleTypeProblem",
      "UpdateRuleSetNotFoundProblem",
      "UpdateRuleSetPerkNotFoundProblem",
      "UpdateRuleSetPlanProblem",
      "UpdateRuleSetProductProblem",
      "UpdateRuleSetTreeQuantityProblem",
      "UpdateScientificSpecieDoesNotExistsProblem",
      "UpdateScientificSpeciePriceNotAllowedProblem",
      "UpdateScientificSpecieTreesPerHaNotAllowedProblem",
      "UpdateScientificSpecieUnknownProblem",
      "UpdateScientificSpecieVoidInputProblem",
      "UpdateScientificSpecieYieldNotAllowedProblem",
      "UpdateScientificUnsupportedLanguagesProblem",
      "UpdateTreecodeExpiresAtNotValidProblem",
      "UpdateTreecodeMissingInputFieldProblem",
      "UpdateTreecodeMissingWhereFieldProblem",
      "UpdateTreecodeNotExistsProblem",
      "UpdateTreecodeUnknownErrorProblem",
      "UserAlreadyDisabledProblem",
      "UserRequestConfirmEmailAlreadyConfirmedProblem",
      "UserSetCommitmentNotFoundProblem",
      "UserSetPreferencesArgsNotProvided",
      "UserSetPreferencesUserNotFoundProblem",
      "UserSetRecoveryPasswordNotFoundProblem",
      "UserSetRolesNotFoundProblem",
      "UserSubmitConfirmEmailAlreadyConfirmedProblem",
      "UserSubmitConfirmEmailVerificationTokenExpiredProblem",
      "UserSubmitConfirmEmailVerificationTokenNotFoundProblem",
      "UserSubmitConfirmEmailVerificationTokenNotValidProblem"
    ],
    "Product": [
      "ProductBeverageBrewing",
      "ProductBundleTree",
      "ProductHoroscopeTree",
      "ProductSubscription",
      "ProductTree",
      "ProductUpperWear"
    ],
    "ProductContent": [
      "SubscriptionImpactContent"
    ],
    "ProductVariant": [
      "ProductBeverageBrewingVariant",
      "ProductBundleTreeVariant",
      "ProductHoroscopeTreeVariant",
      "ProductSubscriptionVariant",
      "ProductTreeVariant",
      "ProductUpperWearVariant"
    ],
    "ProfileMutationDisableImpactResult": [
      "UserProfileImpact",
      "ProfileDisableImpactProfileNotFoundProblem",
      "ProfileDisableImpactAlreadyDisabledProblem"
    ],
    "ProfileMutationEnableImpactResult": [
      "UserProfileImpact",
      "ProfileEnableImpactProfileNotFoundProblem",
      "ProfileEnableImpactAlreadyEnabledProblem"
    ],
    "ProjectSpecieUpdateMutationResponse": [
      "Resource",
      "UpdateProjectSpecieUnknownProblem",
      "UpdateProjectSpecieVoidInputProblem",
      "UpdateProjectSpecieDoesNotExistsProblem",
      "UpdateProjectSpeciePriceNotAllowedProblem",
      "UpdateProjectSpecieYieldNotAllowedProblem",
      "UpdateProjectSpecieTreesPerHaNotAllowedProblem"
    ],
    "PublishForestResponse": [
      "Resource",
      "PublishForestNotFoundProblem",
      "PublishForestUserDoesNotOwnForestProblem",
      "PublishForestNotPayedProblem",
      "PublishForestNotAllowedProblem",
      "PublishForestUnknownProblem"
    ],
    "RecalculateCartResponse": [
      "RecalculateCartSuccess",
      "RecalculateCartNotFoundProblem",
      "RecalculateCartUpdateProblem"
    ],
    "RefreshBillingResponse": [
      "BillingPlan",
      "RefreshBillingProblem"
    ],
    "RefreshPlanResponse": [
      "Plan",
      "RefreshPlanProblem"
    ],
    "ReleaseItemsResponse": [
      "Resource",
      "CartReleaseItemsCartNotFoundProblem"
    ],
    "RemoveDiscountResponse": [
      "Resource",
      "CartRemoveDiscountCartNotFoundProblem",
      "CartRemoveDiscountIncorrectDiscountCodeProblem",
      "CartRemoveDiscountUserMismatchProblem"
    ],
    "RemoveItemResponse": [
      "Resource",
      "CartRemoveItemCartNotFoundProblem",
      "CartRemoveItemMissingCartProblem"
    ],
    "RemoveRuleSetMutationResponse": [
      "Perk",
      "RemoveRuleSetPerkNotFoundProblem",
      "RemoveRuleSetNotFoundProblem"
    ],
    "ReportAbuseCommentResponse": [
      "Resource",
      "ReportAbuseCommentUnknownProblem",
      "ReportAbuseCommentNotFoundProblem"
    ],
    "RequestBackInStockNotificationResponse": [
      "Resource",
      "RequestBackInStockNotificationProductNotFoundProblem",
      "RequestBackInStockNotificationUnknownProblem"
    ],
    "RequestChangeEmailResponse": [
      "Resource",
      "RequestChangeEmailInvalidEmailProblem"
    ],
    "RequestGiftsSummaryResponse": [
      "Resources",
      "RequestGiftsSummaryNotExistProblem"
    ],
    "ReserveItemsResponse": [
      "Resource",
      "CartReserveItemsCartNotFoundProblem",
      "CartReserveItemsMissingRequiredShippingAddressProblem"
    ],
    "ResultForestryTrees": [
      "ForestryTreesConnection",
      "MalformedInputProblem"
    ],
    "SetCapabilityGroupCapabilitiesResponse": [
      "Resource",
      "UpdateCapabilityGroupCapabilitiesCapabilityGroupNotFoundProblem",
      "UpdateCapabilityGroupCapabilitiesMalformedCapabilityProblem"
    ],
    "SetConsentsResponse": [
      "Resource",
      "SetConsentsNotAcceptedProblem",
      "SetConsentsUserNotFoundProblem"
    ],
    "SetForestResponse": [
      "Resource",
      "SetForestUserDoesNotOwnForestProblem",
      "SetForestUserDoesNotOwnTreeProblem",
      "SetForestTreeAlreadyInForestProblem",
      "SetForestTreeNotFoundProblem",
      "SetForestForestNotFoundProblem"
    ],
    "SetOriginatorAvatarResponse": [
      "Resource",
      "SetOriginatorAvatarNotFoundProblem"
    ],
    "SetPaymentDetailsResponse": [
      "SetPaymentDetailsSuccessResponse",
      "SetPaymentDetailsCartNotFoundProblem"
    ],
    "SetProjectSpecieNurseryGalleryResponse": [
      "Resource",
      "SetProjectSpecieNurseryGalleryNotFoundProblem"
    ],
    "SetScientificSpecieFacebookIconResponse": [
      "Resource",
      "SetScientificSpecieFacebookIconNotFoundProblem"
    ],
    "SetScientificSpecieGalleryResponse": [
      "Resource",
      "SetScientificSpecieGalleryNotFoundProblem"
    ],
    "SetScientificSpecieIconResponse": [
      "Resource",
      "SetScientificSpecieIconNotFoundProblem"
    ],
    "SetSocialIdentityInputResponse": [
      "Resource",
      "SetSocialIdentityResponseProblem"
    ],
    "SetSubscriptionPaymentDetailsResponse": [
      "SetSubscriptionPaymentDetailsSuccessResponse",
      "SetSubscriptionPaymentDetailsNotFoundProblem"
    ],
    "SetUserCapabilitiesReponse": [
      "SetUserCapabilitiesUserNotFoundProblem",
      "SetUserCapabilitiesMalformedCapabilityProblem",
      "Resource"
    ],
    "SetUserCapabilityGroupsReponse": [
      "SetUserCapabilityGroupsUserNotFoundProblem",
      "Resource"
    ],
    "SetUserTypeResponse": [
      "Resource",
      "SetUserTypeUserNotFoundProblem"
    ],
    "StreamConnection": [
      "FeedActivityPostCommentsConnection",
      "FeedActivityPostLikeConnection",
      "NotificationStreamConnection",
      "UserFeedConnection"
    ],
    "ToggleLineItemsGiftableResponse": [
      "Resource",
      "CartToggleLineItemsGiftableCartNotFoundProblem",
      "CartToggleLineItemsGiftableUserMismatchProblem",
      "CartToggleLineItemsGiftableUpdateProblem"
    ],
    "TreeBulkChangeGiftableUntilResponse": [
      "TreeBulkChangeGiftableUntilResponseData",
      "TreeBulkChangeGiftableUntilNotValidProblem",
      "TreeBulkChangeGiftableUntilAssignedOnFromNotValidProblem",
      "TreeBulkChangeGiftableUntilAssignedOnToNotValidProblem",
      "TreeBulkChangeGiftableUntilUnknownProblem"
    ],
    "TreeBulkChangeOwnershipResponse": [
      "TreeBulkChangeOwnershipResponseData",
      "TreeBulkChangeOwnershipUnknownProblem",
      "TreeBulkChangeOwnershipInvalidTargetUserProblem"
    ],
    "TreeBulkChangePlanterResponse": [
      "TreeBulkChangePlanterResponseData",
      "TreeBulkChangePlanterUnknownProblem",
      "TreeBulkChangePlanterInvalidTargetUserProblem"
    ],
    "TreeChangeNameResponse": [
      "Resource",
      "TreeChangeNameNotAuthorizedProblem",
      "TreeChangeNameEmptyNameProblem"
    ],
    "Treecode": [
      "TreecodePicker",
      "TreecodeSimple",
      "TreecodeVirgin"
    ],
    "TreecodeBaseConnection": [
      "TreecodeGenerationProcessConnection",
      "TreecodeTreeConnection"
    ],
    "TreecodeDeleteResponse": [
      "Resource",
      "DeleteTreecodeNotExistsProblem",
      "DeleteTreecodeRetailAssociatedProblem",
      "DeleteTreecodeAlreadyConsumedProblem",
      "DeleteTreecodeNotAuthorizedProblem"
    ],
    "TreecodeGameCompleteResponse": [
      "Resource",
      "TreecodeGameCompleteGameExpiredProblem",
      "TreecodeGameCompleteAlreadyCompletedProblem",
      "TreecodeGameCompleteTreecodeNotFoundProblem",
      "TreecodeGameCompleteGameNotFoundProblem",
      "TreecodeGameCompleteTreecodeNotRedeemedProblem",
      "TreecodeGameCompleteUnknownProblem"
    ],
    "TreecodeGiftCreateResponse": [
      "Resource",
      "TreecodeGiftCreateTreesNotAvailableProblem",
      "TreecodeGiftCreateMissingEmailDeliveryFieldProblem",
      "TreecodeGiftCreateMissingGifterIdProblem",
      "TreecodeGiftCreateMissingCreatorIdProblem",
      "TreecodeGiftCreateAlreadyExistentProblem"
    ],
    "TreecodePickerCreateResponse": [
      "Resource",
      "TreecodePickerCreateForestNotFoundProblem",
      "TreecodePickerCreateGifterNotValidProblem",
      "TreecodePickerCreateUnknownErrorProblem",
      "TreecodePickerCreateMissingGameExpiresAtProblem",
      "TreecodePickerCreateExpiresAtNotValidProblem",
      "TreecodePickerCreateGameExpiresAtNotValidProblem",
      "TreecodePickerCreateRedeemableTreeAssignedOnFromNotValidProblem",
      "TreecodePickerCreateRedeemableTreeAssignedOnToNotValidProblem"
    ],
    "TreecodeRedeemResponse": [
      "Resource",
      "RedeemTreecodeNotExistsProblem",
      "RedeemTreecodeAlreadyConsumedProblem",
      "RedeemTreecodeNotEnabledProblem",
      "RedeemTreecodeNotAuthorizedProblem",
      "RedeemTreecodeExpiredProblem",
      "RedeemTreecodeMissingPickedProductProblem",
      "RedeemTreecodeMissingRedeemerIdProblem",
      "RedeemTreecodeMissingTreesAvailabilityProblem"
    ],
    "TreecodeSimpleCreateResponse": [
      "Resource",
      "TreecodeSimpleCreateUnknownErrorProblem",
      "TreecodeSimpleCreateMissingGameExpiresAtProblem",
      "TreecodeSimpleCreateExpiresAtNotValidProblem",
      "TreecodeSimpleCreateGameExpiresAtNotValidProblem",
      "TreecodeSimpleCreateGenerationInProgressProblem",
      "TreecodeSimpleTreesNotAvailableErrorProblem",
      "TreecodeSimpleCreateTreeAssignedOnFromNotValidProblem",
      "TreecodeSimpleCreateTreeAssignedOnToNotValidProblem"
    ],
    "TreecodeUpdateResponse": [
      "Resource",
      "UpdateTreecodeNotExistsProblem",
      "UpdateTreecodeMissingInputFieldProblem",
      "UpdateTreecodeExpiresAtNotValidProblem",
      "UpdateTreecodeMissingWhereFieldProblem",
      "UpdateTreecodeUnknownErrorProblem"
    ],
    "TreecodeVirginCreateResponse": [
      "Resource",
      "TreecodeVirginCreateUnknownErrorProblem",
      "TreecodeVirginCreateExpiresAtNotValidProblem",
      "TreecodeVirginCreateForestNotFoundProblem",
      "TreecodeVirginCreatePlanterNotValidProblem",
      "TreecodeVirginCreateMissingPlanterProblem"
    ],
    "TreeRevertOwnershipResponse": [
      "Resource",
      "TreeRevertOwnershipNotFoundProblem",
      "TreeRevertOwnershipWrongOwnershipProblem",
      "TreeRevertOwnershipUnknownProblem"
    ],
    "TreesResponse": [
      "TreeConnection",
      "TreesInvalidInputProblem"
    ],
    "TreeUnassignResponse": [
      "Resource",
      "TreeUnassignTreeNotFoundProblem",
      "TreeUnassignOwnershipProblem",
      "TreeUnassignUnknownProblem"
    ],
    "UnfollowFeedActivityResponse": [
      "Resource",
      "FeedActivityNotFoundProblem",
      "FeedActivityUnknownErrorProblem"
    ],
    "UnlinkSocialIdentityResponse": [
      "Resource"
    ],
    "UnschedulePublishResponse": [
      "Resource",
      "FeedPostNotFoundProblem"
    ],
    "UnscheduleUnpublishResponse": [
      "Resource",
      "FeedPostNotFoundProblem"
    ],
    "UnsetForestResponse": [
      "Resource",
      "UnsetForestTreeNotFoundProblem",
      "UnsetsetForestTreeNotInForestProblem"
    ],
    "UpdateBillingPlanEntryResponse": [
      "BillingPlanEntry",
      "BillingPlanEntryUnknownProblem",
      "BillingPlanEntryNotFoundProblem",
      "BillingPlanEntryBillingPlanNotFoundProblem",
      "BillingPlanEntryMinimumCycleProblem",
      "BillingPlanEntryCyclesNotProgressiveProblem",
      "BillingPlanEntryDelayNotPositiveProblem",
      "BillingPlanEntryDelayNotProgressiveProblem",
      "BillingPlanEntryDelayTooLongProblem",
      "BillingPlanEntryNotValidProblem"
    ],
    "UpdateBillingPlanResponse": [
      "BillingPlan",
      "BillingPlanUnknownProblem",
      "BillingPlanNotFoundProblem",
      "BillingPlanMissingEntriesProblem",
      "BillingPlanEmptyNameProblem",
      "BillingPlanDurationNotPositiveProblem",
      "BillingPlanInvalidRenewLimitProblem"
    ],
    "UpdateCommunicationKitResponse": [
      "Resource",
      "CommunicationKitNotFoundProblem",
      "CommunicationKitCtaTypeMismatchProblem",
      "CommunicationKitInvalidLocaleProblem",
      "CommunicationKitInvalidCategoryProblem"
    ],
    "UpdateFeedActivityCommentResponse": [
      "Resource",
      "FeedActivityUnknownErrorProblem",
      "FeedActivityNotFoundProblem",
      "FeedActivityCommentNotFoundProblem",
      "FeedActivityCommentUpdateNoChangesProblem"
    ],
    "UpdateFeedAuthorResponse": [
      "Resource",
      "FeedAuthorNotFoundProblem",
      "FeedAuthorUnknownErrorProblem",
      "FeedAuthorUpdateNoArgsProvidedProblem"
    ],
    "UpdateFeedPostGalleryResponse": [
      "Resource",
      "UpdateFeedPostNotFoundProblem",
      "UpdateFeedPostInvalidContentProblem",
      "UpdateFeedPostInvalidContentTypeProblem"
    ],
    "UpdateFeedPostQuizResponse": [
      "Resource",
      "UpdateFeedPostNotFoundProblem",
      "UpdateFeedPostInvalidContentProblem",
      "UpdateFeedPostInvalidContentTypeProblem"
    ],
    "UpdateFeedPostTextResponse": [
      "Resource",
      "UpdateFeedPostNotFoundProblem",
      "UpdateFeedPostInvalidContentProblem",
      "UpdateFeedPostInvalidContentTypeProblem"
    ],
    "UpdateFeedPostVideoResponse": [
      "Resource",
      "UpdateFeedPostNotFoundProblem",
      "UpdateFeedPostInvalidContentProblem",
      "UpdateFeedPostInvalidContentTypeProblem"
    ],
    "UpdateFinancePaymentMutationResponse": [
      "Resource",
      "FinancePaymentNotExistsProblem",
      "FinancePaymentUpdateUnknownErrorProblem",
      "FinancePaymentUpdateVoidInputProblem",
      "FinancePaymentProcurementPlanNotFoundProblem"
    ],
    "UpdateFinanceSupplierMutationResponse": [
      "Resource",
      "FinanceSupplierNotExistsProblem",
      "FinanceSupplierUpdateUnknownErrorProblem",
      "FinanceSupplierNameAlreadyExistsProblem",
      "FinanceSupplierUpdateVoidInputProblem",
      "FinanceSupplierProcurementProjectNotExistsProblem"
    ],
    "UpdateForestResponse": [
      "Resource",
      "UpdateForestNotFoundProblem",
      "UpdateForestUserDoesNotOwnForestProblem",
      "UpdateForestUnknownProblem",
      "UpdateForestEventTypeDoesNotExistsProblem",
      "UpdateForestOwnerNotFoundProblem",
      "UpdateForestSlugNotUniqueProblem"
    ],
    "UpdateInvoiceResponse": [
      "Invoice",
      "InvoiceUpdateUnknownProblem",
      "InvoiceUpdateNotFoundProblem"
    ],
    "UpdateItemResponse": [
      "Resource",
      "CartUpdateItemCartNotFoundProblem",
      "CartUpdateItemCartItemNotFoundProblem",
      "CartUpdateItemMissingCartProblem",
      "CartUpdateItemProductNotAvailableProblem",
      "CartUpdateItemProductQuantityNotAvailableProblem"
    ],
    "UpdateOriginatorResponse": [
      "Resource",
      "UpdateOriginatorNotFoundProblem"
    ],
    "UpdatePlanProductResponse": [
      "PlanProduct",
      "UpdatePlanProductProblem"
    ],
    "UpdatePlanResponse": [
      "Plan",
      "UpdatePlanProblem"
    ],
    "UpdateRuleSetMutationResponse": [
      "PerkRuleSet",
      "UpdateRuleSetNotFoundProblem",
      "UpdateRuleSetPerkNotFoundProblem",
      "UpdateRuleSetProductProblem",
      "UpdateRuleSetPlanProblem",
      "UpdateRuleSetMoreThanOneRuleTypeProblem",
      "UpdateRuleSetMissingRuleTypeProblem",
      "UpdateRuleSetTreeQuantityProblem"
    ],
    "UpdateScientificSpecieMutationResponse": [
      "Resource",
      "UpdateScientificSpecieUnknownProblem",
      "UpdateScientificSpecieDoesNotExistsProblem",
      "UpdateScientificSpecieVoidInputProblem",
      "UpdateScientificUnsupportedLanguagesProblem",
      "UpdateScientificSpeciePriceNotAllowedProblem",
      "UpdateScientificSpecieYieldNotAllowedProblem",
      "UpdateScientificSpecieTreesPerHaNotAllowedProblem"
    ],
    "UpsertFinancePriceMutationResponse": [
      "Resource",
      "FinancePriceUpsertProjectSpecieNotFoundProblem",
      "FinancePriceUpsertProcurementPlanNotFoundProblem",
      "FinancePriceUpsertUnknownErrorProblem",
      "FinancePriceUpsertPriceTooHighProblem"
    ],
    "UserDisableResponse": [
      "Resource",
      "UserAlreadyDisabledProblem"
    ],
    "UserPerk": [
      "UserPerkCommunicationKit"
    ],
    "UserRequestConfirmEmailResponse": [
      "Resource",
      "UserRequestConfirmEmailAlreadyConfirmedProblem"
    ],
    "UserSetCommitmentResponse": [
      "Resource",
      "UserSetCommitmentNotFoundProblem"
    ],
    "UserSetPreferencesResponse": [
      "Resource",
      "UserSetPreferencesUserNotFoundProblem",
      "UserSetPreferencesArgsNotProvided"
    ],
    "UserSetRecoveryPasswordResponse": [
      "UserSetRecoveryPassword",
      "UserSetRecoveryPasswordNotFoundProblem"
    ],
    "UserSetRolesResponse": [
      "Resource",
      "UserSetRolesNotFoundProblem"
    ],
    "UserSubmitConfirmEmailResponse": [
      "Resource",
      "UserSubmitConfirmEmailAlreadyConfirmedProblem",
      "UserSubmitConfirmEmailVerificationTokenNotValidProblem",
      "UserSubmitConfirmEmailVerificationTokenExpiredProblem",
      "UserSubmitConfirmEmailVerificationTokenNotFoundProblem"
    ]
  }
};
      export default result;
    